function _wrapRegExp() {
  _wrapRegExp = function (e, t) {
    return new a(e, void 0, t);
  };
  var e = RegExp.prototype,
    t = new WeakMap();
  function a(e, i, r) {
    var s = new RegExp(e, i);
    return (t.set(s, r || t.get(e)), _setPrototypeOf(s, a.prototype));
  }
  function i(e, a) {
    var i = t.get(a);
    return Object.keys(i).reduce(function (t, a) {
      return ((t[a] = e[i[a]]), t);
    }, Object.create(null));
  }
  return (
    _inherits(a, RegExp),
    (a.prototype.exec = function (t) {
      var a = e.exec.call(this, t);
      return (a && (a.groups = i(a, this)), a);
    }),
    (a.prototype[Symbol.replace] = function (a, r) {
      if ("string" == typeof r) {
        var s = t.get(this);
        return e[Symbol.replace].call(
          this,
          a,
          r.replace(/\$<([^>]+)>/g, function (e, t) {
            return "$" + s[t];
          }),
        );
      }
      if ("function" == typeof r) {
        var n = this;
        return e[Symbol.replace].call(this, a, function () {
          var e = arguments;
          return ("object" != typeof e[e.length - 1] && (e = [].slice.call(e)).push(i(e, n)), r.apply(this, e));
        });
      }
      return e[Symbol.replace].call(this, a, r);
    }),
    _wrapRegExp.apply(this, arguments)
  );
}
function _inherits(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  ((e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } })),
    t && _setPrototypeOf(e, t));
}
function _setPrototypeOf(e, t) {
  return (
    (_setPrototypeOf =
      Object.setPrototypeOf ||
      function (e, t) {
        return ((e.__proto__ = t), e);
      }),
    _setPrototypeOf(e, t)
  );
}
function asyncGeneratorStep(e, t, a, i, r, s, n) {
  try {
    var o = e[s](n),
      l = o.value;
  } catch (e) {
    return void a(e);
  }
  o.done ? t(l) : Promise.resolve(l).then(i, r);
}
function _asyncToGenerator(e) {
  return function () {
    var t = this,
      a = arguments;
    return new Promise(function (i, r) {
      var s = e.apply(t, a);
      function n(e) {
        asyncGeneratorStep(s, i, r, n, o, "next", e);
      }
      function o(e) {
        asyncGeneratorStep(s, i, r, n, o, "throw", e);
      }
      n(void 0);
    });
  };
}
function ownKeys(e, t) {
  var a = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    (t &&
      (i = i.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })),
      a.push.apply(a, i));
  }
  return a;
}
function _objectSpread(e) {
  for (var t = 1; t < arguments.length; t++) {
    var a = null != arguments[t] ? arguments[t] : {};
    t % 2
      ? ownKeys(Object(a), !0).forEach(function (t) {
          _defineProperty(e, t, a[t]);
        })
      : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a))
        : ownKeys(Object(a)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t));
          });
  }
  return e;
}
function _defineProperty(e, t, a) {
  return (
    t in e ? Object.defineProperty(e, t, { value: a, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = a),
    e
  );
}
function _slicedToArray(e, t) {
  return _arrayWithHoles(e) || _iterableToArrayLimit(e, t) || _unsupportedIterableToArray(e, t) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError(
    "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
  );
}
function _unsupportedIterableToArray(e, t) {
  if (e) {
    if ("string" == typeof e) return _arrayLikeToArray(e, t);
    var a = Object.prototype.toString.call(e).slice(8, -1);
    return (
      "Object" === a && e.constructor && (a = e.constructor.name),
      "Map" === a || "Set" === a
        ? Array.from(e)
        : "Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)
          ? _arrayLikeToArray(e, t)
          : void 0
    );
  }
}
function _arrayLikeToArray(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var a = 0, i = new Array(t); a < t; a++) i[a] = e[a];
  return i;
}
function _iterableToArrayLimit(e, t) {
  var a = e && (("undefined" != typeof Symbol && e[Symbol.iterator]) || e["@@iterator"]);
  if (null != a) {
    var i,
      r,
      s = [],
      n = !0,
      o = !1;
    try {
      for (a = a.call(e); !(n = (i = a.next()).done) && (s.push(i.value), !t || s.length !== t); n = !0);
    } catch (e) {
      ((o = !0), (r = e));
    } finally {
      try {
        n || null == a.return || a.return();
      } finally {
        if (o) throw r;
      }
    }
    return s;
  }
}
function _arrayWithHoles(e) {
  if (Array.isArray(e)) return e;
}
!(function (e, t, a, i, r) {
  "use strict";
  function s(e) {
    return e && "object" == typeof e && "default" in e ? e : { default: e };
  }
  function n(e) {
    if (e && e.__esModule) return e;
    var t = Object.create(null);
    return (
      e &&
        Object.keys(e).forEach(function (a) {
          if ("default" !== a) {
            var i = Object.getOwnPropertyDescriptor(e, a);
            Object.defineProperty(
              t,
              a,
              i.get
                ? i
                : {
                    enumerable: !0,
                    get: function () {
                      return e[a];
                    },
                  },
            );
          }
        }),
      (t.default = e),
      Object.freeze(t)
    );
  }
  var o = s(e),
    l = n(e),
    c = s(t),
    d = s(a),
    p = s(i),
    u = s(r);
  function m() {
    var e = "__TESTING_CONTEXT__",
      t = o.default.createContext[e];
    return (
      t ||
        (Object.defineProperty(o.default.createContext, e, {
          value: (t = o.default.createContext({ flags: [], addFlag: () => {}, flagEnabled: () => !1 })),
          enumerable: !1,
          writable: !1,
          configurable: !0,
        }),
        (t.displayName = "TestingContext")),
      t
    );
  }
  var h = (t) => {
      var a = t.children,
        i = _slicedToArray(e.useState([]), 2),
        r = i[0],
        s = i[1],
        n = m(),
        l = e.useCallback(
          (e) => {
            if (!r.some((t) => t.flag === e && t.enabled)) {
              var t = r.map((t) => (t.flag === e && (t.enabled = !0), t));
              (window.removeEventListener("flag.".concat(e), () => l(e)), s(t));
            }
          },
          [r],
        ),
        c = e.useCallback(
          (e) => {
            r.some((t) => t.flag === e) || r.push({ flag: e, enabled: !1 });
          },
          [r],
        ),
        d = e.useCallback(
          (e) => {
            return (
              (t = (function (e) {
                for (var t = void 0, a = e[0], i = 1; i < e.length; ) {
                  var r = e[i],
                    s = e[i + 1];
                  if (((i += 2), ("optionalAccess" === r || "optionalCall" === r) && null == a)) return;
                  "access" === r || "optionalAccess" === r
                    ? ((t = a), (a = s(a)))
                    : ("call" !== r && "optionalCall" !== r) ||
                      ((a = s(function () {
                        for (var e = arguments.length, i = new Array(e), r = 0; r < e; r++) i[r] = arguments[r];
                        return a.call(t, ...i);
                      })),
                      (t = void 0));
                }
                return a;
              })([
                r,
                "access",
                (e) => e.find,
                "call",
                (t) => t((t) => t.flag === e),
                "optionalAccess",
                (e) => e.enabled,
              ])),
              (a = () => !1),
              null != t ? t : a()
            );
            var t, a;
          },
          [r],
        );
      return (
        e.useEffect(() => {
          var e = function (e) {
            e.enabled ||
              (window.addEventListener("flag.".concat(e.flag), () => l(e.flag)),
              window.dispatchEvent(new CustomEvent("flag.".concat(e.flag, ".mounted"))));
          };
          for (var t of r) e(t);
          return () => {
            var e = function (e) {
              window.addEventListener("flag.".concat(e.flag), () => l(e.flag));
            };
            for (var t of r) e(t);
          };
        }, [r]),
        o.default.createElement(n.Provider, { value: { flags: r, addFlag: c, flagEnabled: d } }, a)
      );
    },
    f = (e, t) => {
      var a = "".concat(e, ": ").concat(t);
      (window.Bugsnag && window.Bugsnag.leaveBreadcrumb(a), window.mori.state.isLive || console.log(a));
    },
    g = (e, t, a, i, r, s) => {
      var n = "".concat(e, ": ").concat(t);
      (window.Bugsnag && window.Bugsnag.leaveBreadcrumb(n, { extra1: a, extra2: r, extra3: s }, i),
        window.mori.state.isLive || console.log(n, { [i]: a }));
    },
    v = o.default.createContext({ add: () => {}, remove: () => {} }),
    _ = (e) =>
      o.default.createElement(
        "div",
        _objectSpread({ style: { position: "fixed", right: 0, bottom: "25vh", width: "100%", zIndex: 10 } }, e),
      ),
    y = (t) => {
      var a = t.children,
        i = t.onDismiss,
        r = t.id;
      return (
        e.useEffect(() => {
          var e = setTimeout(() => i(r), 5e3);
          return () => {
            clearTimeout(e);
          };
        }, [r]),
        o.default.createElement(
          "div",
          {
            style: {
              background: "#efefef",
              cursor: "pointer",
              margin: "10px auto",
              padding: 10,
              borderRadius: "4px",
              width: "fit-content",
            },
          },
          a,
        )
      );
    };
  y.displayName = "Toast";
  var b = 0,
    w = (t) => {
      var a = _slicedToArray(e.useState([]), 2),
        i = a[0],
        r = a[1],
        s = (e) => {
          var t = i.filter((t) => t.id !== e);
          r(t);
        };
      return o.default.createElement(
        v.Provider,
        {
          value: {
            add: (e) => {
              var t = { content: e, id: b++ };
              r([...i, t]);
            },
            remove: s,
          },
        },
        t.children,
        o.default.createElement(
          _,
          null,
          i.map((e) => {
            var t = e.content,
              a = e.id;
            return o.default.createElement(y, { key: a, id: a, onDismiss: (e) => s(e) }, t);
          }),
        ),
      );
    },
    S = Bugsnag.getPlugin("react").createErrorBoundary(o.default);
  class E extends o.default.Component {
    render() {
      return o.default.createElement(
        o.default.Fragment,
        null,
        o.default.createElement("div", {
          style: { padding: "15px", maxWidth: "1200px", margin: "60px auto", textAlign: "center" },
          dangerouslySetInnerHTML: { __html: window.mori.errorBoundaryText },
        }),
      );
    }
  }
  E.displayName = "ErrorView";
  class C extends o.default.Component {
    constructor(e) {
      super(e);
    }
    render() {
      return o.default.createElement(S, { FallbackComponent: E }, this.props.children);
    }
  }
  C.displayName = "ErrorBoundary";
  class P {
    static logEvent(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      ((window.dataLayer = window.dataLayer || []), window.dataLayer.push(_objectSpread({ event: e }, t)));
    }
    static logEventGA4(e, t, a) {
      var i = this.replaceSpecialCharacters(t.eventParameterName),
        r = this.replaceSpecialCharacters(t.eventParameterValue);
      ((window.dataLayer = window.dataLayer || []),
        window.dataLayer.push({ event: e, eventName: a, eventParameterName: i, eventParameterValue: r }));
    }
    static logDynamicEvent(e) {
      var t = this.getDynamicEvent(),
        a = t.GTM_TEMPLATE_CATEGORY_EVENT,
        i = t.GTM_TEMPLATE_CATEGORY_NAME,
        r = this.replaceSpecialCharacters(e.eventParameterName),
        s = this.replaceSpecialCharacters(e.eventParameterValue);
      ((window.dataLayer = window.dataLayer || []),
        window.dataLayer.push({ event: a, eventName: i, eventParameterName: r, eventParameterValue: s }));
    }
    static gtmTriggerEvents(e, t, a, i) {
      if (((window.dataLayer = window.dataLayer || []), !window.mori.state.isB2B)) {
        var r = {
          event: ((s = i), (n = () => "site_interaction"), null != s ? s : n()),
          eventArea: e,
          eventAction: t,
          eventValue: this.replaceSpecialCharacters(a),
        };
        window.dataLayer.push(r);
      }
      var s, n;
    }
    static getDynamicEvent() {
      var e = window.mori.state.template,
        t = window.mori.state.gtmEventTrigger[e];
      return {
        TEMPLATE: e,
        GTM_TEMPLATE_PROPERTIES: t,
        GTM_TEMPLATE_CATEGORY_EVENT: t ? t.event : "",
        GTM_TEMPLATE_CATEGORY_NAME: t ? t.name : e,
      };
    }
    static replaceSpecialCharacters(e) {
      return e
        .toLowerCase()
        .replace(/[^a-zA-Z0-9_& ]/g, "_")
        .replace(/&/g, "and")
        .replace(/ /g, "_")
        .replace("<strong>", "")
        .replace("</strong>", "")
        .replace("<p>", "")
        .replace("</p>", "")
        .replace(/___/g, "_")
        .replace(/__/g, "_")
        .replace("_strong_", "")
        .replace("_strong_", "");
    }
    static productViewEvent(e) {
      try {
        window.$g.track({
          scope: "view",
          action: "add",
          data: { product_id: e },
          success: function (e) {
            window.mori.state.isLive || (console.log("Graphene ---- product view ---- event success "), console.log(e));
          },
        });
      } catch (e) {
        window.Bugsnag.notify(new Error("error notifying graphene of productViewEvent :\n".concat(e)), function (e) {
          e.severity = "warning";
        });
      }
    }
    static addToBasketEvent(e) {
      try {
        window.$g.track({
          scope: "basket",
          action: "add",
          data: { product_id: e, quantity: 1 },
          success: function (e) {
            window.mori.state.isLive ||
              (console.log("Graphene ---- add to basket ---- event success "), console.log(e));
          },
        });
      } catch (e) {
        window.Bugsnag.notify(new Error("error notifying graphene of addToBasketEvent :\n".concat(e)), function (e) {
          e.severity = "warning";
        });
      }
    }
  }
  var A = (function () {
    var e = _asyncToGenerator(function* (e) {
      if (!navigator.clipboard)
        return ((e) => {
          var t = document.createElement("textarea");
          ((t.value = e),
            (t.style.top = "0"),
            (t.style.left = "0"),
            (t.style.position = "fixed"),
            document.body.appendChild(t),
            t.focus(),
            t.select());
          var a = !1;
          try {
            a = document.execCommand("copy");
          } catch (e) {
            a = !1;
          }
          return (document.body.removeChild(t), a);
        })(e);
      try {
        return (yield navigator.clipboard.writeText(e), !0);
      } catch (e) {
        return !1;
      }
    });
    return function (t) {
      return e.apply(this, arguments);
    };
  })();
  class k {
    static readCookie(e) {
      for (var t = encodeURIComponent(e) + "=", a = document.cookie.split(";"), i = 0; i < a.length; i++) {
        for (var r = a[i]; " " === r.charAt(0); ) r = r.substring(1, r.length);
        if (0 === r.indexOf(t)) return decodeURIComponent(r.substring(t.length, r.length));
      }
      return null;
    }
    static createCookie(e, t) {
      var a,
        i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 360,
        r = arguments.length > 3 ? arguments[3] : void 0,
        s = new Date();
      (i
        ? (s.setTime(s.getTime() + 24 * i * 60 * 60 * 1e3), (a = "; expires=" + s.toUTCString()))
        : r
          ? (s.setTime(s.getTime() + 60 * r * 60 * 1e3), (a = "; expires=" + s.toUTCString()))
          : (a = ""),
        (document.cookie = encodeURIComponent(e) + "=" + encodeURIComponent(t) + a + "; path=/"));
    }
    static expireCookie(e) {
      this.createCookie(e, "", -1);
    }
  }
  function N(e) {
    for (var t = void 0, a = e[0], i = 1; i < e.length; ) {
      var r = e[i],
        s = e[i + 1];
      if (((i += 2), ("optionalAccess" === r || "optionalCall" === r) && null == a)) return;
      "access" === r || "optionalAccess" === r
        ? ((t = a), (a = s(a)))
        : ("call" !== r && "optionalCall" !== r) ||
          ((a = s(function () {
            for (var e = arguments.length, i = new Array(e), r = 0; r < e; r++) i[r] = arguments[r];
            return a.call(t, ...i);
          })),
          (t = void 0));
    }
    return a;
  }
  var T = (e) => {
    var t = o.default.useContext(v).add,
      a = (function () {
        var a = _asyncToGenerator(function* (a) {
          if (e.blackFridayBackground)
            return (
              window.dispatchEvent(new Event("pdpDiscountCta.clicked")),
              P.logEvent("click_bf_pdp_discount_cta"),
              void P.logDynamicEvent({
                eventParameterName: "discount_message",
                eventParameterValue: "black_friday_cta",
              })
            );
          k.createCookie("discount_codes", a, 0);
          var i = yield A(a);
          t(i ? "Copied ".concat(a, " to your  clipboard") : "".concat(a, " will be applied at checkout"));
        });
        return function (e) {
          return a.apply(this, arguments);
        };
      })(),
      i = [];
    if (
      e.discountCode &&
      e.discountMessage.toLowerCase().includes(e.discountCode.toLowerCase()) &&
      !e.hyperlinkRule.enabled
    ) {
      var r = e.discountMessage.split(e.discountCode);
      r.forEach((t, a) => {
        (0 === a
          ? i.push(o.default.createElement("span", { style: { display: "contents" } }, t.trim(), " "))
          : i.push(o.default.createElement("span", { style: { display: "contents" } }, " ", t.trim(), " ")),
          a !== r.length - 1 &&
            i.push(
              o.default.createElement("span", { style: { display: "contents" } }, e.discountCode.toUpperCase().trim()),
            ));
      });
    } else i.push(o.default.createElement("span", { style: { display: "contents" } }, e.discountMessage.trim()));
    var s = "";
    N([e, "access", (e) => e.blackFridayBackground, "optionalAccess", (e) => e.enable_black_friday_discount]) &&
      (s = "url(".concat(e.blackFridayBackground.bf_discount_background, ")"));
    var n = e.hyperlinkRule.enabled
      ? i[0].props.children.replace("<p>", '<p style="color: '.concat(e.discountMessageTextColor, '">'))
      : "";
    return e.hyperlinkRule.enabled
      ? o.default.createElement(
          "div",
          { className: "pdp_discount_text" },
          o.default.createElement("div", {
            className: "discount_rule rounded shortened",
            style: { backgroundImage: s, background: e.discountMessageBackground, width: "100%" },
            onClick: (t) =>
              ((e, t) => {
                var a = e.target.innerText;
                (P.gtmTriggerEvents("promo_message", "click", a), (window.location.href = t));
              })(t, e.hyperlinkRule.url),
            dangerouslySetInnerHTML: { __html: n },
          }),
        )
      : o.default.createElement(
          "div",
          { className: "pdp_discount_text", onClick: () => a(e.discountCode) },
          o.default.createElement(
            "div",
            {
              className: "discount_rule rounded shortened ".concat(
                N([
                  e,
                  "access",
                  (e) => e.blackFridayBackground,
                  "optionalAccess",
                  (e) => e.enable_black_friday_discount,
                ])
                  ? "black-friday-enabled"
                  : "",
              ),
              style: { backgroundImage: s, background: e.discountMessageBackground },
            },
            o.default.createElement("p", { style: { color: e.discountMessageTextColor } }, ...i),
          ),
        );
  };
  T.displayName = "DiscountCodePrompt";
  var O = (e) => {
      var t = e.config.tagRules.filter((t) => {
          switch (t.relationship) {
            case "present":
              return e.product.tags.includes(t.tag);
            case "not_present":
              return !e.product.tags.includes(t.tag);
            default:
              return !1;
          }
        }),
        a = e.config.typeRules.filter((t) => {
          switch (t.relationship) {
            case "in":
              return t.type
                .split(",")
                .map((e) => e.trim())
                .includes(e.product.type);
            case "not_in":
              return !t.type
                .split(",")
                .map((e) => e.trim())
                .includes(e.product.type);
            case "match":
              return t.type.trim() === e.product.type.trim();
            case "not_match":
              return t.type.trim() !== e.product.type.trim();
            default:
              return !1;
          }
        }),
        i = e.config.collectionRules.filter((t) => e.config.productCollections.includes(t.collection_handle)),
        r = e.config.hyperlinkRules.filter((t) => e.config.productCollections.includes(t.collection_handle)),
        s = [...t, ...i, ...r, ...a];
      if (!s.length) return o.default.createElement(o.default.Fragment, null);
      var n = s[0],
        l = x(t, i, r, a),
        c = n.hasOwnProperty("code") ? n.code.trim() : "";
      return o.default.createElement(T, {
        discountCode: c,
        discountMessage: n.text,
        discountMessageTextColor: n.textColor,
        discountMessageBackground: n.background,
        blackFridayBackground: e.config.blackFridayBackground ? e.config.blackFridayBackground[0] : null,
        hyperlinkRule: { enabled: "hyperlink_rule" === l, url: r.length ? r[0].link_url : "" },
      });
    },
    x = (e, t, a, i) =>
      e.length
        ? "tag_rule"
        : t.length
          ? "collection_rule"
          : a.length
            ? "hyperlink_rule"
            : i.length
              ? "type_rule"
              : null;
  O.displayName = "DiscountCodeWrapper";
  class I extends o.default.Component {
    constructor(e) {
      (super(e), I.prototype.__init.call(this), (this.state = e.animateOnMount ? this.getNewState(e) : {}));
    }
    static getDerivedStateFromProps(e, t) {
      if (e.isVisible !== t.isVisible) {
        var a = _objectSpread(_objectSpread({}, t), e);
        return a.isVisible
          ? { animation: a.animationIn, duration: a.animationInDuration, delay: a.animationInDelay }
          : { animation: a.animationOut, duration: a.animationOutDuration, delay: a.animationOutDelay };
      }
      return {};
    }
    __init() {
      this.getNewState = (e) => {
        var t = e.isVisible,
          a = e.animationIn,
          i = e.animationOut,
          r = e.animationInDuration,
          s = e.animationOutDuration,
          n = e.animationInDelay,
          o = e.animationOutDelay;
        return t ? { animation: a, duration: r, delay: n } : { animation: i, duration: s, delay: o };
      };
    }
    render() {
      var e = this.props,
        t = e.children,
        a = e.style,
        i = e.isVisible,
        r = e.className,
        s = this.state,
        n = s.animation,
        l = s.delay,
        c = s.duration,
        d = ["animated", n, r].filter(Boolean).join(" "),
        p = n ? {} : { opacity: i ? 1 : 0, transition: "opacity ".concat(l, "ms") };
      return o.default.createElement(
        "div",
        {
          className: d,
          style: _objectSpread(
            _objectSpread(
              {
                animationDelay: "".concat(l, "ms"),
                animationDuration: "".concat(c, "ms"),
                pointerEvents: i ? "all" : "none",
              },
              a,
            ),
            p,
          ),
        },
        t,
      );
    }
  }
  I.displayName = "Animated";
  class L extends o.default.Component {
    constructor(e) {
      (super(e), (this.state = { display: this.props.visible, visible: this.props.visible }));
    }
    componentDidUpdate() {
      (this.state.visible != this.props.visible && this.setState({ visible: this.props.visible }),
        this.state.display !== this.state.visible &&
          setTimeout(() => this.updateDisplayToMatchVisibility(), this.props.duration || 250));
    }
    updateDisplayToMatchVisibility() {
      this.state.display !== this.state.visible && this.setState({ display: this.state.visible });
    }
    render() {
      return o.default.createElement(
        I,
        {
          animationIn: "fadeIn",
          animationOut: "fadeOut",
          isVisible: this.state.visible,
          animateOnMount: !1,
          animationInDuration: this.props.duration || 250,
          animationOutDuration: this.props.duration || 250,
          style: this.state.display ? null : { display: "none" },
        },
        this.props.children,
      );
    }
  }
  ((L.displayName = "AnimatedVisibility"),
    Array.prototype.flat ||
      Object.defineProperty(Array.prototype, "flat", {
        configurable: !0,
        value: function e() {
          var t = isNaN(arguments[0]) ? 1 : Number(arguments[0]);
          return t
            ? Array.prototype.reduce.call(
                this,
                function (a, i) {
                  return (Array.isArray(i) ? a.push.apply(a, e.call(i, t - 1)) : a.push(i), a);
                },
                [],
              )
            : Array.prototype.slice.call(this);
        },
        writable: !0,
      }),
    Array.prototype.flatMap ||
      Object.defineProperty(Array.prototype, "flatMap", {
        configurable: !0,
        value: function (e) {
          return Array.prototype.map.apply(this, arguments).flat();
        },
        writable: !0,
      }));
  var M = { exports: {} },
    z = function (e, t) {
      return function () {
        for (var a = new Array(arguments.length), i = 0; i < a.length; i++) a[i] = arguments[i];
        return e.apply(t, a);
      };
    },
    R = z,
    D = Object.prototype.toString;
  function B(e) {
    return "[object Array]" === D.call(e);
  }
  function V(e) {
    return void 0 === e;
  }
  function F(e) {
    return null !== e && "object" == typeof e;
  }
  function U(e) {
    if ("[object Object]" !== D.call(e)) return !1;
    var t = Object.getPrototypeOf(e);
    return null === t || t === Object.prototype;
  }
  function W(e) {
    return "[object Function]" === D.call(e);
  }
  function q(e, t) {
    if (null != e)
      if (("object" != typeof e && (e = [e]), B(e))) for (var a = 0, i = e.length; a < i; a++) t.call(null, e[a], a, e);
      else for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.call(null, e[r], r, e);
  }
  var G = {
      isArray: B,
      isArrayBuffer: function (e) {
        return "[object ArrayBuffer]" === D.call(e);
      },
      isBuffer: function (e) {
        return (
          null !== e &&
          !V(e) &&
          null !== e.constructor &&
          !V(e.constructor) &&
          "function" == typeof e.constructor.isBuffer &&
          e.constructor.isBuffer(e)
        );
      },
      isFormData: function (e) {
        return "undefined" != typeof FormData && e instanceof FormData;
      },
      isArrayBufferView: function (e) {
        return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView
          ? ArrayBuffer.isView(e)
          : e && e.buffer && e.buffer instanceof ArrayBuffer;
      },
      isString: function (e) {
        return "string" == typeof e;
      },
      isNumber: function (e) {
        return "number" == typeof e;
      },
      isObject: F,
      isPlainObject: U,
      isUndefined: V,
      isDate: function (e) {
        return "[object Date]" === D.call(e);
      },
      isFile: function (e) {
        return "[object File]" === D.call(e);
      },
      isBlob: function (e) {
        return "[object Blob]" === D.call(e);
      },
      isFunction: W,
      isStream: function (e) {
        return F(e) && W(e.pipe);
      },
      isURLSearchParams: function (e) {
        return "undefined" != typeof URLSearchParams && e instanceof URLSearchParams;
      },
      isStandardBrowserEnv: function () {
        return (
          ("undefined" == typeof navigator ||
            ("ReactNative" !== navigator.product &&
              "NativeScript" !== navigator.product &&
              "NS" !== navigator.product)) &&
          "undefined" != typeof window &&
          "undefined" != typeof document
        );
      },
      forEach: q,
      merge: function e() {
        var t = {};
        function a(a, i) {
          U(t[i]) && U(a) ? (t[i] = e(t[i], a)) : U(a) ? (t[i] = e({}, a)) : B(a) ? (t[i] = a.slice()) : (t[i] = a);
        }
        for (var i = 0, r = arguments.length; i < r; i++) q(arguments[i], a);
        return t;
      },
      extend: function (e, t, a) {
        return (
          q(t, function (t, i) {
            e[i] = a && "function" == typeof t ? R(t, a) : t;
          }),
          e
        );
      },
      trim: function (e) {
        return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
      },
      stripBOM: function (e) {
        return (65279 === e.charCodeAt(0) && (e = e.slice(1)), e);
      },
    },
    H = G;
  function Y(e) {
    return encodeURIComponent(e)
      .replace(/%3A/gi, ":")
      .replace(/%24/g, "$")
      .replace(/%2C/gi, ",")
      .replace(/%20/g, "+")
      .replace(/%5B/gi, "[")
      .replace(/%5D/gi, "]");
  }
  var X = function (e, t, a) {
      if (!t) return e;
      var i;
      if (a) i = a(t);
      else if (H.isURLSearchParams(t)) i = t.toString();
      else {
        var r = [];
        (H.forEach(t, function (e, t) {
          null != e &&
            (H.isArray(e) ? (t += "[]") : (e = [e]),
            H.forEach(e, function (e) {
              (H.isDate(e) ? (e = e.toISOString()) : H.isObject(e) && (e = JSON.stringify(e)),
                r.push(Y(t) + "=" + Y(e)));
            }));
        }),
          (i = r.join("&")));
      }
      if (i) {
        var s = e.indexOf("#");
        (-1 !== s && (e = e.slice(0, s)), (e += (-1 === e.indexOf("?") ? "?" : "&") + i));
      }
      return e;
    },
    Q = G;
  function J() {
    this.handlers = [];
  }
  ((J.prototype.use = function (e, t, a) {
    return (
      this.handlers.push({
        fulfilled: e,
        rejected: t,
        synchronous: !!a && a.synchronous,
        runWhen: a ? a.runWhen : null,
      }),
      this.handlers.length - 1
    );
  }),
    (J.prototype.eject = function (e) {
      this.handlers[e] && (this.handlers[e] = null);
    }),
    (J.prototype.forEach = function (e) {
      Q.forEach(this.handlers, function (t) {
        null !== t && e(t);
      });
    }));
  var K = J,
    $ = G,
    Z = function (e, t, a, i, r) {
      return (
        (e.config = t),
        a && (e.code = a),
        (e.request = i),
        (e.response = r),
        (e.isAxiosError = !0),
        (e.toJSON = function () {
          return {
            message: this.message,
            name: this.name,
            description: this.description,
            number: this.number,
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null,
          };
        }),
        e
      );
    },
    ee = Z,
    te = function (e, t, a, i, r) {
      var s = new Error(e);
      return ee(s, t, a, i, r);
    },
    ae = te,
    ie = G,
    re = ie.isStandardBrowserEnv()
      ? {
          write: function (e, t, a, i, r, s) {
            var n = [];
            (n.push(e + "=" + encodeURIComponent(t)),
              ie.isNumber(a) && n.push("expires=" + new Date(a).toGMTString()),
              ie.isString(i) && n.push("path=" + i),
              ie.isString(r) && n.push("domain=" + r),
              !0 === s && n.push("secure"),
              (document.cookie = n.join("; ")));
          },
          read: function (e) {
            var t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
            return t ? decodeURIComponent(t[3]) : null;
          },
          remove: function (e) {
            this.write(e, "", Date.now() - 864e5);
          },
        }
      : {
          write: function () {},
          read: function () {
            return null;
          },
          remove: function () {},
        },
    se = function (e) {
      return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e);
    },
    ne = function (e, t) {
      return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
    },
    oe = G,
    le = [
      "age",
      "authorization",
      "content-length",
      "content-type",
      "etag",
      "expires",
      "from",
      "host",
      "if-modified-since",
      "if-unmodified-since",
      "last-modified",
      "location",
      "max-forwards",
      "proxy-authorization",
      "referer",
      "retry-after",
      "user-agent",
    ],
    ce = G,
    de = ce.isStandardBrowserEnv()
      ? (function () {
          var e,
            t = /(msie|trident)/i.test(navigator.userAgent),
            a = document.createElement("a");
          function i(e) {
            var i = e;
            return (
              t && (a.setAttribute("href", i), (i = a.href)),
              a.setAttribute("href", i),
              {
                href: a.href,
                protocol: a.protocol ? a.protocol.replace(/:$/, "") : "",
                host: a.host,
                search: a.search ? a.search.replace(/^\?/, "") : "",
                hash: a.hash ? a.hash.replace(/^#/, "") : "",
                hostname: a.hostname,
                port: a.port,
                pathname: "/" === a.pathname.charAt(0) ? a.pathname : "/" + a.pathname,
              }
            );
          }
          return (
            (e = i(window.location.href)),
            function (t) {
              var a = ce.isString(t) ? i(t) : t;
              return a.protocol === e.protocol && a.host === e.host;
            }
          );
        })()
      : function () {
          return !0;
        };
  function pe(e) {
    this.message = e;
  }
  ((pe.prototype.toString = function () {
    return "Cancel" + (this.message ? ": " + this.message : "");
  }),
    (pe.prototype.__CANCEL__ = !0));
  var ue = pe,
    me = G,
    he = function (e, t, a) {
      var i = a.config.validateStatus;
      a.status && i && !i(a.status)
        ? t(ae("Request failed with status code " + a.status, a.config, null, a.request, a))
        : e(a);
    },
    fe = re,
    ge = X,
    ve = function (e, t) {
      return e && !se(t) ? ne(e, t) : t;
    },
    _e = function (e) {
      var t,
        a,
        i,
        r = {};
      return e
        ? (oe.forEach(e.split("\n"), function (e) {
            if (
              ((i = e.indexOf(":")), (t = oe.trim(e.substr(0, i)).toLowerCase()), (a = oe.trim(e.substr(i + 1))), t)
            ) {
              if (r[t] && le.indexOf(t) >= 0) return;
              r[t] = "set-cookie" === t ? (r[t] ? r[t] : []).concat([a]) : r[t] ? r[t] + ", " + a : a;
            }
          }),
          r)
        : r;
    },
    ye = de,
    be = te,
    we = xe,
    Se = ue,
    Ee = function (e) {
      return new Promise(function (t, a) {
        var i,
          r = e.data,
          s = e.headers,
          n = e.responseType;
        function o() {
          (e.cancelToken && e.cancelToken.unsubscribe(i), e.signal && e.signal.removeEventListener("abort", i));
        }
        me.isFormData(r) && delete s["Content-Type"];
        var l = new XMLHttpRequest();
        if (e.auth) {
          var c = e.auth.username || "",
            d = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
          s.Authorization = "Basic " + btoa(c + ":" + d);
        }
        var p = ve(e.baseURL, e.url);
        function u() {
          if (l) {
            var i = "getAllResponseHeaders" in l ? _e(l.getAllResponseHeaders()) : null,
              r = {
                data: n && "text" !== n && "json" !== n ? l.response : l.responseText,
                status: l.status,
                statusText: l.statusText,
                headers: i,
                config: e,
                request: l,
              };
            (he(
              function (e) {
                (t(e), o());
              },
              function (e) {
                (a(e), o());
              },
              r,
            ),
              (l = null));
          }
        }
        if (
          (l.open(e.method.toUpperCase(), ge(p, e.params, e.paramsSerializer), !0),
          (l.timeout = e.timeout),
          "onloadend" in l
            ? (l.onloadend = u)
            : (l.onreadystatechange = function () {
                l &&
                  4 === l.readyState &&
                  (0 !== l.status || (l.responseURL && 0 === l.responseURL.indexOf("file:"))) &&
                  setTimeout(u);
              }),
          (l.onabort = function () {
            l && (a(be("Request aborted", e, "ECONNABORTED", l)), (l = null));
          }),
          (l.onerror = function () {
            (a(be("Network Error", e, null, l)), (l = null));
          }),
          (l.ontimeout = function () {
            var t = "timeout of " + e.timeout + "ms exceeded",
              i = e.transitional || we.transitional;
            (e.timeoutErrorMessage && (t = e.timeoutErrorMessage),
              a(be(t, e, i.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", l)),
              (l = null));
          }),
          me.isStandardBrowserEnv())
        ) {
          var m = (e.withCredentials || ye(p)) && e.xsrfCookieName ? fe.read(e.xsrfCookieName) : void 0;
          m && (s[e.xsrfHeaderName] = m);
        }
        ("setRequestHeader" in l &&
          me.forEach(s, function (e, t) {
            void 0 === r && "content-type" === t.toLowerCase() ? delete s[t] : l.setRequestHeader(t, e);
          }),
          me.isUndefined(e.withCredentials) || (l.withCredentials = !!e.withCredentials),
          n && "json" !== n && (l.responseType = e.responseType),
          "function" == typeof e.onDownloadProgress && l.addEventListener("progress", e.onDownloadProgress),
          "function" == typeof e.onUploadProgress &&
            l.upload &&
            l.upload.addEventListener("progress", e.onUploadProgress),
          (e.cancelToken || e.signal) &&
            ((i = function (e) {
              l && (a(!e || (e && e.type) ? new Se("canceled") : e), l.abort(), (l = null));
            }),
            e.cancelToken && e.cancelToken.subscribe(i),
            e.signal && (e.signal.aborted ? i() : e.signal.addEventListener("abort", i))),
          r || (r = null),
          l.send(r));
      });
    },
    Ce = G,
    Pe = function (e, t) {
      $.forEach(e, function (a, i) {
        i !== t && i.toUpperCase() === t.toUpperCase() && ((e[t] = a), delete e[i]);
      });
    },
    Ae = Z,
    ke = { "Content-Type": "application/x-www-form-urlencoded" };
  function Ne(e, t) {
    !Ce.isUndefined(e) && Ce.isUndefined(e["Content-Type"]) && (e["Content-Type"] = t);
  }
  var Te,
    Oe = {
      transitional: { silentJSONParsing: !0, forcedJSONParsing: !0, clarifyTimeoutError: !1 },
      adapter:
        (("undefined" != typeof XMLHttpRequest ||
          ("undefined" != typeof process && "[object process]" === Object.prototype.toString.call(process))) &&
          (Te = Ee),
        Te),
      transformRequest: [
        function (e, t) {
          return (
            Pe(t, "Accept"),
            Pe(t, "Content-Type"),
            Ce.isFormData(e) || Ce.isArrayBuffer(e) || Ce.isBuffer(e) || Ce.isStream(e) || Ce.isFile(e) || Ce.isBlob(e)
              ? e
              : Ce.isArrayBufferView(e)
                ? e.buffer
                : Ce.isURLSearchParams(e)
                  ? (Ne(t, "application/x-www-form-urlencoded;charset=utf-8"), e.toString())
                  : Ce.isObject(e) || (t && "application/json" === t["Content-Type"])
                    ? (Ne(t, "application/json"),
                      (function (e, t, a) {
                        if (Ce.isString(e))
                          try {
                            return ((t || JSON.parse)(e), Ce.trim(e));
                          } catch (e) {
                            if ("SyntaxError" !== e.name) throw e;
                          }
                        return (a || JSON.stringify)(e);
                      })(e))
                    : e
          );
        },
      ],
      transformResponse: [
        function (e) {
          var t = this.transitional || Oe.transitional,
            a = t && t.silentJSONParsing,
            i = t && t.forcedJSONParsing,
            r = !a && "json" === this.responseType;
          if (r || (i && Ce.isString(e) && e.length))
            try {
              return JSON.parse(e);
            } catch (e) {
              if (r) {
                if ("SyntaxError" === e.name) throw Ae(e, this, "E_JSON_PARSE");
                throw e;
              }
            }
          return e;
        },
      ],
      timeout: 0,
      xsrfCookieName: "XSRF-TOKEN",
      xsrfHeaderName: "X-XSRF-TOKEN",
      maxContentLength: -1,
      maxBodyLength: -1,
      validateStatus: function (e) {
        return e >= 200 && e < 300;
      },
      headers: { common: { Accept: "application/json, text/plain, */*" } },
    };
  (Ce.forEach(["delete", "get", "head"], function (e) {
    Oe.headers[e] = {};
  }),
    Ce.forEach(["post", "put", "patch"], function (e) {
      Oe.headers[e] = Ce.merge(ke);
    }));
  var xe = Oe,
    Ie = G,
    Le = xe,
    Me = function (e) {
      return !(!e || !e.__CANCEL__);
    },
    ze = G,
    Re = function (e, t, a) {
      var i = this || Le;
      return (
        Ie.forEach(a, function (a) {
          e = a.call(i, e, t);
        }),
        e
      );
    },
    De = Me,
    Be = xe,
    Ve = ue;
  function Fe(e) {
    if ((e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)) throw new Ve("canceled");
  }
  var Ue = G,
    We = function (e, t) {
      t = t || {};
      var a = {};
      function i(e, t) {
        return Ue.isPlainObject(e) && Ue.isPlainObject(t)
          ? Ue.merge(e, t)
          : Ue.isPlainObject(t)
            ? Ue.merge({}, t)
            : Ue.isArray(t)
              ? t.slice()
              : t;
      }
      function r(a) {
        return Ue.isUndefined(t[a]) ? (Ue.isUndefined(e[a]) ? void 0 : i(void 0, e[a])) : i(e[a], t[a]);
      }
      function s(e) {
        if (!Ue.isUndefined(t[e])) return i(void 0, t[e]);
      }
      function n(a) {
        return Ue.isUndefined(t[a]) ? (Ue.isUndefined(e[a]) ? void 0 : i(void 0, e[a])) : i(void 0, t[a]);
      }
      function o(a) {
        return a in t ? i(e[a], t[a]) : a in e ? i(void 0, e[a]) : void 0;
      }
      var l = {
        url: s,
        method: s,
        data: s,
        baseURL: n,
        transformRequest: n,
        transformResponse: n,
        paramsSerializer: n,
        timeout: n,
        timeoutMessage: n,
        withCredentials: n,
        adapter: n,
        responseType: n,
        xsrfCookieName: n,
        xsrfHeaderName: n,
        onUploadProgress: n,
        onDownloadProgress: n,
        decompress: n,
        maxContentLength: n,
        maxBodyLength: n,
        transport: n,
        httpAgent: n,
        httpsAgent: n,
        cancelToken: n,
        socketPath: n,
        responseEncoding: n,
        validateStatus: o,
      };
      return (
        Ue.forEach(Object.keys(e).concat(Object.keys(t)), function (e) {
          var t = l[e] || r,
            i = t(e);
          (Ue.isUndefined(i) && t !== o) || (a[e] = i);
        }),
        a
      );
    },
    je = "0.22.0",
    qe = je,
    Ge = {};
  ["object", "boolean", "number", "function", "string", "symbol"].forEach(function (e, t) {
    Ge[e] = function (a) {
      return typeof a === e || "a" + (t < 1 ? "n " : " ") + e;
    };
  });
  var He = {};
  Ge.transitional = function (e, t, a) {
    function i(e, t) {
      return "[Axios v" + qe + "] Transitional option '" + e + "'" + t + (a ? ". " + a : "");
    }
    return function (a, r, s) {
      if (!1 === e) throw new Error(i(r, " has been removed" + (t ? " in " + t : "")));
      return (
        t &&
          !He[r] &&
          ((He[r] = !0),
          console.warn(i(r, " has been deprecated since v" + t + " and will be removed in the near future"))),
        !e || e(a, r, s)
      );
    };
  };
  var Ye = {
      assertOptions: function (e, t, a) {
        if ("object" != typeof e) throw new TypeError("options must be an object");
        for (var i = Object.keys(e), r = i.length; r-- > 0; ) {
          var s = i[r],
            n = t[s];
          if (n) {
            var o = e[s],
              l = void 0 === o || n(o, s, e);
            if (!0 !== l) throw new TypeError("option " + s + " must be " + l);
          } else if (!0 !== a) throw Error("Unknown option " + s);
        }
      },
      validators: Ge,
    },
    Xe = G,
    Qe = X,
    Je = K,
    Ke = function (e) {
      return (
        Fe(e),
        (e.headers = e.headers || {}),
        (e.data = Re.call(e, e.data, e.headers, e.transformRequest)),
        (e.headers = ze.merge(e.headers.common || {}, e.headers[e.method] || {}, e.headers)),
        ze.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function (t) {
          delete e.headers[t];
        }),
        (e.adapter || Be.adapter)(e).then(
          function (t) {
            return (Fe(e), (t.data = Re.call(e, t.data, t.headers, e.transformResponse)), t);
          },
          function (t) {
            return (
              De(t) ||
                (Fe(e),
                t &&
                  t.response &&
                  (t.response.data = Re.call(e, t.response.data, t.response.headers, e.transformResponse))),
              Promise.reject(t)
            );
          },
        )
      );
    },
    $e = We,
    Ze = Ye,
    et = Ze.validators;
  function tt(e) {
    ((this.defaults = e), (this.interceptors = { request: new Je(), response: new Je() }));
  }
  ((tt.prototype.request = function (e) {
    ("string" == typeof e ? ((e = arguments[1] || {}).url = arguments[0]) : (e = e || {}),
      (e = $e(this.defaults, e)).method
        ? (e.method = e.method.toLowerCase())
        : this.defaults.method
          ? (e.method = this.defaults.method.toLowerCase())
          : (e.method = "get"));
    var t = e.transitional;
    void 0 !== t &&
      Ze.assertOptions(
        t,
        {
          silentJSONParsing: et.transitional(et.boolean),
          forcedJSONParsing: et.transitional(et.boolean),
          clarifyTimeoutError: et.transitional(et.boolean),
        },
        !1,
      );
    var a = [],
      i = !0;
    this.interceptors.request.forEach(function (t) {
      ("function" == typeof t.runWhen && !1 === t.runWhen(e)) ||
        ((i = i && t.synchronous), a.unshift(t.fulfilled, t.rejected));
    });
    var r,
      s = [];
    if (
      (this.interceptors.response.forEach(function (e) {
        s.push(e.fulfilled, e.rejected);
      }),
      !i)
    ) {
      var n = [Ke, void 0];
      for (Array.prototype.unshift.apply(n, a), n = n.concat(s), r = Promise.resolve(e); n.length; )
        r = r.then(n.shift(), n.shift());
      return r;
    }
    for (var o = e; a.length; ) {
      var l = a.shift(),
        c = a.shift();
      try {
        o = l(o);
      } catch (e) {
        c(e);
        break;
      }
    }
    try {
      r = Ke(o);
    } catch (e) {
      return Promise.reject(e);
    }
    for (; s.length; ) r = r.then(s.shift(), s.shift());
    return r;
  }),
    (tt.prototype.getUri = function (e) {
      return ((e = $e(this.defaults, e)), Qe(e.url, e.params, e.paramsSerializer).replace(/^\?/, ""));
    }),
    Xe.forEach(["delete", "get", "head", "options"], function (e) {
      tt.prototype[e] = function (t, a) {
        return this.request($e(a || {}, { method: e, url: t, data: (a || {}).data }));
      };
    }),
    Xe.forEach(["post", "put", "patch"], function (e) {
      tt.prototype[e] = function (t, a, i) {
        return this.request($e(i || {}, { method: e, url: t, data: a }));
      };
    }));
  var at = tt,
    it = ue;
  function rt(e) {
    if ("function" != typeof e) throw new TypeError("executor must be a function.");
    var t;
    this.promise = new Promise(function (e) {
      t = e;
    });
    var a = this;
    (this.promise.then(function (e) {
      if (a._listeners) {
        var t,
          i = a._listeners.length;
        for (t = 0; t < i; t++) a._listeners[t](e);
        a._listeners = null;
      }
    }),
      (this.promise.then = function (e) {
        var t,
          i = new Promise(function (e) {
            (a.subscribe(e), (t = e));
          }).then(e);
        return (
          (i.cancel = function () {
            a.unsubscribe(t);
          }),
          i
        );
      }),
      e(function (e) {
        a.reason || ((a.reason = new it(e)), t(a.reason));
      }));
  }
  ((rt.prototype.throwIfRequested = function () {
    if (this.reason) throw this.reason;
  }),
    (rt.prototype.subscribe = function (e) {
      this.reason ? e(this.reason) : this._listeners ? this._listeners.push(e) : (this._listeners = [e]);
    }),
    (rt.prototype.unsubscribe = function (e) {
      if (this._listeners) {
        var t = this._listeners.indexOf(e);
        -1 !== t && this._listeners.splice(t, 1);
      }
    }),
    (rt.source = function () {
      var e;
      return {
        token: new rt(function (t) {
          e = t;
        }),
        cancel: e,
      };
    }));
  var st = rt,
    nt = G,
    ot = z,
    lt = at,
    ct = We;
  var dt = (function e(t) {
    var a = new lt(t),
      i = ot(lt.prototype.request, a);
    return (
      nt.extend(i, lt.prototype, a),
      nt.extend(i, a),
      (i.create = function (a) {
        return e(ct(t, a));
      }),
      i
    );
  })(xe);
  ((dt.Axios = lt),
    (dt.Cancel = ue),
    (dt.CancelToken = st),
    (dt.isCancel = Me),
    (dt.VERSION = je),
    (dt.all = function (e) {
      return Promise.all(e);
    }),
    (dt.spread = function (e) {
      return function (t) {
        return e.apply(null, t);
      };
    }),
    (dt.isAxiosError = function (e) {
      return "object" == typeof e && !0 === e.isAxiosError;
    }),
    (M.exports = dt),
    (M.exports.default = dt));
  var pt = M.exports;
  function ut(e) {
    for (var t = void 0, a = e[0], i = 1; i < e.length; ) {
      var r = e[i],
        s = e[i + 1];
      if (((i += 2), ("optionalAccess" === r || "optionalCall" === r) && null == a)) return;
      "access" === r || "optionalAccess" === r
        ? ((t = a), (a = s(a)))
        : ("call" !== r && "optionalCall" !== r) ||
          ((a = s(function () {
            for (var e = arguments.length, i = new Array(e), r = 0; r < e; r++) i[r] = arguments[r];
            return a.call(t, ...i);
          })),
          (t = void 0));
    }
    return a;
  }
  var mt = { "Content-Type": "application/json" };
  class ht {
    static add(e) {
      var t = this;
      return _asyncToGenerator(function* () {
        t.logRequest("add", e);
        try {
          var a = e;
          if (
            (window.mori.state.freeShippingBasedOnCustomerTagsActive &&
              window.mori.state.customerEligibleFreeShipping &&
              window.mori.state.customerFreeShippingDateRangeValid &&
              (a.items = e.items.map(
                (e, t) => (
                  0 === t && (e.properties = _objectSpread(_objectSpread({}, e.properties), { f_ship: !0 })),
                  e
                ),
              )),
            a.items.length > 0 && k.readCookie("ab_testing_delivery_threshold"))
          )
            for (var i of a.items)
              i.properties
                ? (i.properties.__ab_testing_delivery_threshold = "true")
                : (i.properties = { __ab_testing_delivery_threshold: "true" });
          var r = yield pt.post("/cart/add.js", a, { headers: mt });
          (t.logResponse("add", r),
            window._learnq &&
              window._learnq.push([
                "track",
                "Added to Cart with Variant",
                {
                  Name: r.data.items[0].product_title,
                  Variant: r.data.items[0].variant_title,
                  ImageURL: r.data.items[0].image,
                  ProductURL: r.data.items[0].url,
                  ProductID: r.data.items[0].id,
                },
              ]));
          var s = yield t.get(),
            n = e.items[0].id,
            o = s.items.find((e) => e.id.toString() === n.toString());
          return (
            o && sessionStorage.setItem("last_added_to_cart", o.product_id.toString()),
            ht.setCartItemsAmountLabel(s),
            document && document.dispatchEvent(new CustomEvent("cartUpdateEvent", { detail: { cartTrigger: !0 } })),
            s
          );
        } catch (e) {
          throw (t.logError("add", e), { cause: e });
        }
      })();
    }
    static getProductTags(e) {
      var t = this;
      return _asyncToGenerator(function* () {
        t.logRequest("get", e);
        try {
          return yield pt.get("/products/".concat(e, ".js"), { headers: mt });
        } catch (e) {
          throw (t.logError("get", e), e);
        }
      })();
    }
    static get() {
      var e = this;
      return _asyncToGenerator(function* () {
        e.logRequest("get");
        try {
          var t = yield pt.get("/cart.js", { headers: mt, params: { time: new Date().getTime() } });
          return (e.logResponse("get", t.data), ht.setCartItemsAmountLabel(t.data), t.data);
        } catch (t) {
          throw (e.logError("get", t), t);
        }
      })();
    }
    static update(e) {
      var t = this;
      return _asyncToGenerator(function* () {
        t.logRequest("update", e);
        try {
          var a = yield pt.post("/cart/update.js", e, { headers: mt });
          return (
            t.logResponse("update", a.data),
            ht.setCartItemsAmountLabel(a.data),
            document && document.dispatchEvent(new CustomEvent("cartUpdateEvent", { detail: { cartTrigger: !0 } })),
            a.data
          );
        } catch (e) {
          throw (t.logError("update", e), e);
        }
      })();
    }
    static change(e) {
      var t = this;
      return _asyncToGenerator(function* () {
        t.logRequest("change", e);
        try {
          var a = yield pt.post("/cart/change.js", e, { headers: mt });
          return (
            t.logResponse("change", a.data),
            ht.setCartItemsAmountLabel(a.data),
            document && document.dispatchEvent(new CustomEvent("cartUpdateEvent", { detail: { cartTrigger: !0 } })),
            a.data
          );
        } catch (e) {
          throw (t.logError("change", e), e);
        }
      })();
    }
    static logRequest(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      g("Cart", "".concat(e), t, "request");
    }
    static logResponse(e, t) {
      g("Cart", "".concat(e), t, "response");
    }
    static logError(e, t) {
      g("Cart", "".concat(e), t, "response");
    }
    static setCartItemsAmountLabel(e) {
      var t =
        e.item_count -
        (e.items || []).filter((e) =>
          [
            "gift-note",
            "gift-wrap",
            "gift-wrap-small",
            "gift-wrap-medium",
            "gift-wrap-large",
            "gift-wrap-large-free",
            "gift-wrap-extra-large",
            "gift-wrap-all",
            "personalisation",
            "donation",
          ].includes(e.handle),
        ).length;
      document.querySelectorAll(".cart_amount_label").forEach((e) => (e.innerHTML = "<span> ".concat(t, " </span>")));
    }
    static serializeAddToCartForm() {
      var e,
        t,
        a = document.querySelector("product-form form")
          ? document.querySelector("product-form form")
          : document.getElementById("AddToCartForm"),
        i =
          ((e = (function (e) {
            for (var t = [], a = e.elements.length, i = 0; i < a; i++) {
              var r = e.elements[i];
              r.disabled ||
                (r.name &&
                  (["file", "reset", "submit", "button"].includes(r.type) ||
                    ("checkbox" !== r.type
                      ? (r.type, (t[t.length] = { name: r.name, value: r.value }))
                      : (t[t.length] = { name: r.name, value: r.checked }))));
            }
            return t;
          })(a)),
          (t = {}),
          e.forEach((e) => {
            t[e.name] = e.value;
          }),
          t);
      return (
        (i.properties = i.properties || {}),
        Object.keys(i).forEach((e) => {
          if (e.includes("properties[")) {
            var t = i[e],
              a = e.replace("properties[", "").replace("]", "");
            ((i.properties = i.properties || {}), (i.properties[a] = t));
          }
        }),
        i
      );
    }
    static sortCart(e) {
      window.Bugsnag.leaveBreadcrumb("Cart.sortCart", { sortCart: e }, "state");
      for (
        var t = e.items,
          a = t
            .map((e) => ((e.properties = e.properties || {}), e))
            .map(
              (e) =>
                ut([
                  e,
                  "access",
                  (e) => e.properties,
                  "access",
                  (e) => e.Discount,
                  "optionalAccess",
                  (e) => e.message,
                ]) || "",
            )
            .filter((e) => e),
          i = {},
          r = 0;
        r < a.length;
        r++
      ) {
        var s = a[r];
        i[s] = i[s] ? i[s] + 1 : 1;
      }
      var n = [],
        o = 0;
      for (var l of Object.entries(i)) {
        var c = _slicedToArray(l, 2),
          d = c[0],
          p = c[1];
        ((n[o] = {}), (n[o][d] = p), o++);
      }
      a = [...new Set(a)].flat();
      var u = _objectSpread({}, e),
        m = t.filter(
          (e) =>
            !a.includes(
              ut([e, "access", (e) => e.properties, "access", (e) => e.Discount, "optionalAccess", (e) => e.message]),
            ),
        ),
        h = a
          .map((e) =>
            t.filter(
              (t) =>
                ut([
                  t,
                  "access",
                  (e) => e.properties,
                  "access",
                  (e) => e.Discount,
                  "optionalAccess",
                  (e) => e.message,
                ]) === e,
            ),
          )
          .reduce((e, t) => e.concat(t), []);
      return ((u.items = h.concat(m.reverse())), { cartSorted: u, discountPromoCounts: n });
    }
    static isMembershipInCart() {
      var e = this;
      return _asyncToGenerator(function* () {
        var t = yield e.get();
        return (
          !!t.items &&
          t.items.some(
            (e) =>
              "sleepclub-membership-signup" === e.handle ||
              "annual-sleep-club-membership-sign-up" === e.handle ||
              "annual-sleep-club-membership" === e.handle ||
              "annual-sleep-club-membership-1" === e.handle,
          )
        );
      })();
    }
  }
  var ft = JSON.parse(
      (function (e) {
        for (var t = void 0, a = e[0], i = 1; i < e.length; ) {
          var r = e[i],
            s = e[i + 1];
          if (((i += 2), ("optionalAccess" === r || "optionalCall" === r) && null == a)) return;
          "access" === r || "optionalAccess" === r
            ? ((t = a), (a = s(a)))
            : ("call" !== r && "optionalCall" !== r) ||
              ((a = s(function () {
                for (var e = arguments.length, i = new Array(e), r = 0; r < e; r++) i[r] = arguments[r];
                return a.call(t, ...i);
              })),
              (t = void 0));
        }
        return a;
      })([
        document,
        "access",
        (e) => e.getElementById,
        "call",
        (e) => e("shopConfig"),
        "optionalAccess",
        (e) => e.innerHTML,
      ]) || '{"moneyFormat":"£{{amount}}"}',
    ),
    gt = ft.moneyFormat,
    vt = ft.currency;
  class _t {
    static imgURL(e, t) {
      var a = e;
      return (
        "object" == typeof e && (a = e.src),
        (a || "")
          .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, ".")
          .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function (e) {
            return "_" + t + e;
          })
      );
    }
    static handleize(e) {
      return (e || "")
        .toLowerCase()
        .replace(" m", "m")
        .replace(" y", "y")
        .replace(/[^\w\u00C0-\u024f]+/g, "-")
        .replace(/^-+|-+$/g, "");
    }
    static alternative_handleize(e) {
      return e ? (e = e.toLowerCase()).replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "") : "";
    }
    static formatMoney(e, t) {
      "string" == typeof e && (e = e.replace(".", ""));
      var a = "",
        i = /\{\{\s*(\w+)\s*\}\}/,
        r = t || gt;
      function s(e, t, a, i) {
        if (((t = t || 2), (a = a || ","), (i = i || "."), isNaN(e) || null === e)) return 0;
        var r = (e = (e / 100).toFixed(t)).split(".");
        return r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a) + (r[1] ? i + r[1] : "");
      }
      switch (r.match(i)[1]) {
        case "amount":
          a = s(e, 2);
          break;
        case "amount_no_decimals":
          a = s(e, 0);
          break;
        case "amount_with_comma_separator":
          a = s(e, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          a = s(e, 0, ".", ",");
      }
      return r.replace(i, a);
    }
    static getCurrency() {
      return vt;
    }
  }
  class yt {
    static read(e, t) {
      if (this.isLocalStorageAvailable()) return this.readFromLocalStorage(e, t);
      var a = k.readCookie(e);
      return a || t;
    }
    static write(e, t) {
      this.isLocalStorageAvailable() ? this.writeToLocalStorage(e, t) : k.createCookie(e, "" + t, 365);
    }
    static writeObject(e, t) {
      if (!this.isLocalStorageAvailable()) throw Error("localstorage unavailable");
      this.writeToLocalStorage(e, t);
    }
    static remove(e) {
      this.isLocalStorageAvailable() ? localStorage.removeItem(e) : k.expireCookie(e);
    }
    static isLocalStorageAvailable() {
      var e = !1;
      try {
        var t = "test",
          a = "key";
        localStorage.setItem(a, t);
        var i = localStorage.getItem(a);
        (localStorage.removeItem(a), (e = i === t));
      } catch (t) {
        e = !1;
      }
      return e;
    }
    static writeToLocalStorage(e, t) {
      if (!this.isLocalStorageAvailable()) throw Error("localstorage unavailable");
      localStorage.setItem(e, JSON.stringify(t));
    }
    static readFromLocalStorage(e, t) {
      if (!this.isLocalStorageAvailable()) throw Error("localstorage unavailable");
      var a = localStorage.getItem(e);
      if (!a) return t;
      try {
        return JSON.parse(a);
      } catch (e) {
        return a || t;
      }
    }
  }
  yt.remove("stored_location_city");
  var bt = [
    "AT",
    "BE",
    "BG",
    "CY",
    "CZ",
    "DE",
    "DK",
    "EE",
    "ES",
    "FI",
    "FR",
    "GR",
    "HR",
    "HU",
    "IE",
    "IT",
    "LT",
    "LU",
    "LV",
    "MT",
    "NL",
    "PL",
    "PT",
    "RO",
    "SE",
    "SI",
    "SK",
  ];
  class wt {
    static __initStatic() {
      this.STORAGE_KEY = "stored_location";
    }
    static getFallback() {
      switch (window.location.hostname) {
        case "eu.babymori.com":
          return "DE";
        case "us.babymori.com":
          return "US";
        default:
          return "GB";
      }
    }
    static normaliseCountryCode(e) {
      return e && "string" == typeof e ? e.substring(0, 2).toUpperCase() : null;
    }
    static getUserCountryCode() {
      var e = yt.read(this.STORAGE_KEY, null),
        t = this.getFallback();
      try {
        var a = window.Shopify.customerPrivacy.getRegion(),
          i = this.normaliseCountryCode(a);
        if (i) return (i !== e && yt.write(this.STORAGE_KEY, i), i);
      } catch (e) {
        window.Bugsnag.notify(
          new Error("Failed to load user location via Shopify:\n".concat(JSON.stringify(e, null, 2))),
          { severity: "info" },
        );
      }
      return e || (yt.write(this.STORAGE_KEY, t), t);
    }
    static isUK() {
      var e = new URLSearchParams(window.location.search),
        t = e.get("mori_test_market") === "GB",
        a = Boolean(
          (window.Shopify && window.Shopify.previewMode) ||
          (window.Shopify && window.Shopify.theme && window.Shopify.theme.role === "development") ||
          document.getElementById("hot-reload-client"),
        );
      return (t && a) || "GB" === this.getUserCountryCode();
    }
    static isUS() {
      return "US" === this.getUserCountryCode();
    }
    static isEU() {
      var e = this.getUserCountryCode();
      return bt.includes(e);
    }
  }
  function St(e) {
    for (var t = void 0, a = e[0], i = 1; i < e.length; ) {
      var r = e[i],
        s = e[i + 1];
      if (((i += 2), ("optionalAccess" === r || "optionalCall" === r) && null == a)) return;
      "access" === r || "optionalAccess" === r
        ? ((t = a), (a = s(a)))
        : ("call" !== r && "optionalCall" !== r) ||
          ((a = s(function () {
            for (var e = arguments.length, i = new Array(e), r = 0; r < e; r++) i[r] = arguments[r];
            return a.call(t, ...i);
          })),
          (t = void 0));
    }
    return a;
  }
  wt.__initStatic();
  class Et {
    static fromLineItem(e) {
      return {
        productTitle: e.title,
        variantImage: e.image,
        SKU: e.sku,
        variantTitle: e.variant_title,
        variantId: e.variant_id,
        variantPrice: e.price,
        variantOptionsWithValues: e.options_with_values,
      };
    }
    static fromVariant(e, t) {
      return {
        productTitle: t.title,
        variantImage:
          this.imageSrc(e.featured_image) ||
          t.featured_image ||
          this.imageSrc(St([t, "access", (e) => e.images, "optionalAccess", (e) => e[0]])),
        variantTitle: e.title,
        variantId: e.id,
        SKU: e.sku,
        variantPrice: e.price,
        variantOptionsWithValues: t.options.map((t, a) => ({ name: t, value: e["option".concat(a + 1)] })),
      };
    }
    static imageSrc(e) {
      return "string" == typeof e ? e : St([e, "optionalAccess", (e) => e.src]);
    }
  }
  class Ct {
    membershipLineItem(e, t, a) {
      return {
        id: a.subscriptionVariantId,
        quantity: 1,
        properties: this.lineItemProperties(Et.fromVariant(e, t), a),
        selling_plan: a.subscriptionId,
      };
    }
    upsellMemebership(e, t, a) {
      var i = this;
      return _asyncToGenerator(function* () {
        (yt.write("productScAddedToProperties", ""),
          yt.write("productScAddedToGiftwrapProperties", ""),
          yt.write("productScAddedToPersonalisationProperties", ""));
        var r = !1,
          s = !1,
          n = e.items.map((e) => {
            if (+t.id == +e.id && t.key === e.key)
              return (
                yt.write(
                  "productScAddedToProperties",
                  "".concat(JSON.stringify({ id: t.id, properties: t.properties })),
                ),
                t.quantity - 1
              );
            if (e.properties["Product id"] || e.properties._Product_id) {
              if (
                (t.properties["p id"] == e.properties["Product id"] ||
                  t.properties._p_id == e.properties._Product_id) &&
                !r
              )
                return (
                  yt.write(
                    "productScAddedToPersonalisationProperties",
                    "".concat(JSON.stringify({ id: e.id, properties: e.properties })),
                  ),
                  (r = !0),
                  t.quantity - 1
                );
              if (
                (t.properties["w id"] == e.properties["Product id"] ||
                  t.properties._w_id == e.properties._Product_id) &&
                !s
              )
                return (
                  yt.write(
                    "productScAddedToGiftwrapProperties",
                    "".concat(JSON.stringify({ id: e.id, properties: e.properties })),
                  ),
                  (s = !0),
                  t.quantity - 1
                );
            }
            return e.quantity;
          });
        (yield ht.update({ updates: n }),
          yield ht.add({
            items: [
              { id: a.subscriptionVariantId, quantity: 1, properties: i.lineItemProperties(Et.fromLineItem(t), a) },
            ],
          }));
      })();
    }
    removeMembership(e, t, a, i, r) {
      return _asyncToGenerator(function* () {
        try {
          var s = e.items.map((e) => (+t.id == +e.id && t.key === e.key ? t.quantity - 1 : e.quantity));
          if (
            (yield ht.update({ updates: s }),
            !t.product_title.toLowerCase().includes("sign up") ||
              !t.product_title.toLowerCase().includes("annual") ||
              !t.product_title.toLowerCase().includes("gift"))
          ) {
            var n = a ? JSON.parse(a) : {},
              o = {},
              l = parseInt(t.properties["Display variant id"]);
            n.id === l && ((o = n.properties), yt.write("productScAddedToProperties", ""));
            var c = [{ id: l, quantity: 1, properties: o }];
            if (i) {
              var d = JSON.parse(i);
              (d.properties["Product id"] !== n.properties["w id"] &&
                d.properties._Product_id !== n.properties._w_id) ||
                (yt.write("productScAddedToGiftwrapProperties", ""),
                c.push({ id: d.id, quantity: 1, properties: d.properties }));
            }
            if (r) {
              var p = JSON.parse(r);
              (p.properties["Product id"] !== n.properties["p id"] &&
                p.properties._Product_id !== n.properties._p_id) ||
                (yt.write("productScAddedToPersonalisationProperties", ""),
                c.push({ id: p.id, quantity: 1, properties: p.properties }));
            }
            c.filter((e) => e.id).length && (yield ht.add({ items: c }));
          }
          (document.body.dispatchEvent(new CustomEvent("afterRemoveItem.ajaxCart")),
            document.body.dispatchEvent(new CustomEvent("cart.updated")));
        } catch (e) {
          window.Bugsnag.notify(new Error("Failed to remove sc membership to cart:\n".concat(e)), {
            severity: "error",
          });
        }
      })();
    }
    lineItemProperties(e, t) {
      var a = this.membershipPreferencesForVariant(e);
      return {
        _Adjustment: "0",
        _Baby_birthday: d.default(a.birthday).format(),
        _Baby_name: "",
        _Colour_preferences: a.colourPreferences.join(","),
        _Display_as: "product",
        _Display_image: e.variantImage,
        _Display_title: "Monthly Sleep Club Membership",
        _Display_variant_title: e.variantTitle,
        _Display_variant_id: e.variantId,
        _Display_price: e.variantPrice,
        _First_sleepsuit_colour:
          St([this, "access", (e) => e.lineItemColourOption, "call", (t) => t(e), "optionalAccess", (e) => e.value]) ||
          "Unknown",
        _First_sleepsuit_size:
          St([this, "access", (e) => e.lineItemSizeOption, "call", (t) => t(e), "optionalAccess", (e) => e.value]) ||
          "Unknown",
        _First_sleepsuit_style: a.stylePreferences[0],
        _Style_preferences: a.stylePreferences.join(","),
        _Gender: this.getGenderPreferencesFromVariant(e),
        _Requires_additional_preferences: !0,
        _Added_on: d.default().format(),
        _charge_interval_frequency: t.chargeIntervalFrequency,
        _shipping_interval_frequency: "30",
        _shipping_interval_unit_type: "Days",
        _subscription_id: t.subscriptionId,
        _sleep_club_interaction: t.sleepClubInteraction,
        _SKU: e.SKU || "",
        _sleep_club_interaction_url: t.sleepClubInteractionUrl,
        _sleep_club_action: t.sleepClubAction,
      };
    }
    membershipPreferencesForVariant(e) {
      return {
        colourPreferences: [],
        stylePreferences: this.getStylePreferencesFromVariant(e),
        birthday: this.getApproximateBirthdayFromVariant(e),
      };
    }
    getGenderPreferencesFromVariant(e) {
      var t = this.lineItemColourOption(e);
      return this.genderPreferencesForColour(t.value);
    }
    getStylePreferencesFromVariant(e) {
      return (
        [
          { matches: ["pyjamas", "pjs", "pj"], style: ["pjs"] },
          { matches: ["front-opening", "front opening"], style: ["front_opening_sleepsuit"] },
          { matches: ["zip-up", "zip up", "zip sleep & play", "zip"], style: ["zip_up_sleepsuit"] },
        ].find((t) => t.matches.some((t) => -1 !== e.productTitle.toLowerCase().indexOf(t))) || {
          style: ["zip_up_sleepsuit"],
        }
      ).style;
    }
    getApproximateBirthdayFromVariant(e) {
      console.log("🚀 ~ SleepClubCart ~ getApproximateBirthdayFromVariant ~ variant:", e);
      var t = this.lineItemSizeOption(e),
        a = this.boundsForSize(t.value),
        i = a[1] - a[0];
      return d.default().subtract(i, "months").toDate();
    }
    lineItemSizeOption(e) {
      return e.variantOptionsWithValues.find((e) => ["size"].includes(e.name.toLowerCase())) || { value: "newborn" };
    }
    lineItemColourOption(e) {
      return (
        e.variantOptionsWithValues.find((e) => ["colour", "color"].includes(e.name.toLowerCase())) || { value: "grey" }
      );
    }
    genderPreferencesForColour(e) {
      var t = {
        "grey stripe": "neutral",
        "animal family": "neutral",
        "grey marl": "neutral",
        "teal stripe": "neutral",
        "lunar stripe": "neutral",
        "blush stripe": "neutral",
        "blue stripe": "boy",
        "grufallo dragonfly blue": "boy",
        "night sky": "neutral",
        "grufallo foxglove pink": "girl",
        space: "neutral",
        teal: "neutral",
        lunar: "neutral",
        octopus: "neutral",
        sage: "neutral",
        reef: "neutral",
        pup: "neutral",
        grey: "neutral",
        white: "neutral",
        forest: "neutral",
        stardust: "girl",
        petal: "girl",
      }[e.toLowerCase()];
      return t || "neutral";
    }
    boundsForSize(e) {
      return {
        newborn: [0, 0],
        "0-3m": [0, 3],
        "0-3 m": [0, 3],
        "0- 3 m": [0, 3],
        "0 - 3 m": [0, 3],
        "0 - 3m": [0, 3],
        "3-6m": [3, 6],
        "3-6 m": [3, 6],
        "3- 6 m": [3, 6],
        "3 - 6 m": [3, 6],
        "3 - 6m": [3, 6],
        "6-9m": [6, 9],
        "6-9 m": [6, 9],
        "6- 9 m": [6, 9],
        "6 - 9 m": [6, 9],
        "6 - 9m": [6, 9],
        "9-12m": [9, 12],
        "9-12 m": [9, 12],
        "9- 12 m": [9, 12],
        "9 - 12 m": [9, 12],
        "9 - 12m": [9, 12],
        "12-18m": [12, 18],
        "12-18 m": [12, 18],
        "12- 18 m": [12, 18],
        "12 - 18 m": [12, 18],
        "12 - 18m": [12, 18],
        "18-24m": [18, 24],
        "18-24 m": [18, 24],
        "18- 24 m": [18, 24],
        "18 - 24 m": [18, 24],
        "18 - 24m": [18, 24],
        "2-3y": [24, 36],
        "2-3 y": [24, 36],
        "2- 3 y": [24, 36],
        "2 - 3 y": [24, 36],
        "2 - 3y": [24, 36],
        "3-4y": [36, 48],
        "3-4 y": [36, 48],
        "3- 4 y": [36, 48],
        "3 - 4 y": [36, 48],
        "3 - 4y": [36, 48],
      }[e.toLowerCase()];
    }
  }
  function Pt(e) {
    for (var t = void 0, a = e[0], i = 1; i < e.length; ) {
      var r = e[i],
        s = e[i + 1];
      if (((i += 2), ("optionalAccess" === r || "optionalCall" === r) && null == a)) return;
      "access" === r || "optionalAccess" === r
        ? ((t = a), (a = s(a)))
        : ("call" !== r && "optionalCall" !== r) ||
          ((a = s(function () {
            for (var e = arguments.length, i = new Array(e), r = 0; r < e; r++) i[r] = arguments[r];
            return a.call(t, ...i);
          })),
          (t = void 0));
    }
    return a;
  }
  var At = (e) => {
    if (!e.image) return o.default.createElement(o.default.Fragment, null);
    var t = Pt([e, "access", (e) => e.widths, "optionalAccess", (e) => e.mobile]) || e.fixedWidth || 375,
      a = Pt([e, "access", (e) => e.widths, "optionalAccess", (e) => e.mobileLarger]) || e.fixedWidth || 600,
      i = Pt([e, "access", (e) => e.widths, "optionalAccess", (e) => e.tablet]) || e.fixedWidth || 1024,
      r = Pt([e, "access", (e) => e.widths, "optionalAccess", (e) => e.desktop]) || e.fixedWidth || 1200,
      s = Pt([e, "access", (e) => e.widths, "optionalAccess", (e) => e.widescreen]) || e.fixedWidth || 1920;
    return o.default.createElement(
      "picture",
      { className: e.className || "" },
      o.default.createElement("source", {
        media: "(max-width: 375px)",
        srcSet: [
          "".concat(_t.imgURL(e.image.src, "".concat(t, "x"))),
          "".concat(_t.imgURL(e.image.src, "".concat(2 * t, "x")), " 2x"),
          "".concat(_t.imgURL(e.image.src, "".concat(3 * t, "x")), " 3x"),
        ].join(","),
      }),
      o.default.createElement("source", {
        media: "(max-width: 600px)",
        srcSet: [
          "".concat(_t.imgURL(e.image.src, "".concat(a, "x"))),
          "".concat(_t.imgURL(e.image.src, "".concat(2 * a, "x")), " 2x"),
          "".concat(_t.imgURL(e.image.src, "".concat(3 * a, "x")), " 3x"),
        ].join(","),
      }),
      o.default.createElement("source", {
        media: "(max-width: 1024px)",
        srcSet: [
          "".concat(_t.imgURL(e.image.src, "".concat(i, "x"))),
          "".concat(_t.imgURL(e.image.src, "".concat(2 * i, "x")), " 2x"),
          "".concat(_t.imgURL(e.image.src, "".concat(3 * i, "x")), " 3x"),
        ].join(","),
      }),
      o.default.createElement("source", {
        media: "(max-width: 1200px)",
        srcSet: [
          "".concat(_t.imgURL(e.image.src, "".concat(r, "x"))),
          "".concat(_t.imgURL(e.image.src, "".concat(2 * r, "x")), " 2x"),
          "".concat(_t.imgURL(e.image.src, "".concat(3 * r, "x")), " 3x"),
        ].join(","),
      }),
      o.default.createElement("source", {
        media: "(min-width: 1201px)",
        srcSet: [
          "".concat(_t.imgURL(e.image.src, "".concat(s, "x"))),
          "".concat(_t.imgURL(e.image.src, "".concat(2 * s, "x")), " 2x"),
          "".concat(_t.imgURL(e.image.src, "".concat(3 * s, "x")), " 3x"),
        ].join(","),
      }),
      o.default.createElement("img", {
        className: e.className,
        src: "".concat(_t.imgURL(e.image.src, a)),
        alt: e.image.alt,
        loading: "lazy",
      }),
      e.children,
    );
  };
  At.displayName = "PictureComponent";
  class kt extends o.default.Component {
    constructor(e) {
      (super(e), (this.state = { showInfoMessage: !1 }));
    }
    render() {
      return o.default.createElement(
        "div",
        { className: "donation_wrapping ".concat(this.props.checked ? "donation_added" : "") },
        o.default.createElement(
          "div",
          { className: "monthly-once-wrapper" },
          o.default.createElement(
            "div",
            { className: "donation_checkbox" },
            o.default.createElement(
              "div",
              { className: "inner_wrapper" },
              o.default.createElement(
                "div",
                { className: "alignment_wrapper" },
                o.default.createElement("input", {
                  id: "charity_dination",
                  style: { display: "none" },
                  type: "checkbox",
                  autoComplete: "off",
                  defaultChecked: this.props.checked,
                  onClick: () => this.props.onDonationClick(!this.props.checked),
                }),
                o.default.createElement(
                  "label",
                  { className: "donation_box_clicked", htmlFor: "charity_dination" },
                  o.default.createElement(
                    "span",
                    { className: "container" },
                    o.default.createElement("span", { className: "checkmark" }),
                  ),
                ),
                o.default.createElement(
                  "label",
                  { className: "donation_text_clicked", htmlFor: "charity_dination" },
                  o.default.createElement(
                    "span",
                    { className: "donation_icon text_spacing" },
                    o.default.createElement(At, { image: { src: this.props.donation.icon } }),
                  ),
                  o.default.createElement(
                    "span",
                    { className: "icon-padding" },
                    "Donate ",
                    this.props.donation.cost,
                    " to ",
                    this.props.donation.charityName,
                  ),
                  o.default.createElement("span", { className: "donation_price" }),
                ),
              ),
              this.props.donation.infoMessage &&
                o.default.createElement(
                  "div",
                  {
                    className: "questionText",
                    onClick: () => this.setState({ showInfoMessage: !this.state.showInfoMessage }),
                  },
                  "info",
                ),
            ),
            this.state.showInfoMessage &&
              this.props.donation.infoMessage &&
              o.default.createElement("div", {
                className: "toggleText",
                dangerouslySetInnerHTML: { __html: this.props.donation.infoMessage },
              }),
          ),
        ),
      );
    }
  }
  kt.displayName = "DonationPrompt";
  var Nt = (t) => {
      var a = t.html,
        i = t.as,
        r = void 0 === i ? o.default.Fragment : i,
        s = e.useMemo(() => {
          if ("undefined" == typeof window) return [];
          var e = new DOMParser().parseFromString(a, "text/html"),
            t = ["strong", "em", "b", "i", "p", "br", "a"],
            i = { a: ["href", "target", "rel"] },
            r = (e, a) => {
              if (e.nodeType === Node.TEXT_NODE) return e.textContent;
              if (e.nodeType === Node.ELEMENT_NODE) {
                var s = e,
                  n = s.tagName.toLowerCase();
                if (!t.includes(n)) return null;
                var l = Array.from(s.childNodes).map((e, t) => r(e, t)),
                  c = { key: a };
                if (i[n])
                  for (var d of Array.from(s.attributes))
                    i[n].includes(d.name) &&
                      ("href" === d.name
                        ? ((p = d.value), /^(https:|http:|mailto:)|^\//.test(p) && (c[d.name] = d.value))
                        : (c[d.name] = d.value));
                return o.default.createElement(n, c, ...l);
              }
              var p;
              return null;
            };
          return Array.from(e.body.childNodes).map((e, t) => r(e, t));
        }, [a]);
      return o.default.createElement(r, null, s);
    },
    Tt = (e) => {
      var t = e.giftWrap,
        a = e.settings,
        i = e.onGiftWrapClick,
        r = e.isTemporaryGiftingProduct;
      if (!a.show) return null;
      var s = r ? "Includes a gift box" : a.pdp_gift_wrap_button_label,
        n = r ? "free" : _t.formatMoney(a.cost);
      return o.default.createElement(
        "div",
        { className: "giftWrapping ".concat(t.applied ? "giftwrap_added" : "", " ") },
        o.default.createElement(
          "div",
          { className: "monthly-once-wrapper" },
          o.default.createElement(
            "div",
            { className: "gift_wrap_checkbox", "data-gift-wrap": a.handle },
            o.default.createElement(
              "div",
              { className: "inner_wrapper" },
              o.default.createElement(
                "div",
                { className: "alignment_wrapper" },
                o.default.createElement("input", {
                  id: "add_gift_wrap",
                  style: { display: "none" },
                  type: "checkbox",
                  checked: t.applied,
                  disabled: r,
                  onChange: (e) => {
                    var t = e.target.checked;
                    (i(t),
                      t
                        ? P.gtmTriggerEvents("gift_wrap", "selected_gift_wrap", "add_gift_wrap_pdp")
                        : P.gtmTriggerEvents("gift_wrap", "unselected_gift_wrap", "add_gift_wrap_pdp"));
                  },
                }),
                o.default.createElement(
                  "label",
                  { className: "giftwrap_box_clicked", htmlFor: "add_gift_wrap" },
                  o.default.createElement(
                    "span",
                    { className: "container" },
                    o.default.createElement("span", { className: "checkmark" }),
                  ),
                ),
                o.default.createElement(
                  "label",
                  { className: "giftwrap_text_clicked", htmlFor: "add_gift_wrap" },
                  o.default.createElement("span", { className: "icon-padding" }, s),
                  o.default.createElement("span", { className: "gift_wrap_price" }, n),
                ),
              ),
            ),
          ),
          o.default.createElement(
            L,
            { visible: t.applied },
            o.default.createElement(
              "div",
              { className: "gift_wrap_details" },
              a.imageUrl && o.default.createElement("img", { src: a.imageUrl, alt: a.title, loading: "lazy" }),
              o.default.createElement(
                "div",
                { className: "benefit__tag", style: { width: "50%", overflow: "hidden" } },
                o.default.createElement(Nt, { html: a.copy }),
              ),
            ),
          ),
        ),
      );
    },
    Ot = {
      colour: ["colour", "color"],
      color: ["colour", "color"],
      size: ["size"],
      personalisation: ["personalisation", "personalization"],
      personalization: ["personalisation", "personalization"],
      title: ["title"],
      tog: ["tog", "togs"],
      togs: ["tog", "togs"],
    },
    xt = {
      "tiny-baby": ["one-size"],
      newborn: ["one-size"],
      "0-3m": ["0-6m", "one-size"],
      "3-6m": ["0-6m", "one-size"],
      "6-9m": ["6-12m", "one-size"],
      "9-12m": ["6-12m", "one-size"],
      "12-18m": ["12-24m", "one-size"],
      "18-24m": ["12-24m", "one-size"],
      "2-3y": ["one-size"],
      "3-4y": ["one-size"],
      "4-5y": ["one-size"],
      "5-6y": ["one-size"],
      small: ["one-size"],
      medium: ["one-size"],
      large: ["one-size"],
      "extra-large": ["one-size"],
      "one-size": ["one-size"],
    };
  class It {
    static optionNameForOption(e, t) {
      if (e.options && Ot[t.toLowerCase()]) {
        var a = e.options.findIndex((e) => Ot[t.toLowerCase()].includes(e.toLowerCase()));
        if (-1 !== a) return "option".concat(a + 1);
      }
    }
    static colourOptionName(e) {
      return It.optionNameForOption(e, "colour");
    }
    static sizeOptionName(e) {
      return It.optionNameForOption(e, "size");
    }
    static alternativeOptionName(e) {
      return It.optionNameForOption(e, "tog");
    }
    static personalisationOptionName(e) {
      return It.optionNameForOption(e, "personalisation");
    }
    static colourOptions(e) {
      var t = It.colourOptionName(e);
      if (!t) return [];
      var a = e.variants.map((e) => e[t]);
      return [...new Set(a)];
    }
    static sizeOptions(e) {
      var t = It.sizeOptionName(e);
      if (!t) return [];
      var a = e.variants.map((e) => e[t]);
      return It.sortSizeOptions([...new Set(a)]);
    }
    static optionValuesForName(e, t) {
      if (!t) return [];
      var a = e.variants.map((e) => e[t]);
      return [...new Set(a)];
    }
    static isSizeInStock(e, t, a) {
      var i = It.sizeOptionName(e),
        r = It.colourOptionName(e);
      if (!i) return !0;
      var s = _t.handleize(t);
      return e.variants
        .filter((e) => !a || _t.handleize(a) === _t.handleize(e[r]))
        .some((e) => {
          var t = _t.handleize(e[i]);
          return !![s, ...(xt[s] || [])].includes(t) && e.available;
        });
    }
    static isAlternativeSizeInStock(e, t, a, i) {
      var r = It.sizeOptionName(e),
        s = It.colourOptionName(e),
        n = It.alternativeOptionName(e);
      return (
        !!(r && s && n) &&
        e.variants.some(
          (e) =>
            _t.handleize(e[r]) === _t.handleize(t) &&
            _t.handleize(e[s]) === _t.handleize(a) &&
            _t.handleize(e[n]) === _t.handleize(i) &&
            e.available,
        )
      );
    }
    static firstAvailableVariantInSize(e, t) {
      var a = It.sizeOptionName(e),
        i = It.personalisationOptionName(e),
        r = e.variants
          .filter((e) => _t.handleize(t) === _t.handleize(e[a]))
          .filter((e) => !i || "yes" !== e[i].toLowerCase())
          .filter((e) => e.available);
      return r.length ? r[0] : null;
    }
    static firstAvailableVariantInColour(e, t) {
      var a = It.colourOptionName(e),
        i = It.personalisationOptionName(e),
        r = e.variants
          .filter((e) => _t.handleize(t) === _t.handleize(e[a]))
          .filter((e) => !i || "yes" !== e[i].toLowerCase())
          .filter((e) => e.available);
      return r.length ? r[0] : null;
    }
    static firstAvailableVariantInSizeAndColour(e, t, a) {
      var i = It.sizeOptionName(e),
        r = It.colourOptionName(e),
        s = It.personalisationOptionName(e),
        n = e.variants
          .filter((e) => _t.handleize(t) === _t.handleize(e[i]))
          .filter((e) => _t.handleize(a) === _t.handleize(e[r]))
          .filter((e) => !s || "yes" !== e[s].toLowerCase())
          .filter((e) => e.available);
      if (n.length) return n[0];
      var o = e.variants
        .filter((e) => _t.handleize(a) === _t.handleize(e[r]))
        .filter((e) => !s || "yes" !== e[s].toLowerCase());
      return o.find((e) => e.available) || o[0];
    }
    static firstAvailableVariantInSizeAndColourAndAlternateOption(e, t, a, i, r) {
      var s = It.sizeOptionName(e),
        n = It.colourOptionName(e),
        o = It.personalisationOptionName(e),
        l = e.variants
          .filter((e) => !t || _t.handleize(t) === _t.handleize(e[s]))
          .filter((e) => !a || _t.handleize(a) === _t.handleize(e[n]))
          .filter((e) => _t.handleize(i) === _t.handleize(e[r]))
          .filter((e) => !o || "yes" !== e[o].toLowerCase())
          .filter((e) => e.available);
      return l.length ? l[0] : null;
    }
    static sortSizeOptions(e) {
      var t = {};
      [
        "tinybaby",
        "tiny baby",
        "premature",
        "newborn",
        "nb",
        "0-3m",
        "0-6m",
        "0-9m",
        "3-6m",
        "6-9m",
        "6-12m",
        "6-24m",
        "9-12m",
        "12-18m",
        "12-24m",
        "18-24m",
        "24-36m",
        "9m-3y",
        "12m-3y",
        "0_3_m",
        "0_6_m",
        "0_9_m",
        "3_6_m",
        "6_9_m",
        "6_12_m",
        "6_24_m",
        "9_12_m",
        "12_18_m",
        "12_24_m",
        "18_24_m",
        "24_36_m",
        "1-2y",
        "1-2yr",
        "2-3y",
        "2-3yr",
        "2-4y",
        "2-4yr",
        "3-4y",
        "3-4yr",
        "3-5y",
        "3-5yr",
        "4-5y",
        "4-5yr",
        "5-6y",
        "5-6yr",
        "6-7y",
        "6-7yr",
        "7-8y",
        "7-8yr",
        "9-10y",
        "10-11y",
        "11-12y",
        "1_2_y",
        "1_2_yr",
        "2_3_y",
        "2_3_yr",
        "2_4_y",
        "2_4_yr",
        "3_4_y",
        "3_4_yr",
        "3_5_y",
        "3_5_yr",
        "4_5_y",
        "4_5_yr",
        "5_6_y",
        "5_6_yr",
        "6_7_y",
        "6_7_yr",
        "7_8_y",
        "7_8_yr",
        "9_10y",
        "10_11y",
        "11_12y",
        "xs",
        "s",
        "small",
        "regular",
        "m",
        "medium",
        "l",
        "large",
        "xl",
        "63x100cm",
        "75x75cm",
        "110x110cm",
        "0.5",
        "0.5tog",
        "1.5",
        "1.5tog",
        "2.5",
        "2.5tog",
      ].forEach((e, a) => (t[e.toLowerCase().replace(/\s/g, "").replace(/-/g, "")] = a));
      var a = (e) => {
        if (!e) return 999;
        e = e.toLowerCase().replace(/\s/g, "").replace(/-/g, "");
        var a = t[e];
        return (a || (a = 999), a);
      };
      return e.sort((e, t) => a(e) - a(t));
    }
  }
  function Lt(e) {
    for (var t = void 0, a = e[0], i = 1; i < e.length; ) {
      var r = e[i],
        s = e[i + 1];
      if (((i += 2), ("optionalAccess" === r || "optionalCall" === r) && null == a)) return;
      "access" === r || "optionalAccess" === r
        ? ((t = a), (a = s(a)))
        : ("call" !== r && "optionalCall" !== r) ||
          ((a = s(function () {
            for (var e = arguments.length, i = new Array(e), r = 0; r < e; r++) i[r] = arguments[r];
            return a.call(t, ...i);
          })),
          (t = void 0));
    }
    return a;
  }
  class Mt extends o.default.Component {
    constructor(e) {
      (super(e), Mt.prototype.__init.call(this), Mt.prototype.__init2.call(this));
      var t = {},
        a = Lt([this.props.productPersonalisationOptions, "optionalAccess", (e) => e.personalization_images]);
      if (a && a.length > 0) {
        var i = (e) =>
            e
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, "_")
              .replace(/(^_|_$)/g, ""),
          r = this.props.productOptions.find(
            (e) => "colour" === e.name.toLowerCase() || "color" === e.name.toLowerCase(),
          ),
          s = [];
        for (var n of Lt([r, "optionalAccess", (e) => e.values]) || [])
          (s.push(i(n)),
            s.push(n.toLowerCase()),
            s.push(n.toLowerCase().replace(/ /g, "-").trim()),
            s.push(n.toLowerCase().replace(/ /g, "").trim()));
        var o = new Set(s);
        ((s = [...o]),
          a.forEach((e) => {
            var a = "";
            if (e.alt && "" !== e.alt.trim()) a = i(e.alt);
            else {
              var r =
                  Lt([
                    e.src,
                    "access",
                    (e) => e.split,
                    "call",
                    (e) => e("/"),
                    "access",
                    (e) => e.pop,
                    "call",
                    (e) => e(),
                    "optionalAccess",
                    (e) => e.split,
                    "call",
                    (e) => e("?"),
                    "access",
                    (e) => e[0],
                  ]) || "",
                n = i(r),
                o = s.sort((e, t) => t.length - e.length).find((e) => n.includes(e));
              if (o) a = o;
              else {
                var l = r.substring(0, r.lastIndexOf(".")) || r;
                a = i(l);
              }
            }
            a && (t[a] = e);
          }));
      } else
        t = this.props.images
          .filter((e) => (e.alt || "").includes("personalisation_image"))
          .reduce(
            (e, t) => (
              t.alt
                .split(" ")
                .filter((e) => e.includes("personalisation_image_"))
                .map((e) => e.replace("personalisation_image_", ""))
                .forEach((a) => {
                  e[a] = t;
                }),
              e
            ),
            {},
          );
      var l = this.getPersonalisationImage(t);
      this.state = {
        personalisationImages: t,
        currentImage: l,
        fontSize: this.calculateFontSizes(),
        invalidCharactersEntered: !1,
      };
    }
    componentDidMount() {
      window.addEventListener("resize", this.handleWindowSizeChange);
    }
    componentWillUnmount() {
      window.removeEventListener("resize", this.handleWindowSizeChange);
    }
    __init() {
      this.handleWindowSizeChange = () => {
        this.setState({ fontSize: this.calculateFontSizes() });
      };
    }
    calculateFontSizes() {
      return window.innerWidth > 766 ? "4.1rem" : "1.8rem";
    }
    componentDidUpdate(e) {
      if (e.variant.id !== this.props.variant.id) {
        var t = this.getPersonalisationImage(this.state.personalisationImages);
        t.id !== this.state.currentImage.id && this.setState({ currentImage: t });
      }
    }
    getPersonalisationImage(e) {
      var t = It.colourOptionName(this.props.product),
        a = (this.props.variant[t] || "").toLowerCase().split(" ").join("_"),
        i = e[a] || e["personalisation_image_".concat(a)];
      return (i || (i = e[Object.keys(e)[0]]), i);
    }
    render() {
      var modal = o.default.createElement(
        "div",
        { className: "personalisation_lb mori-personalisation-overlay is_active_".concat(this.props.active) },
        this.renderFonts(),
        o.default.createElement(
          L,
          { visible: this.props.active },
          o.default.createElement(
            "div",
            { className: "personalisation_popup", id: "sign_up_lb" },
            o.default.createElement(
              "div",
              { className: "content_box" },
              o.default.createElement("span", {
                className: "close_lb close_sign_up_lb",
                onClick: () => {
                  (this.props.onCloseModalClick(), P.gtmTriggerEvents("personalisation", "close", "Personsalise_me"));
                },
              }),
              o.default.createElement("br", null),
              o.default.createElement(
                "div",
                { className: "personalisation-content" },
                this.renderPersonalisationImage(),
                this.renderPersonalisationForm(),
              ),
              o.default.createElement("br", null),
            ),
          ),
        ),
      );

      return c.default.createPortal(modal, document.body);
    }
    renderFonts() {
      return o.default.createElement("link", {
        rel: "stylesheet",
        href:
          "roboto" === this.props.personalisation.font
            ? "https://fonts.googleapis.com/css2?family=Roboto&display=swap"
            : "https://fonts.googleapis.com/css?family=Farsan&display=swap",
      });
    }
    renderPersonalisationImage() {
      var e = this.props.threads.find((e) => e.name === this.props.personalisation.thread) || this.props.threads[0],
        t = this.props.product.tags.includes("milestone_personalisation"),
        a = Lt([
          this,
          "access",
          (e) => e.props,
          "access",
          (e) => e.productPersonalisationOptions,
          "optionalAccess",
          (e) => e.personalization_position,
        ])
          ? Lt([
              this,
              "access",
              (e) => e.props,
              "access",
              (e) => e.productPersonalisationOptions,
              "optionalAccess",
              (e) => e.personalization_position,
              "access",
              (e) => e.toLowerCase,
              "call",
              (e) => e(),
            ])
          : this.props.settings.alignment;
      return o.default.createElement(
        "div",
        { className: "personalisation-image" },
        o.default.createElement(
          "div",
          { className: "personalisation_container" },
          o.default.createElement(
            "div",
            {
              className: "personalisation_image_container",
              style: { backgroundImage: "url(".concat(_t.imgURL(this.state.currentImage.src, "1024x"), ")") },
            },
            o.default.createElement(
              "div",
              { className: "personalisation_wrap" },
              o.default.createElement(
                "div",
                {
                  className: "personalisation_text ".concat(a, " ").concat(t ? "milestone_blanket_text" : ""),
                  style: {
                    fontFamily: this.props.personalisation.font,
                    fontSize: this.state.fontSize,
                    color: e.colour_code,
                    marginLeft: Lt([
                      this,
                      "access",
                      (e) => e.props,
                      "access",
                      (e) => e.productPersonalisationOptions,
                      "optionalAccess",
                      (e) => e.position_adjust_left,
                    ])
                      ? "".concat(
                          Lt([
                            this,
                            "access",
                            (e) => e.props,
                            "access",
                            (e) => e.productPersonalisationOptions,
                            "optionalAccess",
                            (e) => e.position_adjust_left,
                          ]),
                          "%",
                        )
                      : void 0,
                    marginRight: Lt([
                      this,
                      "access",
                      (e) => e.props,
                      "access",
                      (e) => e.productPersonalisationOptions,
                      "optionalAccess",
                      (e) => e.position_adjust_right,
                    ])
                      ? "".concat(
                          Lt([
                            this,
                            "access",
                            (e) => e.props,
                            "access",
                            (e) => e.productPersonalisationOptions,
                            "optionalAccess",
                            (e) => e.position_adjust_right,
                          ]),
                          "%",
                        )
                      : void 0,
                    marginTop: Lt([
                      this,
                      "access",
                      (e) => e.props,
                      "access",
                      (e) => e.productPersonalisationOptions,
                      "optionalAccess",
                      (e) => e.position_adjust_top,
                    ])
                      ? "".concat(
                          Lt([
                            this,
                            "access",
                            (e) => e.props,
                            "access",
                            (e) => e.productPersonalisationOptions,
                            "optionalAccess",
                            (e) => e.position_adjust_top,
                          ]),
                          "%",
                        )
                      : void 0,
                    marginBottom: Lt([
                      this,
                      "access",
                      (e) => e.props,
                      "access",
                      (e) => e.productPersonalisationOptions,
                      "optionalAccess",
                      (e) => e.position_adjust_bottom,
                    ])
                      ? "".concat(
                          Lt([
                            this,
                            "access",
                            (e) => e.props,
                            "access",
                            (e) => e.productPersonalisationOptions,
                            "optionalAccess",
                            (e) => e.position_adjust_bottom,
                          ]),
                          "%",
                        )
                      : void 0,
                  },
                },
                this.props.personalisation.name,
                " ",
                t && " is...",
              ),
            ),
          ),
        ),
      );
    }
    renderPersonalisationForm() {
      return o.default.createElement(
        "div",
        { className: "personalisation-text" },
        o.default.createElement(
          "div",
          null,
          o.default.createElement("h2", null, "Personalise your ", this.props.product.title),
          o.default.createElement("p", null, this.props.settings.copyDescription),
        ),
        o.default.createElement(
          "div",
          null,
          o.default.createElement("input", {
            type: "text",
            id: "personalisation_input",
            placeholder: "".concat(this.props.settings.maxLength, " characters max"),
            value: this.props.personalisation.name || "",
            maxLength: this.props.settings.maxLength,
            onChange: (e) => this.onPersonalisationTextInput(e.target.value),
          }),
          this.state.invalidCharactersEntered &&
            o.default.createElement(
              "div",
              { className: "spec_char_error" },
              "Special characters, numbers and symbols are not allowed",
            ),
        ),
        this.renderThreadSwatches(),
        o.default.createElement(
          "div",
          { className: "personalisation-buttons" },
          o.default.createElement(
            "div",
            {
              className: "btn alt",
              id: "personalisation_cancel",
              onClick: () => {
                (this.props.onPersonalisationCleared(),
                  P.gtmTriggerEvents("personalisation", "cta_click", this.props.settings.copyCancelButton));
              },
            },
            this.props.settings.copyCancelButton,
          ),
          o.default.createElement(
            "div",
            {
              className: "btn",
              id: "personalisation_save",
              onClick: () => {
                (this.props.onCloseModalClick(),
                  P.gtmTriggerEvents("personalisation", "cta_click", this.props.settings.copySaveButton));
              },
            },
            this.props.settings.copySaveButton,
          ),
        ),
        !this.props.settings.compulsory &&
          o.default.createElement(
            "p",
            { className: "disclaimer_caption" },
            Lt([
              this,
              "access",
              (e) => e.props,
              "access",
              (e) => e.settings,
              "access",
              (e) => e.copyDisclaimer,
              "optionalAccess",
              (e) => e.replace,
              "call",
              (e) => e("[price]", _t.formatMoney(this.props.settings.cost)),
            ]),
          ),
      );
    }
    renderThreadSwatches() {
      var e = this.props,
        t = e.threads,
        a = e.settings,
        i = a.availableThreads.split(",");
      return (
        a.useAllThreads || ((i = i.map((e) => e.trim())).length && (t = t.filter((e) => i.includes(e.name)))),
        o.default.createElement(
          "div",
          { className: "swatch-options-thread" },
          o.default.createElement(
            "div",
            { className: "threadswatch clearfix  thread-options", id: "thread_color" },
            o.default.createElement(
              "div",
              { className: "thread_color_text_wrapper" },
              o.default.createElement("p", { style: { marginBottom: "unset" } }, "Thread colour: "),
              o.default.createElement(
                "p",
                { className: "thread_color_name", style: { marginBottom: "unset", marginLeft: "3px" } },
                this.props.personalisation.thread,
              ),
            ),
            t.map((e, t) => this.renderThreadSwatch(e, t)),
          ),
        )
      );
    }
    renderThreadSwatch(e, t) {
      return e.name && e.colour_code
        ? o.default.createElement(
            "div",
            {
              key: t,
              style: { marginLeft: 0 === t ? "0" : "10px" },
              "data-value": e.name,
              className: "swatch-element color available thread thread-colour",
              onClick: () => this.props.onPersonalisationThreadChanged(e.name),
            },
            o.default.createElement("input", {
              id: "thread-swatch-".concat(e.name),
              "data-hex": e.colour_code,
              type: "radio",
              name: "pers-thread",
              value: e.name,
              className: "thread-choice",
              readOnly: !0,
              onClick: () => P.gtmTriggerEvents("personalisation", "thread_click", e.name),
              checked: this.props.personalisation.thread === e.name,
            }),
            o.default.createElement("label", {
              htmlFor: "thread-swatch-".concat(e.name),
              style: { background: e.colour_code },
            }),
          )
        : o.default.createElement(o.default.Fragment, null);
    }
    __init2() {
      this.onPersonalisationTextInput = (e) => {
        var t = !1,
          a = /^\s/.test(e),
          i = this.checkIfHasSpecialCharacters(e);
        (a || i ? (t = !0) : this.props.onPersonalisationNameChanged(e),
          this.setState({ invalidCharactersEntered: t }));
      };
    }
    checkIfHasSpecialCharacters(e) {
      return /(?:[^A-Za-z\s-]|[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g.test(
        e,
      );
    }
  }
  Mt.displayName = "PersonalisationLightbox";
  var zt = (e) =>
      l.createElement(
        "svg",
        _objectSpread(
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: "1.5em",
            height: "1.5em",
            fill: "none",
            viewBox: "0 0 500 500",
          },
          e,
        ),
        l.createElement("path", { d: "M0 0h500v500H0z" }),
        l.createElement("path", {
          stroke: "#99C5A4",
          strokeWidth: 13,
          d: "m382.241 43.789 75.528 74.133c9.304 9.133 9.396 24.094.204 33.339L208.188 402.499c-9.042 9.094-23.705 9.26-32.951.373l-73.017-70.185-.433-.427c-8.956-9.058-9.074-23.667-.158-32.868L348.903 44.207c9.073-9.363 24.034-9.55 33.338-.418ZM303.561 84.388 410.13 191.83",
        }),
        l.createElement("path", {
          stroke: "#99C5A4",
          strokeWidth: 13,
          d: "M95.5 309 50.587 443.294c-2.291 6.852 4.252 13.365 11.093 11.042L205.5 405.5M69 387l41.929 48.917M356.846 142.04 141.087 363.913",
        }),
      ),
    Rt = (e) =>
      l.createElement(
        "svg",
        _objectSpread(
          { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 500 500" },
          e,
        ),
        l.createElement("path", { fill: "#fff", d: "M0 0h500v500H0z" }),
        l.createElement("path", {
          stroke: "#99C5A4",
          strokeLinejoin: "round",
          strokeWidth: 12,
          d: "m217.081 210.609-11.069-41.236 157.337-42.226 22.596 84.176M259.874 154.916l-58.476 15.693-8.094-30.14c-1.822-6.794 2.207-13.77 8.991-15.592l141.992-38.105c6.794-1.822 13.77 2.206 15.592 8.99l8.094 30.14-58.788 15.775",
        }),
        l.createElement("path", {
          stroke: "#99C5A4",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 12,
          d: "M287.459 102.025c3.635-3.113 10.84-11.087 13.779-14.869 5.869-7.553 10.016-16.617 10.84-26.148.705-8.111-1.41-17.029-7.754-22.12-3.919-3.14-9.202-4.495-14.146-3.634-7.983 1.4-14.099 8.12-17.606 15.436-4.174 8.707-5.502 18.577-5.145 28.227s1.575 16.406 3.726 25.818M251.423 111.693c-5.539-.119-12.168-4.816-15.674-9.11-2.6-3.186-4.596-6.958-5.173-11.032s.375-8.45 3.058-11.573c3.378-3.936 9.11-5.356 14.191-4.33 5.081 1.034 9.531 4.23 12.927 8.14 5.128 5.895 8.167 13.577 8.451 21.386l33.619 103.833",
        }),
        l.createElement("path", {
          stroke: "#99C5A4",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 17.395,
          d: "M60 161.16h68.236l58.65 184.337a15.25 15.25 0 0 0 14.53 10.62h174.879a17.94 17.94 0 0 0 16.361-10.565l48.029-136.545H190.896",
        }),
        l.createElement("path", {
          stroke: "#99C5A4",
          strokeLinejoin: "round",
          strokeWidth: 17.395,
          d: "M214.197 465.305c20.064 0 36.329-16.265 36.329-36.329s-16.265-36.329-36.329-36.329-36.329 16.265-36.329 36.329 16.265 36.329 36.329 36.329ZM368.137 465.305c20.064 0 36.329-16.265 36.329-36.329s-16.265-36.329-36.329-36.329-36.329 16.265-36.329 36.329 16.265 36.329 36.329 36.329Z",
        }),
      );
  class Dt extends o.default.Component {
    render() {
      return this.props.personalisation.applied
        ? this.renderPersonalisationResult()
        : this.renderPersonalisationButton();
    }
    renderPersonalisationResult() {
      return o.default.createElement(
        "div",
        { className: "personalisation-result-wrapper personalisation_added sc-incompatible-content" },
        o.default.createElement(
          "div",
          { className: "personalisation_checkbox", onClick: () => this.props.onPersonaliseClick() },
          o.default.createElement(
            "label",
            { className: "container" },
            o.default.createElement("input", {
              id: "add_personalisation",
              type: "checkbox",
              readOnly: !0,
              checked: !0,
            }),
            o.default.createElement("span", { className: "checkmark" }),
          ),
          o.default.createElement(
            "label",
            { className: "checkbox-label", id: "personalsiation-cb" },
            o.default.createElement("span", { className: "personalise_text icon-padding" }, "Personalised "),
            !this.props.settings.compulsory &&
              o.default.createElement("span", null, _t.formatMoney(this.props.settings.cost)),
            this.props.settings.compulsory && o.default.createElement("span", null, "free"),
          ),
        ),
        o.default.createElement(
          "div",
          { className: "personalisation-result", onClick: () => this.props.onPersonaliseClick() },
          o.default.createElement(
            "div",
            { className: "btn hollow small", id: "change-personalisation", style: { cursor: "pointer" } },
            o.default.createElement(
              "div",
              { className: "personalisation_text_wrapper" },
              o.default.createElement(
                "div",
                { className: "thread-result" },
                o.default.createElement("p", null, "Thread:"),
                o.default.createElement("p", { id: "personalisation-result-color" }, this.props.personalisation.thread),
              ),
              o.default.createElement(
                "div",
                { className: "personalisation_name" },
                o.default.createElement("p", null, "Name:"),
                o.default.createElement("p", { id: "personalisation-result" }, this.props.personalisation.name),
              ),
            ),
            o.default.createElement(zt, null),
          ),
        ),
      );
    }
    renderPersonalisationButton() {
      return o.default.createElement(
        "div",
        { className: "personalisation-result-wrapper sc-incompatible-content" },
        o.default.createElement(
          "div",
          {
            className: "personalisation_checkbox",
            onClick: (e) => {
              (e.preventDefault(),
                this.props.onPersonaliseClick(),
                P.gtmTriggerEvents("personalisation", "selected_personalisation", "Personsalise_me"));
            },
          },
          o.default.createElement(
            "label",
            { className: "container" },
            o.default.createElement("input", {
              id: "add_personalisation",
              type: "checkbox",
              readOnly: !0,
              checked: !1,
            }),
            o.default.createElement("span", { className: "checkmark" }),
          ),
          o.default.createElement(
            "label",
            { className: "checkbox-label", id: "personalsiation-cb" },
            o.default.createElement("span", { className: "personalise_text icon-padding" }, "Personalise me "),
            !this.props.settings.compulsory &&
              o.default.createElement("span", null, _t.formatMoney(this.props.settings.cost)),
            this.props.settings.compulsory &&
              o.default.createElement(
                "span",
                { className: "compulsory_personalise-price", "aria-label": "FREE" },
                "free",
              ),
          ),
        ),
      );
    }
  }
  Dt.displayName = "PersonalisationPrompt";
  var Bt = (function (e) {
      for (var t = void 0, a = e[0], i = 1; i < e.length; ) {
        var r = e[i],
          s = e[i + 1];
        if (((i += 2), ("optionalAccess" === r || "optionalCall" === r) && null == a)) return;
        "access" === r || "optionalAccess" === r
          ? ((t = a), (a = s(a)))
          : ("call" !== r && "optionalCall" !== r) ||
            ((a = s(function () {
              for (var e = arguments.length, i = new Array(e), r = 0; r < e; r++) i[r] = arguments[r];
              return a.call(t, ...i);
            })),
            (t = void 0));
      }
      return a;
    })([window, "access", (e) => e.mori, "optionalAccess", (e) => e.sleepClub, "access", (e) => e.products]),
    Vt = (t) => {
      var a = yt.read("stored_location", null),
        i = !!t.isPreselectActive && t.isPreselectActive,
        r = t.shouldMembershipBePreSelected && "GB" === a && i;
      e.useEffect(
        () => (
          r &&
            window.dispatchEvent(
              new CustomEvent("pricing.change", {
                detail: { price: window.mori.sleepClub.products.monthly.cost, compareAtPrice: 0 },
              }),
            ),
          () => {}
        ),
        [],
      );
      var s = Math.min(Bt.annual.cost / 12, Bt.monthly.cost);
      return o.default.createElement(
        o.default.Fragment,
        null,
        o.default.createElement(
          "div",
          { className: "monthly_once_wrapper", id: "sleepclub_upsell_panel_new" },
          o.default.createElement(Ft, {
            selected: !t.settings.applied,
            onSelected: () => t.onMembershipSelected(!1),
            position: "left",
            text: "Buy once",
            subtext: _t.formatMoney(t.settings.variantCost),
          }),
          o.default.createElement(Ft, {
            selected: t.settings.applied,
            onSelected: () => t.onMembershipSelected(!0),
            position: "right",
            text: "Buy with membership",
            subtext: "From ".concat(_t.formatMoney(s), "/pm"),
            isSCMemberInCart: t.isSCMemberInCart,
          }),
        ),
      );
    },
    Ft = (e) => {
      var t = e.selected ? "#99C5A4" : "#e5e6e6",
        a = e.isSCMemberInCart,
        i = "0";
      switch (e.position) {
        case "left":
          i = "6px 0 0 6px";
          break;
        case "center":
          i = "0";
          break;
        case "right":
          i = "0 6px 6px 0";
      }
      return o.default.createElement(
        "div",
        {
          style: {
            borderRadius: i,
            borderTop: "2px solid ".concat(t),
            borderRight: "right" == e.position ? "2px solid ".concat(t) : "1px solid #94b7bb",
            borderBottom: "2px solid ".concat(t),
            borderLeft: "left" == e.position ? "2px solid ".concat(t) : "1px solid #94b7bb",
            width: "100%",
            position: "relative",
          },
        },
        o.default.createElement(
          "div",
          {
            className: "monthly ".concat(a ? "buy_disabled" : ""),
            onClick: (t) => {
              a
                ? t.preventDefault()
                : (e.onSelected(), t.preventDefault(), P.gtmTriggerEvents("sleep_club_upsell", "selected", e.text));
            },
          },
          o.default.createElement(
            "label",
            { htmlFor: "monthlyRadioBtn-".concat(e.text.replaceAll(" ", "-")) },
            o.default.createElement(
              "div",
              { className: "inputBtns ".concat(e.selected ? "betterRadioBtns" : "") },
              o.default.createElement(
                "div",
                { className: "checkMark_wrapper" },
                o.default.createElement("div", { className: "".concat(e.selected ? "checkMark" : "") }),
              ),
            ),
            o.default.createElement("input", {
              id: "monthlyRadioBtn-".concat(e.text.replaceAll(" ", "-")),
              name: "memberships",
              type: "radio",
              defaultChecked: e.selected,
            }),
            a
              ? o.default.createElement("strong", { className: "buy_disabled_text" }, "Membership added to your bag")
              : o.default.createElement(
                  o.default.Fragment,
                  null,
                  e.text,
                  !e.selected && o.default.createElement("b", null, e.subtext),
                  e.selected && o.default.createElement("b", null, e.subtext),
                ),
          ),
        ),
      );
    };
  function Ut(e) {
    for (var t = void 0, a = e[0], i = 1; i < e.length; ) {
      var r = e[i],
        s = e[i + 1];
      if (((i += 2), ("optionalAccess" === r || "optionalCall" === r) && null == a)) return;
      "access" === r || "optionalAccess" === r
        ? ((t = a), (a = s(a)))
        : ("call" !== r && "optionalCall" !== r) ||
          ((a = s(function () {
            for (var e = arguments.length, i = new Array(e), r = 0; r < e; r++) i[r] = arguments[r];
            return a.call(t, ...i);
          })),
          (t = void 0));
    }
    return a;
  }
  ((Vt.displayName = "ProductSleepClubUpsell"), (Ft.displayName = "PurchaseOptionBox"));
  var Wt = (e) => {
    var t = window.mori.state.buy_x_tags_discounts;
    if (!t || 0 === t.length) return { message: e, url: "" };
    var a = _t.handleize(e);
    return {
      message: e,
      url:
        Ut([
          t.find((e) => {
            var t = e.tag,
              i = t.indexOf(":");
            return (-1 !== i && (t = t.substring(i + 1).trim()), a === _t.handleize(t));
          }),
          "optionalAccess",
          (e) => e.url,
        ]) || "#",
    };
  };
  function jt(e) {
    return { "babymori.com": "GB", "us.babymori.com": "US", "eu.babymori.com": "IE" }[e];
  }
  function qt(e, t, a, i, r, s, n) {
    ((s.gender = e), (n.parent_to_be = t), (n.parent = a), (n.gifter = i), (n.grandparent = r));
  }
  -1 === window.location.href.indexOf("us.babymori.com") && window.location.href.indexOf("babymoriusa");
  class Gt {
    static submitToOmetria(e, t, a) {
      ("function" == typeof window.ometria.identify && window.ometria.identify(e),
        Gt.subscribe(_objectSpread({ email: e, timestamp_subscribed: Gt.getCurrentUTCDateTime() }, t), a));
    }
    static submitToKlaviyo(e, t, a) {
      Gt.subscribeKlaviyo(_objectSpread({ email: e, timestamp_subscribed: Gt.getCurrentUTCDateTime() }, t), a);
    }
    static subscribeToOmetriaList(e, t, a, i, r) {
      var s;
      (console.log("submitObject", JSON.stringify(i)),
        i
          ? ((s = i),
            "function" == typeof window.ometria.identify && window.ometria.identify(s.email),
            (i.timestamp_subscribed = Gt.getCurrentUTCDateTime()))
          : ((document.querySelector(".om-form-date-subscribed").value = Gt.getCurrentUTCDateTime()),
            (s = Gt.serializeOmetriaObject(a, document.getElementById(e))),
            console.log("OBJ AFTER", s),
            "function" == typeof window.ometria.identify && window.ometria.identify(s.email)));
      var n = r || !1;
      Gt.subscribe(s, t, n);
    }
    static subscribe(e, t, a) {
      (e.list || (e.list = "10"),
        ((e) =>
          new Promise((t, a) => {
            ((e.country_id = jt(window.location.hostname)),
              !e.properties.signup_source ||
                (-1 === window.location.href.indexOf("us.babymori.com") &&
                  -1 === window.location.href.indexOf("minimori.com") &&
                  -1 === window.location.href.indexOf("babymoriusa")) ||
                (console.log("setting", e),
                e.properties.signup_source.startsWith("us: ") ||
                  (e.properties.signup_source = "us: ".concat(e.properties.signup_source))));
            var i = new XMLHttpRequest();
            (i.open(
              "POST",
              "https://i0t3ym2636.execute-api.eu-west-2.amazonaws.com/Testing/mailing-lists/subscribe",
              !0,
            ),
              i.setRequestHeader("Content-Type", "application/json; charset=utf-8"),
              (i.onload = (e) => t(e)),
              (i.onerror = (e) => (
                console.log("subscribing"),
                window.Bugsnag.notify(
                  new Error("Failed to subscribe to Ometria:\n".concat(JSON.stringify(e, null, 2))),
                  { severity: "error" },
                ),
                console.log("ERROR: ", e),
                a(e)
              )),
              i.send(JSON.stringify(e)));
          }))(e)
          .then((i) => {
            "ERROR" === i.status
              ? t("error")
              : (a ? k.createCookie(a, "true", 1e3) : k.createCookie("hasSubscribed", "true", 1e3),
                P.logEvent("newsletterSignup", { adwords_email_signup: e.email }),
                t(null));
          })
          .catch(() => {
            t("error");
          }));
    }
    static subscribeKlaviyo(e, t, a) {
      ((e) =>
        new Promise((t, a) => {
          ((e.country_id = jt(window.location.hostname)),
            !e.properties.signup_source ||
              (-1 === window.location.href.indexOf("us.babymori.com") &&
                -1 === window.location.href.indexOf("minimori.com") &&
                -1 === window.location.href.indexOf("babymoriusa")) ||
              (console.log("setting", e),
              e.properties.signup_source.startsWith("us: ") ||
                (e.properties.signup_source = "us: ".concat(e.properties.signup_source))));
          var i = new XMLHttpRequest();
          (i.open("POST", "https://i0t3ym2636.execute-api.eu-west-2.amazonaws.com/Testing/mailing-lists/subscribe", !0),
            i.setRequestHeader("Content-Type", "application/json; charset=utf-8"),
            (i.onload = (e) => (console.log("RES:", e), t(e))),
            (i.onerror = (e) => (
              window.Bugsnag.notify(new Error("Failed to subscribe to Ometria:\n".concat(JSON.stringify(e, null, 2))), {
                severity: "error",
              }),
              console.log("ERROR: ", e),
              a(e)
            )),
            (e.for_klaviyo = !0),
            (e.klaviyo_data = {
              data: {
                type: "profile",
                attributes: { email: e.email, klaviyoList: e.klaviyoList, properties: e.properties },
              },
            }),
            i.send(JSON.stringify(e)));
        }))(e)
        .then((i) => {
          "ERROR" === i.status
            ? t("error")
            : (a ? k.createCookie(a, "true", 1e3) : k.createCookie("hasSubscribed", "true", 1e3),
              P.logEvent("newsletterSignup", { adwords_email_signup: e.email }),
              t(null));
        })
        .catch(() => {
          t("error");
        });
    }
    static getCurrentUTCDateTime() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
        t = e ? new Date(e) : new Date(),
        a = t.getUTCDate(),
        i = t.getUTCMonth() + 1;
      return (
        t.getFullYear() +
        "-" +
        i +
        "-" +
        a +
        "T" +
        t.getUTCHours() +
        ":" +
        t.getUTCMinutes() +
        ":" +
        t.getUTCSeconds() +
        "+00"
      );
    }
    static serializeOmetriaObject(e, t) {
      var a = {
          accepts_marketing: "",
          collection: "",
          dm_first_party_opt_out: "",
          dm_third_party_opt_out: "",
          email: "",
          form_first_party_opt_out: "",
          list: "",
          marketing_optin: "",
          timestamp_subscribed: "",
          properties: {},
        },
        i = {},
        r = {};
      (function (e) {
        var t,
          a,
          i = [];
        if ("object" == typeof e && "FORM" == e.nodeName)
          for (var r = e.elements.length, s = 0; s < r; s++)
            if (
              (t = e.elements[s]).name &&
              !t.disabled &&
              "file" != t.type &&
              "reset" != t.type &&
              "submit" != t.type &&
              "button" != t.type
            )
              if ("select-multiple" == t.type)
                for (a = e.elements[s].options.length, j = 0; j < a; j++)
                  t.options[j].selected && (i[i.length] = { name: t.name, value: t.options[j].value });
              else
                (("checkbox" != t.type && "radio" != t.type) || t.checked) &&
                  (i[i.length] = { name: t.name, value: t.value });
        return i;
      })(t).forEach((e) => {
        i[e.name]
          ? (i[e.name].push || (i[e.name].push = [i[e.name]]), i[e.name].push(e.value || ""))
          : (i[e.name] = e.value || "");
      });
      var s = [
        "list",
        "collection",
        "source",
        "email",
        "firstname",
        "lastname",
        "country_id",
        "date_of_birth",
        "gender",
        "timestamp_subscribed",
        "accepts_marketing",
        "form_first_party_opt_out",
        "dm_first_party_opt_out",
        "dm_third_party_opt_out",
      ];
      if (e)
        switch (e) {
          case "parent":
            !(function (e, t, a) {
              a.parent = e;
            })(1, 0, r);
            break;
          case "gifter":
            !(function (e, t, a) {
              a.gifter = e;
            })(1, 0, r);
        }
      for (var n in i) {
        if ("lifestage" === n)
          switch (i[n]) {
            case "Mum":
            case "Mom":
              qt("f", 0, 1, 0, 0, a, r);
              break;
            case "Dad":
              qt("m", 0, 1, 0, 0, a, r);
              break;
            case "Mum to be":
            case "Mom to be":
              qt("f", 1, 0, 0, 0, a, r);
              break;
            case "Dad to be":
              qt("m", 1, 0, 0, 0, a, r);
              break;
            case "Gifter":
              qt("u", 0, 0, 1, 0, a, r);
              break;
            case "Grandmother":
              qt("f", 0, 0, 0, 1, a, r);
              break;
            case "Grandfather":
              qt("m", 0, 0, 0, 1, a, r);
          }
        s.indexOf(n) > -1 ? (a[n] = i[n]) : (r[n] = i[n]);
      }
      return (
        "No" !== a.accepts_marketing && a.accepts_marketing
          ? (a.marketing_optin = "EXPLICITLY_OPTEDIN")
          : (a.marketing_optin = "EXPLICITLY_OPTEDOUT"),
        (a.properties = r),
        a
      );
    }
    static addToCartEvent() {
      return _asyncToGenerator(function* () {
        try {
          if (!window.mori.state.isB2B) {
            var e = yield ht.get();
            if (e.items.length) {
              var t = new window.ometria.Basket();
              t.setId(e.token);
              var a = "".concat(window.location.origin, "/cart/");
              (t.setTotal((e.total_price / 100).toFixed(2), e.currency),
                e.items.forEach((e) => {
                  (t.addLineItem(e.product_id, e.quantity, (e.price / 100).toFixed(2), e.variant_id),
                    (a += ",".concat(e.variant_id, ":").concat(e.quantity)));
                }),
                t.setUrl(a.replace("/,", "/")),
                window.ometria.setBasket(t));
            }
          }
        } catch (e) {
          console.log("noooo....", e);
        }
      })();
    }
  }
  ((window.isValidEmail = class {
    static validEmail(e) {
      var t = !1;
      return (/^\w+([.+-]?\w+)*@\w+([.+-]?\w+)*(\.\w{2,6})+$/.test(e) && (t = !0), t);
    }
  }.validEmail),
    (window.getCurrentUTCDateTime = Gt.getCurrentUTCDateTime),
    (window.subscribeToOmetriaList = Gt.subscribeToOmetriaList),
    (window.serializeOmetriaObject = Gt.serializeOmetriaObject));
  class Ht extends e.Component {
    render() {
      return o.default.createElement(
        "span",
        { className: "money", style: this.props.style },
        _t.formatMoney(this.props.value),
      );
    }
  }
  Ht.displayName = "MoneySpan";
  class Yt extends o.default.Component {
    constructor(e) {
      super(e);
    }
    render() {
      return o.default.createElement(
        "div",
        {
          className: "gift gift_wrap_checkbox_wrapper" + (this.props.isChecked ? " giftwrap_all_border" : ""),
          style: { display: this.props.isHidden ? "none" : "" },
        },
        o.default.createElement(
          "div",
          { className: "gift_wrap_checkbox" },
          o.default.createElement("input", {
            type: "checkbox",
            id: "gift_wrap_all",
            style: { display: "none" },
            checked: this.props.isChecked,
            onChange: (e) => this.props.onChange(e),
          }),
          o.default.createElement(
            "label",
            { className: "checkmark_wrapper", htmlFor: "gift_wrap_all" },
            o.default.createElement(
              "span",
              { className: "inner_wrapper" },
              o.default.createElement("span", { className: "checkmark" }),
            ),
          ),
          o.default.createElement(
            "label",
            { className: "gift_wrap_all_label", htmlFor: "gift_wrap_all" },
            o.default.createElement(Rt, { className: "svg--icon-add-ons gift_wrap" }),
            o.default.createElement(
              "span",
              { className: "giftwrap_all_text" },
              " ",
              this.props.settings.pdp_gift_wrap_all_title,
              " ",
            ),
            o.default.createElement(Ht, { value: this.props.product.variants[0].price }),
          ),
        ),
      );
    }
  }
  Yt.displayName = "GiftWrapEntireOrderCheckbox";
  var Xt = ["mori-starter-set", "supreme-set", "starter-set", "mori-newborn-baby-starter-essentials-set"],
    Qt = "variant",
    Jt = "personalisation",
    Kt = "thread",
    $t = (t) => {
      var a = yt.read("stored_location", null),
        i = !!t.isPreselectActive && t.isPreselectActive,
        r = t.shouldMembershipBePreSelected && "GB" === a && i;
      return (
        e.useEffect(
          () => (
            r &&
              window.dispatchEvent(
                new CustomEvent("pricing.change", {
                  detail: { price: window.mori.sleepClub.products.monthly.cost, compareAtPrice: 0 },
                }),
              ),
            () => {}
          ),
          [],
        ),
        o.default.createElement(
          o.default.Fragment,
          null,
          o.default.createElement(
            "div",
            { className: "monthly_once_wrapper", id: "sleepclub_upsell_panel_old" },
            o.default.createElement(Zt, {
              selected: !t.settings.applied,
              onSelected: () => t.onMembershipSelected(!1),
              position: "left",
              text: "Buy once",
              subtext: _t.formatMoney(t.settings.variantCost),
            }),
            o.default.createElement(Zt, {
              selected: t.settings.applied,
              onSelected: () => t.onMembershipSelected(!0),
              position: "right",
              text: "Membership",
              subtext: "".concat(_t.formatMoney(t.settings.membershipCost), "/month"),
            }),
          ),
          o.default.createElement(
            "div",
            { className: "membership-wrapper" },
            o.default.createElement(
              "div",
              { className: "membership" },
              o.default.createElement(
                "div",
                { className: "membership-content" },
                o.default.createElement(
                  "p",
                  null,
                  "Skip or cancel membership anytime,",
                  o.default.createElement("br", null),
                  "learn more about Sleep Club ",
                  o.default.createElement(
                    "span",
                    {
                      className: "membershipPopup",
                      onClick: () => {
                        (P.logEvent("pdp_sleepclub_here_click", { pdp_sleepclub_here_click_url: window.location.href }),
                          P.logDynamicEvent({ eventParameterName: "sc_learn_more_text", eventParameterValue: "here" }),
                          document.body.dispatchEvent(new CustomEvent("sleepclub.open.popup")));
                      },
                    },
                    "here",
                  ),
                ),
              ),
            ),
          ),
        )
      );
    },
    Zt = (e) => {
      var t = e.selected ? "#99C5A4" : "#e5e6e6",
        a = "0";
      switch (e.position) {
        case "left":
          a = "6px 0 0 6px";
          break;
        case "center":
          a = "0";
          break;
        case "right":
          a = "0 6px 6px 0";
      }
      return o.default.createElement(
        "div",
        {
          style: {
            borderRadius: a,
            borderTop: "2px solid ".concat(t),
            borderRight: "right" == e.position ? "2px solid ".concat(t) : "1px solid #94b7bb",
            borderBottom: "2px solid ".concat(t),
            borderLeft: "left" == e.position ? "2px solid ".concat(t) : "1px solid #94b7bb",
            width: "100%",
            position: "relative",
          },
        },
        o.default.createElement(
          "div",
          {
            className: "monthly",
            onClick: (t) => {
              (e.onSelected(), t.preventDefault(), P.gtmTriggerEvents("sleep_club_upsell", "selected", e.text));
            },
          },
          o.default.createElement(
            "label",
            { htmlFor: "monthlyRadioBtn" },
            o.default.createElement(
              "div",
              { className: "inputBtns ".concat(e.selected ? "betterRadioBtns" : "") },
              o.default.createElement(
                "div",
                { className: "checkMark_wrapper" },
                o.default.createElement("div", { className: "checkMark" }),
              ),
            ),
            o.default.createElement("input", {
              id: "monthlyRadioBtn",
              name: "memberships",
              type: "radio",
              defaultChecked: e.selected,
            }),
            e.text,
            !e.selected && o.default.createElement("span", null, e.subtext),
            e.selected && o.default.createElement("b", null, e.subtext),
          ),
        ),
      );
    };
  (($t.displayName = "ProductSleepClubUpsellTestCopy"), (Zt.displayName = "PurchaseOptionBox"));
  var ea = window.mori.sleepClub.products,
    ta = [
      {
        id: "annual",
        text: "Annual",
        subtext: "".concat(_t.formatMoney(ea.annual.cost / 12), " / month"),
        details: "".concat(_t.formatMoney(ea.annual.cost), " billed annually"),
      },
      {
        id: "monthly",
        text: "Monthly",
        subtext: "".concat(_t.formatMoney(ea.monthly.cost), " / month"),
        details: "pause or cancel anytime.",
      },
    ],
    aa = (t) => {
      var a = t.selectedPlanId,
        i = t.onPlanSelected,
        r = t.settings,
        s = { annual: e.useRef(null), monthly: e.useRef(null) };
      e.useEffect(() => {
        !(function (e) {
          for (var t = void 0, a = e[0], i = 1; i < e.length; ) {
            var r = e[i],
              s = e[i + 1];
            if (((i += 2), ("optionalAccess" === r || "optionalCall" === r) && null == a)) return;
            "access" === r || "optionalAccess" === r
              ? ((t = a), (a = s(a)))
              : ("call" !== r && "optionalCall" !== r) ||
                ((a = s(function () {
                  for (var e = arguments.length, i = new Array(e), r = 0; r < e; r++) i[r] = arguments[r];
                  return a.call(t, ...i);
                })),
                (t = void 0));
          }
        })([
          s,
          "access",
          (e) => e[a],
          "optionalAccess",
          (e) => e.current,
          "optionalAccess",
          (e) => e.focus,
          "call",
          (e) => e(),
        ]);
      }, [a]);
      return o.default.createElement(
        "div",
        { className: "scMembershipPlanSelector" },
        o.default.createElement(
          "div",
          { className: "monthly_once_wrapper", role: "radiogroup", "aria-label": "Membership plan" },
          o.default.createElement("span", { className: "plan-subheading" }, "choose your membership plan:"),
          ta.map((e, t) =>
            o.default.createElement(
              o.default.Fragment,
              { key: e.id },
              t > 0 &&
                o.default.createElement(
                  "div",
                  { className: "option-divider" },
                  o.default.createElement("span", null, "OR"),
                ),
              o.default.createElement(
                "div",
                {
                  ref: s[e.id],
                  className: "scMembershipPlanOption ".concat(e.id === a ? "is-selected" : ""),
                  style: { color: "".concat(e.id === a ? "var(--brand-green)" : "") },
                  onClick: () => i(e.id),
                  role: "radio",
                  "aria-checked": e.id === a,
                  tabIndex: e.id === a ? 0 : -1,
                  onKeyDown: (t) =>
                    ((e, t) => {
                      if (" " === e.key || "Enter" === e.key) return (e.preventDefault(), void i(t));
                      var a = ta.findIndex((e) => e.id === t),
                        r = -1;
                      if (
                        ("ArrowDown" === e.key || "ArrowRight" === e.key
                          ? (e.preventDefault(), (r = (a + 1) % ta.length))
                          : ("ArrowUp" !== e.key && "ArrowLeft" !== e.key) ||
                            (e.preventDefault(), (r = (a - 1 + ta.length) % ta.length)),
                        -1 !== r)
                      ) {
                        var s = ta[r];
                        i(s.id);
                      }
                    })(t, e.id),
                },
                o.default.createElement("span", { className: "plan-text" }, e.text),
                o.default.createElement("span", { className: "plan-subtext" }, e.subtext),
                o.default.createElement(
                  "div",
                  { className: "scMembershipPlanDetails" },
                  o.default.createElement("p", null, e.details),
                ),
              ),
            ),
          ),
        ),
        o.default.createElement(
          "div",
          { className: "perks_wrapper" },
          o.default.createElement("div", { className: "title_text" }, r.scMembershipHeading),
          o.default.createElement(
            "div",
            { className: "perks_inner_wrapper" },
            o.default.createElement(
              "div",
              { className: "perks" },
              o.default.createElement(Nt, { html: r.scMembershipPerks }),
            ),
          ),
        ),
      );
    };
  aa.displayName = "MembershipOptions";
  class ia extends o.default.Component {
    render() {
      var e = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif",
        t = "no-image",
        a = this.props.href ? this.props.href : "",
        i = this.props.classToAdd ? this.props.classToAdd : "";
      return (
        this.props.image_url &&
          ((e = this.props.image_url.replace(/(\.[^.]*)$/, "_small$1").replace("http:", "")),
          (t = this.props.image_alt)),
        this.props.customSettings.customProductImageUrl && (e = this.props.customSettings.customProductImageUrl),
        this.props.customSettings.customProductUrl && (a = this.props.customSettings.customProductUrl),
        o.default.createElement(
          o.default.Fragment,
          null,
          a
            ? o.default.createElement(
                "a",
                { href: a, className: i },
                o.default.createElement("img", { src: e, alt: t }),
              )
            : o.default.createElement("img", { className: i, src: e, alt: t }),
        )
      );
    }
  }
  function ra(e) {
    for (var t = void 0, a = e[0], i = 1; i < e.length; ) {
      var r = e[i],
        s = e[i + 1];
      if (((i += 2), ("optionalAccess" === r || "optionalCall" === r) && null == a)) return;
      "access" === r || "optionalAccess" === r
        ? ((t = a), (a = s(a)))
        : ("call" !== r && "optionalCall" !== r) ||
          ((a = s(function () {
            for (var e = arguments.length, i = new Array(e), r = 0; r < e; r++) i[r] = arguments[r];
            return a.call(t, ...i);
          })),
          (t = void 0));
    }
    return a;
  }
  ia.displayName = "ThumbnailImage";
  function validateMoriSleepClubPurchase(variant) {
    if (!variant || variant.available !== true) return false;

    var host = document.querySelector("[data-mori-sleepclub-cta-host]"),
      section = host ? host.closest(".mori-product-section") : null;

    return !section || typeof section.moriValidateDropdownSelection !== "function"
      || section.moriValidateDropdownSelection();
  }

  var sa = (t) => {
    var a = t.isOpen,
      i = t.onClose,
      r = t.product,
      s = t.variant,
      n = t.settings,
      l = ra([r, "access", (e) => e.images, "optionalAccess", (e) => e[0]]),
      c = "string" == typeof l ? l : ra([l, "optionalAccess", (e) => e.src]),
      d = ra([s, "access", (e) => e.featured_image, "optionalAccess", (e) => e.src]) || r.featured_image || c,
      p = e.useRef(null),
      u = e.useRef(null),
      m = _slicedToArray(e.useState("annual"), 2),
      h = m[0],
      f = m[1],
      g = _slicedToArray(e.useState(!1), 2),
      v = g[0],
      _ = g[1],
      y = _slicedToArray(e.useState(a), 2),
      b = y[0],
      w = y[1];
    (e.useEffect(() => {
      if (a) {
        if (((u.current = document.activeElement), document.body.classList.add("no-scroll-drawer"), p.current)) {
          var e = p.current.querySelector(
            'button:not(.icon-fallback-text), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
          );
          ((t = e), (i = () => p.current), null != t ? t : i()).focus();
        }
      } else
        (document.body.classList.remove("no-scroll-drawer"),
          ra([u, "access", (e) => e.current, "optionalAccess", (e) => e.focus, "call", (e) => e()]));
      var t, i;
    }, [a]),
      e.useEffect(() => {
        var e = (e) => {
          "Escape" === e.key && a && i();
        };
        if (a)
          return (
            document.addEventListener("keydown", e),
            () => {
              document.removeEventListener("keydown", e);
            }
          );
      }, [a, i]),
      e.useEffect(() => {
        a && w(!0);
      }, [a]));
    var S = (function () {
      var e = _asyncToGenerator(function* () {
        if (!validateMoriSleepClubPurchase(s)) {
          i();
          return;
        }
        _(!0);
        try {
          var e = window.mori.sleepClub.products[h],
            t = "monthly" === h ? "30" : "360",
            a = { monthly: "710782550403", annual: "710782681475" }[h],
            n = new Ct().membershipLineItem(s, r, {
              subscriptionId: +a,
              subscriptionVariantId: e.variantId,
              sleepClubInteraction: "product-page-drawer",
              sleepClubInteractionUrl: window.location.pathname + window.location.search,
              sleepClubAction: "buy",
              chargeIntervalFrequency: t,
            }),
            o = _objectSpread(_objectSpread({}, n), {}, { selling_plan: n.selling_plan.toString() }),
            l = { id: s.id, quantity: 1, parent_id: n.id };
          (yield ht.add({ items: [o, l] }),
            i(),
            document.body.dispatchEvent(new CustomEvent("afterAddItem.ajaxCart")),
            document.body.dispatchEvent(new CustomEvent("cart.updated")));
        } catch (e) {
          console.error("Failed to add membership to cart", e);
        } finally {
          _(!1);
        }
      });
      return function () {
        return e.apply(this, arguments);
      };
    })();
    return b
      ? o.default.createElement(
          "div",
          {
            className: "scMembershipDrawerOverlay ".concat(a ? "scMembershipDrawerOverlay--open" : ""),
            onClick: (e) => {
              var t = e.target;
              p.current && !p.current.contains(t) && i();
            },
            "data-testid": "membership-drawer-wrapper",
          },
          o.default.createElement(
            "aside",
            {
              ref: p,
              className: "scMembershipDrawerPanel ".concat(a ? "scMembershipDrawerPanel--open" : ""),
              role: "dialog",
              "aria-modal": "true",
              "aria-labelledby": "membership-drawer-title",
              tabIndex: -1,
              onTransitionEnd: (e) => {
                "transform" !== e.propertyName || a || w(!1);
              },
            },
            o.default.createElement(
              "div",
              { id: "MembershipDrawer", className: "scMembershipDrawer" },
              o.default.createElement(
                "div",
                { className: "scMembershipDrawer__header" },
                o.default.createElement(
                  "div",
                  { className: "scMembershipDrawer__headerInner" },
                  o.default.createElement(
                    "h3",
                    { id: "membership-drawer-title", className: "scMembershipDrawer__title h3" },
                    "Membership Options",
                  ),
                  o.default.createElement(
                    "div",
                    { className: "scMembershipDrawer__close" },
                    o.default.createElement(
                      "button",
                      { type: "button", className: "icon-fallback-text", onClick: i },
                      o.default.createElement("span", {
                        className: "scMembershipDrawer__closeIcon",
                        "aria-hidden": "true",
                      }),
                      o.default.createElement("span", { className: "sr-only" }, "Close Membership Options"),
                    ),
                  ),
                ),
              ),
              o.default.createElement(
                "div",
                { className: "scMembershipDrawer__content" },
                o.default.createElement(
                  "div",
                  { className: "scMembershipDrawer__product-summary" },
                  o.default.createElement(
                    "div",
                    { className: "scMembershipDrawer__product-image" },
                    o.default.createElement(ia, { image_url: d, image_alt: r.title, customSettings: {} }),
                  ),
                  o.default.createElement(
                    "div",
                    { className: "scMembershipDrawer__product-details" },
                    o.default.createElement("p", { className: "scMembershipDrawer__product-title" }, r.title),
                    "Default Title" !== s.title &&
                      o.default.createElement("p", { className: "scMembershipDrawer__variant-title" }, s.title),
                  ),
                ),
                o.default.createElement(aa, { selectedPlanId: h, onPlanSelected: f, settings: n }),
              ),
              o.default.createElement(
                "div",
                { className: "scMembershipDrawer__footer" },
                o.default.createElement(
                  "button",
                  { className: "btn btn--full", onClick: S, disabled: v || !s || s.available !== true },
                  v ? "Adding..." : "Add ".concat(h, " membership"),
                ),
              ),
            ),
          ),
        )
      : null;
  };
  function na(e) {
    for (var t = void 0, a = e[0], i = 1; i < e.length; ) {
      var r = e[i],
        s = e[i + 1];
      if (((i += 2), ("optionalAccess" === r || "optionalCall" === r) && null == a)) return;
      "access" === r || "optionalAccess" === r
        ? ((t = a), (a = s(a)))
        : ("call" !== r && "optionalCall" !== r) ||
          ((a = s(function () {
            for (var e = arguments.length, i = new Array(e), r = 0; r < e; r++) i[r] = arguments[r];
            return a.call(t, ...i);
          })),
          (t = void 0));
    }
    return a;
  }
  sa.displayName = "MembershipOptionsDrawer";
  class oa extends o.default.Component {
    __init() {
      this.useOldSCUpsell =
        "true" ===
        na([
          document,
          "access",
          (e) => e.getElementById,
          "call",
          (e) => e("showOldProductUpsells"),
          "optionalAccess",
          (e) => e.value,
        ]);
    }
    constructor(e) {
      (super(e),
        oa.prototype.__init.call(this),
        oa.prototype.__init2.call(this),
        oa.prototype.__init3.call(this),
        oa.prototype.__init4.call(this));
      var t = na([this.props.productPersonalisationOptions, "optionalAccess", (e) => e.personalization_images]),
        a = this.getParameterByName(Jt),
        i = this.getParameterByName(Kt) || this.props.threads[0].name,
        r = this.isPreselected(),
        s = t && t.length > 0,
        n = this.props.images.some((e) => e.alt && e.alt.includes("personalisation_image_"));
      this.isTemporaryGiftingProduct = Xt.includes(this.props.product.handle);
      var o = !1;
      if (document.getElementById("GiftWrapMetafieldInfoRoot")) {
        var l = document.getElementById("GiftWrapMetafieldInfoRoot")
          ? JSON.parse(document.getElementById("GiftWrapMetafieldInfoRoot").innerHTML)
          : {};
        l.giftingSize && l.giftingSize.length > 0 && l.giftingSize.includes("product_has_no_giftwrapping") && (o = !0);
      }
      (k.readCookie("scPanelOveride") && (this.useOldSCUpsell = !1),
        (this.state = {
          modalActive: !1,
          isMembershipDrawerOpen: !1,
          variant: this.props.initialVariant,
          metafieldHiddenWrapping: o,
          personalisation: {
            applied: !!a,
            name: a,
            thread: i,
            font: "farsan",
            productId: this.props.settings.personalisation.productId,
            partToPersonalise: this.props.settings.personalisation.partToPersonalise,
          },
          giftWrap: { applied: this.isTemporaryGiftingProduct },
          giftWrapAll: { isGiftWrapAllChecked: !1, isGiftWrapAllHidden: !1 },
          donation: { applied: !1 },
          sleepClub: {
            applied: !1,
            available: !1,
            membershipCost: window.mori.sleepClub.products.monthly.cost,
            variantCost: this.props.initialVariant.price,
            sleepClubEnabled: window.mori.sleepClub.enabled,
          },
          isProductAvailable: !0,
          isSCMemberInCart: !0,
          isLoading: this.props.settings.personalisation.enabled || this.props.settings.giftWrap.enabled,
          isPreselectActive: r,
          hasPersonalisation: s || (this.props.settings.personalisation.enabled && n),
        }),
        (this.onPersonaliseClick = this.onPersonaliseClick.bind(this)),
        (this.onCloseModalClick = this.onCloseModalClick.bind(this)),
        (this.onPersonalisationNameChanged = this.onPersonalisationNameChanged.bind(this)),
        (this.onPersonalisationThreadChanged = this.onPersonalisationThreadChanged.bind(this)),
        (this.onGiftWrapEntireOrderCheckboxChange = this.onGiftWrapEntireOrderCheckboxChange.bind(this)),
        (this.onPersonalisationCleared = this.onPersonalisationCleared.bind(this)),
        (this.onGiftWrapClick = this.onGiftWrapClick.bind(this)),
        (this.onMembershipSelected = this.onMembershipSelected.bind(this)),
        (this.onDonationClick = this.onDonationClick.bind(this)));
    }
    isPreselected() {
      if (!this.props.preSelectParam || !this.props.shouldMembershipBePreSelected) return !1;
      var e = this.getParameterByName(this.props.preSelectParam);
      return !!e && "true" === e;
    }
    componentDidMount() {
      var e = this;
      return _asyncToGenerator(function* () {
        (document.addEventListener("variantChanged", e.handleVariantChange),
          na([
            document,
            "access",
            (e) => e.getElementById,
            "call",
            (e) => e("AddToCart"),
            "optionalAccess",
            (e) => e.addEventListener,
            "call",
            (t) => t("click", e.handleAddToCartClick),
          ]),
          document.dispatchEvent(new CustomEvent("PDP_Loaded")),
          document.body.addEventListener("cart.updated", e.updateIsSCMemberInCart),
          e.props.settings.giftWrapAll.giftWrapEntireOrderAvailable && e.updateGiftWrapAllStatus(),
          !window.mori.state.isB2B && window.$g && P.productViewEvent("".concat(e.props.product.id)),
          !e.state.hasPersonalisation && e.props.settings.personalisation.compulsory && e.onProductNotAvailable());
        var t = yield ht.isMembershipInCart();
        if (
          (e.setState({ isSCMemberInCart: t, isLoading: !1 }),
          window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], (a) => {
            a instanceof Error && console.error("Failed to load consent-tracking-api in ProductAddOns", a.message);
            var i = e.props.product.tags.includes("APPEARS_ON_SC_PORTAL"),
              r = wt.isUK();
            e.setState({
              sleepClub: _objectSpread(
                _objectSpread({}, e.state.sleepClub),
                {},
                { available: r && i, applied: e.state.isPreselectActive && !t && r && i },
              ),
            });
          }),
          k.readCookie("_shop_pay_experiment"))
        ) {
          var a = "disabled";
          ("shop_pay_enabled" === k.readCookie("_shop_pay_experiment") && (a = "enabled"),
            P.logEvent("shop_pay_test_pdp", { shop_pay_enabled: a }));
        }
      })();
    }
    componentWillUnmount() {
      (document.removeEventListener("variantChanged", this.handleVariantChange),
        na([
          document,
          "access",
          (e) => e.getElementById,
          "call",
          (e) => e("AddToCart"),
          "optionalAccess",
          (e) => e.removeEventListener,
          "call",
          (e) => e("click", this.handleAddToCartClick),
        ]),
        document.body.removeEventListener("cart.updated", this.updateIsSCMemberInCart));
    }
    componentDidUpdate() {
      this.props.freeReturnsElement &&
        (this.state.personalisation.applied
          ? this.props.freeReturnsElement.classList.add("disabled")
          : this.props.freeReturnsElement.classList.remove("disabled"));
    }
    __init2() {
      var e = this;
      this.updateIsSCMemberInCart = _asyncToGenerator(function* () {
        var t = yield ht.isMembershipInCart();
        e.setState({ isSCMemberInCart: t });
      });
    }
    shouldHideGiftWrapForVariant() {
      return this.state.metafieldHiddenWrapping || !this.state.variant.available;
    }
    __init3() {
      this.handleVariantChange = (e) => {
        var t = e.detail.variant;
        t &&
          this.setState(
            {
              variant: t,
              sleepClub: _objectSpread(_objectSpread({}, this.state.sleepClub), {}, {
                variantCost: t.price,
                applied: t.available === true && this.state.sleepClub.applied,
              }),
            },
            () => {
              (this.emitPricing(), this.updateInputValueForOnePixelApp());
            },
          );
      };
    }
    __init4() {
      this.handleAddToCartClick = (e) => {
        (e.preventDefault(),
          this.state.sleepClub.applied
            ? this.addSleepClubtoCart()
            : this.props.settings.personalisation.compulsory
              ? this.state.personalisation.name
                ? this.addToCart()
                : (this.state.hasPersonalisation
                    ? window.dispatchEvent(
                        new CustomEvent("alert.emit", {
                          detail: {
                            title: "Personalisation required",
                            message:
                              "Personalisation is required for this product. Please add a name to be embroidered before continuing",
                          },
                        }),
                      )
                    : this.onProductNotAvailable(),
                  this.setState({ modalActive: !0 }))
              : this.addToCart());
      };
    }
    onProductNotAvailable() {
      (window.dispatchEvent(
        new CustomEvent("alert.emit", {
          detail: {
            title: "Embroidery unavailable",
            message: "Unfortunately embroidery is not available at this time",
          },
        }),
      ),
        this.setState({ isProductAvailable: !1 }),
        (document.getElementById("AddToCart").disabled = !0),
        (document.getElementById("AddToCart").innerHTML = "<span> Product Not Available</span>"));
    }
    onPersonaliseClick() {
      this.setState({ modalActive: !0 });
    }
    onCloseModalClick() {
      this.setState({ modalActive: !1 });
    }
    onPersonalisationNameChanged(e) {
      e.trim().length > this.props.settings.personalisation.maxLength ||
        this.setState(
          {
            personalisation: _objectSpread(
              _objectSpread({}, this.state.personalisation),
              {},
              { name: e, applied: 0 !== e.trim().length },
            ),
          },
          () => {
            this.addPersonalisationToUrl();
          },
        );
    }
    onPersonalisationThreadChanged(e) {
      this.setState(
        { personalisation: _objectSpread(_objectSpread({}, this.state.personalisation), {}, { thread: e }) },
        () => {
          this.addPersonalisationToUrl();
        },
      );
    }
    onPersonalisationCleared() {
      this.setState(
        {
          personalisation: _objectSpread(
            _objectSpread({}, this.state.personalisation),
            {},
            { applied: !1, thread: this.props.threads[0].name, name: null },
          ),
          modalActive: !1,
        },
        () => {
          this.removePersonalisationFromUrl();
        },
      );
    }
    onGiftWrapClick(e) {
      return (this.setState({ giftWrap: { applied: e } }), !1);
    }
    onMembershipSelected(e) {
      if (e && !validateMoriSleepClubPurchase(this.state.variant)) return;

      (e
        ? (P.logEvent("pdp_membership", { membership_or_buy_once_pdp_url: window.location.href }),
          P.logDynamicEvent({ eventParameterName: "sc_purchase_option", eventParameterValue: "membership" }))
        : (P.logEvent("pdp_buy_once", { membership_or_buy_once_pdp_url: window.location.href }),
          P.logDynamicEvent({ eventParameterName: "sc_purchase_option", eventParameterValue: "buy_once" })),
        this.setState({ sleepClub: _objectSpread(_objectSpread({}, this.state.sleepClub), {}, { applied: e }) }, () => {
          this.emitPricing();
        }));
    }
    updateGiftWrapAllStatus() {
      var e = this;
      return _asyncToGenerator(function* () {
        var t = e.props.settings.giftWrapAll.giftWrapEntireOrderProduct,
          a = t.variants[0].id;
        if (t)
          try {
            var i = yield ht.get();
            if (!i) return;
            var r = i.items.find((e) => e.id === a),
              s = r && r.quantity > 0;
            e.setState({ giftWrapAll: { isGiftWrapAllChecked: s, isGiftWrapAllHidden: s } });
          } catch (e) {
            console.error("Error updating gift wrap all status:", e);
          }
      })();
    }
    onGiftWrapEntireOrderCheckboxChange(e) {
      var t = e.currentTarget.checked;
      this.setState({ giftWrapAll: { isGiftWrapAllChecked: t } });
    }
    addGiftWrapAllToCart() {
      var e = { id: this.props.settings.giftWrapAll.giftWrapEntireOrderProduct.variants[0].id, quantity: 1 };
      return !this.state.giftWrapAll.isGiftWrapAllChecked || this.state.giftWrapAll.isGiftWrapAllHidden ? null : e;
    }
    emitPricing() {
      var e = this.state.variant.price,
        t = this.state.variant.compare_at_price;
      (this.state.sleepClub.applied && ((e = this.state.sleepClub.membershipCost), (t = 0)),
        window.dispatchEvent(new CustomEvent("pricing.change", { detail: { price: e, compareAtPrice: t } })));
    }
    addPersonalisationToUrl() {
      window.history.replaceState(
        {},
        "",
        "?".concat(
          [
            "".concat(Qt, "=").concat(this.state.variant.id),
            "".concat(Jt, "=").concat(this.state.personalisation.name),
            "".concat(Kt, "=").concat(this.state.personalisation.thread),
          ].join("&"),
        ),
      );
    }
    removePersonalisationFromUrl() {
      window.history.replaceState({}, "", "?".concat(["".concat(Qt, "=").concat(this.state.variant.id)].join("&")));
    }
    getParameterByName(e) {
      var t = window.location.href;
      e = e.replace(/[\[\]]/g, "\\$&");
      var a = new RegExp("[?&]" + e + "(=([^&#]*)|&|#|$)").exec(t);
      return a ? (a[2] ? decodeURIComponent(a[2].replace(/\+/g, " ")) : "") : null;
    }
    addToCart() {
      var e = this;
      return _asyncToGenerator(function* () {
        var t = new Date().getTime(),
          a = ht.serializeAddToCartForm(),
          i = e.productPersonalisation(t),
          r = e.productGiftWrap(t, void 0 !== a.id ? a.id : t),
          s = e.productDonation(t),
          n = document.querySelector('#AddToCart[type="submit"]'),
          o = document.querySelector('[type="submit"] span'),
          l = document.querySelector(".loading-overlay__spinner"),
          c = e.state.giftWrapAll.isGiftWrapAllChecked ? e.addGiftWrapAllToCart() : null;
        (window.mori.state.updatedPdpStructureActive &&
          (na([n, "optionalAccess", (e) => e.classList, "access", (e) => e.add, "call", (e) => e("loading")]),
          na([n, "optionalAccess", (e) => e.setAttribute, "call", (e) => e("aria-disabled", "true")]),
          na([n, "optionalAccess", (e) => e.setAttribute, "call", (e) => e("disabled", "disabled")]),
          na([o, "optionalAccess", (e) => e.classList, "access", (e) => e.add, "call", (e) => e("hidden")]),
          na([l, "optionalAccess", (e) => e.classList, "access", (e) => e.remove, "call", (e) => e("hidden")])),
          (a.properties = a.properties || {}));
        var d = e.props.product.tags.find((e) => e.includes("discount:"));
        (d && (a.properties.Discount = Wt(d)),
          i &&
            ((a.properties._p_id = t.toString()),
            e.props.settings.personalisation.compulsory && (a.properties._compulsory = !0)),
          r && ((a.properties._w_id = t.toString()), (a.properties._GiftWrapping = e.props.settings.giftWrap.tag)),
          s &&
            ((a.properties._donation_id = t.toString()), (a.properties._Donation = e.props.settings.donation.handle)));
        var p = [a, i, r, s, c].filter(Boolean);
        try {
          if ((yield ht.add({ items: p })).items.length < 1) return;
          (e.state.giftWrapAll.isGiftWrapAllChecked &&
            e.setState({ giftWrapAll: { isGiftWrapAllChecked: !0, isGiftWrapAllHidden: !0 } }),
            !window.mori.state.isB2B && window.$g && P.addToBasketEvent("".concat(e.props.product.id)),
            P.logEvent("afterAddItem.ajaxCart", {
              gtm_product_name: e.props.product.title,
              gtm_product_variant: e.props.product.title,
              gtm_product_price: e.state.variant.price,
              gtm_product_id: e.props.product.id,
            }),
            P.logEvent("fb_add_to_cart", {
              fb_value: e.state.variant.price / 100,
              fb_currency: _t.getCurrency(),
              fb_content_ids: e.state.variant.id,
            }),
            Gt.addToCartEvent(),
            document.body.dispatchEvent(new CustomEvent("afterAddItem.ajaxCart")),
            document.body.dispatchEvent(new CustomEvent("cart.updated")));
        } catch (e) {
          if (
            !na([
              e,
              "access",
              (e) => e.cause,
              "optionalAccess",
              (e) => e.response,
              "optionalAccess",
              (e) => e.data,
              "optionalAccess",
              (e) => e.description,
              "access",
              (e) => e.includes,
              "call",
              (e) => e("are in your cart"),
            ])
          )
            throw e;
          (na([
            n,
            "optionalAccess",
            (e) => e.insertAdjacentHTML,
            "call",
            (e) => e("afterend", "<p id='allStockInCartError'>all available stock of this color/size is in cart</p>"),
          ]),
            setTimeout(() => {
              na([
                document,
                "access",
                (e) => e.getElementById,
                "call",
                (e) => e("allStockInCartError"),
                "optionalAccess",
                (e) => e.remove,
                "call",
                (e) => e(),
              ]);
            }, 5e3));
        } finally {
          (na([n, "optionalAccess", (e) => e.classList, "access", (e) => e.remove, "call", (e) => e("loading")]),
            na([n, "optionalAccess", (e) => e.removeAttribute, "call", (e) => e("aria-disabled")]),
            na([n, "optionalAccess", (e) => e.removeAttribute, "call", (e) => e("disabled")]),
            na([o, "optionalAccess", (e) => e.classList, "access", (e) => e.remove, "call", (e) => e("hidden")]),
            na([l, "optionalAccess", (e) => e.classList, "access", (e) => e.add, "call", (e) => e("hidden")]));
        }
      })();
    }
    addSleepClubtoCart() {
      var e = this;
      return _asyncToGenerator(function* () {
        if (!validateMoriSleepClubPurchase(e.state.variant)) return;

        if (e.useOldSCUpsell) {
          console.log("addSleepClubtoCart... ");
          var t = new Ct().membershipLineItem(e.state.variant, e.props.product, {
            subscriptionId: 710782550403,
            subscriptionVariantId: window.mori.sleepClub.products.monthly.variantId,
            sleepClubInteraction: "product-page",
            sleepClubInteractionUrl: window.location.pathname + window.location.search,
            sleepClubAction: "buy",
          });
          (console.log("lineItem... ", t), yield ht.add({ items: [t] }));
        }
        (!window.mori.state.isB2B && window.$g && P.addToBasketEvent("".concat(e.props.product.id)),
          P.logEvent("afterAddItem.ajaxCart", {
            gtm_product_name: e.props.product.title,
            gtm_product_variant: e.props.product.title,
            gtm_product_price: e.state.variant.price,
            gtm_product_id: e.props.product.id,
          }),
          P.logEvent("fb_add_to_cart", {
            fb_value: e.state.variant.price / 100,
            fb_currency: _t.getCurrency(),
            fb_content_ids: e.state.variant.id,
          }),
          document.body.dispatchEvent(new CustomEvent("afterAddItem.ajaxCart")),
          document.body.dispatchEvent(new CustomEvent("cart.updated")),
          e.setState(
            {
              isSCMemberInCart: !0,
              sleepClub: _objectSpread(_objectSpread({}, e.state.sleepClub), {}, { applied: !1 }),
            },
            () => {
              e.emitPricing();
            },
          ));
      })();
    }
    productPersonalisation(e) {
      if (!this.state.hasPersonalisation) return null;
      if (!this.state.personalisation.applied) return null;
      var t = this.state.personalisation.name;
      this.props.product.tags.includes("milestone_personalisation") && (t += " is...");
      var a;
      return (
        (a = {
          _Personalisation_text: t,
          _Personalisation_for: ""
            .concat(this.state.variant.sku)
            .concat(this.state.personalisation.partToPersonalise || ""),
          _Product_id: e,
          _Thread_font: this.state.personalisation.font,
          _Thread_color: this.state.personalisation.thread,
        }),
        { id: this.state.personalisation.productId, quantity: 1, properties: a }
      );
    }
    productGiftWrap(e, t) {
      var a = this.isTemporaryGiftingProduct;
      if ((!this.props.settings.giftWrap.enabled && !a) || !this.state.giftWrap.applied) return null;
      var i = {};
      return (
        (i = { _Product_id: e, _Wrapping_for: this.state.variant.sku }),
        a
          ? ((i._is_gifted = "Set"),
            location.host.toLowerCase().includes("eu.babymori")
              ? { id: 56261882642806, quantity: 1, properties: i, parent_id: t }
              : location.host.toLowerCase().includes("us.babymori")
                ? { id: 43029153218673, quantity: 1, properties: i, parent_id: t }
                : { id: 56423011221891, quantity: 1, properties: i, parent_id: t })
          : { id: this.props.settings.giftWrap.productId, quantity: 1, properties: i }
      );
    }
    productDonation(e) {
      if (!this.props.settings.donation.active) return null;
      if (!this.state.donation.applied) return null;
      var t;
      return (
        (t = { _Product_id: e, _Donation_for: this.props.product.title }),
        { id: this.props.settings.donation.id, quantity: 1, properties: t }
      );
    }
    renderSkeleton() {
      var e = this.state.sleepClub.applied;
      return o.default.createElement(
        "div",
        { className: "shimmer faux-image" },
        this.props.settings.donation.active && !e && o.default.createElement("div", { className: "donation_skeleton" }),
        this.state.hasPersonalisation &&
          !e &&
          o.default.createElement("div", { className: "personalisation_skeleton" }),
        this.props.settings.giftWrap.enabled &&
          !e &&
          o.default.createElement("div", { className: "giftwrap_skeleton" }),
      );
    }
    onDonationClick(e) {
      this.setState({ donation: { applied: e } });
    }
    updateInputValueForOnePixelApp() {
      var e = document.querySelector('input[name="id"]');
      e && (e.value = this.state.variant.id.toString());
    }
    render() {
      var e = this.state.isLoading,
        t = this.state.isProductAvailable,
        a = window.mori.state.isPDPGiftWrapShown,
        i = this.props.settings.donation.active,
        r = this.state.sleepClub.available,
        s = window.mori.state.is_sc_member,
        n = this.state.sleepClub.applied,
        l = this.state.isSCMemberInCart,
        c = this.props.settings.giftWrap.enabled,
        d = this.state.hasPersonalisation,
        p = this.state.giftWrapAll,
        u = p.isGiftWrapAllChecked,
        m = p.isGiftWrapAllHidden,
        h = this.props.settings.giftWrapAll,
        f = h.giftWrapEntireOrderProduct,
        g = h.giftWrapEntireOrderAvailable,
        v = window.mori.state.current_store,
        _ = r && !s && this.state.variant && this.state.variant.available === true,
        y = n,
        b = document.querySelector("[data-mori-sleepclub-cta-host]");
      return o.default.createElement(
        "div",
        { "data-testid": "product" },
        e && this.renderSkeleton(),
        i &&
          !e &&
          !y &&
          o.default.createElement(
            L,
            { visible: !0 },
            o.default.createElement(kt, {
              donation: this.props.settings.donation,
              onDonationClick: this.onDonationClick,
              checked: this.state.donation.applied,
            }),
          ),
        d &&
          !e &&
          "US" !== v &&
          !y &&
          o.default.createElement(
            L,
            { visible: !0 },
            o.default.createElement(Dt, {
              settings: this.props.settings.personalisation,
              onPersonaliseClick: this.onPersonaliseClick,
              personalisation: this.state.personalisation,
            }),
            o.default.createElement(
              "div",
              { className: "variant_change_alert" },
              "You've selected a different product variant.",
              o.default.createElement("br", null),
              "Please make sure the thread colour of your personalisation is still the one you want.",
            ),
          ),
        c &&
          !e &&
          "US" !== v &&
          !this.shouldHideGiftWrapForVariant() &&
          !y &&
          o.default.createElement(
            L,
            { visible: !0 },
            t &&
              a &&
              o.default.createElement(Tt, {
                giftWrap: this.state.giftWrap,
                settings: this.props.settings.giftWrap,
                onGiftWrapClick: this.onGiftWrapClick,
                isTemporaryGiftingProduct: this.isTemporaryGiftingProduct,
              }),
          ),
        "US" === v &&
          this.isTemporaryGiftingProduct &&
          !y &&
          o.default.createElement(
            L,
            { visible: !0 },
            t &&
              a &&
              o.default.createElement(Tt, {
                giftWrap: this.state.giftWrap,
                settings: this.props.settings.giftWrap,
                onGiftWrapClick: this.onGiftWrapClick,
                isTemporaryGiftingProduct: this.isTemporaryGiftingProduct,
              }),
          ),
        g &&
          !this.isTemporaryGiftingProduct &&
          !e &&
          "US" === v &&
          !this.shouldHideGiftWrapForVariant() &&
          !y &&
          o.default.createElement(
            L,
            { visible: !0 },
            o.default.createElement(Yt, {
              isChecked: u,
              isHidden: m,
              product: f,
              onChange: this.onGiftWrapEntireOrderCheckboxChange,
              settings: this.props.settings.giftWrapAll,
            }),
            m &&
              u &&
              o.default.createElement(
                "div",
                { className: "gift gift_wrap_checkbox_wrapper", style: { background: "rgba(63, 63, 68, 0.05)" } },
                o.default.createElement(
                  "span",
                  { className: "gift_wrap_added_text" },
                  this.props.settings.giftWrapAll.pdp_gift_wrap_all_success_message,
                ),
              ),
          ),
        _ &&
          !e &&
          !this.useOldSCUpsell &&
          (b
            ? window.ReactDOM.createPortal(
                o.default.createElement(Vt, {
                  settings: this.state.sleepClub,
                  onMembershipSelected: this.onMembershipSelected,
                  shouldMembershipBePreSelected: this.props.shouldMembershipBePreSelected,
                  isPreselectActive: this.state.isPreselectActive,
                  isSCMemberInCart: l,
                }),
                b,
              )
            : o.default.createElement(Vt, {
                settings: this.state.sleepClub,
                onMembershipSelected: this.onMembershipSelected,
                shouldMembershipBePreSelected: this.props.shouldMembershipBePreSelected,
                isPreselectActive: this.state.isPreselectActive,
                isSCMemberInCart: l,
              })),
        _ &&
          !e &&
          !this.useOldSCUpsell &&
          o.default.createElement(sa, {
            isOpen: this.state.sleepClub.applied && this.state.variant && this.state.variant.available === true,
            onClose: () => this.onMembershipSelected(!1),
            product: this.props.product,
            variant: this.state.variant,
            settings: this.props.settings.scMembershipDetails,
          }),
        !l &&
          r &&
          this.state.variant && this.state.variant.available === true &&
          !e &&
          this.useOldSCUpsell &&
          (b
            ? window.ReactDOM.createPortal(
                o.default.createElement($t, {
                  settings: this.state.sleepClub,
                  onMembershipSelected: this.onMembershipSelected,
                  shouldMembershipBePreSelected: this.props.shouldMembershipBePreSelected,
                  isPreselectActive: this.state.isPreselectActive,
                }),
                b,
              )
            : o.default.createElement($t, {
                settings: this.state.sleepClub,
                onMembershipSelected: this.onMembershipSelected,
                shouldMembershipBePreSelected: this.props.shouldMembershipBePreSelected,
                isPreselectActive: this.state.isPreselectActive,
              })),
        d &&
          !y &&
          o.default.createElement(Mt, {
            active: this.state.modalActive,
            product: this.props.product,
            variant: this.state.variant,
            images: this.props.images,
            personalisation: this.state.personalisation,
            settings: this.props.settings.personalisation,
            threads: this.props.threads,
            productOptions: this.props.productOptions,
            onCloseModalClick: this.onCloseModalClick,
            onPersonalisationNameChanged: this.onPersonalisationNameChanged,
            onPersonalisationCleared: this.onPersonalisationCleared,
            onPersonalisationThreadChanged: this.onPersonalisationThreadChanged,
            productPersonalisationOptions: this.props.productPersonalisationOptions,
          }),
      );
    }
  }
  oa.displayName = "ProductAddOns";
  var la = (e) => {
    if (e.dealRoundel && !e.dealRoundel.roundel_url.includes("__unset"))
      return o.default.createElement(
        "div",
        null,
        o.default.createElement("div", {
          className: "dynamic_roundels daily_deal_roundel",
          style: { backgroundImage: 'url("'.concat(e.dealRoundel.roundel_url, '")'), zIndex: 2 },
        }),
        o.default.createElement("div", {
          className: "dynamic_roundels hidden daily_deal_roundel",
          style: { backgroundImage: 'url("'.concat(e.dealRoundel.roundel_url, '")'), zIndex: 2 },
        }),
      );
    var t = (e) => {
        var t = (e || "").split(" ").find((e) => e.includes("roundel"));
        return t ? t.toLowerCase() : "";
      },
      a = t(e.altTag),
      i = t(e.hoverAltTag);
    return o.default.createElement(
      "div",
      null,
      !!a && o.default.createElement("div", { className: "dynamic_roundels primaryRoundel ".concat(a) }),
      !!i && o.default.createElement("div", { className: "dynamic_roundels hoverRoundel hidden ".concat(i) }),
    );
  };
  la.displayName = "ProductRoundel";
  class ca extends e.Component {
    constructor(e) {
      (super(e),
        (this.pillTextColor = window.mori.styling.plpPillSettings.roundel.text),
        (this.pillBackgroundColor = window.mori.styling.plpPillSettings.roundel.background));
    }
    render() {
      if (!this.props.shouldShow || !this.props.fieldText) return o.default.createElement(o.default.Fragment, null);
      var e = this.props.fieldText;
      return (
        (e = e.toLowerCase().includes("up to")
          ? e.replace("Up To", "up to")
          : e.toLowerCase().includes("upf")
            ? e.replace("Upf", "UPF")
            : e.toLowerCase()),
        o.default.createElement(
          "div",
          {
            className: "text-collection roundel-updated-pill",
            style: { color: this.pillTextColor, backgroundColor: this.pillBackgroundColor },
          },
          e,
        )
      );
    }
  }
  ca.displayName = "RoundelTextPill";
  class da extends o.default.Component {
    constructor(e) {
      (super(e), da.prototype.__init.call(this), (this.state = { width: window.innerWidth }));
    }
    componentDidMount() {
      window.addEventListener("resize", this.handleWindowSizeChange);
    }
    componentWillUnmount() {
      window.removeEventListener("resize", this.handleWindowSizeChange);
    }
    __init() {
      this.handleWindowSizeChange = () => {
        this.setState({ width: window.innerWidth });
      };
    }
    render() {
      var e = this.state.width <= 1e3,
        t = this.props,
        a = t.productMetafields,
        i = t.product,
        r = !1;
      if (
        (i.price && i.compare_at_price && (r = i.price < i.compare_at_price),
        !a || (!a.buyXGetY && !a.fallbackPromoText))
      )
        return o.default.createElement(o.default.Fragment, null);
      var s = (function (e) {
        for (var t = void 0, a = e[0], i = 1; i < e.length; ) {
          var r = e[i],
            s = e[i + 1];
          if (((i += 2), ("optionalAccess" === r || "optionalCall" === r) && null == a)) return;
          "access" === r || "optionalAccess" === r
            ? ((t = a), (a = s(a)))
            : ("call" !== r && "optionalCall" !== r) ||
              ((a = s(function () {
                for (var e = arguments.length, i = new Array(e), r = 0; r < e; r++) i[r] = arguments[r];
                return a.call(t, ...i);
              })),
              (t = void 0));
        }
        return a;
      })([a, "access", (e) => e.buyXGetY, "optionalAccess", (e) => e[0]]);
      if (r && s) return o.default.createElement(o.default.Fragment, null);
      var n = s ? Wt(s) : { message: null, url: "#" },
        l = n.message,
        c = n.url,
        d = a.fallbackPromoText;
      return o.default.createElement(
        o.default.Fragment,
        null,
        (l || d) &&
          o.default.createElement(
            "div",
            { className: "sc-incompatible-content pdp_discount_text", style: { margin: e ? "0 15px" : "0" } },
            o.default.createElement(
              "div",
              { className: "discount_rule" },
              l ? o.default.createElement("a", { href: c }, l) : o.default.createElement("span", null, d),
            ),
          ),
      );
    }
  }
  da.displayName = "ProductDiscountBanner";
  /*! *****************************************************************************
  Copyright (c) Microsoft Corporation. All rights reserved.
  Licensed under the Apache License, Version 2.0 (the "License"); you may not use
  this file except in compliance with the License. You may obtain a copy of the
  License at http://www.apache.org/licenses/LICENSE-2.0

  THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
  KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
  WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
  MERCHANTABLITY OR NON-INFRINGEMENT.

  See the Apache Version 2.0 License for specific language governing permissions
  and limitations under the License.
  ***************************************************************************** */ var pa = function (e, t) {
    return (
      (pa =
        Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array &&
          function (e, t) {
            e.__proto__ = t;
          }) ||
        function (e, t) {
          for (var a in t) t.hasOwnProperty(a) && (e[a] = t[a]);
        }),
      pa(e, t)
    );
  };
  function ua(e, t) {
    function a() {
      this.constructor = e;
    }
    (pa(e, t), (e.prototype = null === t ? Object.create(t) : ((a.prototype = t.prototype), new a())));
  }
  var ma = function () {
    return (
      (ma =
        Object.assign ||
        function (e) {
          for (var t, a = 1, i = arguments.length; a < i; a++)
            for (var r in (t = arguments[a])) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
          return e;
        }),
      ma.apply(this, arguments)
    );
  };
  var ha = {
      wrapperComponent: null,
      contentComponent: null,
      previousScale: 1,
      scale: 1,
      positionX: 0,
      positionY: 0,
      options: {
        disabled: !1,
        transformEnabled: !0,
        minPositionX: null,
        maxPositionX: null,
        minPositionY: null,
        maxPositionY: null,
        minScale: 1,
        maxScale: 8,
        limitToBounds: !0,
        limitToWrapper: !1,
        centerContent: !0,
        wrapperClass: "",
        contentClass: "",
      },
      wheel: { disabled: !1, step: 5, wheelEnabled: !0, touchPadEnabled: !0, limitsOnWheel: !1 },
      pan: {
        disabled: !1,
        panAnimationType: "linear",
        lockAxisX: !1,
        lockAxisY: !1,
        velocity: !0,
        velocityEqualToMove: !0,
        velocitySensitivity: 2,
        velocityActiveScale: 1,
        velocityMinSpeed: 1,
        velocityBaseTime: 1600,
        velocityAnimationType: "easeOutQuart",
        padding: !0,
        paddingSize: 30,
        panReturnAnimationTime: 400,
        panReturnAnimationType: "easeOut",
        disableOnTarget: [],
      },
      pinch: { disabled: !1 },
      zoomIn: { disabled: !1, step: 20, animation: !0, animationType: "easeOut", animationTime: 200 },
      zoomOut: { disabled: !1, step: 20, animation: !0, animationType: "easeOut", animationTime: 200 },
      doubleClick: {
        disabled: !1,
        step: 20,
        mode: "zoomIn",
        animation: !0,
        animationType: "easeOut",
        animationTime: 200,
      },
      reset: { disabled: !1, animation: !0, animationType: "easeOut", animationTime: 200 },
      scalePadding: { disabled: !1, size: 0.2, animationTime: 200, animationType: "easeOut" },
    },
    fa = function (e, t) {
      return Number(e.toFixed(t));
    },
    ga = function (e, t) {
      return "number" == typeof e ? e : t;
    },
    va = function (e, t, a, i) {
      return fa(i ? (e < t ? t : e > a ? a : e) : e, 2);
    },
    _a = function (e, t, a, i, r, s, n) {
      var o = e > t ? a * (n ? 1 : 0.5) : 0,
        l = i > r ? s * (n ? 1 : 0.5) : 0;
      return { minPositionX: e - t - o, maxPositionX: o, minPositionY: i - r - l, maxPositionY: l };
    },
    ya = function (e, t) {
      return Math.sqrt(Math.pow(e.pageX - t.pageX, 2) + Math.pow(e.pageY - t.pageY, 2));
    },
    ba = function (e) {
      var t = ma({}, e);
      return (
        Object.keys(t).forEach(function (e) {
          return void 0 === t[e] && delete t[e];
        }),
        t
      );
    },
    wa = function (e, t) {
      e && "function" == typeof e && e(t);
    },
    Sa = function (e, t) {
      return Object.keys(e).reduce(function (a, i) {
        return (
          "object" == typeof t[i] && null !== t[i]
            ? (a[i] = ma(ma({}, e[i]), t[i]))
            : (a[i] = void 0 === t[i] ? e[i] : t[i]),
          a
        );
      }, {});
    };
  var Ea = {
    easeOut: function (e) {
      return -Math.cos(e * Math.PI) / 2 + 0.5;
    },
    linear: function (e) {
      return e;
    },
    easeInQuad: function (e) {
      return e * e;
    },
    easeOutQuad: function (e) {
      return e * (2 - e);
    },
    easeInOutQuad: function (e) {
      return e < 0.5 ? 2 * e * e : (4 - 2 * e) * e - 1;
    },
    easeInCubic: function (e) {
      return e * e * e;
    },
    easeOutCubic: function (e) {
      return --e * e * e + 1;
    },
    easeInOutCubic: function (e) {
      return e < 0.5 ? 4 * e * e * e : (e - 1) * (2 * e - 2) * (2 * e - 2) + 1;
    },
    easeInQuart: function (e) {
      return e * e * e * e;
    },
    easeOutQuart: function (e) {
      return 1 - --e * e * e * e;
    },
    easeInOutQuart: function (e) {
      return e < 0.5 ? 8 * e * e * e * e : 1 - 8 * --e * e * e * e;
    },
    easeInQuint: function (e) {
      return e * e * e * e * e;
    },
    easeOutQuint: function (e) {
      return 1 + --e * e * e * e * e;
    },
    easeInOutQuint: function (e) {
      return e < 0.5 ? 16 * e * e * e * e * e : 1 + 16 * --e * e * e * e * e;
    },
  };
  function Ca() {
    this.mounted &&
      (this.animation && cancelAnimationFrame(this.animation),
      (this.animate = !1),
      (this.animation = !1),
      (this.velocity = !1));
  }
  function Pa(e, t, a) {
    var i = this;
    if (this.mounted) {
      var r = new Date().getTime();
      (Ca.call(this),
        (this.animation = function () {
          if (i.animation && i.mounted) {
            var s = new Date().getTime() - r,
              n = s / t,
              o = (0, Ea[e])(n);
            s >= t ? (a(1), (i.animation = null)) : (a(o), requestAnimationFrame(i.animation));
          }
        }),
        requestAnimationFrame(this.animation));
    }
  }
  function Aa(e) {
    var t = this,
      a = e.targetState,
      i = e.speed,
      r = e.type,
      s = this.stateProvider,
      n = s.scale,
      o = s.positionX,
      l = s.positionY,
      c = a.scale - n,
      d = a.positionX - o,
      p = a.positionY - l;
    0 === i
      ? ((this.stateProvider.previousScale = this.stateProvider.scale),
        (this.stateProvider.scale = a.scale),
        (this.stateProvider.positionX = a.positionX),
        (this.stateProvider.positionY = a.positionY),
        this.applyTransformation())
      : Pa.call(this, r, i, function (e) {
          ((t.stateProvider.previousScale = t.stateProvider.scale),
            (t.stateProvider.scale = n + c * e),
            (t.stateProvider.positionX = o + d * e),
            (t.stateProvider.positionY = l + p * e),
            t.applyTransformation());
        });
  }
  function ka(e, t, a, i, r) {
    var s = t - (r ? i : 0);
    return !isNaN(a) && e >= a ? a : !isNaN(t) && e <= s ? s : e;
  }
  function Na(e, t, a, i, r, s) {
    var n = a.minPositionX,
      o = a.minPositionY,
      l = a.maxPositionX,
      c = a.maxPositionY,
      d = s ? (r * s.offsetWidth) / 100 : 0,
      p = s ? (r * s.offsetHeight) / 100 : 0;
    return { x: va(e, n - d, l + d, i), y: va(t, o - p, c + p, i) };
  }
  function Ta(e, t, a) {
    var i = t.getBoundingClientRect(),
      r = (e.clientX - i.left) / a,
      s = (e.clientY - i.top) / a;
    return ((isNaN(r) || isNaN(s)) && console.error("No mouse or touch offset found"), { mouseX: r, mouseY: s });
  }
  function Oa(e, t, a, i, r) {
    var s = this.stateProvider,
      n = s.scale,
      o = s.positionX,
      l = s.positionY,
      c = s.options.transformEnabled,
      d = a - n;
    return "number" != typeof e || "number" != typeof t
      ? console.error("Mouse X and Y position were not provided!")
      : c
        ? Na(o - e * d, l - t * d, i, r, 0, null)
        : { newPositionX: o, newPositionY: l };
  }
  function xa(e) {
    var t = e.touches;
    return t && 1 === t.length
      ? { clientX: t[0].clientX, clientY: t[0].clientY }
      : t
        ? null
        : { clientX: e.clientX, clientY: e.clientY };
  }
  function Ia(e) {
    var t = this.stateProvider,
      a = t.scale,
      i = t.positionX,
      r = t.positionY,
      s = t.options,
      n = s.limitToBounds,
      o = s.minScale,
      l = t.pan,
      c = l.lockAxisX,
      d = l.lockAxisY,
      p = l.padding,
      u = l.paddingSize,
      m = t.wrapperComponent;
    if (this.startCoords) {
      var h = this.startCoords,
        f = h.x,
        g = h.y,
        v = xa(e);
      if (!v) return console.error("Cannot find mouse client positions");
      var _ = v.clientX,
        y = v.clientY,
        b = c ? i : _ - f,
        w = d ? r : y - g,
        S = p && a >= o ? u : 0;
      if (b !== i || w !== r) {
        var E = Na(b, w, this.bounds, n, S, m);
        za.call(this, E.x, E.y);
      }
    }
  }
  function La() {
    var e = this.stateProvider,
      t = e.scale,
      a = e.options.minScale,
      i = e.pan,
      r = i.disabled,
      s = i.padding,
      n = i.panReturnAnimationTime,
      o = i.panReturnAnimationType;
    if (!(r || t < a || !s)) {
      var l = Ma.call(this);
      Aa.call(this, { targetState: l, speed: n, type: o });
    }
  }
  function Ma() {
    var e = this.stateProvider,
      t = e.positionX,
      a = e.positionY,
      i = e.scale,
      r = e.options,
      s = r.disabled,
      n = r.limitToBounds,
      o = r.limitToWrapper,
      l = this.state.wrapperComponent;
    if (!s) {
      var c = this.bounds,
        d = c.maxPositionX,
        p = c.minPositionX,
        u = c.maxPositionY,
        m = c.minPositionY,
        h = t > d || t < p,
        f = a > u || a < m,
        g = t > d ? l.offsetWidth : this.stateProvider.minPositionX || 0,
        v = a > u ? l.offsetHeight : this.stateProvider.minPositionY || 0,
        _ = Oa.call(this, g, v, i, this.bounds, n || o),
        y = _.x,
        b = _.y;
      return { scale: i, positionX: h ? y : t, positionY: f ? b : a };
    }
  }
  function za(e, t) {
    this.stateProvider.pan.padding &&
      ((this.stateProvider.positionX = e), (this.stateProvider.positionY = t), this.applyTransformation());
  }
  function Ra(e, t, a, i, r) {
    var s = this.stateProvider,
      n = s.scale,
      o = s.options,
      l = o.maxScale,
      c = o.minScale,
      d = s.scalePadding,
      p = d.size,
      u = d.disabled,
      m = s.wrapperComponent,
      h = null;
    if (r) {
      h = n + (t - t * (1e-4 * window.innerWidth)) * e * (n / (e < 0 ? 30 : 20));
    } else {
      var f = 2 - window.innerWidth / m.offsetWidth;
      h = n + t * e * ((n - n * Math.max(0.2, Math.min(0.99, f))) / 20);
    }
    if (i) return h;
    var g = !a && !u;
    return ka(fa(h, 3), c, l, p, g);
  }
  function Da(e, t) {
    var a = this.stateProvider,
      i = (function (e, t, a) {
        var i = e.offsetWidth,
          r = e.offsetHeight,
          s = t.offsetWidth * a,
          n = t.offsetHeight * a;
        return {
          wrapperWidth: i,
          wrapperHeight: r,
          newContentWidth: s,
          newDiffWidth: i - s,
          newContentHeight: n,
          newDiffHeight: r - n,
        };
      })(a.wrapperComponent, a.contentComponent, e),
      r = i.wrapperWidth,
      s = i.wrapperHeight,
      n = i.newContentWidth,
      o = i.newDiffWidth,
      l = i.newContentHeight,
      c = i.newDiffHeight,
      d = _a(r, n, o, s, l, c, t);
    return ((this.bounds = d), d);
  }
  function Ba(e) {
    var t = this.stateProvider,
      a = t.scale,
      i = t.contentComponent,
      r = t.options.limitToBounds,
      s = t.scalePadding,
      n = s.size,
      o = s.disabled,
      l = t.wheel,
      c = l.step,
      d = l.limitsOnWheel;
    (e.preventDefault(), e.stopPropagation());
    var p = (function (e, t) {
        var a = e ? (e.deltaY < 0 ? 1 : -1) : 0;
        return ga(t, a);
      })(e, null),
      u = Ra.call(this, p, c, !e.ctrlKey);
    if (a !== u) {
      var m = Da.call(this, u, !d),
        h = Ta(e, i, a),
        f = h.mouseX,
        g = h.mouseY,
        v = r && (o || 0 === n || d),
        _ = Oa.call(this, f, g, u, m, v),
        y = _.x,
        b = _.y;
      ((this.bounds = m),
        (this.stateProvider.previousScale = a),
        (this.stateProvider.scale = u),
        (this.stateProvider.positionX = y),
        (this.stateProvider.positionY = b),
        this.applyTransformation());
    }
  }
  function Va(e, t, a, i, r) {
    var s = this.stateProvider,
      n = s.contentComponent,
      o = s.options,
      l = o.disabled,
      c = o.minScale,
      d = o.maxScale,
      p = o.limitToBounds,
      u = o.limitToWrapper;
    if (!l && !e) {
      var m = ka(fa(t, 2), c, d, null, null),
        h = Da.call(this, m, u),
        f = a,
        g = i;
      if (r) {
        var v = Ta(r, n, t);
        ((f = v.mouseX), (g = v.mouseY));
      }
      var _ = Oa.call(this, f, g, m, h, p);
      return { scale: m, positionX: _.x, positionY: _.y };
    }
  }
  function Fa() {
    var e = this.stateProvider,
      t = e.scale,
      a = e.wrapperComponent,
      i = e.options,
      r = i.minScale,
      s = i.limitToBounds,
      n = e.scalePadding,
      o = n.disabled,
      l = n.animationTime,
      c = n.animationType,
      d = o || t >= r;
    if (((t >= 1 || s) && La.call(this), !d)) {
      var p = a.offsetWidth / 2,
        u = a.offsetHeight / 2,
        m = Va.call(this, !1, r, p, u, null);
      Aa.call(this, { targetState: m, speed: l, type: c });
    }
  }
  function Ua(e) {
    (e.preventDefault(), e.stopPropagation());
    var t = this.stateProvider,
      a = t.contentComponent,
      i = t.scale,
      r = t.doubleClick,
      s = r.disabled,
      n = r.mode,
      o = r.step,
      l = r.animationTime,
      c = r.animationType;
    if ("reset" === n) return ja.call(this, e, l);
    var d = "zoomOut" === n ? -1 : 1,
      p = Ra.call(this, d, o, void 0, void 0, !0),
      u = Ta(e, a, i),
      m = u.mouseX,
      h = u.mouseY,
      f = Va.call(this, s, p, m, h);
    if (f.scale !== i) {
      var g = qa(Ra.call(this, d, o, !0, void 0, !0), p, l);
      Aa.call(this, { targetState: f, speed: g, type: c });
    }
  }
  function Wa(e, t) {
    var a = this.stateProvider,
      i = a.scale,
      r = a.positionX,
      s = a.positionY,
      n = a.wrapperComponent,
      o = a.zoomIn,
      l = a.zoomOut,
      c = (n.offsetWidth / 2 - r) / i,
      d = (n.offsetHeight / 2 - s) / i,
      p = Ra.call(this, e, t, void 0, void 0, !0),
      u = p > i,
      m = u ? o.animationTime : l.animationTime,
      h = u ? o.animationType : l.animationType,
      f = u ? o.disabled : l.disabled,
      g = Va.call(this, f, p, c, d);
    if (g.scale !== i) {
      var v = qa(Ra.call(this, e, t, !0, void 0, !0), p, m);
      Aa.call(this, { targetState: g, speed: v, type: h });
    }
  }
  function ja(e) {
    var t = this.props.defaultValues,
      a = t.defaultScale,
      i = t.defaultPositionX,
      r = t.defaultPositionY,
      s = this.stateProvider,
      n = s.scale,
      o = s.positionX,
      l = s.positionY,
      c = s.reset,
      d = s.options,
      p = d.disabled,
      u = d.limitToBounds,
      m = d.centerContent,
      h = d.limitToWrapper;
    if (!(p || c.disabled || (n === a && o === i && l === r))) {
      var f = "number" == typeof e ? e : c.animationTime,
        g = ga(a, ha.scale),
        v = ga(i, ha.positionX),
        _ = ga(r, ha.positionY);
      if ((u && !h) || m) {
        var y = Da.call(this, g, h);
        ((v = y.minPositionX), (_ = y.minPositionY));
      }
      var b = { scale: g, positionX: v, positionY: _ };
      Aa.call(this, { targetState: b, speed: f, type: c.animationType });
    }
  }
  function qa(e, t, a) {
    return a * (t / e);
  }
  function Ga(e, t) {
    var a = Math.pow(10, t);
    return Math.round(e * a) / a;
  }
  function Ha(e) {
    return e === 1 / 0 || e === -1 / 0;
  }
  function Ya(e, t) {
    var a = this.stateProvider,
      i = a.options,
      r = i.minScale,
      s = i.maxScale,
      n = a.scalePadding,
      o = n.size,
      l = n.disabled;
    if ("number" != typeof t || "number" != typeof e) return console.error("Pinch touches distance was not provided");
    if (!(e < 0)) {
      var c = (e / t) * this.pinchStartScale;
      return ka(fa(c, 2), r, s, o, !l);
    }
  }
  function Xa(e) {
    var t = this.stateProvider,
      a = t.scale,
      i = t.options,
      r = i.limitToBounds,
      s = i.limitToWrapper,
      n = t.scalePadding,
      o = n.disabled,
      l = n.size,
      c = t.wheel.limitsOnWheel,
      d = t.pinch,
      p = this.state.contentComponent;
    if (
      !d.disabled &&
      !this.stateProvider.options.disabled &&
      (e.cancelable && (e.preventDefault(), e.stopPropagation()), null !== this.pinchStartDistance)
    ) {
      var u = (function (e, t, a) {
          var i = a.getBoundingClientRect(),
            r = e.touches,
            s = Ga(r[0].clientX - i.left, 5),
            n = Ga(r[0].clientY - i.top, 5);
          return {
            mouseX: (s + Ga(r[1].clientX - i.left, 5)) / 2 / t,
            mouseY: (n + Ga(r[1].clientY - i.top, 5)) / 2 / t,
          };
        })(e, a, p),
        m = u.mouseX,
        h = u.mouseY;
      if (!Ha(m) && !Ha(h)) {
        var f = (function (e) {
            return ya(e.touches[0], e.touches[1]);
          })(e),
          g = Ya.call(this, f, this.pinchStartDistance);
        if (!Ha(g) && g !== a) {
          var v = Da.call(this, g, s),
            _ = r && (o || 0 === l || c),
            y = Oa.call(this, m, h, g, v, _),
            b = y.x,
            w = y.y;
          ((this.lastDistance = f),
            (this.stateProvider.positionX = b),
            (this.stateProvider.positionY = w),
            (this.stateProvider.scale = g),
            (this.stateProvider.previousScale = a),
            this.applyTransformation());
        }
      }
    }
  }
  function Qa(e, t) {
    return this.stateProvider.pan.velocityEqualToMove ? t - t / Math.max(1, e) : t;
  }
  function Ja() {
    this.setState({ startAnimation: !1 });
  }
  function Ka() {
    this.setState({ startAnimation: !0 });
  }
  function $a() {
    var e = this,
      t = this.stateProvider,
      a = t.positionX,
      i = t.positionY,
      r = t.options.limitToBounds,
      s = t.pan,
      n = s.velocityBaseTime,
      o = s.lockAxisX,
      l = s.lockAxisY,
      c = s.velocityAnimationType,
      d = s.panReturnAnimationTime,
      p = s.panReturnAnimationType,
      u = s.padding,
      m = s.paddingSize,
      h = t.wrapperComponent;
    if (this.mounted) {
      if (!this.velocity || !this.bounds) return Ca.call(this);
      var f = this.bounds,
        g = f.maxPositionX,
        v = f.minPositionX,
        _ = f.maxPositionY,
        y = f.minPositionY,
        b = this.velocity,
        w = b.velocityX,
        S = b.velocityY,
        E = b.velocity,
        C = Qa.call(this, E, n);
      if (C) {
        var P = w,
          A = S,
          k = C > d ? C : d,
          N = u ? m : 0,
          T = h ? (N * h.offsetWidth) / 100 : 0,
          O = h ? (N * h.offsetHeight) / 100 : 0,
          x = g + T,
          I = v - T,
          L = _ + O,
          M = y - O,
          z = Na(a, i, this.bounds, r, N, h),
          R = new Date().getTime();
        Pa.call(this, c, k, function (t) {
          var s = new Date().getTime() - R,
            n = s / d,
            c = (0, Ea[p])(n);
          (s > d || c > 1 || c === 1 / 0 || c === -1 / 0) && (c = 1);
          var u = ei(o, P, t, c, v, g, r, a, z.x, I, x),
            m = ei(l, A, t, c, y, _, r, i, z.y, M, L);
          (a === u && i === m) ||
            ((e.stateProvider.positionX = u), (e.stateProvider.positionY = m), e.applyTransformation());
        });
      } else La.call(this);
    }
  }
  function Za(e) {
    var t = this,
      a = this.stateProvider,
      i = a.scale,
      r = a.options.disabled,
      s = a.pan,
      n = s.velocity,
      o = s.velocitySensitivity,
      l = s.velocityActiveScale,
      c = s.velocityMinSpeed,
      d = a.wrapperComponent;
    if (!(!n || l >= i || r)) {
      Ja.call(this);
      var p = Date.now();
      if (this.lastMousePosition) {
        var u = xa(e);
        if (!u) return console.error("No mouse or touch position detected");
        var m = u.clientX,
          h = u.clientY,
          f = m - this.lastMousePosition.clientX,
          g = h - this.lastMousePosition.clientY,
          v = p - this.velocityTime,
          _ = 2 - d.offsetWidth / window.innerWidth,
          y = 2 - d.offsetHeight / window.innerHeight,
          b = (f / v) * o * i * (20 * Math.max(c, Math.min(2, _))),
          w = (g / v) * o * i * (20 * Math.max(c, Math.min(2, y))),
          S = f * f + g * g,
          E = (Math.sqrt(S) / v) * o;
        if (this.velocity && E < this.velocity.velocity && this.throttle) return;
        ((this.velocity = { velocityX: b, velocityY: w, velocity: E }),
          this.throttle && clearTimeout(this.throttle),
          (this.throttle = setTimeout(function () {
            t.mounted && (t.throttle = !1);
          }, 30)));
      }
      var C = xa(e);
      ((this.lastMousePosition = C), (this.velocityTime = p));
    }
  }
  function ei(e, t, a, i, r, s, n, o, l, c, d) {
    if (n) {
      var p;
      if (l > r && o > s) return (p = l - (l - s) * i) > d ? d : p < s ? s : p;
      if (l < r && o < r) return (p = l - (l - r) * i) < c ? c : p > r ? r : p;
    }
    return e ? l : va(o + t * a, r, s, n);
  }
  var ti = [
      "previousScale",
      "scale",
      "positionX",
      "positionY",
      "defaultPositionX",
      "defaultPositionY",
      "defaultScale",
      "onWheelStart",
      "onWheel",
      "onWheelStop",
      "onPanningStart",
      "onPanning",
      "onPanningStop",
      "onPinchingStart",
      "onPinching",
      "onPinchingStop",
      "onZoomChange",
      "options",
      "wheel",
      "scalePadding",
      "pan",
      "pinch",
      "zoomIn",
      "zoomOut",
      "doubleClick",
      "reset",
    ],
    ai = function (e) {
      return Object.keys(e).reduce(function (t, a) {
        return (ti.includes(a) && (t[a] = e[a]), t);
      }, {});
    },
    ii = o.default.createContext({}),
    ri = null,
    si = null,
    ni = (function (e) {
      function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (
          (t.mounted = !0),
          (t.state = { wrapperComponent: void 0, contentComponent: void 0 }),
          (t.stateProvider = ma(ma(ma(ma({}, ha), Sa(ha, t.props.dynamicValues)), t.props.defaultValues), {
            previousScale: t.props.dynamicValues.scale || t.props.defaultValues.scale || ha.scale,
          })),
          (t.windowToWrapperScaleX = 0),
          (t.windowToWrapperScaleY = 0),
          (t.startCoords = null),
          (t.isDown = !1),
          (t.pinchStartDistance = null),
          (t.lastDistance = null),
          (t.pinchStartScale = null),
          (t.distance = null),
          (t.bounds = null),
          (t.velocityTime = null),
          (t.lastMousePosition = null),
          (t.velocity = null),
          (t.offsetX = null),
          (t.offsetY = null),
          (t.throttle = !1),
          (t.previousWheelEvent = null),
          (t.lastScale = null),
          (t.animate = null),
          (t.animation = null),
          (t.maxBounds = null),
          (t.handleWheel = function (e) {
            var a = t.stateProvider,
              i = a.scale,
              r = a.wheel,
              s = r.disabled,
              n = r.wheelEnabled,
              o = r.touchPadEnabled,
              l = t.props,
              c = l.onWheelStart,
              d = l.onWheel,
              p = l.onWheelStop,
              u = t.state,
              m = u.wrapperComponent,
              h = u.contentComponent;
            t.isDown ||
              s ||
              t.stateProvider.options.disabled ||
              !m ||
              !h ||
              ((n || e.ctrlKey) &&
                ((!o && e.ctrlKey) ||
                  (ri || ((t.lastScale = i), Ca.call(t), wa(c, t.getCallbackProps())),
                  Ba.call(t, e),
                  wa(d, t.getCallbackProps()),
                  t.applyTransformation(null, null, null),
                  (t.previousWheelEvent = e),
                  (function (e, t, a) {
                    var i = a.scale,
                      r = a.options,
                      s = r.maxScale,
                      n = r.minScale;
                    return (
                      !!e &&
                      (i < s ||
                        i > n ||
                        Math.sign(e.deltaY) !== Math.sign(t.deltaY) ||
                        (e.deltaY > 0 && e.deltaY < t.deltaY) ||
                        (e.deltaY < 0 && e.deltaY > t.deltaY) ||
                        Math.sign(e.deltaY) !== Math.sign(t.deltaY))
                    );
                  })(t.previousWheelEvent, e, t.stateProvider) &&
                    (clearTimeout(ri),
                    (ri = setTimeout(function () {
                      t.mounted && (wa(p, t.getCallbackProps()), (ri = null));
                    }, 180))),
                  (t.animate = !1),
                  (t.lastScale = t.stateProvider.scale),
                  clearTimeout(si),
                  (si = setTimeout(function () {
                    t.mounted && Fa.call(t, e);
                  }, 100)))));
          }),
          (t.checkPanningTarget = function (e) {
            var a = t.stateProvider.pan.disableOnTarget;
            return (
              a
                .map(function (e) {
                  return e.toUpperCase();
                })
                .includes(e.target.tagName) ||
              a.find(function (t) {
                return e.target.classList.value.includes(t);
              })
            );
          }),
          (t.checkIsPanningActive = function (e) {
            var a = t.stateProvider.pan.disabled,
              i = t.state,
              r = i.wrapperComponent,
              s = i.contentComponent;
            return (
              !t.isDown ||
              a ||
              t.stateProvider.options.disabled ||
              (e.touches &&
                (1 !== e.touches.length ||
                  Math.abs(t.startCoords.x - e.touches[0].clientX) < 1 ||
                  Math.abs(t.startCoords.y - e.touches[0].clientY) < 1)) ||
              !r ||
              !s
            );
          }),
          (t.handleSetUpPanning = function (e, a) {
            var i = t.stateProvider,
              r = i.positionX,
              s = i.positionY;
            ((t.isDown = !0),
              (t.startCoords = { x: e - r, y: a - s }),
              wa(t.props.onPanningStart, t.getCallbackProps()));
          }),
          (t.handleStartPanning = function (e) {
            var a = t.stateProvider,
              i = a.wrapperComponent,
              r = a.scale,
              s = a.options,
              n = s.minScale,
              o = s.maxScale,
              l = s.limitToWrapper,
              c = a.pan.disabled,
              d = e.target,
              p = e.touches;
            c ||
              t.stateProvider.options.disabled ||
              (i && !i.contains(d)) ||
              t.checkPanningTarget(e) ||
              r < n ||
              r > o ||
              (Ca.call(t),
              (t.bounds = Da.call(t, r, l)),
              p && 1 === p.length && t.handleSetUpPanning(p[0].clientX, p[0].clientY),
              p || t.handleSetUpPanning(e.clientX, e.clientY));
          }),
          (t.handlePanning = function (e) {
            (t.isDown && e.preventDefault(),
              t.checkIsPanningActive(e) ||
                (e.stopPropagation(), Za.call(t, e), Ia.call(t, e), wa(t.props.onPanning, t.getCallbackProps())));
          }),
          (t.handleStopPanning = function () {
            if (t.isDown) {
              ((t.isDown = !1),
                (t.animate = !1),
                (t.animation = !1),
                Ka.call(t),
                wa(t.props.onPanningStop, t.getCallbackProps()));
              var e = t.stateProvider,
                a = e.pan.velocity,
                i = e.scale;
              t.velocity && a && i > 1 ? $a.call(t) : La.call(t);
            }
          }),
          (t.handlePinchStart = function (e) {
            var a = t.stateProvider.scale;
            (e.preventDefault(), e.stopPropagation(), Ca.call(t));
            var i = ya(e.touches[0], e.touches[1]);
            ((t.pinchStartDistance = i),
              (t.lastDistance = i),
              (t.pinchStartScale = a),
              (t.isDown = !1),
              wa(t.props.onPinchingStart, t.getCallbackProps()));
          }),
          (t.handlePinch = function (e) {
            ((t.isDown = !1), Xa.call(t, e), wa(t.props.onPinching, t.getCallbackProps()));
          }),
          (t.handlePinchStop = function () {
            "number" == typeof t.pinchStartScale &&
              ((t.isDown = !1),
              (t.velocity = null),
              (t.lastDistance = null),
              (t.pinchStartScale = null),
              (t.pinchStartDistance = null),
              Fa.call(t),
              wa(t.props.onPinchingStop, t.getCallbackProps()));
          }),
          (t.handleTouchStart = function (e) {
            var a = t.stateProvider,
              i = a.wrapperComponent,
              r = a.contentComponent,
              s = a.scale,
              n = a.options,
              o = n.disabled,
              l = n.minScale,
              c = e.touches;
            if (!o && i && r && !(s < l))
              return (
                Ca.call(t),
                c && 1 === c.length ? t.handleStartPanning(e) : c && 2 === c.length ? t.handlePinchStart(e) : void 0
              );
          }),
          (t.handleTouch = function (e) {
            var a = t.stateProvider,
              i = a.pan,
              r = a.pinch;
            if (!a.options.disabled)
              return i.disabled || 1 !== e.touches.length
                ? r.disabled || 2 !== e.touches.length
                  ? void 0
                  : t.handlePinch(e)
                : t.handlePanning(e);
          }),
          (t.handleTouchStop = function () {
            (t.handleStopPanning(), t.handlePinchStop());
          }),
          (t.zoomIn = function (e) {
            var a = t.stateProvider,
              i = a.zoomIn,
              r = i.disabled,
              s = i.step,
              n = a.options,
              o = t.state,
              l = o.wrapperComponent,
              c = o.contentComponent;
            if (!e) throw Error("Zoom in function requires event prop");
            !r && !n.disabled && l && c && Wa.call(t, 1, s);
          }),
          (t.zoomOut = function (e) {
            var a = t.stateProvider,
              i = a.zoomOut,
              r = i.disabled,
              s = i.step,
              n = a.options,
              o = t.state,
              l = o.wrapperComponent,
              c = o.contentComponent;
            if (!e) throw Error("Zoom out function requires event prop");
            !r && !n.disabled && l && c && Wa.call(t, -1, s);
          }),
          (t.handleDbClick = function (e) {
            var a = t.stateProvider,
              i = a.options,
              r = a.doubleClick,
              s = r.disabled,
              n = r.step,
              o = t.state,
              l = o.wrapperComponent,
              c = o.contentComponent;
            if (!e) throw Error("Double click function requires event prop");
            !s && !i.disabled && l && c && Ua.call(t, e, 1, n);
          }),
          (t.setScale = function (e, a, i) {
            (void 0 === a && (a = 200), void 0 === i && (i = "easeOut"));
            var r = t.stateProvider,
              s = r.positionX,
              n = r.positionY,
              o = r.scale,
              l = r.options.disabled,
              c = t.state,
              d = c.wrapperComponent,
              p = c.contentComponent;
            if (!l && d && p) {
              var u = { positionX: s, positionY: n, scale: isNaN(e) ? o : e };
              Aa.call(t, { targetState: u, speed: a, type: i });
            }
          }),
          (t.setPositionX = function (e, a, i) {
            (void 0 === a && (a = 200), void 0 === i && (i = "easeOut"));
            var r = t.stateProvider,
              s = r.positionX,
              n = r.positionY,
              o = r.scale,
              l = r.options,
              c = l.disabled,
              d = l.transformEnabled,
              p = t.state,
              u = p.wrapperComponent,
              m = p.contentComponent;
            if (!c && d && u && m) {
              var h = { positionX: isNaN(e) ? s : e, positionY: n, scale: o };
              Aa.call(t, { targetState: h, speed: a, type: i });
            }
          }),
          (t.setPositionY = function (e, a, i) {
            (void 0 === a && (a = 200), void 0 === i && (i = "easeOut"));
            var r = t.stateProvider,
              s = r.positionX,
              n = r.scale,
              o = r.positionY,
              l = r.options,
              c = l.disabled,
              d = l.transformEnabled,
              p = t.state,
              u = p.wrapperComponent,
              m = p.contentComponent;
            if (!c && d && u && m) {
              var h = { positionX: s, positionY: isNaN(e) ? o : e, scale: n };
              Aa.call(t, { targetState: h, speed: a, type: i });
            }
          }),
          (t.setTransform = function (e, a, i, r, s) {
            (void 0 === r && (r = 200), void 0 === s && (s = "easeOut"));
            var n = t.stateProvider,
              o = n.positionX,
              l = n.positionY,
              c = n.scale,
              d = n.options,
              p = d.disabled,
              u = d.transformEnabled,
              m = t.state,
              h = m.wrapperComponent,
              f = m.contentComponent;
            if (!p && u && h && f) {
              var g = { positionX: isNaN(e) ? o : e, positionY: isNaN(a) ? l : a, scale: isNaN(i) ? c : i };
              Aa.call(t, { targetState: g, speed: r, type: s });
            }
          }),
          (t.resetTransform = function () {
            var e = t.stateProvider.options,
              a = e.disabled,
              i = e.transformEnabled;
            !a && i && ja.call(t);
          }),
          (t.setDefaultState = function () {
            ((t.animation = null),
              (t.stateProvider = ma(
                ma(ma({}, t.stateProvider), { scale: ha.scale, positionX: ha.positionX, positionY: ha.positionY }),
                t.props.defaultValues,
              )),
              t.forceUpdate());
          }),
          (t.setWrapperComponent = function (e) {
            t.setState({ wrapperComponent: e });
          }),
          (t.setContentComponent = function (e) {
            t.setState({ contentComponent: e }, function () {
              var a = t.stateProvider,
                i = a.wrapperComponent,
                r = a.options,
                s = r.centerContent,
                n = r.limitToBounds,
                o = r.limitToWrapper,
                l = a.scale,
                c = t.props.defaultValues,
                d = c.positionX,
                p = c.positionY;
              if ((n && !o) || (s && !d && !p)) {
                var u = "translate(25%, 25%) scale(" + l + ")";
                ((e.style.transform = u), (e.style.WebkitTransform = u), t.forceUpdate());
                var m = new Date().getTime(),
                  h = setInterval(function () {
                    if (i.offsetWidth) {
                      var e = Da.call(t, l, !1);
                      ((t.stateProvider.positionX = e.minPositionX),
                        (t.stateProvider.positionY = e.minPositionY),
                        t.applyTransformation(null, null, null),
                        clearInterval(h),
                        (h = null));
                    } else new Date().getTime() - m > 2e3 && (clearInterval(h), (h = null));
                  }, 20);
              } else t.applyTransformation(null, null, null);
            });
          }),
          (t.applyTransformation = function (e, a, i) {
            if (t.mounted) {
              var r = t.state.contentComponent,
                s = t.props.onZoomChange,
                n = t.stateProvider,
                o = n.previousScale,
                l = n.scale,
                c = n.positionX,
                d = n.positionY;
              if (!r) return console.error("There is no content component");
              var p = "translate(" + (a || c) + "px, " + (i || d) + "px) scale(" + (e || l) + ")";
              ((r.style.transform = p),
                (r.style.WebkitTransform = p),
                t.forceUpdate(),
                s && o !== l && wa(s, t.getCallbackProps()));
            }
          }),
          (t.getCallbackProps = function () {
            return ai(t.stateProvider);
          }),
          t
        );
      }
      return (
        ua(t, e),
        (t.prototype.componentDidMount = function () {
          var e = !1;
          (window.addEventListener("mousedown", this.handleStartPanning, e),
            window.addEventListener("mousemove", this.handlePanning, e),
            window.addEventListener("mouseup", this.handleStopPanning, e));
        }),
        (t.prototype.componentWillUnmount = function () {
          var e = !1;
          (window.removeEventListener("mousedown", this.handleStartPanning, e),
            window.removeEventListener("mousemove", this.handlePanning, e),
            window.removeEventListener("mouseup", this.handleStopPanning, e),
            Ca.call(this));
        }),
        (t.prototype.componentDidUpdate = function (e, t) {
          var a,
            i = this.state,
            r = i.wrapperComponent,
            s = i.contentComponent,
            n = this.props.dynamicValues;
          if (
            (!t.contentComponent && s && (this.stateProvider.contentComponent = s),
            !t.wrapperComponent && r && void 0 !== r)
          ) {
            ((this.stateProvider.wrapperComponent = r),
              (this.windowToWrapperScaleX = (a = r) ? window.innerWidth / a.offsetWidth : 0),
              (this.windowToWrapperScaleY = (function (e) {
                return e ? window.innerHeight / e.offsetHeight : 0;
              })(r)));
            var o = !1;
            (r.addEventListener("wheel", this.handleWheel, o),
              r.addEventListener("dblclick", this.handleDbClick, o),
              r.addEventListener("touchstart", this.handleTouchStart, o),
              r.addEventListener("touchmove", this.handleTouch, o),
              r.addEventListener("touchend", this.handleTouchStop, o));
          }
          (((r && s) || e.dynamicValues !== n) &&
            (this.maxBounds = Da.call(this, this.stateProvider.scale, this.stateProvider.options.limitToWrapper)),
            e.dynamicValues &&
              e.dynamicValues !== n &&
              ((this.animation = null),
              (this.stateProvider = ma(ma({}, this.stateProvider), Sa(this.stateProvider, n))),
              this.applyTransformation(null, null, null)));
        }),
        (t.prototype.render = function () {
          var e = this.state,
            t = e.wrapperComponent,
            a = e.contentComponent,
            i = {
              loaded: Boolean(t && a),
              state: this.getCallbackProps(),
              dispatch: {
                setScale: this.setScale,
                setPositionX: this.setPositionX,
                setPositionY: this.setPositionY,
                zoomIn: this.zoomIn,
                zoomOut: this.zoomOut,
                setTransform: this.setTransform,
                resetTransform: this.resetTransform,
                setDefaultState: this.setDefaultState,
              },
              nodes: { setWrapperComponent: this.setWrapperComponent, setContentComponent: this.setContentComponent },
            },
            r = this.props.children,
            s = "function" == typeof r ? r(ma(ma({}, i.state), i.dispatch)) : r;
          return o.default.createElement(ii.Provider, { value: i }, s);
        }),
        t
      );
    })(e.Component),
    oi = function (e) {
      var t = e.children,
        a = e.defaultPositionX,
        i = e.defaultPositionY,
        r = e.defaultScale,
        s = e.onWheelStart,
        n = e.onWheel,
        l = e.onWheelStop,
        c = e.onPanningStart,
        d = e.onPanning,
        p = e.onPanningStop,
        u = e.onPinchingStart,
        m = e.onPinching,
        h = e.onPinchingStop,
        f = e.onZoomChange,
        g = (function (e, t) {
          var a = {};
          for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && t.indexOf(i) < 0 && (a[i] = e[i]);
          if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var r = 0;
            for (i = Object.getOwnPropertySymbols(e); r < i.length; r++)
              t.indexOf(i[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[r]) && (a[i[r]] = e[i[r]]);
          }
          return a;
        })(e, [
          "children",
          "defaultPositionX",
          "defaultPositionY",
          "defaultScale",
          "onWheelStart",
          "onWheel",
          "onWheelStop",
          "onPanningStart",
          "onPanning",
          "onPanningStop",
          "onPinchingStart",
          "onPinching",
          "onPinchingStop",
          "onZoomChange",
        ]),
        v = ma({}, g);
      return (
        v.options && v.options.limitToWrapper && (v.options.limitToBounds = !0),
        o.default.createElement(
          ni,
          {
            defaultValues: ba({ positionX: a, positionY: i, scale: r }),
            dynamicValues: ba(ai(v)),
            onWheelStart: s,
            onWheel: n,
            onWheelStop: l,
            onPanningStart: c,
            onPanning: d,
            onPanningStop: p,
            onPinchingStart: u,
            onPinching: m,
            onPinchingStop: h,
            onZoomChange: f,
          },
          t,
        )
      );
    };
  var li = "TransformComponent-module_container__3NwNd",
    ci = "TransformComponent-module_content__TZU5O";
  !(function (e, t) {
    void 0 === t && (t = {});
    var a = t.insertAt;
    if (e && "undefined" != typeof document) {
      var i = document.head || document.getElementsByTagName("head")[0],
        r = document.createElement("style");
      ((r.type = "text/css"),
        "top" === a && i.firstChild ? i.insertBefore(r, i.firstChild) : i.appendChild(r),
        r.styleSheet ? (r.styleSheet.cssText = e) : r.appendChild(document.createTextNode(e)));
    }
  })(
    ".TransformComponent-module_container__3NwNd {\n  position: relative;\n  width: fit-content;\n  height: fit-content;\n  overflow: hidden;\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Safari */\n  -khtml-user-select: none; /* Konqueror HTML */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none;\n  margin: 0;\n  padding: 0;\n}\n.TransformComponent-module_content__TZU5O {\n  display: flex;\n  flex-wrap: wrap;\n  width: fit-content;\n  height: fit-content;\n  margin: 0;\n  padding: 0;\n  transform-origin: 0% 0%;\n}\n.TransformComponent-module_content__TZU5O img {\n  pointer-events: none;\n}\n",
  );
  var di = (function (e) {
    function t() {
      var t = (null !== e && e.apply(this, arguments)) || this;
      return ((t.wrapperRef = o.default.createRef()), (t.contentRef = o.default.createRef()), t);
    }
    return (
      ua(t, e),
      (t.prototype.componentDidMount = function () {
        var e = this.context.nodes;
        (e.setWrapperComponent(this.wrapperRef.current), e.setContentComponent(this.contentRef.current));
      }),
      (t.prototype.render = function () {
        var e = this.props.children,
          t = this.context.state,
          a = t.positionX,
          i = t.positionY,
          r = t.scale,
          s = t.options,
          n = s.wrapperClass,
          l = s.contentClass,
          c = {
            WebkitTransform: "translate(" + a + "px, " + i + "px) scale(" + r + ")",
            transform: "translate(" + a + "px, " + i + "px) scale(" + r + ")",
          };
        return o.default.createElement(
          "div",
          { ref: this.wrapperRef, className: "react-transform-component " + li + " " + n },
          o.default.createElement(
            "div",
            { ref: this.contentRef, className: "react-transform-element " + ci + " " + l, style: c },
            e,
          ),
        );
      }),
      t
    );
  })(o.default.Component);
  di.contextType = ii;
  class pi extends o.default.Component {
    constructor(e) {
      (super(e), pi.prototype.__init.call(this), (this.state = { width: window.innerWidth }));
    }
    componentDidMount() {
      window.addEventListener("resize", this.handleWindowSizeChange);
    }
    componentWillUnmount() {
      window.removeEventListener("resize", this.handleWindowSizeChange);
    }
    __init() {
      this.handleWindowSizeChange = () => {
        this.setState({ width: window.innerWidth });
      };
    }
    render() {
      var e = this.state.width <= 1e3;
      return o.default.createElement(
        "div",
        { className: "product-image__zoom-lightbox" },
        o.default.createElement(
          oi,
          null,
          o.default.createElement(
            di,
            null,
            e && o.default.createElement("img", { src: this.props.source }),
            !e && o.default.createElement("img", { style: { maxHeight: "80vh" }, src: this.props.source }),
          ),
        ),
        o.default.createElement("div", { className: "close-button", onClick: () => this.props.onCloseClick() }),
      );
    }
  }
  function ui(e) {
    for (var t = void 0, a = e[0], i = 1; i < e.length; ) {
      var r = e[i],
        s = e[i + 1];
      if (((i += 2), ("optionalAccess" === r || "optionalCall" === r) && null == a)) return;
      "access" === r || "optionalAccess" === r
        ? ((t = a), (a = s(a)))
        : ("call" !== r && "optionalCall" !== r) ||
          ((a = s(function () {
            for (var e = arguments.length, i = new Array(e), r = 0; r < e; r++) i[r] = arguments[r];
            return a.call(t, ...i);
          })),
          (t = void 0));
    }
    return a;
  }
  pi.displayName = "ProductLightbox";
  var mi = (function () {
    var e = _asyncToGenerator(function* (e, t, a, i) {
      var r,
        s,
        n = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
      if (!ui([window, "access", (e) => e.mori, "optionalAccess", (e) => e.state, "optionalAccess", (e) => e.isB2B]))
        try {
          var o = window.location.hostname,
            l = "https://babymori.myshopify.com/api/2024-10/graphql.json",
            c = "04b86ac123c79f9e1b4848ab6f653b63";
          ("eu.babymori.com" === o &&
            ((l = "https://mori-de.myshopify.com/api/2024-10/graphql.json"), (c = "c571e38577cc776a7892924efb91f83b")),
            "us.babymori.com" === o &&
              ((l = "https://babymoriusa.myshopify.com/api/2024-10/graphql.json"),
              (c = "f534d54bc606eb6099901500cea29d53")),
            "dev.babymori.com" === o &&
              ((l = "https://moridev.myshopify.com/api/2024-10/graphql.json"),
              (c = "18232881a014305fccf115eea8b97b27")));
          var d = 'query MyQuery {\n        product(id: "gid://shopify/Product/'
              .concat(a, '") {\n          metafield(key: "')
              .concat(e, '", namespace: "')
              .concat(
                t,
                '") {\n            value \n            references(first: 250) {\n              nodes {\n                ... on Product {\n                  handle \n                }\n              }\n            }\n          }    \n        }\n      }',
              ),
            p = JSON.stringify({ query: d, variables: {} }),
            u = yield pt.post(l, p, {
              headers: { "X-Shopify-Storefront-Access-Token": c, "Content-Type": "application/json" },
              signal: i.signal,
            });
          return u.data.data.product
            ? n
              ? ui([
                  u,
                  "access",
                  (e) => e.data,
                  "access",
                  (e) => e.data,
                  "access",
                  (e) => e.product,
                  "optionalAccess",
                  (e) => e.metafield,
                ])
              : ((r = ui([
                  u,
                  "access",
                  (e) => e.data,
                  "access",
                  (e) => e.data,
                  "access",
                  (e) => e.product,
                  "optionalAccess",
                  (e) => e.metafield,
                  "optionalAccess",
                  (e) => e.value,
                ])),
                (s = () => "_"),
                null != r ? r : s())
            : "_";
        } catch (e) {
          if (e.response) console.error("Error response:", e.response);
          else {
            if ("canceled" === e.message.toLowerCase()) return "_";
            console.error("error occurred:", e);
          }
          return "_";
        }
    });
    return function (t, a, i, r) {
      return e.apply(this, arguments);
    };
  })();
  var hi = (t) => {
      var a = _slicedToArray(e.useState(null), 2),
        i = a[0],
        r = a[1],
        s = _slicedToArray(e.useState(null), 2),
        n = s[0],
        o = s[1];
      return (
        e.useEffect(() => {
          (r(null), o(null));
          var e = new AbortController(),
            a = t.variants.some((e) => {
              return ((t = e.compare_at_price), (a = () => 0), (null != t ? t : a()) > 0);
              var t, a;
            }),
            i = (function () {
              var i = _asyncToGenerator(function* () {
                try {
                  if (!a) {
                    var i = yield mi("buy_x_get_y", "custom", t.id, e);
                    if (!e.signal.aborted) {
                      var s = i.replace(/^\["\**|\**"\]$/g, "");
                      if (s && "_" !== s) {
                        var n = s.split("&");
                        if (2 === n.length) {
                          var l = n[0].split(" ").slice(0, 2).join(" ");
                          r("".concat(l.trim(), " & ").concat(n[1].trim()));
                        } else r(s);
                      }
                    }
                  }
                  var c = document.getElementById("ProductMetafieldsRoot"),
                    d = c ? JSON.parse(c.innerHTML) : null;
                  if (d && d[t.id]) {
                    var p = d[t.id];
                    o(p);
                  }
                } catch (t) {
                  e.signal.aborted || console.error("Error fetching product metafields:", t);
                }
              });
              return function () {
                return i.apply(this, arguments);
              };
            })();
          return (
            i(),
            () => {
              e.abort();
            }
          );
        }, [t.id, t.variants]),
        { promoMessage: i, roundelText: n }
      );
    },
    fi = (e) => (t) => {
      var a = hi(t.product),
        i = a.promoMessage,
        r = a.roundelText;
      return o.default.createElement(e, _objectSpread(_objectSpread({}, t), {}, { promoMessage: i, roundelText: r }));
    };
  function gi(e) {
    for (var t = void 0, a = e[0], i = 1; i < e.length; ) {
      var r = e[i],
        s = e[i + 1];
      if (((i += 2), ("optionalAccess" === r || "optionalCall" === r) && null == a)) return;
      "access" === r || "optionalAccess" === r
        ? ((t = a), (a = s(a)))
        : ("call" !== r && "optionalCall" !== r) ||
          ((a = s(function () {
            for (var e = arguments.length, i = new Array(e), r = 0; r < e; r++) i[r] = arguments[r];
            return a.call(t, ...i);
          })),
          (t = void 0));
    }
    return a;
  }
  class vi extends o.default.Component {
    __init() {
      this.filterPrefix = "filter_image_";
    }
    __init2() {
      this.enableLifestyleViews = !1;
    }
    constructor(e) {
      (super(e),
        vi.prototype.__init.call(this),
        vi.prototype.__init2.call(this),
        vi.prototype.__init3.call(this),
        vi.prototype.__init4.call(this),
        vi.prototype.__init5.call(this),
        vi.prototype.__init6.call(this));
      var t,
        a,
        i = this.filterImages(this.props.initialVariant),
        r = i.images,
        s = i.slidesToShow,
        n = this.props.initialVariant;
      if (document.getElementById("EnableLifestyleImagesPDP")) {
        var l = document.getElementById("EnableLifestyleImagesPDP");
        if (l) {
          var c = JSON.parse(l.textContent || "{}");
          this.enableLifestyleViews =
            ((t = gi([c, "optionalAccess", (e) => e.enable_lifestyle_images])), (a = () => !1), null != t ? t : a());
        }
      }
      var d = this.hasAnyImageFilterTags(this.props.images),
        p = this.variantSlideIndex(r, n);
      ((this.sliderComponent = o.default.createRef()),
        (this.state = {
          allImages: this.props.images,
          images: r,
          variant: n,
          slideIndex: p,
          initialSlideIndex: p,
          lightboxActive: !1,
          slidesToShow: s,
          movedByVariantChange: !1,
          movedBySwipe: !1,
          movedByNavigationImage: !1,
          pdpSliderABTestActive: !1,
          hasAnyImageFilterTags: d,
          isMobile: window.innerWidth <= 769,
        }),
        (this.onCloseClick = this.onCloseClick.bind(this)),
        (this.handleFlagChange = this.handleFlagChange.bind(this)),
        (this.handleMobileImageSliderTest = this.handleMobileImageSliderTest.bind(this)));
    }
    componentDidMount() {
      (window.addEventListener("resize", this.handleWindowSizeChange),
        window.addEventListener("flag.swap_images", this.handleFlagChange),
        window.dispatchEvent(new CustomEvent("flag.swap_images.mounted")),
        document.addEventListener("variantChanged", this.handleVariantChange),
        window.addEventListener("flag.mobile_image_slider_test", this.handleMobileImageSliderTest));
    }
    componentDidUpdate(e, t, a) {
      t.pdpSliderABTestActive !== this.state.pdpSliderABTestActive &&
        this.state.isMobile &&
        this.addEventListenersForAbTest();
    }
    addEventListenersForAbTest() {
      var e,
        t = this.sliderComponent.current,
        a = 0,
        i = t.style.touchAction;
      (t.addEventListener("touchstart", (e) => {
        var t = e.changedTouches[0];
        a = t.screenX;
      }),
        t.addEventListener("touchmove", (r) => {
          var s = r.changedTouches[0],
            n = s.screenX - a;
          Math.abs(n) > 15
            ? ((t.style.touchAction = "pinch-zoom"),
              clearTimeout(e),
              (e = setTimeout(() => (t.style.touchAction = i), 3e3)))
            : (t.style.touchAction = i);
        }));
    }
    componentWillUnmount() {
      (window.removeEventListener("resize", this.handleWindowSizeChange),
        window.removeEventListener("flag.swap_images", this.handleFlagChange),
        document.removeEventListener("variantChanged", this.handleVariantChange),
        window.removeEventListener("flag.mobile_image_slider_test", this.handleMobileImageSliderTest));
    }
    __init3() {
      this.handleWindowSizeChange = () => {
        var e = window.innerWidth <= 767;
        this.setState({ isMobile: e });
      };
    }
    __init4() {
      this.handleFlagChange = () => {
        if (
          gi([
            this,
            "access",
            (e) => e.props,
            "access",
            (e) => e.product,
            "optionalAccess",
            (e) => e.tags,
            "optionalAccess",
            (e) => e.includes,
            "call",
            (e) => e("dino_collection"),
          ])
        ) {
          var e = this.props.images,
            t = e[0],
            a = e[1];
          ((e[0] = a), (e[1] = t), this.setState({ allImages: e }));
          var i = this.filterImages(this.state.variant),
            r = i.images,
            s = i.slidesToShow;
          this.setState({ images: r, slidesToShow: s });
        }
        window.removeEventListener("flag.swap_images", this.handleFlagChange);
      };
    }
    __init5() {
      this.handleMobileImageSliderTest = () => {
        if (this.state.isMobile) {
          document.querySelector('meta[name="viewport"]') &&
            (document.querySelector('meta[name="viewport"]').content =
              "user-scalable=yes, initial-scale=1, maximum-scale=3, minimum-scale=0.5, width=device-width, height=device-height, target-densitydpi=device-dpi");
          var e = this.filterImages(this.state.variant, !0),
            t = e.images,
            a = e.slidesToShow,
            i = 0;
          (this.state.hasAnyImageFilterTags || (i = this.variantSlideIndex(t, this.state.variant)),
            this.setState({ pdpSliderABTestActive: !0, images: t, slidesToShow: a, slideIndex: i }));
        }
      };
    }
    __init6() {
      this.handleVariantChange = (e) => {
        var t = e.detail.variant;
        if (t) {
          var a = this.filterImages(t, this.state.pdpSliderABTestActive),
            i = a.images,
            r = a.slidesToShow,
            s = this.variantSlideIndex(i, t);
          (this.state.pdpSliderABTestActive && this.state.isMobile && this.state.hasAnyImageFilterTags && (s = 0),
            this.setState(
              { images: i, variant: t, slideIndex: s, initialSlideIndex: s, slidesToShow: r, movedByVariantChange: !0 },
              () => {
                (this.slider.slickGoTo(s, !0),
                  this.state.pdpSliderABTestActive &&
                    this.state.isMobile &&
                    setTimeout(() => this.slider.slickGoTo(s), 100));
              },
            ));
        }
      };
    }
    onCloseClick() {
      this.setState({ lightboxActive: !1 });
    }
    vwoTestEventSetup() {
      window.VWO &&
        ((window.VWO = window.VWO || []),
        (window.VWO.event =
          window.VWO.event ||
          function () {
            window.VWO.push(["event"].concat([].slice.call(arguments)));
          }),
        window.VWO.event("pdp", { image_swipe: !0 }));
    }
    logImageChange() {
      if (!this.state.movedByVariantChange)
        return this.state.movedBySwipe
          ? (this.setState({ movedBySwipe: !1 }),
            this.state.pdpSliderABTestActive && this.state.isMobile && this.vwoTestEventSetup(),
            void P.gtmTriggerEvents("image_slider", "swipe", "image_swipe"))
          : this.state.movedByNavigationImage
            ? (this.setState({ movedByNavigationImage: !1 }),
              void P.gtmTriggerEvents("image_slider", "click", "image_thumbnail"))
            : void P.gtmTriggerEvents("image_slider", "click", "arrow_scroll");
      this.setState({ movedByVariantChange: !1 });
    }
    filterAlt(e) {
      var t = _t.alternative_handleize(e.toLowerCase());
      return ((t = t.replace(/-/g, "_")), "".concat(this.filterPrefix).concat(t));
    }
    hasAnyImageFilterTags(e) {
      var t = [
        this.filterAlt(this.props.initialVariant.option1 || ""),
        this.filterAlt(this.props.initialVariant.option2 || ""),
        this.filterAlt(this.props.initialVariant.option3 || ""),
      ];
      return (
        (t = t.map((e) => (e !== this.filterPrefix ? e : "")).filter(Boolean)),
        e.some((e) => {
          var t = e.alt || "";
          return (t = t.toLowerCase()).includes(this.filterPrefix);
        })
      );
    }
    filterImages(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
        a = 5,
        i = this.props.images.filter((e) => !(e.alt || "").includes("personalisation_image")),
        r = [this.filterAlt(e.option1 || ""), this.filterAlt(e.option2 || ""), this.filterAlt(e.option3 || "")];
      if (
        ((r = r.map((e) => (e !== this.filterPrefix ? e : "")).filter(Boolean)),
        0 ===
          (i = i.filter((e) => {
            var t = e.alt || "";
            return (
              !(t = t.toLowerCase()).includes(this.filterPrefix) ||
              (t.includes(",")
                ? r.some((e) => t.split(",").some((t) => t.trim() === e.trim()))
                : r.some((e) => t.split(" ").some((t) => t.trim() === e.trim())))
            );
          })).length && (i = this.props.images.filter((e) => !(e.alt || "").includes("personalisation_image"))),
        0 === i.length)
      )
        return {
          images: this.props.images.filter((e) => !(e.alt || "").includes("personalisation_image")),
          slidesToShow: a,
        };
      if ((i.length < 6 && (a = i.length), !this.props.isProductImageHorizontal && !t))
        for (; i.length < 6; ) i = [...i, ...i];
      return (
        "color" ===
          gi([
            this,
            "access",
            (e) => e.props,
            "access",
            (e) => e.product,
            "access",
            (e) => e.options,
            "access",
            (e) => e[0],
            "optionalAccess",
            (e) => e.toLowerCase,
            "call",
            (e) => e(),
          ]) ||
        "colour" ===
          gi([
            this,
            "access",
            (e) => e.props,
            "access",
            (e) => e.product,
            "access",
            (e) => e.options,
            "access",
            (e) => e[0],
            "optionalAccess",
            (e) => e.toLowerCase,
            "call",
            (e) => e(),
          ])
          ? e.option1
          : ("color" !==
              gi([
                this,
                "access",
                (e) => e.props,
                "access",
                (e) => e.product,
                "access",
                (e) => e.options,
                "access",
                (e) => e[1],
                "optionalAccess",
                (e) => e.toLowerCase,
                "call",
                (e) => e(),
              ]) &&
              "colour" !==
                gi([
                  this,
                  "access",
                  (e) => e.props,
                  "access",
                  (e) => e.product,
                  "access",
                  (e) => e.options,
                  "access",
                  (e) => e[1],
                  "optionalAccess",
                  (e) => e.toLowerCase,
                  "call",
                  (e) => e(),
                ])) ||
            e.option2,
        { images: i, slidesToShow: a }
      );
    }
    variantSlideIndex(e, t) {
      var a = e.findIndex((e) => e.src.split("?")[0] === (t.featured_image || { src: "" }).src.split("?")[0]);
      return ((-1 === a || (this.enableLifestyleViews && (a -= 1) < 0)) && (a = 0), a);
    }
    render() {
      return this.state.isMobile ? this.renderMobile() : this.renderDesktop();
    }
    renderMobile() {
      var e = this.props.isProductImageHorizontal ? 2 : 1,
        t = this.props.roundelText,
        a = !!t,
        i = this.state.pdpSliderABTestActive ? "pdpSliderABTestActive" : "";
      return o.default.createElement(
        o.default.Fragment,
        null,
        o.default.createElement(
          "div",
          { className: i, ref: this.sliderComponent },
          o.default.createElement(
            p.default,
            {
              adaptiveHeight: !1,
              arrows: !this.state.pdpSliderABTestActive,
              afterChange: (e) => {
                (this.setState({ slideIndex: e }), this.logImageChange());
              },
              customPaging: (e) =>
                4 === e && this.state.slideIndex > 4 && this.state.slideIndex + 1 === this.state.images.length
                  ? o.default.createElement("button", { className: "fill_dot_right--disabled" }, e + 1)
                  : 4 === e && this.state.slideIndex > 4
                    ? o.default.createElement("button", { className: "fill_dot_right" }, e + 1)
                    : e <= 4
                      ? o.default.createElement("button", null, e + 1)
                      : o.default.createElement("div", { className: "hide_dot" }),
              onSwipe: () => this.setState({ movedBySwipe: !0 }),
              className: "product-image__slider",
              easing: "linear",
              infinite: !this.state.pdpSliderABTestActive,
              initialSlide: this.state.slideIndex,
              ref: (e) => (this.slider = e),
              slidesToScroll: e,
              slidesToShow: 1 === this.state.images.length ? 1 : e,
              dots: this.state.pdpSliderABTestActive,
              centerMode: this.state.pdpSliderABTestActive,
              swipeToSlide: !0,
              centerPadding: 0,
              responsive: [
                { breakpoint: 1024, settings: { centerPadding: 0 } },
                { breakpoint: 600, settings: { centerPadding: 40 } },
                { breakpoint: 500, settings: { centerPadding: 30 } },
                { breakpoint: 410, settings: { centerPadding: 20 } },
                { breakpoint: 361, settings: { centerPadding: 10 } },
              ],
            },
            this.state.images.map((e, i) =>
              o.default.createElement(
                wi,
                { image: e, product: this.props.product, key: i },
                o.default.createElement(la, { altTag: e.alt, hoverAltTag: "", dealRoundel: this.props.dealRoundel }),
                o.default.createElement(
                  "div",
                  { className: "pdp-top-left-messages" },
                  o.default.createElement(
                    "div",
                    { className: "image_messages_container" },
                    a && o.default.createElement(ca, { shouldShow: !0, fieldText: t }),
                  ),
                ),
                !this.state.pdpSliderABTestActive &&
                  o.default.createElement(bi, {
                    onZoomClick: () => {
                      (this.setState({ lightboxActive: !0, slideIndex: i }),
                        P.gtmTriggerEvents("image_slider", "zoom", "mobile__image_zoom"));
                    },
                  }),
              ),
            ),
          ),
          o.default.createElement(da, {
            productMetafields: this.props.productMetafields,
            product: this.props.product,
            discountRuleIcon: this.props.discountRuleIcon,
          }),
          this.state.lightboxActive &&
            o.default.createElement(pi, {
              source: this.state.images[this.state.slideIndex].src,
              onCloseClick: this.onCloseClick,
            }),
        ),
      );
    }
    renderDesktop() {
      var e = this.state.images[this.state.slideIndex],
        t = this.props.roundelText,
        a = !!t;
      return o.default.createElement(
        o.default.Fragment,
        null,
        o.default.createElement(
          "div",
          {
            className: "product-image-desktop__container ".concat(
              this.props.isProductImageHorizontal ? "horizontal_layout" : "",
            ),
          },
          o.default.createElement(
            "div",
            { className: "product-image-desktop__navigation" },
            o.default.createElement(
              p.default,
              {
                arrows: !0,
                beforeChange: (e, t) => this.setState({ slideIndex: t }),
                afterChange: () => this.logImageChange(),
                centerMode: !1,
                dots: !1,
                initialSlide: this.state.initialSlideIndex,
                ref: (e) => (this.slider = e),
                slidesToScroll: 1,
                slidesToShow: this.state.slidesToShow,
                infinite: !0,
                variableWidth: this.props.isProductImageHorizontal,
                focusOnSelect: !0,
                vertical: !this.props.isProductImageHorizontal,
                draggable: !0,
              },
              this.state.images.map((e, t) =>
                o.default.createElement(yi, {
                  key: t,
                  image: e,
                  onClick: () => {
                    this.setState({ movedByNavigationImage: !0 });
                  },
                  product: this.props.product,
                }),
              ),
            ),
          ),
          o.default.createElement(
            _i,
            {
              metafields: this.props.productMetafields,
              image: e,
              product: this.props.product,
              discountRuleIcon: this.props.discountRuleIcon,
            },
            o.default.createElement(la, { altTag: e.alt, hoverAltTag: "", dealRoundel: this.props.dealRoundel }),
            o.default.createElement(
              "div",
              { className: "pdp-top-left-messages" },
              o.default.createElement(
                "div",
                { className: "image_messages_container" },
                a && o.default.createElement(ca, { shouldShow: !0, fieldText: t }),
              ),
            ),
            o.default.createElement(bi, {
              onZoomClick: () => {
                (this.setState({ lightboxActive: !0 }),
                  P.gtmTriggerEvents("image_slider", "zoom", "desktop__image_zoom"));
              },
            }),
          ),
        ),
        this.state.lightboxActive && o.default.createElement(pi, { source: e.src, onCloseClick: this.onCloseClick }),
      );
    }
  }
  vi.displayName = "ProductImages";
  var _i = (t) => {
      var a = t.image.alt || "",
        i = a.length && a.includes(".mp4") ? Si(a) : null;
      ("video" === t.image.media_type &&
        (i = gi([
          t,
          "access",
          (e) => e.image,
          "access",
          (e) => e.sources,
          "optionalAccess",
          (e) => e[0],
          "access",
          (e) => e.url,
        ])),
        console.log("isMp4", i));
      var r,
        s,
        n = _slicedToArray(e.useState(""), 2),
        l = n[0],
        c = n[1];
      return (
        (r = t.image.src),
        ((s = new Image()).src = r),
        (s.onload = function (e) {
          var t = e.currentTarget;
          t.width !== t.height && c("kidly-by-mori");
        }),
        o.default.createElement(
          "div",
          { className: "product-image-desktop__image-container" },
          !i &&
            o.default.createElement(
              "div",
              {
                className: "product-image-desktop__image ".concat(l),
                style: { backgroundImage: "url('".concat(_t.imgURL(t.image.src, "1000x1000"), "')") },
              },
              t.children,
            ),
          i &&
            o.default.createElement(
              "video",
              { autoPlay: !0, loop: !0, muted: !0, style: { width: "100%", height: "100%" } },
              o.default.createElement("source", { type: "video/mp4", src: i }),
              "Your browser doesn't support HTML5 video tag.",
            ),
          o.default.createElement(da, {
            productMetafields: t.metafields,
            product: t.product,
            discountRuleIcon: t.discountRuleIcon,
          }),
        )
      );
    },
    yi = (t) => {
      var a,
        i,
        r = _slicedToArray(e.useState(""), 2),
        s = r[0],
        n = r[1];
      return (
        (a = t.image.src),
        (i = new Image()),
        "video" === t.image.media_type
          ? (i.src =
              gi([t, "access", (e) => e.image, "access", (e) => e.preview_image, "optionalAccess", (e) => e.src]) || "")
          : (i.src = a),
        (i.onload = function (e) {
          var t = e.currentTarget;
          t.width !== t.height && n("kidly-by-mori");
        }),
        o.default.createElement(
          "div",
          { onClick: t.onClick },
          o.default.createElement("img", {
            className: "product-image-desktop__navigation-image ".concat(s),
            src: _t.imgURL(
              "video" === t.image.media_type
                ? gi([t, "access", (e) => e.image, "access", (e) => e.preview_image, "optionalAccess", (e) => e.src])
                : t.image.src,
              "130x130",
            ),
            width: "65",
            height: "65",
          }),
        )
      );
    },
    bi = (e) => o.default.createElement("div", { className: "product-image__zoom-button", onClick: e.onZoomClick }),
    wi = (t) => {
      var a,
        i,
        r = t.image.alt || "",
        s = _slicedToArray(e.useState(""), 2),
        n = s[0],
        l = s[1],
        c = r.length && r.includes(".mp4") ? Si(r) : null;
      return (
        "video" === t.image.media_type &&
          (c = gi([
            t,
            "access",
            (e) => e.image,
            "access",
            (e) => e.sources,
            "optionalAccess",
            (e) => e[0],
            "access",
            (e) => e.url,
          ])),
        (a = t.image.src),
        ((i = new Image()).src = a),
        (i.onload = function (e) {
          var t = e.currentTarget;
          t.width !== t.height && l("kidly-by-mori");
        }),
        o.default.createElement(
          "div",
          { className: "product-image__image-container" },
          !c && o.default.createElement(At, { image: t.image, className: "product-image__image ".concat(n) }),
          c &&
            o.default.createElement(
              "video",
              {
                autoPlay: !0,
                controls: !0,
                loop: !0,
                muted: !0,
                playsInline: !0,
                className: "product-image__image",
                style: { width: "100%", height: "100%" },
              },
              o.default.createElement("source", { type: "video/mp4", src: c }),
              "Your browser doesn't support HTML5 video tag.",
            ),
          !c && t.children,
        )
      );
    };
  function Si(e) {
    return (e.includes(",") ? e.split(",") : e.split(" ")).find((e) => e.includes(".mp4"));
  }
  ((_i.displayName = "DesktopPrimaryImage"),
    (yi.displayName = "DesktopProductNavigationImage"),
    (bi.displayName = "ProductImageZoomButton"),
    (wi.displayName = "MobileProductImage"));
  var Ei = fi(vi);
  function Ci(e) {
    for (var t = void 0, a = e[0], i = 1; i < e.length; ) {
      var r = e[i],
        s = e[i + 1];
      if (((i += 2), ("optionalAccess" === r || "optionalCall" === r) && null == a)) return;
      "access" === r || "optionalAccess" === r
        ? ((t = a), (a = s(a)))
        : ("call" !== r && "optionalCall" !== r) ||
          ((a = s(function () {
            for (var e = arguments.length, i = new Array(e), r = 0; r < e; r++) i[r] = arguments[r];
            return a.call(t, ...i);
          })),
          (t = void 0));
    }
    return a;
  }
  class Pi extends o.default.Component {
    constructor(e) {
      super(e);
      var t = this.getSettingToUse(),
        a = Ci([t, "optionalAccess", (e) => e.isUS]) || !1;
      this.state = { isModalActive: !1, showMetric: !a, showImperial: a, settings: t, isB2B: window.mori.state.isB2B };
    }
    getSettingToUse() {
      (this.props.settings, this.props.settings.length);
      var e = this.props.settings[0],
        t = 4;
      return (
        this.props.settings.map((a) => {
          var i = a.matchedImportance.indexOf(!0);
          -1 !== i && i < t && ((t = i), (e = a));
        }),
        e
      );
    }
    componentDidMount() {
      this.setState({
        showMetric:
          !(
            !Ci([
              this,
              "access",
              (e) => e.state,
              "access",
              (e) => e.settings,
              "optionalAccess",
              (e) => e.metricContent,
            ]) ||
            Ci([
              this,
              "access",
              (e) => e.state,
              "access",
              (e) => e.settings,
              "optionalAccess",
              (e) => e.imperialContent,
            ])
          ) || this.state.showMetric,
        showImperial:
          !(
            !Ci([
              this,
              "access",
              (e) => e.state,
              "access",
              (e) => e.settings,
              "optionalAccess",
              (e) => e.imperialContent,
            ]) ||
            Ci([this, "access", (e) => e.state, "access", (e) => e.settings, "optionalAccess", (e) => e.metricContent])
          ) || this.state.showImperial,
      });
    }
    render() {
      return (
        Ci([
          document,
          "access",
          (e) => e.querySelector,
          "call",
          (e) => e(".size_return--wrapper.shimmer_size_and_return"),
          "optionalAccess",
          (e) => e.classList,
          "access",
          (e) => e.remove,
          "call",
          (e) => e("shimmer_size_and_return"),
        ]),
        Ci([this, "access", (e) => e.state, "access", (e) => e.settings, "optionalAccess", (e) => e.hasSizeGuide])
          ? o.default.createElement(
              "div",
              null,
              this.renderSizeGuideButton(),
              this.state.isModalActive ? this.renderModal() : o.default.createElement(o.default.Fragment, null),
            )
          : (Ci([
              document,
              "access",
              (e) => e.querySelector,
              "call",
              (e) => e("#SizeGuidesNode"),
              "optionalAccess",
              (e) => e.remove,
              "call",
              (e) => e(),
            ]),
            o.default.createElement(o.default.Fragment, null))
      );
    }
    renderSizeGuideButton() {
      return o.default.createElement(
        "div",
        { className: "size-guide-button-wrapper" },
        o.default.createElement(
          "div",
          {
            className: "size-guide--wrapper",
            onClick: () => {
              (this.onSizeGuideClick(), P.gtmTriggerEvents("size_guide", "icon_click", "size guide opened"));
            },
          },
          o.default.createElement(
            "div",
            { id: "sizeBtn" },
            Ci([
              this,
              "access",
              (e) => e.state,
              "access",
              (e) => e.settings,
              "optionalAccess",
              (e) => e.togGuideLines,
              "access",
              (e) => e.length,
            ]) > 0
              ? "size & tog guide"
              : "size guide",
          ),
        ),
      );
    }
    renderModal() {
      var e = !1;
      var modal = o.default.createElement(
        "div",
        {
          className: "popup-wrapper mori-size-guide-overlay "
            .concat(this.state.isModalActive ? "show-popup" : "hide-popup", " ")
            .concat(this.state.isB2B ? "isB2B" : ""),
          onClick: (e) => this.areaAroundPopupClicked(e),
        },
        o.default.createElement(
          "div",
          { className: "popup ".concat(this.state.isB2B ? "isB2B" : "") },
          o.default.createElement(
            "div",
            { className: "popup-content" },
            o.default.createElement(
              "div",
              { className: "top_part_wrapper" },
              o.default.createElement(
                "div",
                { className: "green_header_bar" },
                this.state.settings.enable_image
                  ? o.default.createElement(
                      "span",
                      { className: "popupProductTitle" },
                      " ",
                      Ci([
                        this,
                        "access",
                        (e) => e.state,
                        "access",
                        (e) => e.settings,
                        "optionalAccess",
                        (e) => e.sizeGuideTitle,
                      ]),
                    )
                  : o.default.createElement("span", {
                      className: "mori-mascot-icon",
                      dangerouslySetInnerHTML: {
                        __html: Ci([
                          document,
                          "access",
                          (e) => e.getElementById,
                          "call",
                          (e) => e("global_svg_template"),
                          "optionalAccess",
                          (e) => e.content,
                          "access",
                          (e) => e.querySelector,
                          "call",
                          (e) => e("#mori-mascot svg"),
                          "optionalAccess",
                          (e) => e.outerHTML,
                        ]),
                      },
                    }),
                o.default.createElement(
                  "div",
                  {
                    className: "close-wrapper",
                    onClick: (e) => {
                      (this.onCloseModalClick(), P.gtmTriggerEvents("size_guide", "icon_click", "size guide closed"));
                    },
                  },
                  o.default.createElement("div", { className: "close-icon" }),
                ),
              ),
              Ci([
                this,
                "access",
                (e) => e.state,
                "access",
                (e) => e.settings,
                "optionalAccess",
                (e) => e.isImageOnlySizeGuide,
              ])
                ? o.default.createElement(
                    "div",
                    { className: "image_only_wrapper" },
                    o.default.createElement("img", {
                      src: Ci([
                        this,
                        "access",
                        (e) => e.state,
                        "access",
                        (e) => e.settings,
                        "optionalAccess",
                        (e) => e.imageOnlyImage,
                        "access",
                        (e) => e.src,
                      ]),
                      srcSet: Ci([
                        this,
                        "access",
                        (e) => e.state,
                        "access",
                        (e) => e.settings,
                        "optionalAccess",
                        (e) => e.imageOnlyImage,
                        "access",
                        (e) => e.srcset,
                      ]),
                    }),
                  )
                : o.default.createElement(
                    "div",
                    null,
                    Ci([
                      this,
                      "access",
                      (e) => e.state,
                      "access",
                      (e) => e.settings,
                      "optionalAccess",
                      (e) => e.metricContent,
                      "access",
                      (e) => e.includes,
                      "call",
                      (e) => e("<img"),
                    ]) &&
                      o.default.createElement(
                        "div",
                        { className: "size-guide-image" },
                        (e = !0),
                        Ci([
                          this,
                          "access",
                          (e) => e.state,
                          "access",
                          (e) => e.settings,
                          "optionalAccess",
                          (e) => e.guideImageSRC,
                        ]) &&
                          o.default.createElement("img", {
                            src: Ci([
                              this,
                              "access",
                              (e) => e.state,
                              "access",
                              (e) => e.settings,
                              "optionalAccess",
                              (e) => e.guideImageSRC,
                            ]),
                            alt: "",
                          }),
                      ),
                    o.default.createElement(
                      "div",
                      { className: "chosen-size-unit" },
                      Ci([this, "access", (e) => e.state, "access", (e) => e.settings, "optionalAccess", (e) => e.isUS])
                        ? this.renderUSStore()
                        : this.renderOtherStores(),
                    ),
                  ),
            ),
            !0 !==
              Ci([
                this,
                "access",
                (e) => e.state,
                "access",
                (e) => e.settings,
                "optionalAccess",
                (e) => e.isImageOnlySizeGuide,
              ]) &&
              o.default.createElement(
                "div",
                { className: "size-content " + "".concat(e ? "show_image" : "") },
                o.default.createElement(
                  "section",
                  { id: "scrollbar" },
                  Ci([
                    this,
                    "access",
                    (e) => e.state,
                    "access",
                    (e) => e.settings,
                    "optionalAccess",
                    (e) => e.metricContent,
                  ]) &&
                    o.default.createElement("span", {
                      className: "metricUnits ".concat(
                        this.state.showMetric ? "show-size-content" : "hide-size-content",
                      ),
                      dangerouslySetInnerHTML: {
                        __html: Ci([
                          this,
                          "access",
                          (e) => e.state,
                          "access",
                          (e) => e.settings,
                          "optionalAccess",
                          (e) => e.metricContent,
                        ]),
                      },
                    }),
                  Ci([
                    this,
                    "access",
                    (e) => e.state,
                    "access",
                    (e) => e.settings,
                    "optionalAccess",
                    (e) => e.imperialContent,
                  ]) &&
                    o.default.createElement("span", {
                      className: "imperialUnits ".concat(
                        this.state.showImperial ? "show-size-content" : "hide-size-content",
                      ),
                      dangerouslySetInnerHTML: {
                        __html: Ci([
                          this,
                          "access",
                          (e) => e.state,
                          "access",
                          (e) => e.settings,
                          "optionalAccess",
                          (e) => e.imperialContent,
                        ]),
                      },
                    }),
                ),
                Ci([
                  this,
                  "access",
                  (e) => e.state,
                  "access",
                  (e) => e.settings,
                  "optionalAccess",
                  (e) => e.togGuideLines,
                  "access",
                  (e) => e.length,
                ]) > 0 &&
                  o.default.createElement(
                    "div",
                    { className: "tog-size-guide-container" },
                    o.default.createElement("div", { className: "tog-size-guide-title" }, "how to dress"),
                    o.default.createElement(
                      "div",
                      { className: "tog-size-guide-table" },
                      o.default.createElement(
                        "div",
                        {
                          className: "tog-size-guide-headers",
                          style: { backgroundColor: this.state.settings.togHeaderColor },
                        },
                        o.default.createElement("div", { className: "tog-size-guide-header" }, "ROOM TEMP"),
                        o.default.createElement("div", { className: "tog-size-guide-header" }, "SLEEPING BAG"),
                        o.default.createElement("div", { className: "tog-size-guide-header" }, "WHAT TO WEAR"),
                      ),
                      o.default.createElement(
                        "div",
                        { className: "tog-size-guide-lines" },
                        Ci([
                          this,
                          "access",
                          (e) => e.state,
                          "access",
                          (e) => e.settings,
                          "access",
                          (e) => e.togGuideLines,
                          "optionalAccess",
                          (e) => e.map,
                          "call",
                          (e) =>
                            e((e) =>
                              o.default.createElement(
                                "div",
                                {
                                  className: "tog-size-guide-lines-container",
                                  style: { backgroundColor: e.togLineColor },
                                },
                                o.default.createElement(
                                  "div",
                                  { className: "tog-size-guide-line-room-temps" },
                                  e.togRoomTemp.map((e) =>
                                    o.default.createElement(
                                      "div",
                                      { className: "tog-size-guide-line-room-temp" },
                                      o.default.createElement(
                                        "div",
                                        { className: "tog-size-guide-line-room-temp-celcius" },
                                        e.split("|")[0],
                                      ),
                                      o.default.createElement(
                                        "div",
                                        { className: "tog-size-guide-line-room-temp-farenheit" },
                                        e.split("|")[1],
                                      ),
                                    ),
                                  ),
                                ),
                                o.default.createElement(
                                  "div",
                                  { className: "tog-size-guide-line-size" },
                                  o.default.createElement("div", {
                                    className: "tog-sleeping-bag-icon ".concat(
                                      "true" === e.alternateSleepingBagIcon ? "alternate-tog-sleeping-bag-icon" : "",
                                    ),
                                  }),
                                  e.togSize,
                                ),
                                o.default.createElement(
                                  "div",
                                  { className: "tog-size-guide-line-pairings" },
                                  e.togPairings.map((e) =>
                                    o.default.createElement(
                                      "div",
                                      { className: "tog-size-guide-line-pairing" },
                                      ...this.renderBagImages(e),
                                    ),
                                  ),
                                ),
                              ),
                            ),
                        ]),
                      ),
                    ),
                    o.default.createElement(
                      "div",
                      { className: "tog-size-guide-subscript" },
                      "These are gentle recommendations-always follow your instincts and your baby's comfort when dressing them for sleep.",
                    ),
                  ),
              ),
          ),
        ),
      );

      return c.default.createPortal(modal, document.body);
    }
    renderBagImages(e) {
      var t = [],
        a = e.split(" ");
      for (var i of a)
        i.includes("[p1]")
          ? t.push(o.default.createElement("div", { className: "p1" }))
          : i.includes("[p2]")
            ? t.push(o.default.createElement("div", { className: "p2" }))
            : i.includes("[p3]")
              ? t.push(o.default.createElement("div", { className: "p3" }))
              : i.includes("[p4]")
                ? t.push(o.default.createElement("div", { className: "p4" }))
                : i.includes("[p5]")
                  ? t.push(o.default.createElement("div", { className: "p5" }))
                  : i.includes("[p6]")
                    ? t.push(o.default.createElement("div", { className: "p6" }))
                    : t.push(i);
      return t;
    }
    renderUSStore() {
      return o.default.createElement(
        o.default.Fragment,
        null,
        Ci([this, "access", (e) => e.state, "access", (e) => e.settings, "optionalAccess", (e) => e.imperialContent]) &&
          o.default.createElement(
            "div",
            {
              className: "imperial-unit-chosen ".concat(this.state.showImperial ? "selected-tab" : "unselected-tab"),
              onClick: () => this.onImpericalContent(),
            },
            "inches",
          ),
        Ci([this, "access", (e) => e.state, "access", (e) => e.settings, "optionalAccess", (e) => e.metricContent]) &&
          o.default.createElement(
            "div",
            {
              className: "metric-unit-chosen ".concat(this.state.showMetric ? "selected-tab" : "unselected-tab"),
              onClick: () => this.onMetricContent(),
            },
            "cm",
          ),
      );
    }
    renderOtherStores() {
      return o.default.createElement(
        o.default.Fragment,
        null,
        Ci([this, "access", (e) => e.state, "access", (e) => e.settings, "optionalAccess", (e) => e.metricContent]) &&
          o.default.createElement(
            "div",
            {
              className: "metric-unit-chosen ".concat(this.state.showMetric ? "selected-tab" : "unselected-tab"),
              onClick: () => this.onMetricContent(),
            },
            "cm",
          ),
        Ci([this, "access", (e) => e.state, "access", (e) => e.settings, "optionalAccess", (e) => e.imperialContent]) &&
          o.default.createElement(
            "div",
            {
              className: "imperial-unit-chosen ".concat(this.state.showImperial ? "selected-tab" : "unselected-tab"),
              onClick: () => this.onImpericalContent(),
            },
            "inches",
          ),
      );
    }
    onSizeGuideClick() {
      this.setState({ isModalActive: !0 });
    }
    onCloseModalClick() {
      this.setState({ isModalActive: !1 });
    }
    areaAroundPopupClicked(e) {
      e.target === e.currentTarget && this.onCloseModalClick();
    }
    onMetricContent() {
      (P.gtmTriggerEvents("size_guide", "size_click", "cm"), this.setState({ showMetric: !0, showImperial: !1 }));
    }
    onImpericalContent() {
      (P.gtmTriggerEvents("size_guide", "size_click", "inches"), this.setState({ showImperial: !0, showMetric: !1 }));
    }
  }
  function Ai(e) {
    for (var t = void 0, a = e[0], i = 1; i < e.length; ) {
      var r = e[i],
        s = e[i + 1];
      if (((i += 2), ("optionalAccess" === r || "optionalCall" === r) && null == a)) return;
      "access" === r || "optionalAccess" === r
        ? ((t = a), (a = s(a)))
        : ("call" !== r && "optionalCall" !== r) ||
          ((a = s(function () {
            for (var e = arguments.length, i = new Array(e), r = 0; r < e; r++) i[r] = arguments[r];
            return a.call(t, ...i);
          })),
          (t = void 0));
    }
    return a;
  }
  Pi.displayName = "ProductSizeGuides";
  class ki extends o.default.Component {
    constructor(e) {
      super(e);
    }
    render() {
      return (
        this.props.featured_text &&
        o.default.createElement(
          "div",
          { className: "custom_ratings_section" },
          o.default.createElement(
            "div",
            { className: "heading_part" },
            o.default.createElement("div", { className: "heading_text" }, "Rated 5 out of 5"),
            o.default.createElement("div", {
              className: "stars_icon",
              dangerouslySetInnerHTML: {
                __html: Ai([
                  document,
                  "access",
                  (e) => e.getElementById,
                  "call",
                  (e) => e("svg_template"),
                  "optionalAccess",
                  (e) => e.content,
                  "access",
                  (e) => e.querySelector,
                  "call",
                  (e) => e("#reviewStars svg"),
                  "access",
                  (e) => e.outerHTML,
                ]),
              },
            }),
          ),
          o.default.createElement(
            "div",
            { className: "chosen_review_text" },
            o.default.createElement(
              "p",
              null,
              "“",
              this.props.featured_text,
              "”",
              o.default.createElement(
                "span",
                { className: "reviewer" },
                o.default.createElement("span", { className: "dash" }, "—"),
                this.props.reviewer_name,
              ),
            ),
          ),
        )
      );
    }
  }
  ki.displayName = "FeaturedReviews";
  var Ni = (t) => {
    var a = t.moriFriendsScDiscount ? 0.9 : 0.8,
      i = t.showSleepClubPricing ? a : 1,
      r = _slicedToArray(e.useState(Math.round(t.initialVariant.price * i)), 2),
      s = r[0],
      n = r[1],
      l = _slicedToArray(e.useState(!0), 2),
      c = l[0],
      d = l[1],
      p = _slicedToArray(e.useState((t.initialVariant.compare_at_price || 0) * i), 2),
      u = p[0],
      m = p[1],
      h = _slicedToArray(
        e.useState(
          Math.round(
            (100 * (t.initialVariant.compare_at_price - t.initialVariant.price)) / t.initialVariant.compare_at_price,
          ),
        ),
        2,
      ),
      f = h[0],
      g = h[1],
      v = t.product.id,
      _ = e.useCallback((e) => {
        console.log("Product: ", t);
        var a = e.detail.price,
          r = e.detail.compareAtPrice;
        (d(!0),
          n(a * i),
          m(r * i),
          g(Math.round((100 * (r - a)) / r)),
          v &&
            b(v, a).finally(() => {
              d(!1);
            }));
      }, []),
      y = (e, t, a, i) => {
        var r = s;
        a && (r = a);
        var o = 0,
          l = !1;
        (e ? ((l = !0), (o = +r - 100 * +e)) : t && ((l = !0), (o = +r - (+t / 100) * +r)),
          l && (n(o), g(u > 0 ? Math.round((100 * (u - o)) / u) : Math.round((100 * (r - o)) / r))));
      };
    if (
      (e.useEffect(() => {
        v &&
          b(v, s).finally(() => {
            d(!1);
          });
      }, []),
      e.useEffect(
        () => (
          window.addEventListener("pricing.change", _),
          () => {
            window.removeEventListener("pricing.change", _);
          }
        ),
        [_],
      ),
      t.showSleepClubPricing)
    )
      return o.default.createElement("span", { id: "SCPrice" }, _t.formatMoney(s));
    function b(e, t) {
      return w.apply(this, arguments);
    }
    function w() {
      return (
        (w = _asyncToGenerator(function* (e, t) {
          var a = new AbortController(),
            i = yield mi("auto_discount_amount", "custom", e, a);
          if (a.signal.aborted || !S(i)) {
            var r = new AbortController(),
              s = yield mi("auto_discount_percentage", "custom", e, r);
            !r.signal.aborted && S(s) && y(void 0, s, t);
          } else y(i, void 0, t);
        })),
        w.apply(this, arguments)
      );
    }
    var S = (e) => e && "_" !== e && 0 !== e && "0.0" !== e && "" !== e;
    return c
      ? o.default.createElement(
          "div",
          {
            className: "shimmer faux-image skeleton-loader__product-price",
            "data-testId": "skeleton-loader__product-price-section",
          },
          o.default.createElement("span", { className: "product-price skeleton-loader" }),
          o.default.createElement("span", { className: "compare-price skeleton-loader" }),
          o.default.createElement("span", { className: "text-save-tag skeleton-loader" }),
        )
      : u > s && !c
        ? o.default.createElement(
            o.default.Fragment,
            null,
            o.default.createElement("span", { className: "product-price color--red-light" }, _t.formatMoney(s)),
            o.default.createElement(
              "span",
              { className: "compare-price" },
              o.default.createElement("s", null, _t.formatMoney(u)),
            ),
            o.default.createElement("span", { className: "text-save-tag" }, "save ", f, "%"),
          )
        : o.default.createElement("span", { className: "product-price color--grey-dark" }, _t.formatMoney(s));
  };
  Ni.displayName = "ProductPrice";
  var Ti = (e) => {
    var t =
        "*:not(:has(#ProductRecommendationsRoot, #FeaturedReviewsRoot, #reviews_section, .trustpilot-micro_trustscore))",
      a = new DOMParser().parseFromString(e, "text/html").querySelectorAll("body > #PageContainer > main > ".concat(t)),
      i = document.querySelector(".main-content"),
      r = document.querySelectorAll(".main-content > ".concat(t));
    if (!i || !a) throw new Error("Couldn't switch main content!!");
    (r.forEach((e) => e.remove()), i.prepend(...a));
  };
  class Oi extends e.Component {
    render() {
      return this.props.product.available
        ? o.default.createElement(o.default.Fragment, null)
        : this.props.product.tags.includes("oos_coming_soon")
          ? o.default.createElement("span", { className: "soldout" }, "- coming soon -")
          : this.props.product.tags.includes("display_oos")
            ? o.default.createElement("span", { className: "soldout" }, "- Sold out")
            : this.props.product.tags.includes("pre_launch")
              ? o.default.createElement("span", { className: "soldout" }, "- coming soon -")
              : o.default.createElement("span", { className: "soldout" }, "- Sold out");
    }
  }
  Oi.displayName = "OutOfStockIndicator";
  var xi = (t) => {
    var a = e.useContext(m()),
      i = _slicedToArray(e.useState(""), 2),
      r = i[0],
      s = i[1];
    a.addFlag("swap_images");
    var n,
      l,
      c = a.flagEnabled("swap_images"),
      d = t.featureImage,
      p = t.hoverImage,
      u = t.altText ? t.altText[0] : "",
      h = t.altText ? t.altText[1] : "";
    return (
      (n = t.featureImage),
      ((l = new Image()).src = n),
      (l.onload = function (e) {
        var t = e.currentTarget;
        t.width !== t.height && s("kidly-by-mori");
      }),
      o.default.createElement(
        o.default.Fragment,
        null,
        o.default.createElement("img", {
          className: "product-image featured-image "
            .concat(r, " ")
            .concat(t.hoverEnabled ? "" : "hover-disabled", " ")
            .concat("content_block" === h ? "content_block" : ""),
          id: "featured",
          src: c ? p : d,
          alt: u,
        }),
        t.hoverEnabled &&
          o.default.createElement("img", {
            className: "product-image featured-image show_on_hover ".concat(r),
            src: c ? d : p,
            alt: h,
            loading: "lazy",
          }),
      )
    );
  };
  function Ii(e) {
    for (var t = void 0, a = e[0], i = 1; i < e.length; ) {
      var r = e[i],
        s = e[i + 1];
      if (((i += 2), ("optionalAccess" === r || "optionalCall" === r) && null == a)) return;
      "access" === r || "optionalAccess" === r
        ? ((t = a), (a = s(a)))
        : ("call" !== r && "optionalCall" !== r) ||
          ((a = s(function () {
            for (var e = arguments.length, i = new Array(e), r = 0; r < e; r++) i[r] = arguments[r];
            return a.call(t, ...i);
          })),
          (t = void 0));
    }
    return a;
  }
  xi.displayName = "ProductFeatureImage";
  class Li extends e.Component {
    constructor(e) {
      (super(e),
        (this.state = {
          description: "",
          onSale: !1,
          scPriceApplies: !1,
          autoDiscountAmount: void 0,
          autoDiscountPercentage: void 0,
        }));
    }
    shouldUseAutomaticDiscount() {
      var e = window.mori.state.autoDiscountExclusionList,
        t = window.location.href.split("/"),
        a = t.indexOf("collections"),
        i = !0;
      if (-1 != a) {
        var r = t[a + 1];
        e.some((e) => r.includes(e)) && (i = !1);
      }
      return i;
    }
    componentDidMount() {
      this.recalculateState(this.props);
      var e = new AbortController();
      this.shouldUseAutomaticDiscount() &&
        mi("auto_discount_amount", "custom", this.props.product.id, e).then((t) => {
          if (!e.signal.aborted)
            if ("_" !== t && 0 !== t && "" !== t && "0.0" != t) this.setState({ autoDiscountAmount: t });
            else {
              var a = new AbortController();
              mi("auto_discount_percentage", "custom", this.props.product.id, a).then((e) => {
                a.signal.aborted ||
                  ("_" !== e && 0 !== e && "" != e && "0.0" != e && this.setState({ autoDiscountPercentage: e }));
              });
            }
        });
    }
    componentDidUpdate(e) {
      (this.props.product === e.product && this.props.selectedVariant === e.selectedVariant) ||
        this.recalculateState(this.props);
    }
    recalculateState(e) {
      var t = e.product.variants
          .filter(
            (e) =>
              "yes" !== (e.option1 || "").toLowerCase() &&
              "yes" !== (e.option2 || "").toLowerCase() &&
              "yes" !== (e.option3 || "").toLowerCase(),
          )
          .map((e) => e.price),
        a = [...new Set(t)].length > 1,
        i = "",
        r = !1;
      (e.product.auto_discount_message
        ? (r = !0)
        : ((r =
            Ii([e, "access", (e) => e.selectedVariant, "optionalAccess", (e) => e.compare_at_price]) >
            Ii([e, "access", (e) => e.selectedVariant, "optionalAccess", (e) => e.price])),
          e.selectedVariant || (r = e.product.compare_at_price > e.product.price)),
        a && e.openQuickshotProductHash !== e.product.hash && (i = "From "),
        (i = r ? "From " : ""));
      var s = e.showSleepClubPrice && !r && !e.product.tags.includes("no_sc_discount_applies");
      this.setState({ description: i, onSale: r, scPriceApplies: s });
    }
    getPriceAndDiscountPrice() {
      return this.props.quickShopIsOpen && this.props.selectedVariant
        ? { originalPrice: this.props.selectedVariant.compare_at_price, currentPrice: this.props.selectedVariant.price }
        : { originalPrice: this.props.product.compare_at_price, currentPrice: this.props.product.price };
    }
    renderLowestPrice(e) {
      var t = this.props.product.variants[0].price;
      return (
        this.props.product.variants.forEach((e) => {
          e.price < t && (t = e.price);
        }),
        e ? this.renderSalePrice(e, t) : this.renderNormalPrice(t)
      );
    }
    render() {
      if (this.state.scPriceApplies) return this.renderSCPrice();
      if (this.state.onSale) {
        var e = this.getPriceAndDiscountPrice(),
          t = e.originalPrice,
          a = e.currentPrice;
        return !this.props.quickShopIsOpen &&
          "price-ascending" === this.props.appliedSort &&
          this.props.isGrapheneEnabled
          ? this.renderLowestPrice(t)
          : t
            ? this.renderSalePrice(t, a)
            : this.renderNormalPrice(a);
      }
      return "price-ascending" === this.props.appliedSort && this.props.isGrapheneEnabled && !this.props.quickShopIsOpen
        ? this.renderLowestPrice()
        : this.props.selectedVariant
          ? this.renderNormalPrice(this.props.selectedVariant.price)
          : this.renderNormalPrice(this.props.product.price);
    }
    renderNormalPrice(e) {
      var t = this.updatePriceWithAutoDiscount(e);
      return t !== e
        ? o.default.createElement(
            "span",
            null,
            this.state.description,
            o.default.createElement("span", { className: "bold color_red" }, o.default.createElement(Ht, { value: t })),
            " ",
            o.default.createElement("s", null, o.default.createElement(Ht, { value: e })),
          )
        : o.default.createElement(
            "span",
            null,
            this.state.description,
            o.default.createElement(
              "span",
              { className: "bold color_grey" },
              o.default.createElement(Ht, { value: t }),
            ),
          );
    }
    updatePriceWithAutoDiscount(e) {
      return this.props.product.auto_discount_message
        ? e
        : this.state.autoDiscountAmount
          ? +e - 100 * +this.state.autoDiscountAmount
          : this.state.autoDiscountPercentage
            ? +e - (+this.state.autoDiscountPercentage / 100) * +e
            : e;
    }
    renderSCPrice() {
      var e = 0.8,
        t = this.props.product.vendor.toLowerCase().trim();
      return (
        "mori" !== t && "kidly by mori" !== t && "storksak by mori" !== t && (e = 0.9),
        o.default.createElement(
          "span",
          null,
          "Sleep Club Price: ".concat(this.state.description),
          o.default.createElement(Ht, { value: this.updatePriceWithAutoDiscount(this.props.product.price * e) }),
        )
      );
    }
    renderSalePrice(e, t) {
      var a = this.updatePriceWithAutoDiscount(t),
        i = e;
      return o.default.createElement(
        "span",
        null,
        this.state.description,
        o.default.createElement("span", { className: "bold color_red" }, o.default.createElement(Ht, { value: a })),
        " ",
        o.default.createElement("s", null, o.default.createElement(Ht, { value: i })),
      );
    }
  }
  function Mi(e) {
    for (var t = void 0, a = e[0], i = 1; i < e.length; ) {
      var r = e[i],
        s = e[i + 1];
      if (((i += 2), ("optionalAccess" === r || "optionalCall" === r) && null == a)) return;
      "access" === r || "optionalAccess" === r
        ? ((t = a), (a = s(a)))
        : ("call" !== r && "optionalCall" !== r) ||
          ((a = s(function () {
            for (var e = arguments.length, i = new Array(e), r = 0; r < e; r++) i[r] = arguments[r];
            return a.call(t, ...i);
          })),
          (t = void 0));
    }
    return a;
  }
  Li.displayName = "ProductPriceLine";
  var zi = [
    "best-seller",
    "new-in",
    "limited-edition",
    "sale",
    "fourth-free",
    "custom-tag",
    "today-tag",
    "print-of-the-month",
  ];
  class Ri extends e.Component {
    constructor(e) {
      super(e);
      var t = "",
        a = !1;
      (this.isProductAndVariantOnSale() ? (a = !0) : (t = this.props.product.tags.find((e) => zi.includes(e))),
        a &&
          (t = Mi([
            this,
            "access",
            (e) => e.props,
            "access",
            (e) => e.selectedVarient,
            "optionalAccess",
            (e) => e.compare_at_price,
          ])
            ? Mi([
                this,
                "access",
                (e) => e.props,
                "access",
                (e) => e.selectedVarient,
                "optionalAccess",
                (e) => e.compare_at_price,
              ]) <=
              Mi([this, "access", (e) => e.props, "access", (e) => e.selectedVarient, "optionalAccess", (e) => e.price])
              ? ""
              : "save-tag"
            : ""),
        (this.state = { tag: t, autoDiscountAmount: void 0, autoDiscountPercentage: void 0 }));
    }
    fetchAutomaticDiscount() {
      var e = new AbortController();
      mi("auto_discount_amount", "custom", this.props.product.id, e).then((t) => {
        if (!e.signal.aborted)
          if ("_" !== t && 0 !== t && "" !== t && "0.0" != t) this.setState({ autoDiscountAmount: t });
          else {
            var a = new AbortController();
            mi("auto_discount_percentage", "custom", this.props.product.id, a).then((e) => {
              a.signal.aborted ||
                ("_" !== e && 0 !== e && "" != e && "0.0" != e && this.setState({ autoDiscountPercentage: e }));
            });
          }
      });
    }
    componentDidMount() {
      this.fetchAutomaticDiscount();
    }
    isProductAndVariantOnSale() {
      return !!this.props.product.compare_at_price && this.props.product.price < this.props.product.compare_at_price;
    }
    componentDidUpdate(e, t, a) {
      var i = "",
        r = !1;
      (this.isProductAndVariantOnSale() ? (r = !0) : (i = this.props.product.tags.find((e) => zi.includes(e))),
        r &&
          (i = Mi([
            this,
            "access",
            (e) => e.props,
            "access",
            (e) => e.selectedVarient,
            "optionalAccess",
            (e) => e.compare_at_price,
          ])
            ? Mi([
                this,
                "access",
                (e) => e.props,
                "access",
                (e) => e.selectedVarient,
                "optionalAccess",
                (e) => e.compare_at_price,
              ]) <=
              Mi([this, "access", (e) => e.props, "access", (e) => e.selectedVarient, "optionalAccess", (e) => e.price])
              ? ""
              : "save-tag"
            : ""),
        this.state.tag !== i && this.setState({ tag: i }));
    }
    getPriceAndDiscountPrice() {
      var e = Mi([
          this,
          "access",
          (e) => e.props,
          "access",
          (e) => e.product,
          "optionalAccess",
          (e) => e.compare_at_price,
        ]),
        t = Mi([
          this,
          "access",
          (e) => e.props,
          "access",
          (e) => e.selectedVarient,
          "optionalAccess",
          (e) => e.compare_at_price,
        ]);
      return e
        ? {
            compareAtPrice: e,
            price: Mi([this, "access", (e) => e.props, "access", (e) => e.product, "optionalAccess", (e) => e.price]),
          }
        : {
            compareAtPrice: t,
            price: Mi([
              this,
              "access",
              (e) => e.props,
              "access",
              (e) => e.selectedVarient,
              "optionalAccess",
              (e) => e.price,
            ]),
          };
    }
    render() {
      if (!this.state.tag) return null;
      if ("save-tag" === this.state.tag) return this.renderSaveTag();
      var e = {
        "best-seller": o.default.createElement(
          "div",
          { className: "text-best-seller text-collection" },
          this.props.settings["best-seller"],
        ),
        "new-in": o.default.createElement(
          "div",
          { className: "text-new-in text-collection" },
          this.props.settings["new-in"],
        ),
        "limited-edition": o.default.createElement(
          "div",
          { className: "text-limited-edition text-collection" },
          this.props.settings["limited-edition"],
        ),
        sale: o.default.createElement("div", { className: "text-sale text-collection" }, this.props.settings.sale),
        "fourth-free": o.default.createElement(
          "div",
          { className: "text-fourth-free text-collection" },
          this.props.settings["fourth-free"],
        ),
        "custom-tag": o.default.createElement(
          "div",
          { className: "text-custom-tag text-collection" },
          this.props.settings["custom-tag"],
        ),
        "today-tag": o.default.createElement(
          "div",
          { className: "text-today-tag text-collection" },
          this.props.settings["today-tag"],
        ),
        "print-of-the-month": o.default.createElement(
          "div",
          { className: "text-collection print_of_month", style: { color: "#8EBEB8" } },
          "sleep club print of the month",
        ),
      }[this.state.tag];
      return e || null;
    }
    renderSaveTag() {
      var e = this.getPriceAndDiscountPrice(),
        t = e.compareAtPrice,
        a = e.price;
      if (!t || 0 === t) return null;
      (this.props.isScMember && !this.props.isScProduct && a >= t && (a *= 0.8),
        this.state.autoDiscountAmount && (a -= 100 * this.state.autoDiscountAmount),
        this.state.autoDiscountPercentage && (a -= (this.state.autoDiscountPercentage / 100) * a));
      var i = Math.round((100 * (t - a)) / t);
      return o.default.createElement(
        o.default.Fragment,
        null,
        o.default.createElement(
          "div",
          { className: "text-save-tag text-collection" },
          this.props.isUSsaveTagRunning
            ? o.default.createElement(
                "span",
                { className: "top_save_tag us_test" },
                " ",
                this.props.settings["save-tag"],
                " ",
                i,
                "%",
              )
            : o.default.createElement("span", { className: "top_save_tag" }, i, "% OFF"),
        ),
      );
    }
  }
  Ri.displayName = "ProductTextRow";
  var Di = [
    "personalized",
    "personalised",
    "personalization",
    "personalisation",
    "gift-wrap",
    "gift-wrap-all",
    "gift-wrap-medium",
    "gift-wrap-small",
    "gift-wrap-extra-large",
    "gift-wrap-large",
    "gift-wrap-large-free",
    "gift-note",
    "donation",
    "vip-gift-note",
    "personalised-front-opening-sleepsuit",
    "personalised-clever-zip-up-sleepsuit",
    "personalised-toddler-bath-towel",
    "personalised-baby-blanket",
    "personalised-baby-bath-towel",
    "personalised-baby-gift-set",
    "sleepclub-membership-signup",
    "annual-sleep-club-membership-sign-up",
    "annual-sleep-club-membership",
    "annual-sleep-club-membership-1",
    "https-babymori-com-pages-sleepclub-gift-membership",
  ];
  function Bi(t) {
    var a = (function () {
        var t = _slicedToArray(e.useState(window.innerWidth), 2),
          a = t[0],
          i = t[1],
          r = e.useCallback((e) => {
            i(window.innerWidth);
          }, []);
        return (
          e.useEffect(
            () => (
              window.addEventListener("resize", r),
              () => {
                window.removeEventListener("resize", r);
              }
            ),
            [r],
          ),
          a
        );
      })(),
      i = _slicedToArray(e.useState(a < t), 2),
      r = i[0],
      s = i[1];
    return (
      e.useEffect(() => {
        s(a < t);
      }, [a]),
      r
    );
  }
  function Vi(e) {
    for (var t = void 0, a = e[0], i = 1; i < e.length; ) {
      var r = e[i],
        s = e[i + 1];
      if (((i += 2), ("optionalAccess" === r || "optionalCall" === r) && null == a)) return;
      "access" === r || "optionalAccess" === r
        ? ((t = a), (a = s(a)))
        : ("call" !== r && "optionalCall" !== r) ||
          ((a = s(function () {
            for (var e = arguments.length, i = new Array(e), r = 0; r < e; r++) i[r] = arguments[r];
            return a.call(t, ...i);
          })),
          (t = void 0));
    }
    return a;
  }
  var Fi = ["title", "tog"],
    Ui = window.mori.state.template,
    Wi = window.mori.state.isB2B,
    ji = window.mori.state.gtmEventTrigger[Ui],
    qi = ji ? ji.name : Ui,
    Gi =
      "us.babymori.com" !== window.location.hostname
        ? o.default.createElement("span", { className: "quick_cta" }, "Add to bag")
        : o.default.createElement("span", { className: "quick_cta" }, "Add to cart");
  class Hi extends e.Component {
    constructor(e) {
      super(e);
      var t,
        a = It.colourOptions(this.props.product),
        i = It.sizeOptions(this.props.product),
        r = Fi.find((e) => It.optionNameForOption(this.props.product, e)),
        s = [];
      r && (t = It.optionNameForOption(this.props.product, r)) && (s = It.optionValuesForName(this.props.product, t));
      var n = window.location.href.includes("/collections"),
        o = n ? "gtm_plp_colour_swatch_element" : "gtm_pdp_colour_swatch_element",
        l = Vi([
          window,
          "access",
          (e) => e.mori,
          "access",
          (e) => e.state,
          "access",
          (e) => e.cartItems,
          "optionalAccess",
          (e) => e.items,
        ]),
        c = 1;
      if (l && l.length) {
        var d = l.find((e) => e.variant_id === this.props.selectedVariant.id);
        d && (c = d.quantity);
      }
      ((this.state = {
        colours: a,
        sizes: i,
        isExpanded: this.props.openQuickshotProductHash === this.props.product.hash,
        isAdding: !1,
        alternateOptions: s,
        alternateOptionName: t,
        isCartPage: window.location.href.includes("/cart"),
        isPlp: n,
        gtmClasses: o,
        errorMessage: "",
        inputQuantity: c,
        cartItems: l,
        inventoryQuantity: Vi([
          this,
          "access",
          (e) => e.props,
          "access",
          (e) => e.selectedVariant,
          "optionalAccess",
          (e) => e.inventory_quantity,
        ]),
      }),
        (this.onProductAdded = this.onProductAdded.bind(this)));
    }
    getFirstAvailableSize() {
      return this.state.sizes.length
        ? this.state.sizes.filter((e) => this.isSizeInStock(e))[0]
        : this.props.selectedSize;
    }
    componentDidMount() {
      this.props.onSizeSelected(this.props.selectedSize);
    }
    componentDidUpdate(e) {
      (this.props.openQuickshotProductHash !== e.openQuickshotProductHash &&
        this.setState({ isExpanded: this.props.openQuickshotProductHash === this.props.product.hash }),
        this.props.openQuickshotProductHash &&
          this.state.errorMessage &&
          (this.state.isExpanded || this.setState({ errorMessage: "", inputQuantity: 1 })),
        this.props.product !== e.product && this.setState({ colours: It.colourOptions(this.props.product) }));
    }
    isSizeInStock(e) {
      return It.isSizeInStock(this.props.product, e, this.props.selectedColour);
    }
    isAlternativeSizeInStock(e) {
      return It.isAlternativeSizeInStock(this.props.product, this.props.selectedSize, this.props.selectedColour, e);
    }
    onAddToCartClicked() {
      (this.setState({ isAdding: !0 }), new XMLHttpRequest());
      var e = {};
      if (
        (this.props.product.tags &&
          this.props.product.tags.forEach((t) => {
            t.includes("discount: ") && (e.Discount = Wt(t));
          }),
        Xt.includes(this.props.product.handle.toLowerCase()))
      ) {
        var t = new Date().getTime(),
          a = this.productGiftWrap(t, void 0 !== this.props.selectedVariant.id ? this.props.selectedVariant.id : t),
          i = { id: this.props.selectedVariant.id, quantity: 1, properties: e };
        a &&
          ((i.properties._w_id = t.toString()),
          (i.properties._GiftWrapping = "gift-wrap-large"),
          ht.add({ items: [i, a] }).then(() => {
            (this.onProductAdded(), Gt.addToCartEvent());
          }));
      } else
        ht.add({ items: [{ id: this.props.selectedVariant.id, quantity: 1, properties: e }] }).then(() => {
          (this.onProductAdded(), Gt.addToCartEvent());
        });
    }
    productGiftWrap(e, t) {
      var a = Xt.includes(this.props.product.handle.toLowerCase());
      if (!a) return null;
      var i = {};
      return (
        (i = { _Product_id: this.props.product.id, _Wrapping_for: this.props.selectedVariant.sku }),
        a
          ? ((i._is_gifted = "Set"),
            location.host.toLowerCase().includes("eu.babymori")
              ? { id: 56261882642806, quantity: 1, properties: i, parent_id: t }
              : location.host.toLowerCase().includes("us.babymori")
                ? { id: 43029153218673, quantity: 1, properties: i, parent_id: t }
                : { id: 56423011221891, quantity: 1, properties: i, parent_id: t })
          : null
      );
    }
    onProductAdded() {
      (!window.mori.state.isB2B &&
        window.$g &&
        this.props.isGrapheneEnabled &&
        P.addToBasketEvent("".concat(this.props.product.id)),
        this.props.enableNostoAddToBag &&
          (console.log("Sending the nosto add to bag event"),
          nostojs((e) => {
            e.recordSearchAddToCart("serp", { productId: this.props.product.id.toString() });
          })),
        document.body.dispatchEvent(new CustomEvent("afterAddItem.ajaxCart")),
        P.logEvent("afterAddItem.ajaxCart", {
          gtm_product_name: this.props.product.title,
          gtm_product_variant: this.props.product.title,
          gtm_product_price: this.props.selectedVariant.price,
          gtm_product_id: this.props.product.id,
        }),
        P.logEvent("fb_add_to_cart", {
          fb_value: this.props.selectedVariant.price / 100,
          fb_currency: _t.getCurrency(),
          fb_content_ids: this.props.selectedVariant.id,
        }),
        this.setState({ isAdding: !1 }, () => {
          this.state.isCartPage
            ? document.body.dispatchEvent(
                new CustomEvent("cart.recommendations.added", { detail: { handle: this.props.product.handle } }),
              )
            : document.body.dispatchEvent(new CustomEvent("cart.updated"));
        }));
    }
    render() {
      var e = this.shouldQuickShopShow();
      return o.default.createElement(
        "div",
        { className: "quick_shop_wrapper" },
        o.default.createElement(
          "form",
          { action: "" },
          !this.props.isSplit && this.renderColourSwatches(),
          !this.props.switchOffQuickshop &&
            e &&
            o.default.createElement(
              o.default.Fragment,
              null,
              this.renderSizeSwatches(),
              this.renderAlternateOptionSwatches(),
            ),
        ),
        !this.props.switchOffQuickshop &&
          !Wi &&
          e &&
          o.default.createElement(o.default.Fragment, null, this.renderCta(), this.renderQuickShopIcon()),
        Wi &&
          o.default.createElement(
            o.default.Fragment,
            null,
            o.default.createElement(
              "div",
              null,
              !this.props.switchOffQuickshop &&
                e &&
                o.default.createElement(
                  "div",
                  { className: "b2b_quick_shop_active" },
                  this.renderQuantityInput(),
                  this.renderCta(),
                  this.renderQuickShopIcon(),
                ),
              this.state.errorMessage &&
                o.default.createElement(
                  "div",
                  null,
                  o.default.createElement("span", { className: "b2b_input_error_state" }, this.state.errorMessage),
                ),
            ),
          ),
      );
    }
    renderColourSwatches() {
      if (this.state.colours.length < 2 || this.props.isSplit) return o.default.createElement("div", null);
      var e,
        t,
        a = this.state.colours.map((e) =>
          o.default.createElement(
            "div",
            {
              key: e,
              className: ""
                .concat(this.state.gtmClasses, " swatch-element  handle-")
                .concat(this.props.product.handle, " color ")
                .concat(_t.alternative_handleize(e), " available"),
            },
            o.default.createElement("input", {
              className: "collection_swatch_input",
              type: "radio",
              value: _t.alternative_handleize(e),
              checked:
                Vi([
                  this,
                  "access",
                  (e) => e.props,
                  "access",
                  (e) => e.selectedColour,
                  "optionalAccess",
                  (e) => e.toLowerCase,
                  "call",
                  (e) => e(),
                ]) === Vi([e, "optionalAccess", (e) => e.toLowerCase, "call", (e) => e()]),
              readOnly: !0,
            }),
            o.default.createElement("label", {
              className: "collection_swatch ".concat(_t.alternative_handleize(e)),
              onClick: () => {
                (this.props.onColourSelected(e),
                  this.props.onQuickShopOpened(this.props.product.hash),
                  P.gtmTriggerEvents("quick_shop", "colour_click", e));
              },
            }),
          ),
        ),
        i = () =>
          this.props.isMobile && this.props.noOfMobileSwatches && a.length > this.props.noOfMobileSwatches
            ? this.props.noOfMobileSwatches
            : this.props.noOfDesktopSwatches && a.length > this.props.noOfDesktopSwatches
              ? this.props.noOfDesktopSwatches
              : null,
        r = o.default.createElement(
          "div",
          {
            className: ""
              .concat(this.state.gtmClasses, " swatch-element view__more-wrapper  handle-")
              .concat(this.props.product.handle, " available"),
          },
          o.default.createElement(
            "span",
            { className: "collection_swatch view__more" },
            o.default.createElement(
              "a",
              { href: "/products/".concat(this.props.product.handle) },
              a.length - ((e = i()), (t = () => 0), null != e ? e : t()),
            ),
          ),
        );
      return i()
        ? o.default.createElement(
            "div",
            { className: "swatch clearfix color-options collection_thumb_swatch" },
            a.slice(0, i()),
            r,
          )
        : o.default.createElement("div", { className: "swatch clearfix color-options collection_thumb_swatch" }, a);
    }
    formatSizeName(e) {
      var t = e.substring(0, 4).toLowerCase();
      if ("us -" === t) {
        var a = e.toLowerCase().trim().replace("us - ", "");
        return a.split(" ").length > 1 ? "US ".concat(a.split(" ").join(".").toUpperCase()) : e.toUpperCase();
      }
      if ("us" == e.substring(0, 2).toLowerCase()) return e.toUpperCase();
      if ("uk -" === t) {
        var i = e.toLowerCase().trim().replace("uk - ", "");
        return i.split(" ").length > 1 ? "UK ".concat(i.split(" ").join(".").toUpperCase()) : e.toUpperCase();
      }
      if ("uk" == e.substring(0, 2).toLowerCase()) return e.toUpperCase();
      if ("eu -" === t) {
        var r = e.toLowerCase().trim().replace("eu - ", "");
        return r.split(" ").length > 1 ? "EU ".concat(r.split(" ").join(".").toUpperCase()) : e.toUpperCase();
      }
      return "eu" == e.substring(0, 2).toLowerCase() ? e.toUpperCase() : e;
    }
    renderSizeSwatches() {
      if (!this.state.isExpanded) return null;
      if (this.state.sizes.length < 2) return null;
      var e = this.state.sizes;
      if ((this.props.hideSoldOutVariants && (e = e.filter((e) => this.isSizeInStock(e))), e.length < 2)) return null;
      var t = e.map((e) =>
        o.default.createElement(
          "div",
          { key: e, className: "swatch-element size" },
          o.default.createElement("input", {
            type: "radio",
            value: e,
            disabled: !0,
            checked:
              Vi([
                this,
                "access",
                (e) => e.props,
                "access",
                (e) => e.selectedSize,
                "optionalAccess",
                (e) => e.toLowerCase,
                "call",
                (e) => e(),
              ]) === Vi([e, "optionalAccess", (e) => e.toLowerCase, "call", (e) => e()]) && this.isSizeInStock(e),
            readOnly: !0,
          }),
          o.default.createElement(
            "label",
            {
              className: "collection_swatch ".concat(this.isSizeInStock(e) ? "" : "outOfStockSizes"),
              onClick: () => {
                (this.isSizeInStock(e) &&
                  (this.props.onSizeSelected(e), this.props.onQuickShopOpened(this.props.product.hash)),
                  P.gtmTriggerEvents("quick_shop", "size_click", e));
              },
            },
            this.formatSizeName(e),
          ),
        ),
      );
      return o.default.createElement(
        "div",
        { className: "quick_shop_open" },
        o.default.createElement(
          "div",
          { className: "quick_shop active", style: { display: "block" } },
          o.default.createElement("div", { className: "swatch clearfix size-options sorted" }, t),
        ),
      );
    }
    renderAlternateOptionSwatches() {
      if (!this.state.isExpanded) return o.default.createElement("div", null);
      if (this.state.alternateOptions.length < 2) return o.default.createElement("div", null);
      var e = (e) => {
          this.isAlternativeSizeInStock(e) &&
            (this.props.onAlternateOptionSelected(e), this.props.onQuickShopOpened(this.props.product.hash));
        },
        t = this.state.alternateOptions.map((t) =>
          o.default.createElement(
            "div",
            { key: t, className: "swatch-element size" },
            o.default.createElement("input", {
              type: "radio",
              value: t,
              disabled: !0,
              checked:
                Vi([
                  this,
                  "access",
                  (e) => e.props,
                  "access",
                  (e) => e.selectedAlternateOption,
                  "optionalAccess",
                  (e) => e.toString,
                  "call",
                  (e) => e(),
                  "access",
                  (e) => e.toLowerCase,
                  "call",
                  (e) => e(),
                ]) ===
                  Vi([
                    t,
                    "optionalAccess",
                    (e) => e.toString,
                    "call",
                    (e) => e(),
                    "access",
                    (e) => e.toLowerCase,
                    "call",
                    (e) => e(),
                  ]) && this.isAlternativeSizeInStock(t),
              readOnly: !0,
            }),
            o.default.createElement(
              "label",
              {
                className: "collection_swatch ".concat(this.isAlternativeSizeInStock(t) ? "" : "outOfStockSizes"),
                onClick: () => e(t),
              },
              t,
            ),
          ),
        );
      return o.default.createElement(
        "div",
        { className: "quick_shop_open" },
        o.default.createElement(
          "div",
          { className: "quick_shop active", style: { display: "block" } },
          o.default.createElement("div", { className: "swatch clearfix size-options sorted" }, t),
        ),
      );
    }
    updatedInventory(e) {
      this.setState({ inventoryQuantity: e });
    }
    onB2BAddToCartClicked() {
      var e = this;
      return _asyncToGenerator(function* () {
        var t = e.state,
          a = t.inventoryQuantity,
          i = t.inputQuantity,
          r = e.props.selectedVariant.available && 0 === a;
        if (i > a || r) e.setState({ errorMessage: "Only ".concat(a, " items in stock"), isAdding: !1 });
        else if (i) {
          e.setState({ isAdding: !0 });
          try {
            var s = { id: e.props.selectedVariant.id, quantity: i };
            yield ht.add({ items: [s] });
            var n = a - i;
            (e.updatedInventory(n), e.setState({ isAdding: !1 }));
          } catch (t) {
            (console.error({ error: t }),
              t && e.setState({ isAdding: !1, inputQuantity: 1, errorMessage: "Error adding item to cart." }));
          }
        } else e.setState({ errorMessage: "This field is required", isAdding: !1 });
      })();
    }
    renderCta() {
      var e = Wi ? "b2b_add_to_cart" : "qs_add_to_cart",
        t = () => (Wi ? this.onB2BAddToCartClicked() : this.onAddToCartClicked());
      if (!this.state.isExpanded) return null;
      if (!this.props.selectedVariant || !this.props.selectedVariant.id) {
        var a = "Select a size";
        return (
          ((this.state.sizes.length < 2 && this.state.alternateOptions.length < 2) ||
            !this.isSizeInStock(this.props.selectedSize)) &&
            (a = "Out of stock"),
          o.default.createElement(
            "div",
            { className: "quick_shop_open" },
            o.default.createElement(
              "div",
              { className: "qs_add_to_cart btn disabled" },
              o.default.createElement("span", null, a),
            ),
          )
        );
      }
      return this.props.selectedVariant.available
        ? this.state.isAdding
          ? o.default.createElement(
              "div",
              { className: "quick_shop_open" },
              o.default.createElement(
                "div",
                { className: "".concat(e, " btn active") },
                o.default.createElement("span", null, "One moment..."),
              ),
            )
          : o.default.createElement(
              "div",
              { className: "quick_shop_open" },
              o.default.createElement(
                "div",
                {
                  className: "".concat(e, " btn active"),
                  onClick: () => {
                    (t(),
                      P.gtmTriggerEvents(
                        "quick_shop",
                        "cta_click",
                        "us.babymori.com" !== window.location.hostname ? "Add to bag" : "Add to cart",
                      ));
                  },
                },
                Gi,
              ),
            )
        : o.default.createElement(
            "div",
            { className: "quick_shop_open" },
            o.default.createElement(
              "div",
              { className: "qs_add_to_cart btn disabled" },
              o.default.createElement("span", null, "Out of stock"),
            ),
          );
    }
    renderQuantityInput() {
      var e = this.state,
        t = e.errorMessage,
        a = e.isExpanded,
        i = e.inputQuantity,
        r = e.inventoryQuantity;
      return a
        ? o.default.createElement(
            "div",
            { className: "b2b_quantity_input_wrapper" },
            o.default.createElement("input", {
              type: "number",
              style: { border: t ? "1px solid #FF0000" : "", width: "100%", padding: "8px" },
              id: "product_variant_id-".concat(this.props.selectedVariant.id),
              value: i || "",
              onFocus: () => this.setState({ errorMessage: "" }),
              onChange: (e) => {
                e.preventDefault();
                var t = parseInt(e.currentTarget.value);
                t < 0 || this.setState({ inputQuantity: t });
              },
              min: "1",
              max: r,
              required: !0,
              placeholder: "0",
            }),
          )
        : null;
    }
    renderQuickShopIcon() {
      return this.state.isExpanded
        ? null
        : this.state.alternateOptions.length < 2 && this.state.sizes.length < 2 && this.state.colours.length < 2
          ? this.state.isAdding
            ? o.default.createElement(
                "p",
                {
                  className: "quick_shop_link active quick_shop_initialised quick-shop-tour-anchor ".concat(
                    this.props.styleOverride,
                  ),
                },
                o.default.createElement("span", { className: "quick_shop_icon" }),
                o.default.createElement("span", { className: "quick_cta" }, "One moment..."),
              )
            : o.default.createElement(
                "p",
                {
                  className: "quick_shop_link active quick_shop_initialised quick-shop-tour-anchor ".concat(
                    this.props.styleOverride,
                  ),
                  onClick: () => {
                    (this.onAddToCartClicked(),
                      P.logEvent("add_to_bag_product_grid", { eventName: qi, click_label: "add to bag" }));
                  },
                },
                o.default.createElement("span", { className: "quick_shop_icon" }),
                Gi,
              )
          : o.default.createElement(
              "p",
              {
                className: "quick_shop_link active quick_shop_initialised quick-shop-tour-anchor ".concat(
                  this.props.styleOverride,
                ),
                onClick: () => {
                  (this.props.onQuickShopOpened(this.props.product.hash),
                    this.props.quickShopIsOpen(),
                    P.gtmTriggerEvents("quick_shop", "quick_shop_click", "quick_shop_opened"));
                },
              },
              o.default.createElement("span", { className: "quick_shop_icon" }),
              o.default.createElement("span", { className: "quick_cta" }, "Quick shop"),
            );
    }
    shouldQuickShopShow() {
      return !(Di.filter((e) => this.props.product.handle.includes(e)).length > 0);
    }
  }
  Hi.displayName = "QuickShop";
  var Yi,
    Xi,
    Qi =
      ((Yi = Hi),
      (Xi = 768),
      function (e) {
        var t = Bi(Xi);
        return o.default.createElement(Yi, _objectSpread(_objectSpread({}, e), {}, { isMobile: t }));
      }),
    Ji = o.default.memo((e) => {
      var t = e.message;
      return t
        ? o.default.createElement(
            "span",
            { className: "promo_line__message", role: "status", "aria-live": "polite", "aria-atomic": "true" },
            t,
          )
        : null;
    });
  Ji.displayName = "PromoLineMessage";
  var Ki = (t) => {
    var a,
      i,
      r = t.product,
      s = _slicedToArray(e.useState(null), 2),
      n = s[0],
      l = s[1];
    return (
      e.useEffect(() => {
        var e = new AbortController(),
          t = (function () {
            var t = _asyncToGenerator(function* () {
              try {
                var t = yield mi("brand_line", "custom", r.id, e);
                if (!t || "_" === t) return void l(null);
                l(t);
              } catch (e) {
                throw (console.error("Error fetching product brand line: ".concat(e)), e);
              }
            });
            return function () {
              return t.apply(this, arguments);
            };
          })();
        return (
          t(),
          () => {
            e.abort();
          }
        );
      }, [r]),
      o.default.createElement(
        "span",
        { className: "brand_line__message", "aria-label": "Brand line message", "data-testid": "brand-line-message" },
        ((i = () => ""), null != (a = n) ? a : i()),
      )
    );
  };
  Ki.displayName = "ProductBrandLine";
  class $i {
    static fetchProductReviews(e) {
      return new Promise((t, a) => {
        var i = new XMLHttpRequest(),
          r = e.productSkus.join("%2");
        (i.open(
          "GET",
          "https://api.reviews.io/product/rating-batch?store=".concat(e.publicStoreKey, "&sku=").concat(r),
          !0,
        ),
          i.setRequestHeader("Content-Type", "application/json"),
          (i.onload = function () {
            var e = JSON.parse(i.response);
            t({ data: e.map((e) => ({ sku: e.sku, averageRating: e.average_rating, numRatings: e.num_ratings })) });
          }),
          (i.onerror = (e) => a(e)),
          i.send());
      });
    }
  }
  function Zi(e, t) {
    return null != e ? e : t();
  }
  function er(e) {
    for (var t = void 0, a = e[0], i = 1; i < e.length; ) {
      var r = e[i],
        s = e[i + 1];
      if (((i += 2), ("optionalAccess" === r || "optionalCall" === r) && null == a)) return;
      "access" === r || "optionalAccess" === r
        ? ((t = a), (a = s(a)))
        : ("call" !== r && "optionalCall" !== r) ||
          ((a = s(function () {
            for (var e = arguments.length, i = new Array(e), r = 0; r < e; r++) i[r] = arguments[r];
            return a.call(t, ...i);
          })),
          (t = void 0));
    }
    return a;
  }
  var tr = ["title", "tog"];
  class ar extends e.Component {
    constructor(e) {
      super(e);
      var t = this.props.product;
      document.getElementById("ProductMetafieldsRoot") &&
        JSON.parse(document.getElementById("ProductMetafieldsRoot").innerHTML);
      var a = t.handle.toLowerCase(),
        i = a.includes("sleep-club") || a.includes("sleepclub"),
        r = this.getInitialSelectedVariant(this.props.appliedFilters);
      (r && er([r, "optionalAccess", (e) => e.available])) || (r = t.variants.find((e) => e.available));
      var s = tr.find((e) => It.optionNameForOption(t, e)),
        n = null,
        o = null,
        l = null,
        c = null,
        d = t.tags.find((e) => e.includes("DefaultColor:"));
      if (d) {
        var p = d.replace("DefaultColor:", "").trim(),
          u = t.variants.filter((e) => e.title.toLowerCase().includes(p.toLowerCase()));
        u.length > 0 &&
          (u.sort((e, t) => e.inventory_quantity > t.inventory_quantity), (r = u.find((e) => e.available) || u[0]));
      }
      (window.location.pathname.split("/").includes("sale") &&
        (r = t.variants.find(
          (e) => !!e.compare_at_price && (!!(e.compare_at_price > e.price && e.available) || void 0),
        )),
        (r && r.available) || (r = t.variants.find((e) => e.available)),
        r &&
          ((n = r[It.colourOptionName(t)]),
          (o = r[It.sizeOptionName(t)]),
          s && (l = r[(c = It.optionNameForOption(t, s))])));
      var m = !1;
      (this.props.appliedFilters || []).some((e) => "gender" === e.category) && (m = !0);
      var h = !1,
        f = !!t.tags.includes("display_oos");
      !t.available && (t.tags.includes("pre_launch") || f || t.tags.includes("oos_coming_soon")) && (h = !0);
      var g = window.matchMedia("only screen and (max-width: 768px)").matches;
      ((this.state = {
        isScMember: this.props.isScMember || !1,
        isScProduct: i || !1,
        selectedVariant: r,
        selectedColour: n || null,
        selectedSize: o,
        hasInteracted: m,
        selectedAlternateOption: l,
        alternateOptionName: c,
        quickShopIsOpen: !1,
        isSplit: !1,
        comingSoonTagAndOos: h,
        isLoadingAutoDiscount: !0,
        selectedProduct: t,
        selectedKey: t.title,
        variantLimits: g ? 5 : 9,
      }),
        (this.onColourSelected = this.onColourSelected.bind(this)),
        (this.onSizeSelected = this.onSizeSelected.bind(this)),
        (this.onAlternateOptionSelected = this.onAlternateOptionSelected.bind(this)),
        (this.quickShopIsOpen = this.quickShopIsOpen.bind(this)));
    }
    componentDidMount() {
      var e = new AbortController(),
        t = !1,
        a = !1,
        i = void 0;
      if (
        (setTimeout(() => {
          ((t = !0), a && this.setState({ automaticDiscountTitle: i, isLoadingAutoDiscount: !1 }));
        }, 1e3),
        this.props.isScMember
          ? this.setState({ isLoadingAutoDiscount: !1 })
          : mi(
              "auto_discount_title",
              "custom",
              Zi(
                er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
                () => this.props.product,
              ).id,
              e,
            ).then((r) => {
              if (!e.signal.aborted) {
                var s = r.trim();
                if ((i = "" !== s && "_" !== s ? s : void 0)) {
                  var n = window.mori.state.autoDiscountExclusionList,
                    o = window.location.href.split("/"),
                    l = o.indexOf("collections");
                  if (-1 != l) {
                    var c = o[l + 1];
                    n.some((e) => c.includes(e)) && (i = void 0);
                  }
                }
                ((a = !0), t && this.setState({ automaticDiscountTitle: i, isLoadingAutoDiscount: !1 }));
              }
            }),
        er([
          Zi(
            er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
            () => this.props.product,
          ),
          "access",
          (e) => e.split_variants,
          "optionalAccess",
          (e) => e.option_id,
        ]))
      ) {
        var r = Zi(
          er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
          () => this.props.product,
        ).variants.filter((e) => {
          var t = e.hierarchy_id.split("/");
          return void 0 === this.state.selectedSize
            ? t.includes(
                Zi(
                  er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
                  () => this.props.product,
                ).split_variants.option_id,
              )
            : t.includes(
                Zi(
                  er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
                  () => this.props.product,
                ).split_variants.option_id,
              ) && e.options.includes(this.state.selectedSize);
        });
        if (r.length > 0) {
          var s = r[0],
            n =
              s[
                It.colourOptionName(
                  Zi(
                    er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
                    () => this.props.product,
                  ),
                )
              ];
          this.setState({ selectedVariant: s, selectedColour: n, quickShopIsOpen: !0, isSplit: !0 });
        }
      }
      var o = Zi(
        er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
        () => this.props.product,
      ).variants.map((e) => e.sku);
      $i.fetchProductReviews({ publicStoreKey: "babymori.com", productSkus: [o[0]] })
        .then((e) => {
          if (e.data.length > 0) {
            var t = e.data.map((e) => parseFloat(e.averageRating)),
              a = 0;
            for (var i of t) a += i;
            var r = a / e.data.length;
            r >= 4 && this.setState({ reviewScore: r.toFixed(1) });
          }
        })
        .catch((e) => console.log(e));
    }
    componentDidUpdate(e) {
      var t = this.props,
        a = t.appliedFilters,
        i = t.hasInteracted;
      if (
        (Zi(er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]), () => this.props.product),
        a.length !== e.appliedFilters.length)
      ) {
        var r = this.getInitialSelectedVariant(a);
        if (
          ((this.props.appliedFilters || []).some((e) => "gender" === e.category) && (i = !0),
          r ||
            (r = Zi(
              er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
              () => this.props.product,
            ).variants.find((e) => e.available)),
          !r)
        )
          return void this.setState({
            selectedVariant: r,
            selectedColour: null,
            selectedSize: null,
            hasInteracted: i,
            selectedAlternateOption: null,
          });
        var s,
          n =
            r[
              It.colourOptionName(
                Zi(
                  er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
                  () => this.props.product,
                ),
              )
            ],
          o =
            r[
              It.sizeOptionName(
                Zi(
                  er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
                  () => this.props.product,
                ),
              )
            ];
        (this.state.alternateOptionName && (s = r[this.state.alternateOptionName]),
          this.setState({
            selectedVariant: r,
            selectedColour: n,
            selectedSize: o,
            hasInteracted: i,
            selectedAlternateOption: s,
          }));
      }
    }
    formattedOptionsForSplitVariant(e) {
      if (e) return e.toLowerCase().trim().replaceAll(" ", "_");
    }
    getFeaturedImageForSplitVariant() {
      var e = Zi(
        er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
        () => this.props.product,
      ).media;
      if (this.state.selectedVariant) {
        var t = this.formattedOptionsForSplitVariant(this.state.selectedVariant.option1),
          a = this.formattedOptionsForSplitVariant(Zi(this.state.selectedVariant.option2, () => "")),
          i = e.filter((e) => {
            if (!e.alt) return !1;
            var i = e.alt
              .toLowerCase()
              .trim()
              .split(",")
              .find((e) => e.includes("featured_"));
            if (!i) return !1;
            var r = i.replace("featured_", "").trim();
            return r === t || r === a;
          });
        if (0 !== i.length) return _t.imgURL(i[0].src, "480x480");
      }
    }
    getProductUrl() {
      return (
        "/products/" +
        Zi(er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]), () => this.props.product)
          .handle
      );
    }
    formatSplitVariantNaming() {
      var e = Zi(
          er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
          () => this.props.product,
        ).title,
        t = this.state.selectedColour;
      if (t) {
        var a = t.split(" ");
        for (var i of a) e = e.replaceAll(i, "");
        return (e = e.replaceAll("-", "").trim()).trim() + " - " + t;
      }
      return (e = e.replaceAll("- -", "-").trim());
    }
    getFeaturedVariantUrl() {
      var e = Zi(
        er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
        () => this.props.product,
      ).handle.toLowerCase();
      return e.includes("membership") && (e.includes("sleepclub") || e.includes("sleep-club"))
        ? "/pages/sleepclub"
        : this.state.selectedVariant
          ? "/products/"
              .concat(
                Zi(
                  er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
                  () => this.props.product,
                ).handle,
                "?variant=",
              )
              .concat(this.state.selectedVariant.id)
          : this.getProductUrl();
    }
    getFeaturedVariantUrlWithoutId() {
      return this.state.selectedVariant
        ? "/products/".concat(
            Zi(
              er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
              () => this.props.product,
            ).handle,
          )
        : this.getProductUrl();
    }
    getDefaultFeaturedImage() {
      var e = Zi(
        er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
        () => this.props.product,
      ).images[0];
      return "content_block" ===
        Zi(er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]), () => this.props.product)
          .handle
        ? _t.imgURL(e, "480x480")
        : (this.state.quickShopIsOpen &&
              er([
                this,
                "access",
                (e) => e.state,
                "access",
                (e) => e.selectedVariant,
                "optionalAccess",
                (e) => e.featured_image,
              ])) ||
            (Zi(
              er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
              () => this.props.product,
            ).is_split_by_variant &&
              er([
                this,
                "access",
                (e) => e.state,
                "access",
                (e) => e.selectedVariant,
                "optionalAccess",
                (e) => e.featured_image,
                "optionalAccess",
                (e) => e.src,
              ]))
          ? _t.imgURL(this.state.selectedVariant.featured_image.src, "480x480")
          : (Zi(
              er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
              () => this.props.product,
            ).featured_image &&
              (e = Zi(
                er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
                () => this.props.product,
              ).featured_image),
            _t.imgURL(e, "480x480"));
    }
    getProductSplitVariantImage() {
      if (
        !Zi(er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]), () => this.props.product)
          .variants[0]
      )
        return this.getDefaultFeaturedImage();
      var e = Zi(
        er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
        () => this.props.product,
      ).variants[0].featured_image;
      return e && e.src ? e.src : this.getDefaultFeaturedImage();
    }
    getFeaturedImage() {
      if (
        "tf_image" ===
          Zi(er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]), () => this.props.product)
            .handle ||
        "content_block" ===
          Zi(er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]), () => this.props.product)
            .handle
      )
        return this.getDefaultFeaturedImage();
      if (
        Zi(er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]), () => this.props.product)
          .is_split_by_variant
      )
        return this.getProductSplitVariantImage();
      if (!this.state.hasInteracted || !this.state.selectedVariant) return this.getDefaultFeaturedImage();
      var e = this.state.selectedVariant.featured_image;
      return e ? _t.imgURL(e.src, "480x480") : this.getDefaultFeaturedImage();
    }
    getHoverImage() {
      if (
        er([
          Zi(
            er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
            () => this.props.product,
          ),
          "access",
          (e) => e.split_variants,
          "optionalAccess",
          (e) => e.option_id,
        ])
      ) {
        var e = this.getFeaturedImageForSplitVariant();
        if (e) return e;
      }
      var t = this.getFeaturedImage(),
        a = null;
      if (
        (Zi(er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]), () => this.props.product)
          .is_split_by_variant && (a = this.getProductSplitVariantImage()),
        Zi(er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]), () => this.props.product)
          .images.length > 1 || (a = this.getFeaturedImage()),
        a && a != t)
      )
        return a;
      var i = Zi(
        er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
        () => this.props.product,
      ).images.find(
        (e) => _t.imgURL(e, "480x480").split("?")[0].replace("https:", "") !== t.split("?")[0].replace("https:", ""),
      );
      return i ? _t.imgURL(i, "480x480") : t;
    }
    getInitialSelectedVariant(e) {
      var t = (e || []).filter(
        (e) =>
          "size" === e.category ||
          e.filterValue.includes("filter: gender - boy") ||
          e.filterValue.includes("filter: gender - girl"),
      );
      if (0 === t.length) {
        if (
          !Zi(
            er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
            () => this.props.product,
          ).featured_image
        )
          return Zi(
            er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
            () => this.props.product,
          ).variants.find((e) => e.available);
        for (
          var a = null,
            i = Zi(
              er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
              () => this.props.product,
            ).featured_image.split("/products/")[1],
            r = 0;
          r <
          Zi(er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]), () => this.props.product)
            .variants.length;
          r++
        ) {
          var s = Zi(
            er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
            () => this.props.product,
          ).variants[r];
          if (null != s.featured_image)
            if (i == s.featured_image.src.split("/products/")[1]) {
              a = s;
              break;
            }
        }
        return null == a
          ? Zi(
              er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
              () => this.props.product,
            ).variants.find((e) => e.available)
          : a;
      }
      var n,
        o = e.some((e) => "size" === e.category),
        l = e.some((e) => "gender" === e.category);
      if (o) {
        var c = e.filter((e) => "size" === e.category).length > 1;
        if (this.props.isGrapheneEnabled && c && !l) return this.getOneSelectedSizeFromMultiselect(t);
        if (
          ((n = er([
            e,
            "access",
            (e) => e.find,
            "call",
            (e) => e((e) => "size" === e.category),
            "optionalAccess",
            (e) => e.value,
          ])),
          !l)
        )
          return this.getSelectedVariantForColourAndSize(null, n);
      }
      if (l) {
        var d = er([
            e,
            "access",
            (e) => e.find,
            "call",
            (e) => e((e) => "gender" === e.category),
            "optionalAccess",
            (e) => e.value,
          ]),
          p = ["grey", "grey-stripe", "white", "grey-and-white", "white-and-grey", "forest"];
        ("girl" === d && p.push("blue", "blue-stripe", "space"),
          "boy" === d && p.push("blush", "blush-stripe", "stardust", "white-and-blush"));
        for (
          var u,
            m = It.colourOptions(
              Zi(
                er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
                () => this.props.product,
              ),
            )
              .map((e) => _t.handleize(e))
              .filter((e) => !p.includes(e)),
            h = 0;
          h < m.length;
          h++
        ) {
          var f = m[h];
          if ((u = this.getSelectedVariantForColourAndSize(f, n))) return u;
        }
      }
      return Zi(
        er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
        () => this.props.product,
      ).variants.find((e) => e.available);
    }
    getOneSelectedSizeFromMultiselect(e) {
      var t,
        a = e
          .filter((e) => "size" === e.category)
          .map((e) => {
            var t = e.value;
            return (/\d+-\d+-[a-z]/.test(t) && (t = t.split("-").join(" ").replace(" ", "-").replace(" ", "")), t);
          }),
        i = It.sizeOptions(
          Zi(
            er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
            () => this.props.product,
          ),
        ).map((e) => e.toLowerCase().replaceAll(" ", ""));
      for (var r of (a = a.sort((e, t) => i.indexOf(e) - i.indexOf(t))))
        if ((t = this.getSelectedVariantForColourAndSize(null, r))) break;
      return t;
    }
    getSelectedVariantForColourAndSize(e, t, a) {
      if (!t && !e && !a) return null;
      /\d+-\d+-[a-z]/.test(t) && (t = t.split("-").join(" ").replace(" ", "-").replace(" ", ""));
      var i = null;
      return (
        t &&
          !e &&
          (i = It.firstAvailableVariantInSize(
            Zi(
              er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
              () => this.props.product,
            ),
            t,
          )),
        !t &&
          e &&
          (i = It.firstAvailableVariantInColour(
            Zi(
              er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
              () => this.props.product,
            ),
            e,
          )),
        a &&
          (i = It.firstAvailableVariantInSizeAndColourAndAlternateOption(
            Zi(
              er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
              () => this.props.product,
            ),
            t,
            e,
            a,
            this.state.alternateOptionName,
          )),
        t &&
          e &&
          !i &&
          ((i = It.firstAvailableVariantInSizeAndColour(
            Zi(
              er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
              () => this.props.product,
            ),
            t,
            e,
          )) ||
            (i = It.firstAvailableVariantInColour(
              Zi(
                er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
                () => this.props.product,
              ),
              e,
            ))),
        i
      );
    }
    onColourSelected(e) {
      var t,
        a = It.sizeOptionName(
          Zi(
            er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
            () => this.props.product,
          ),
        ),
        i = this.getSelectedVariantForColourAndSize(e, this.state.selectedSize, this.state.selectedAlternateOption);
      (this.state.alternateOptionName && (t = i[this.state.alternateOptionName]),
        this.setState({
          selectedColour: e,
          selectedSize: Zi(er([i, "optionalAccess", (e) => e[a]]), () => null),
          hasInteracted: !0,
          selectedVariant: i,
          selectedAlternateOption: t,
        }),
        this.state.quickShopIsOpen || this.quickShopIsOpen());
    }
    onSizeSelected(e) {
      var t,
        a = this.getSelectedVariantForColourAndSize(this.state.selectedColour, e, this.state.selectedAlternateOption);
      (this.state.alternateOptionName && (t = a[this.state.alternateOptionName]),
        this.setState({ selectedSize: e, hasInteracted: !0, selectedVariant: a, selectedAlternateOption: t }));
    }
    onAlternateOptionSelected(e) {
      var t = this.getSelectedVariantForColourAndSize(this.state.selectedColour, this.state.selectedSize, e);
      this.setState({ selectedAlternateOption: e, hasInteracted: !0, selectedVariant: t });
    }
    quickShopIsOpen() {
      this.setState({ quickShopIsOpen: !0 });
    }
    defaultHoverImage() {
      var e = this.getDefaultFeaturedImage(),
        t =
          Zi(er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]), () => this.props.product)
            .images.length > 1
            ? Zi(
                er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
                () => this.props.product,
              ).images[1]
            : Zi(
                er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
                () => this.props.product,
              ).images[0];
      t = _t.imgURL(t, "480x480");
      var a =
        this.state.selectedVariant && this.state.selectedVariant.featured_image
          ? this.state.selectedVariant.featured_image.src
          : null;
      return a
        ? ((a = _t.imgURL(a, "480x480")).split("?")[0].replace("https:", "") ===
            e.split("?")[0].replace("https:", "") && (a = t),
          a)
        : t;
    }
    productClickThrough() {
      P.logEvent("plp_pdp_clickthrough", {
        click_label: window.location.pathname,
        target_product_url: this.getFeaturedVariantUrlWithoutId(),
      });
      var e = window.location.pathname.split("/")[2],
        t = this.getFeaturedVariantUrlWithoutId().split("/")[2],
        a = P.getDynamicEvent().GTM_TEMPLATE_CATEGORY_NAME,
        i = "".concat(a, "__product"),
        r = e ? "".concat(e, "__").concat(t) : "".concat(a, "__").concat(t);
      P.logDynamicEvent({ eventParameterName: i, eventParameterValue: r });
    }
    renderContentBlock(e, t, a) {
      var i = !!e.liveText.replace(/(<([^>]+)>)/gi, "").trim(),
        r = !!e.ctaText.replace(/(<([^>]+)>)/gi, "").trim();
      return o.default.createElement(
        o.default.Fragment,
        null,
        o.default.createElement(
          "div",
          { className: t.join(" "), style: { textAlign: "center" }, "data-testid": "product-grid-item" },
          o.default.createElement(
            "div",
            {
              className: "product-image-wrap interstatial_img inter_images ".concat(e.handle),
              onClick: () => {
                P.gtmTriggerEvents(
                  e.handle,
                  "cta_click",
                  i ? e.liveText.replace(/(<([^>]+)>)/gi, "").trim() : e.images[0].split("/").splice(-1).toString(),
                );
              },
            },
            "no_link" === e.ctaUrl
              ? o.default.createElement(
                  "div",
                  {
                    className: "grid__image gtm-trigger--plp_content_block_click",
                    "data-gtm-click_content_block_label": e.ctaUrl,
                    onClick: () => window.dispatchEvent(new Event("contentBlock.clicked")),
                  },
                  o.default.createElement(xi, {
                    featureImage: a,
                    hoverImage: void 0,
                    vendor: Zi(
                      Zi(
                        er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
                        () => this.props.product,
                      ).vendor,
                      () =>
                        Zi(
                          er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
                          () => this.props.product,
                        ).title,
                    ),
                  }),
                )
              : o.default.createElement(
                  "a",
                  {
                    href: e.ctaUrl,
                    target: "_blank",
                    rel: "noreferrer noopener",
                    className: "grid__image gtm-trigger--plp_content_block_click",
                    "data-gtm-click_content_block_label": e.ctaUrl,
                    onClick: () => window.dispatchEvent(new Event("contentBlock.clicked")),
                  },
                  o.default.createElement(xi, {
                    featureImage: a,
                    hoverImage: void 0,
                    vendor: Zi(
                      Zi(
                        er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
                        () => this.props.product,
                      ).vendor,
                      () =>
                        Zi(
                          er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
                          () => this.props.product,
                        ).title,
                    ),
                  }),
                ),
            (i || r) &&
              o.default.createElement(
                "div",
                { id: "content_block_".concat(e.blockNumber), className: "live_text_wrapper" },
                i &&
                  o.default.createElement("div", {
                    className: "live_text",
                    dangerouslySetInnerHTML: { __html: e.liveText },
                  }),
                r &&
                  o.default.createElement("a", {
                    className: "_standard_button cta_text",
                    href: e.ctaUrl,
                    target: "_blank",
                    dangerouslySetInnerHTML: { __html: e.ctaText },
                  }),
              ),
          ),
        ),
      );
    }
    getProductSelectionState(e, t) {
      var a = It.sizeOptionName(e),
        i = It.colourOptionName(e),
        r =
          (t && a ? It.firstAvailableVariantInSize(e, t) : null) ||
          e.variants.find((e) => e.available) ||
          e.variants[0];
      return r
        ? { selectedProduct: e, selectedVariant: r, selectedColour: i ? r[i] : null, selectedSize: a ? r[a] : null }
        : { selectedProduct: e, selectedVariant: null, selectedColour: null, selectedSize: null };
    }
    render() {
      var e = this,
        t = [
          "grid__item",
          "product-grid-item",
          "type_grid_item_regular",
          "large--one-quarter",
          "medium--one-quarter",
          "small--one-half",
          "col-item-".concat(this.state.selectedProduct.handle),
        ];
      ("free-baby-blanket-1" === this.state.selectedProduct.handle && t.push("hidden_item"),
        this.state.isScMember && t.push("sleepclub_logged_in"));
      var a = (e) => {
          if (this.state.selectedProduct.media) return "";
          var t = Zi(
              er([
                e,
                "access",
                (e) => e.replace,
                "call",
                (e) => e("_480x480", ""),
                "access",
                (e) => e.split,
                "call",
                (e) => e("?"),
                "optionalAccess",
                (e) => e[0],
              ]),
              () => "not__--__found",
            ),
            a = this.state.selectedProduct.media.find((e) => e.src.includes(t));
          return a ? a.alt : "";
        },
        i = (e) => {
          var t =
            er([
              this,
              "access",
              (e) => e.state,
              "access",
              (e) => e.selectedProduct,
              "optionalAccess",
              (e) => e.media,
              "optionalAccess",
              (e) => e.filter,
              "call",
              (t) => t((t) => t.src === e.replace("_480x480", "")),
            ]) || [];
          if (!t.length) return "";
          var a = t.map((e) =>
            er([
              e,
              "access",
              (e) => e.alt,
              "optionalAccess",
              (e) => e.match,
              "call",
              (e) => e(_wrapRegExp(/:(.*):/, { alt_text: 1 })),
            ]),
          );
          return (
            er([a, "access", (e) => e[0], "optionalAccess", (e) => e.groups, "optionalAccess", (e) => e.alt_text]) || ""
          );
        },
        r = this.getDefaultFeaturedImage(),
        s = a(r),
        n = this.state.quickShopIsOpen ? this.getHoverImage() : this.defaultHoverImage(),
        l = a(n),
        c = i(r),
        d = i(n);
      "content_block" === this.state.selectedProduct.handle && (d = "content_block");
      var p = "";
      er([
        this,
        "access",
        (e) => e.props,
        "access",
        (e) => e.idsOfProductsWhichPricesAreLoading,
        "optionalAccess",
        (e) => e.includes,
        "call",
        (e) => e(this.state.selectedProduct.id),
      ]) && (p = "waitingForCorrectPrices");
      var u = "content_block" !== this.state.selectedProduct.handle && r !== n,
        m = window.mori.state.isB2B,
        h = this.props,
        f = h.promoMessage,
        g = h.roundelText,
        v =
          (h.product,
          (e) => {
            var t = e.variants[0].option1;
            return (
              e.options.length > 1 &&
                (("color" !== e.options[1].toLowerCase() && "colour" !== e.options[1].toLowerCase()) ||
                  (t = e.variants[0].option2)),
              t.toLowerCase().replaceAll("&", "").replaceAll("  ", " ").split(" ").join("-")
            );
          }),
        _ = (e) => "handle-".concat(e.handle),
        y = [],
        b = 0,
        w = [this.props.product, ...(this.props.product.extraProducts || [])],
        S = [...w],
        E = S.filter((e) => {
          var t = e.variants;
          if (!t) return !1;
          var a = t.length,
            i = Math.round(a / 2);
          return t.filter((e) => !e.available).length > i;
        }),
        C = E.map((e) => e.handle),
        A = S.filter((e) => !C.includes(e.handle)),
        k = E.sort((e, t) => (e.handle.toLocaleLowerCase() > t.handle.toLocaleLowerCase() ? 1 : -1));
      if (
        ((w = [...A.sort((e, t) => (e.handle.toLocaleLowerCase() > t.handle.toLocaleLowerCase() ? 1 : -1)), ...k]),
        this.props.product.is_merged_variant)
      ) {
        var N = function (t) {
          if (b >= e.state.variantLimits) return "break";
          (y.push(
            o.default.createElement(
              "div",
              {
                onClick: (a) => {
                  e.setState((a) =>
                    _objectSpread(
                      _objectSpread({}, e.getProductSelectionState(t, a.selectedSize)),
                      {},
                      { selectedKey: Zi(t.newKey, () => t.id.toString()) },
                    ),
                  );
                },
                key: "".concat(t.newKey ? t.newKey : t.id, "_product_swatch"),
                className: "gtm_plp_colour_swatch_element "
                  .concat(_(t), " swatch-element color ")
                  .concat(
                    t.newKey
                      ? t.newKey === e.state.selectedKey
                        ? "selected"
                        : ""
                      : t.id === e.state.selectedProduct.id
                        ? "selected"
                        : "",
                    " ",
                  )
                  .concat(v(t), " ")
                  .concat(t.isStockAvailable ? "available" : ""),
              },
              o.default.createElement("label", { className: "collection_swatch ".concat(v(t)) }),
            ),
          ),
            (b += 1));
        };
        for (var T of w) {
          if ("break" === N(T)) break;
        }
        if (
          this.props.product.extraProducts &&
          this.props.product.extraProducts.length + 1 > this.state.variantLimits
        ) {
          var O = this.props.product.extraProducts.length - this.state.variantLimits;
          y.push(
            o.default.createElement(
              "div",
              {
                key: "view-more",
                className:
                  "linked_view_more_override gtm_plp_colour_swatch_element swatch-element view__more-wrapper  handle-"
                    .concat(_(this.props.product), " ")
                    .concat(this.props.product.isStockAvailable ? "available" : ""),
              },
              o.default.createElement(
                "span",
                { className: "collection_swatch view__more" },
                o.default.createElement(
                  "a",
                  { href: "/products/".concat(_(this.props.product).replace("handle-", "")) },
                  O,
                ),
              ),
            ),
          );
        }
      } else if (this.props.product.is_merged_product) {
        var x = function (t) {
          if (b >= e.state.variantLimits) return "break";
          (y.push(
            o.default.createElement("div", {
              onClick: (a) => {
                e.setState((a) => _objectSpread({}, e.getProductSelectionState(t, a.selectedSize)));
              },
              key: "".concat(t.id, "_product_swatch"),
              style: { backgroundImage: "url(".concat(t.featured_image, ")") },
              className: "merged_product_swatch "
                .concat(_(t), " ")
                .concat(t.id === e.state.selectedProduct.id ? "selected" : ""),
            }),
          ),
            (b += 1));
        };
        for (var I of w) {
          if ("break" === x(I)) break;
        }
        if (
          this.props.product.extraProducts &&
          this.props.product.extraProducts.length + 1 > this.state.variantLimits
        ) {
          var L = this.props.product.extraProducts.length - this.state.variantLimits;
          y.push(
            o.default.createElement(
              "div",
              {
                key: "view-more",
                className:
                  "linked_view_more_override gtm_plp_colour_swatch_element swatch-element view__more-wrapper  handle-"
                    .concat(_(this.props.product), " ")
                    .concat(this.props.product.isStockAvailable ? "available" : ""),
              },
              o.default.createElement(
                "span",
                { className: "collection_swatch view__more" },
                o.default.createElement(
                  "a",
                  { href: "/products/".concat(_(this.props.product).replace("handle-", "")) },
                  L,
                ),
              ),
            ),
          );
        }
      }
      return "tf_image" === this.state.selectedProduct.handle || "content_block" === this.state.selectedProduct.handle
        ? this.renderContentBlock(
            Zi(
              er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
              () => this.props.product,
            ),
            t,
            r,
          )
        : o.default.createElement(
            "div",
            { className: t.join(" "), "data-testid": "product-grid-item" },
            o.default.createElement(
              "div",
              { className: "product-image-wrap" },
              o.default.createElement(
                "a",
                {
                  className: "grid__image",
                  href: this.getFeaturedVariantUrl(),
                  onClick: () => this.productClickThrough(),
                },
                o.default.createElement(la, { altTag: s, hoverAltTag: l, dealRoundel: this.props.dealRoundel }),
                o.default.createElement(xi, {
                  featureImage: r,
                  hoverImage: n,
                  hoverEnabled: u,
                  altText: [c, d],
                  vendor: Zi(this.state.selectedProduct.vendor, () => this.state.selectedProduct.title),
                }),
              ),
              !m &&
                o.default.createElement(Ri, {
                  product: this.state.selectedProduct,
                  settings: this.props.settings,
                  isScMember: this.props.isScMember,
                  isScProduct: this.state.isScProduct,
                  selectedVarient: this.state.selectedVariant,
                  isUSsaveTagRunning: this.props.isUSsaveTagRunning,
                }),
              !m &&
                !this.state.selectedProduct.tags.includes("print-of-the-month") &&
                o.default.createElement(ca, { shouldShow: !0, fieldText: g }),
            ),
            o.default.createElement(
              "div",
              { className: "brand-and-star-section" },
              o.default.createElement(Ki, { product: this.state.selectedProduct }),
              this.state.reviewScore
                ? o.default.createElement(
                    "div",
                    { className: "star-ratings-wrapper" },
                    o.default.createElement(
                      "svg",
                      {
                        className: "star-rating",
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                      o.default.createElement("path", {
                        d: "M6.09203 0L7.45977 4.20949H11.8859L8.30508 6.81109L9.67283 11.0206L6.09203 8.41897L2.51122 11.0206L3.87897 6.81109L0.298165 4.20949H4.72428L6.09203 0Z",
                        fill: "#f3af53",
                      }),
                    ),
                    o.default.createElement("p", { className: "ratings-text" }, this.state.reviewScore),
                  )
                : o.default.createElement("div", null),
            ),
            o.default.createElement(
              "p",
              { className: "h6" },
              o.default.createElement(
                "a",
                {
                  href: this.getProductUrl(),
                  onClick: () => P.logEvent("plp_pdp_clickthrough", { click_label: window.location.pathname }),
                },
                this.state.isSplit ? "".concat(this.formatSplitVariantNaming()) : this.state.selectedProduct.title,
              ),
            ),
            o.default.createElement(
              "p",
              { className: "price ".concat(p) },
              o.default.createElement(Li, {
                openQuickshotProductHash: this.props.openQuickshotProductHash,
                selectedVariant: this.state.selectedVariant,
                product: this.state.selectedProduct,
                showSleepClubPrice: !this.state.isScProduct && this.state.isScMember,
                quickShopIsOpen: this.state.quickShopIsOpen,
                appliedSort: this.props.appliedSort,
                isGrapheneEnabled: this.props.isGrapheneEnabled,
              }),
            ),
            !this.state.isScMember &&
              o.default.createElement(
                o.default.Fragment,
                null,
                this.state.isLoadingAutoDiscount
                  ? o.default.createElement(
                      "div",
                      { className: "shimmer faux-image automatic-discount-title" },
                      o.default.createElement("span", { className: "skeleton-loader" }),
                    )
                  : this.state.automaticDiscountTitle && !this.state.selectedProduct.auto_discount_message
                    ? o.default.createElement(
                        "p",
                        { className: "automatic-discount-title" },
                        this.state.automaticDiscountTitle,
                        " - Auto Applied",
                      )
                    : null,
                this.state.selectedProduct.auto_discount_message
                  ? o.default.createElement(
                      "p",
                      { className: "automatic-discount-title" },
                      this.state.selectedProduct.auto_discount_message,
                      " - Auto Applied",
                    )
                  : null,
              ),
            o.default.createElement(Ji, {
              message: ((e) =>
                e &&
                e.toLowerCase().includes("buy") &&
                e.toLowerCase().includes("get") &&
                this.state.automaticDiscountTitle &&
                "_" !== this.state.automaticDiscountTitle
                  ? null
                  : e)(f),
            }),
            o.default.createElement(
              "div",
              { className: "product_switch_wrapper" },
              this.props.product.is_merged_variant && y,
              this.props.product.is_merged_product && y,
            ),
            o.default.createElement(Oi, {
              product: Zi(
                er([this, "access", (e) => e.state, "optionalAccess", (e) => e.selectedProduct]),
                () => this.props.product,
              ),
            }),
            !this.state.comingSoonTagAndOos &&
              o.default.createElement(Qi, {
                product: this.state.selectedProduct,
                selectedVariant: this.state.selectedVariant
                  ? this.state.selectedVariant
                  : this.state.selectedProduct.variants.find((e) => e.available),
                isSplit: this.state.isSplit,
                selectedColour: this.state.selectedColour,
                selectedSize: this.state.selectedSize,
                selectedAlternateOption: this.state.selectedAlternateOption,
                onColourSelected: this.onColourSelected,
                onSizeSelected: this.onSizeSelected,
                onAlternateOptionSelected: this.onAlternateOptionSelected,
                openQuickshotProductHash: this.props.openQuickshotProductHash,
                onQuickShopOpened: this.props.onQuickShopOpened,
                quickShopIsOpen: this.quickShopIsOpen,
                switchOffQuickshop: this.props.switchOffQuickshop,
                isGrapheneEnabled: this.props.isGrapheneEnabled,
                gtmEvent: this.props.settings.gtmEvent,
                styleOverride: this.props.styleOverride,
                noOfDesktopSwatches: 9,
                noOfMobileSwatches: 5,
                showQuickShopIcon: !0,
              }),
          );
    }
  }
  ar.displayName = "MergedProductGridItem";
  var ir = fi(ar);
  function rr(e, t) {
    return null != e ? e : t();
  }
  function sr(e) {
    for (var t = void 0, a = e[0], i = 1; i < e.length; ) {
      var r = e[i],
        s = e[i + 1];
      if (((i += 2), ("optionalAccess" === r || "optionalCall" === r) && null == a)) return;
      "access" === r || "optionalAccess" === r
        ? ((t = a), (a = s(a)))
        : ("call" !== r && "optionalCall" !== r) ||
          ((a = s(function () {
            for (var e = arguments.length, i = new Array(e), r = 0; r < e; r++) i[r] = arguments[r];
            return a.call(t, ...i);
          })),
          (t = void 0));
    }
    return a;
  }
  var nr = ["title", "tog"];
  class or extends e.Component {
    constructor(e) {
      super(e);
      var t = this.props.product.handle.toLowerCase(),
        a = t.includes("sleep-club") || t.includes("sleepclub"),
        i = this.getInitialSelectedVariant(this.props.appliedFilters);
      (i && sr([i, "optionalAccess", (e) => e.available])) ||
        (i = this.props.product.variants.find((e) => e.available));
      var r = nr.find((e) => It.optionNameForOption(this.props.product, e)),
        s = null,
        n = null,
        o = null,
        l = null,
        c = this.props.product.tags.find((e) => e.includes("DefaultColor:"));
      if (c) {
        var d = c.replace("DefaultColor:", "").trim(),
          p = this.props.product.variants.filter((e) => e.title.includes(d));
        p.length > 0 && (p.sort((e, t) => e.inventory_quantity > t.inventory_quantity), (i = p[0]));
      }
      (window.location.pathname.split("/").includes("sale") &&
        (i = this.props.product.variants.find((e) => !!e.compare_at_price && (e.compare_at_price > e.price || void 0))),
        i &&
          ((s = i[It.colourOptionName(this.props.product)]),
          (n = i[It.sizeOptionName(this.props.product)]),
          r && (o = i[(l = It.optionNameForOption(this.props.product, r))])));
      var u = !1;
      (this.props.appliedFilters || []).some((e) => "gender" === e.category) && (u = !0);
      var m = !1,
        h = !!this.props.product.tags.includes("display_oos");
      (!this.props.product.available &&
        (this.props.product.tags.includes("pre_launch") || h || this.props.product.tags.includes("oos_coming_soon")) &&
        (m = !0),
        (this.state = {
          isScMember: this.props.isScMember || !1,
          isScProduct: a || !1,
          selectedVariant: i,
          selectedColour: s || null,
          selectedSize: n,
          hasInteracted: u,
          selectedAlternateOption: o,
          alternateOptionName: l,
          quickShopIsOpen: !1,
          isSplit: !1,
          comingSoonTagAndOos: m,
          isLoadingAutoDiscount: !0,
        }),
        (this.onColourSelected = this.onColourSelected.bind(this)),
        (this.onSizeSelected = this.onSizeSelected.bind(this)),
        (this.onAlternateOptionSelected = this.onAlternateOptionSelected.bind(this)),
        (this.quickShopIsOpen = this.quickShopIsOpen.bind(this)));
    }
    componentDidMount() {
      var e = new AbortController(),
        t = !1,
        a = !1,
        i = void 0;
      (setTimeout(() => {
        ((t = !0), a && this.setState({ automaticDiscountTitle: i, isLoadingAutoDiscount: !1 }));
      }, 1e3),
        this.props.isScMember
          ? this.setState({ isLoadingAutoDiscount: !1 })
          : mi("auto_discount_title", "custom", this.props.product.id, e).then((r) => {
              if (!e.signal.aborted) {
                var s = r.trim();
                if ((i = "" !== s && "_" !== s ? s : void 0)) {
                  var n = window.mori.state.autoDiscountExclusionList,
                    o = window.location.href.split("/"),
                    l = o.indexOf("collections");
                  if (-1 != l) {
                    var c = o[l + 1];
                    n.some((e) => c.includes(e)) && (i = void 0);
                  }
                }
                ((a = !0), t && this.setState({ automaticDiscountTitle: i, isLoadingAutoDiscount: !1 }));
              }
            }));
      var r = this.props.product.variants.some((e) =>
        sr([
          e,
          "access",
          (e) => e.sku,
          "optionalAccess",
          (e) => e.toLowerCase,
          "call",
          (e) => e(),
          "access",
          (e) => e.startsWith,
          "call",
          (e) => e("x"),
        ]),
      );
      if (
        sr([
          this,
          "access",
          (e) => e.props,
          "access",
          (e) => e.product,
          "access",
          (e) => e.split_variants,
          "optionalAccess",
          (e) => e.option_id,
        ]) &&
        !r
      ) {
        var s = this.props.product.variants.filter((e) => {
          var t = e.hierarchy_id.split("/");
          return void 0 === this.state.selectedSize
            ? t.includes(this.props.product.split_variants.option_id)
            : t.includes(this.props.product.split_variants.option_id) && e.options.includes(this.state.selectedSize);
        });
        if (s.length > 0) {
          var n = s[0],
            o = n[It.colourOptionName(this.props.product)];
          this.setState({ selectedVariant: n, selectedColour: o, quickShopIsOpen: !0, isSplit: !0 });
        }
      }
      var l = this.props.product.variants.map((e) => e.sku);
      $i.fetchProductReviews({ publicStoreKey: "babymori.com", productSkus: [l[0]] })
        .then((e) => {
          if (e.data.length > 0) {
            var t = e.data.map((e) => parseFloat(e.averageRating)),
              a = 0;
            for (var i of t) a += i;
            var r = a / e.data.length;
            r >= 4 && this.setState({ reviewScore: r.toFixed(1) });
          }
        })
        .catch((e) => console.log(e));
    }
    componentDidUpdate(e) {
      var t = this.props,
        a = t.appliedFilters,
        i = t.hasInteracted,
        r = t.product;
      if (a.length !== e.appliedFilters.length || r.variants.length !== e.product.variants.length) {
        var s = this.getInitialSelectedVariant(a);
        if (
          ((this.props.appliedFilters || []).some((e) => "gender" === e.category) && (i = !0),
          s || (s = this.props.product.variants.find((e) => e.available)),
          !s)
        )
          return void this.setState({
            selectedVariant: s,
            selectedColour: null,
            selectedSize: null,
            hasInteracted: i,
            selectedAlternateOption: null,
          });
        var n,
          o = s[It.colourOptionName(this.props.product)],
          l = s[It.sizeOptionName(this.props.product)];
        (this.state.alternateOptionName && (n = s[this.state.alternateOptionName]),
          this.setState({
            selectedVariant: s,
            selectedColour: o,
            selectedSize: l,
            hasInteracted: i,
            selectedAlternateOption: n,
          }));
      }
    }
    formattedOptionsForSplitVariant(e) {
      if (e) return e.toLowerCase().trim().replaceAll(" ", "_");
    }
    getFeaturedImageForSplitVariant() {
      var e = this.props.product.media;
      if (this.state.selectedVariant) {
        var t = this.formattedOptionsForSplitVariant(this.state.selectedVariant.option1),
          a = this.formattedOptionsForSplitVariant(rr(this.state.selectedVariant.option2, () => "")),
          i = e.filter((e) => {
            if (!e.alt) return !1;
            var i = e.alt
              .toLowerCase()
              .trim()
              .split(",")
              .find((e) => e.includes("featured_"));
            if (!i) return !1;
            var r = i.replace("featured_", "").trim();
            return r === t || r === a;
          });
        if (0 !== i.length) return _t.imgURL(i[0].src, "480x480");
      }
    }
    getProductUrl() {
      return "/products/" + this.props.product.handle;
    }
    formatSplitVariantNaming() {
      var e = this.props.product.title,
        t = this.state.selectedColour;
      if (t && !e.includes("-")) {
        var a = t.split(" "),
          i = e.split(" "),
          r = "";
        for (var s of i) {
          var n = !1;
          for (var o of a) s.toLowerCase().trim() !== o.toLowerCase().trim() && (n = !0);
          n && (r = r + " " + s);
        }
        return r.trim() + " - " + t;
      }
      return (e = e.replaceAll("- -", "-").trim());
    }
    getFeaturedVariantUrl() {
      var e = this.props.product.handle.toLowerCase();
      return e.includes("membership") && (e.includes("sleepclub") || e.includes("sleep-club"))
        ? "/pages/sleepclub"
        : this.state.selectedVariant
          ? "/products/".concat(this.props.product.handle, "?variant=").concat(this.state.selectedVariant.id)
          : this.getProductUrl();
    }
    getFeaturedVariantUrlWithoutId() {
      return this.state.selectedVariant ? "/products/".concat(this.props.product.handle) : this.getProductUrl();
    }
    getDefaultFeaturedImage() {
      var e = this.props.product.images[0];
      return "content_block" === this.props.product.handle
        ? _t.imgURL(e, "480x480")
        : (this.state.quickShopIsOpen &&
              sr([
                this,
                "access",
                (e) => e.state,
                "access",
                (e) => e.selectedVariant,
                "optionalAccess",
                (e) => e.featured_image,
              ])) ||
            (this.props.product.is_split_by_variant &&
              sr([
                this,
                "access",
                (e) => e.state,
                "access",
                (e) => e.selectedVariant,
                "optionalAccess",
                (e) => e.featured_image,
                "optionalAccess",
                (e) => e.src,
              ]))
          ? _t.imgURL(this.state.selectedVariant.featured_image.src, "480x480")
          : (this.props.product.featured_image && (e = this.props.product.featured_image), _t.imgURL(e, "480x480"));
    }
    getProductSplitVariantImage() {
      if (!this.props.product.variants[0]) return this.getDefaultFeaturedImage();
      var e = this.props.product.variants[0].featured_image;
      return e && e.src ? e.src : this.getDefaultFeaturedImage();
    }
    getFeaturedImage() {
      if ("tf_image" === this.props.product.handle || "content_block" === this.props.product.handle)
        return this.getDefaultFeaturedImage();
      if (this.props.product.is_split_by_variant) return this.getProductSplitVariantImage();
      if (!this.state.hasInteracted || !this.state.selectedVariant) return this.getDefaultFeaturedImage();
      var e = this.state.selectedVariant.featured_image;
      return e ? _t.imgURL(e.src, "480x480") : this.getDefaultFeaturedImage();
    }
    getHoverImage() {
      if (
        sr([
          this,
          "access",
          (e) => e.props,
          "access",
          (e) => e.product,
          "access",
          (e) => e.split_variants,
          "optionalAccess",
          (e) => e.option_id,
        ])
      ) {
        var e = this.getFeaturedImageForSplitVariant();
        if (e) return e;
      }
      var t = this.getFeaturedImage(),
        a = null;
      if (
        (this.props.product.is_split_by_variant && (a = this.getProductSplitVariantImage()),
        this.props.product.images.length > 1 || (a = this.getFeaturedImage()),
        a && a != t)
      )
        return a;
      var i = this.props.product.images.find(
        (e) => _t.imgURL(e, "480x480").split("?")[0].replace("https:", "") !== t.split("?")[0].replace("https:", ""),
      );
      return i ? _t.imgURL(i, "480x480") : t;
    }
    getInitialSelectedVariant(e) {
      var t = (e || []).filter(
        (e) =>
          "size" === e.category ||
          e.filterValue.includes("filter: gender - boy") ||
          e.filterValue.includes("filter: gender - girl"),
      );
      if (0 === t.length) {
        if (!this.props.product.featured_image) return this.props.product.variants.find((e) => e.available);
        for (
          var a = null, i = this.props.product.featured_image.split("/products/")[1], r = 0;
          r < this.props.product.variants.length;
          r++
        ) {
          var s = this.props.product.variants[r];
          if (null != s.featured_image)
            if (i == s.featured_image.src.split("/products/")[1]) {
              a = s;
              break;
            }
        }
        return null == a ? this.props.product.variants.find((e) => e.available) : a;
      }
      var n,
        o = e.some((e) => "size" === e.category),
        l = e.some((e) => "gender" === e.category);
      if (o) {
        var c = e.filter((e) => "size" === e.category).length > 1;
        if (this.props.isGrapheneEnabled && c && !l) return this.getOneSelectedSizeFromMultiselect(t);
        if (
          ((n = sr([
            e,
            "access",
            (e) => e.find,
            "call",
            (e) => e((e) => "size" === e.category),
            "optionalAccess",
            (e) => e.value,
          ])),
          !l)
        )
          return this.getSelectedVariantForColourAndSize(null, n);
      }
      if (l) {
        var d = sr([
            e,
            "access",
            (e) => e.find,
            "call",
            (e) => e((e) => "gender" === e.category),
            "optionalAccess",
            (e) => e.value,
          ]),
          p = ["grey", "grey-stripe", "white", "grey-and-white", "white-and-grey", "forest"];
        ("girl" === d && p.push("blue", "blue-stripe", "space"),
          "boy" === d && p.push("blush", "blush-stripe", "stardust", "white-and-blush"));
        for (
          var u,
            m = It.colourOptions(this.props.product)
              .map((e) => _t.handleize(e))
              .filter((e) => !p.includes(e)),
            h = 0;
          h < m.length;
          h++
        ) {
          var f = m[h];
          if ((u = this.getSelectedVariantForColourAndSize(f, n))) return u;
        }
      }
      return this.props.product.variants.find((e) => e.available);
    }
    getOneSelectedSizeFromMultiselect(e) {
      var t,
        a = e
          .filter((e) => "size" === e.category)
          .map((e) => {
            var t = e.value;
            return (/\d+-\d+-[a-z]/.test(t) && (t = t.split("-").join(" ").replace(" ", "-").replace(" ", "")), t);
          }),
        i = It.sizeOptions(this.props.product).map((e) => e.toLowerCase().replaceAll(" ", ""));
      for (var r of (a = a.sort((e, t) => i.indexOf(e) - i.indexOf(t))))
        if ((t = this.getSelectedVariantForColourAndSize(null, r))) break;
      return t;
    }
    getSelectedVariantForColourAndSize(e, t, a) {
      if (!t && !e && !a) return null;
      /\d+-\d+-[a-z]/.test(t) && (t = t.split("-").join(" ").replace(" ", "-").replace(" ", ""));
      var i = null;
      return (
        t && !e && (i = It.firstAvailableVariantInSize(this.props.product, t)),
        !t && e && (i = It.firstAvailableVariantInColour(this.props.product, e)),
        a &&
          (i = It.firstAvailableVariantInSizeAndColourAndAlternateOption(
            this.props.product,
            t,
            e,
            a,
            this.state.alternateOptionName,
          )),
        t &&
          e &&
          !i &&
          ((i = It.firstAvailableVariantInSizeAndColour(this.props.product, t, e)) ||
            (i = It.firstAvailableVariantInColour(this.props.product, e))),
        i
      );
    }
    onColourSelected(e) {
      var t,
        a = It.sizeOptionName(this.props.product),
        i = this.getSelectedVariantForColourAndSize(e, this.state.selectedSize, this.state.selectedAlternateOption);
      (this.state.alternateOptionName && (t = i[this.state.alternateOptionName]),
        this.setState({
          selectedColour: e,
          selectedSize: rr(sr([i, "optionalAccess", (e) => e[a]]), () => null),
          hasInteracted: !0,
          selectedVariant: i,
          selectedAlternateOption: t,
        }),
        this.state.quickShopIsOpen || this.quickShopIsOpen());
    }
    onSizeSelected(e) {
      var t,
        a = this.getSelectedVariantForColourAndSize(this.state.selectedColour, e, this.state.selectedAlternateOption);
      (this.state.alternateOptionName && (t = a[this.state.alternateOptionName]),
        this.setState({ selectedSize: e, hasInteracted: !0, selectedVariant: a, selectedAlternateOption: t }));
    }
    onAlternateOptionSelected(e) {
      var t = this.getSelectedVariantForColourAndSize(this.state.selectedColour, this.state.selectedSize, e);
      this.setState({ selectedAlternateOption: e, hasInteracted: !0, selectedVariant: t });
    }
    quickShopIsOpen() {
      this.setState({ quickShopIsOpen: !0 });
    }
    defaultHoverImage() {
      var e = this.getDefaultFeaturedImage(),
        t = this.props.product.images.length > 1 ? this.props.product.images[1] : this.props.product.images[0];
      t = _t.imgURL(t, "480x480");
      var a =
        this.state.selectedVariant && this.state.selectedVariant.featured_image
          ? this.state.selectedVariant.featured_image.src
          : null;
      return a
        ? ((a = _t.imgURL(a, "480x480")).split("?")[0].replace("https:", "") ===
            e.split("?")[0].replace("https:", "") && (a = t),
          a)
        : t;
    }
    productClickThrough() {
      P.logEvent("plp_pdp_clickthrough", {
        click_label: window.location.pathname,
        target_product_url: this.getFeaturedVariantUrlWithoutId(),
      });
      var e = window.location.pathname.split("/")[2],
        t = this.getFeaturedVariantUrlWithoutId().split("/")[2],
        a = P.getDynamicEvent().GTM_TEMPLATE_CATEGORY_NAME,
        i = "".concat(a, "__product"),
        r = e ? "".concat(e, "__").concat(t) : "".concat(a, "__").concat(t);
      P.logDynamicEvent({ eventParameterName: i, eventParameterValue: r });
    }
    renderContentBlock(e, t, a) {
      var i = !!e.liveText.replace(/(<([^>]+)>)/gi, "").trim(),
        r = !!e.ctaText.replace(/(<([^>]+)>)/gi, "").trim();
      return o.default.createElement(
        o.default.Fragment,
        null,
        o.default.createElement(
          "div",
          { className: t.join(" "), style: { textAlign: "center" }, "data-testid": "product-grid-item" },
          o.default.createElement(
            "div",
            {
              className: "product-image-wrap interstatial_img inter_images ".concat(e.handle),
              onClick: () => {
                P.gtmTriggerEvents(
                  e.handle,
                  "cta_click",
                  i ? e.liveText.replace(/(<([^>]+)>)/gi, "").trim() : e.images[0].split("/").splice(-1).toString(),
                );
              },
            },
            "no_link" === e.ctaUrl
              ? o.default.createElement(
                  "div",
                  {
                    className: "grid__image gtm-trigger--plp_content_block_click",
                    "data-gtm-click_content_block_label": e.ctaUrl,
                    onClick: () => window.dispatchEvent(new Event("contentBlock.clicked")),
                  },
                  o.default.createElement(xi, {
                    featureImage: a,
                    hoverImage: void 0,
                    vendor: rr(this.props.product.vendor, () => this.props.product.title),
                  }),
                )
              : o.default.createElement(
                  "a",
                  {
                    href: e.ctaUrl,
                    target: "_blank",
                    rel: "noreferrer noopener",
                    className: "grid__image gtm-trigger--plp_content_block_click",
                    "data-gtm-click_content_block_label": e.ctaUrl,
                    onClick: () => window.dispatchEvent(new Event("contentBlock.clicked")),
                  },
                  o.default.createElement(xi, {
                    featureImage: a,
                    hoverImage: void 0,
                    vendor: rr(this.props.product.vendor, () => this.props.product.title),
                  }),
                ),
            (i || r) &&
              o.default.createElement(
                "div",
                {
                  id: "content_block_".concat(e.blockNumber),
                  style: { backgroundColor: e.backgroundColour },
                  className: "live_text_wrapper",
                },
                i &&
                  o.default.createElement("div", {
                    className: "live_text",
                    dangerouslySetInnerHTML: { __html: e.liveText },
                  }),
                r &&
                  o.default.createElement("a", {
                    className: "_standard_button cta_text",
                    href: e.ctaUrl,
                    target: "_blank",
                    dangerouslySetInnerHTML: { __html: e.ctaText },
                  }),
                o.default.createElement(
                  "style",
                  null,
                  "\n                  #content_block_"
                    .concat(e.blockNumber, " * {\n                     color: ")
                    .concat(e.textColour, " !important;\n                  }                  \n                "),
                ),
              ),
          ),
        ),
      );
    }
    render() {
      var e = [
        "grid__item",
        "product-grid-item",
        "type_grid_item_regular",
        "large--one-quarter",
        "medium--one-quarter",
        "small--one-half",
        "col-item-".concat(this.props.product.handle),
      ];
      ("free-baby-blanket-1" === this.props.product.handle && e.push("hidden_item"),
        this.state.isScMember && e.push("sleepclub_logged_in"));
      var t = (e) => {
          if (!this.props.product.media) return "";
          var t = rr(
              sr([
                e,
                "access",
                (e) => e.replace,
                "call",
                (e) => e("_480x480", ""),
                "access",
                (e) => e.split,
                "call",
                (e) => e("?"),
                "optionalAccess",
                (e) => e[0],
              ]),
              () => "not__--__found",
            ),
            a = this.props.product.media.find((e) => e.src.includes(t));
          return a ? a.alt : "";
        },
        a = (e) => {
          var t =
            sr([
              this,
              "access",
              (e) => e.props,
              "access",
              (e) => e.product,
              "optionalAccess",
              (e) => e.media,
              "optionalAccess",
              (e) => e.filter,
              "call",
              (t) => t((t) => t.src === e.replace("_480x480", "")),
            ]) || [];
          if (!t.length) return "";
          var a = t.map((e) =>
            sr([
              e,
              "access",
              (e) => e.alt,
              "optionalAccess",
              (e) => e.match,
              "call",
              (e) => e(_wrapRegExp(/:(.*):/, { alt_text: 1 })),
            ]),
          );
          return (
            sr([a, "access", (e) => e[0], "optionalAccess", (e) => e.groups, "optionalAccess", (e) => e.alt_text]) || ""
          );
        },
        i = this.getDefaultFeaturedImage(),
        r = t(i),
        s = this.state.quickShopIsOpen ? this.getHoverImage() : this.defaultHoverImage(),
        n = t(s),
        l = a(i),
        c = this.props,
        d = c.promoMessage,
        p = c.roundelText,
        u = c.product,
        m = a(s);
      "content_block" === this.props.product.handle && (m = "content_block");
      var h = "";
      sr([
        this,
        "access",
        (e) => e.props,
        "access",
        (e) => e.idsOfProductsWhichPricesAreLoading,
        "optionalAccess",
        (e) => e.includes,
        "call",
        (e) => e(this.props.product.id),
      ]) && (h = "waitingForCorrectPrices");
      var f = "content_block" !== this.props.product.handle && i !== s,
        g = window.mori.state.isB2B;
      return "tf_image" === this.props.product.handle || "content_block" === this.props.product.handle
        ? this.renderContentBlock(this.props.product, e, i)
        : o.default.createElement(
            "div",
            { className: e.join(" "), "data-testid": "product-grid-item", "product-handle": this.props.product.handle },
            o.default.createElement(
              "div",
              { className: "product-image-wrap" },
              o.default.createElement(
                "a",
                {
                  className: "grid__image",
                  href: this.getFeaturedVariantUrl(),
                  onClick: () => this.productClickThrough(),
                },
                o.default.createElement(la, { altTag: r, hoverAltTag: n, dealRoundel: this.props.dealRoundel }),
                o.default.createElement(xi, {
                  featureImage: i,
                  hoverImage: s,
                  hoverEnabled: f,
                  altText: [l, m],
                  vendor: rr(this.props.product.vendor, () => this.props.product.title),
                }),
              ),
              !g &&
                o.default.createElement(Ri, {
                  product: this.props.product,
                  settings: this.props.settings,
                  isScMember: this.props.isScMember,
                  isScProduct: this.state.isScProduct,
                  selectedVarient: this.state.selectedVariant,
                  isUSsaveTagRunning: this.props.isUSsaveTagRunning,
                }),
              !g &&
                !this.props.product.tags.includes("print-of-the-month") &&
                o.default.createElement(ca, { shouldShow: !0, fieldText: p }),
            ),
            o.default.createElement(
              "div",
              { className: "brand-and-star-section" },
              o.default.createElement(Ki, { product: this.props.product }),
              this.state.reviewScore
                ? o.default.createElement(
                    "div",
                    { className: "star-ratings-wrapper" },
                    o.default.createElement(
                      "svg",
                      {
                        className: "star-rating",
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                      o.default.createElement("path", {
                        d: "M6.09203 0L7.45977 4.20949H11.8859L8.30508 6.81109L9.67283 11.0206L6.09203 8.41897L2.51122 11.0206L3.87897 6.81109L0.298165 4.20949H4.72428L6.09203 0Z",
                        fill: "#f3af53",
                      }),
                    ),
                    o.default.createElement("p", { className: "ratings-text" }, this.state.reviewScore),
                  )
                : o.default.createElement("div", null),
            ),
            o.default.createElement(
              "p",
              { className: "h6" },
              o.default.createElement(
                "a",
                {
                  href: this.getProductUrl(),
                  onClick: () => P.logEvent("plp_pdp_clickthrough", { click_label: window.location.pathname }),
                },
                this.state.isSplit ? "".concat(this.formatSplitVariantNaming()) : this.props.product.title,
              ),
            ),
            o.default.createElement(
              "p",
              { className: "price ".concat(h) },
              o.default.createElement(Li, {
                openQuickshotProductHash: this.props.openQuickshotProductHash,
                selectedVariant: this.state.selectedVariant,
                product: this.props.product,
                showSleepClubPrice: !this.state.isScProduct && this.state.isScMember,
                quickShopIsOpen: this.state.quickShopIsOpen,
                appliedSort: this.props.appliedSort,
                isGrapheneEnabled: this.props.isGrapheneEnabled,
              }),
            ),
            !this.props.isScMember && this.state.isLoadingAutoDiscount
              ? o.default.createElement(
                  "div",
                  { className: "shimmer faux-image automatic-discount-title" },
                  o.default.createElement("span", { className: "skeleton-loader" }),
                )
              : o.default.createElement(
                  o.default.Fragment,
                  null,
                  !this.props.isScMember &&
                    this.state.automaticDiscountTitle &&
                    !u.auto_discount_message &&
                    o.default.createElement(
                      "p",
                      { className: "automatic-discount-title" },
                      this.state.automaticDiscountTitle,
                      " - Auto Applied",
                    ),
                  !this.props.isScMember && u.auto_discount_message
                    ? o.default.createElement(
                        "p",
                        { className: "automatic-discount-title" },
                        u.auto_discount_message,
                        " - Auto Applied",
                      )
                    : null,
                ),
            o.default.createElement(Ji, {
              message: ((e) =>
                e &&
                e.toLowerCase().includes("buy") &&
                e.toLowerCase().includes("get") &&
                this.state.automaticDiscountTitle &&
                "_" !== this.state.automaticDiscountTitle
                  ? null
                  : e)(d),
            }),
            o.default.createElement(Oi, { product: this.props.product }),
            !this.state.comingSoonTagAndOos &&
              o.default.createElement(Qi, {
                product: this.props.product,
                selectedVariant: this.state.selectedVariant
                  ? this.state.selectedVariant
                  : this.props.product.variants.find((e) => e.available),
                isSplit: this.state.isSplit,
                selectedColour: this.state.selectedColour,
                selectedSize: this.state.selectedSize,
                selectedAlternateOption: this.state.selectedAlternateOption,
                onColourSelected: this.onColourSelected,
                onSizeSelected: this.onSizeSelected,
                onAlternateOptionSelected: this.onAlternateOptionSelected,
                openQuickshotProductHash: this.props.openQuickshotProductHash,
                onQuickShopOpened: this.props.onQuickShopOpened,
                quickShopIsOpen: this.quickShopIsOpen,
                switchOffQuickshop: this.props.switchOffQuickshop,
                isGrapheneEnabled: this.props.isGrapheneEnabled,
                gtmEvent: this.props.settings.gtmEvent,
                styleOverride: this.props.styleOverride,
                noOfDesktopSwatches: rr(this.props.noOfDesktopSwatches, () => 9),
                enableNostoAddToBag: this.props.enableNostoAddToBag,
                noOfMobileSwatches: 5,
                showQuickShopIcon: !0,
              }),
          );
    }
  }
  or.displayName = "ProductGridItem";
  var lr = fi(or);
  class cr {
    static getProduct(e) {
      return new Promise((t, a) => {
        var i = new XMLHttpRequest();
        (i.open("GET", "/collections/all/products/" + e + ".js", !0),
          i.setRequestHeader("Content-Type", "application/json"),
          (i.onload = function () {
            t(JSON.parse(i.response));
          }),
          (i.onerror = (e) => a(e)),
          i.send());
      });
    }
  }
  class dr {
    static getHandleById(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "EU";
      return new Promise((a, i) => {
        var r = "https://babymori.myshopify.com/api/2024-04/graphql.json",
          s = "04b86ac123c79f9e1b4848ab6f653b63";
        ("EU" === t &&
          ((r = "https://mori-de.myshopify.com/api/2024-04/graphql.json"), (s = "c571e38577cc776a7892924efb91f83b")),
          "US" === t &&
            ((r = "https://babymoriusa.myshopify.com/api/2024-04/graphql.json"),
            (s = "f534d54bc606eb6099901500cea29d53")));
        var n = new Headers();
        (n.append("X-Shopify-Storefront-Access-Token", s), n.append("Content-Type", "application/json"));
        var o = 'query ProductHandle {\n                product(id: "gid://shopify/Product/'.concat(
          e,
          '") {\n                  handle\n                }\n              }',
        );
        o = o.replace(/\n/g, "").replace(/\s{2}/g, "");
        var l,
          c = { method: "POST", headers: n, body: JSON.stringify({ query: o, variables: {} }), redirect: "follow" };
        fetch(r, c)
          .then((e) => e.text())
          .then((e) => {
            ((l = e), (e = JSON.parse(e)), a({ handle: e.data.product.handle }));
          })
          .catch((e) => {
            (console.log(e),
              window.Bugsnag.notify(new Error("Fetching from storefrontAPI failed:\n".concat(e)), function (t) {
                ((t.severity = "error"),
                  t.addMetadata("details", { requestOptions: c, result_: l, occurredIn: "helper function", error: e }));
              }),
              i(e));
          });
      });
    }
    static getCurrencyAndStock(e, t, a, i) {
      return new Promise((r, s) => {
        var n = { GBP: "GB", AUD: "AU", CAD: "CA", CHF: "CH", JPY: "JP", USD: "US", EUR: "MC", AED: "AE", HKD: "HK" }[
            a
          ],
          o = JSON.parse(JSON.stringify(e)).map((e) => "id:".concat(e.id, " OR"));
        (o.length > 20 && (o = o.slice(0, t.length - 20)),
          (o[o.length - 1] = o[o.length - 1].replace("OR", "")),
          (o = o.join(" ")));
        var l = "https://babymori.myshopify.com/api/2024-04/graphql.json",
          c = "04b86ac123c79f9e1b4848ab6f653b63";
        ("EU" === i &&
          ((l = "https://mori-de.myshopify.com/api/2024-04/graphql.json"), (c = "c571e38577cc776a7892924efb91f83b")),
          "US" === i &&
            ((l = "https://babymoriusa.myshopify.com/api/2024-04/graphql.json"),
            (c = "f534d54bc606eb6099901500cea29d53")));
        var d = new Headers();
        (d.append("X-Shopify-Storefront-Access-Token", c), d.append("Content-Type", "application/json"));
        var p = "query allProducts @inContext(country: "
          .concat(n, ') {\n                products(query: "')
          .concat(
            o,
            '", first: 20) {\n                    nodes {\n                        id \n                        availableForSale \n                        dailyDealsRoundel: metafield(namespace: "daily_deals", key: "roundel") {\n                          value\n                        } \n                        variants(first: 100) {\n                            nodes {\n                                id \n                                quantityAvailable \n                                availableForSale \n                                priceV2 {\n                                    amount \n                                    currencyCode\n                                } \n                                compareAtPriceV2 {\n                                    amount \n                                    currencyCode\n                                }\n                            }\n                        }\n                    }\n                }\n              }',
          );
        p = p.replace(/\n/g, "").replace(/\s{2}/g, "");
        var u,
          m = { method: "POST", headers: d, body: JSON.stringify({ query: p, variables: {} }), redirect: "follow" };
        fetch(l, m)
          .then((e) => e.text())
          .then((a) => {
            var i = {},
              s = [];
            ((u = a),
              (a = JSON.parse(a)),
              window.mori.state.isLive || console.log("Storefront API Response: ", a),
              a.data.products.nodes.map((e) => {
                var t = e.id.replace("gid://shopify/Product/", "");
                ((i[t] = { variants: {} }),
                  e.dailyDealsRoundel &&
                    s.push({
                      product_id: e.id.replace("gid://shopify/Product/", ""),
                      roundel_url: e.dailyDealsRoundel.value,
                    }),
                  e.variants.nodes.length &&
                    e.variants.nodes.map((e) => {
                      var a = e.id.replace("gid://shopify/ProductVariant/", "");
                      ((e[a] = {
                        compareAtPrice: e.compareAtPriceV2
                          ? Math.round(100 * parseFloat(e.compareAtPriceV2.amount))
                          : 0,
                        price: Math.round(100 * parseFloat(e.priceV2.amount)),
                        stock: e.quantityAvailable,
                        available: e.availableForSale,
                      }),
                        (i[t].variants[a] = _objectSpread(_objectSpread({}, i[t].variants[a]), e[a])));
                    }),
                  (i[t].available = e.availableForSale));
              }));
            var n = this.getCorrectPriceInCorrectCurrency(e, i),
              o = n;
            (t.length > 20 && (o = [...t.slice(0, t.length - e.length), ...n]),
              r({ products: o, sortedContent: i, dealRoundels: s }));
          })
          .catch((e) => {
            (console.log(e),
              window.Bugsnag.notify(new Error("Fetching from storefrontAPI failed:\n".concat(e)), function (t) {
                ((t.severity = "error"),
                  t.addMetadata("details", { requestOptions: m, result_: u, occurredIn: "helper function", error: e }));
              }),
              s(e));
          });
      });
    }
    static getCorrectPriceInCorrectCurrency(e, t) {
      return e.map((e) => {
        if (!e.handle.includes("content_block") && t[e.id]) {
          var a = Object.values(t[e.id].variants),
            i = a.filter((e) => e.stock),
            r = a[0];
          if (i.length) {
            var s = 9999999;
            i.map((e) => {
              e.price < s && ((s = e.price), (r = e));
            });
          }
          ((e.available = t[e.id].available),
            (e.price = r.price),
            (e.compare_at_price = r.compareAtPrice),
            (e.variants = e.variants.map(
              (a) => (
                (a.compare_at_price = t[e.id].variants["".concat(a.id)].compareAtPrice),
                (a.price = t[e.id].variants["".concat(a.id)].price),
                (a.stock = t[e.id].variants["".concat(a.id)].stock),
                (a.available = t[e.id].variants["".concat(a.id)].stock > 0),
                a
              ),
            )));
        }
        return e;
      });
    }
  }
  function pr(e) {
    var t,
      a,
      i = ((a = () => ""), null != (t = e) ? t : a());
    try {
      i = decodeURIComponent(i);
    } catch (e) {}
    return i.trim().toUpperCase();
  }
  function ur(e, t) {
    return !("string" != typeof t || !t) && pr(e) === pr(t);
  }
  var mr = (e) => {
      var t = e.width,
        a = void 0 === t ? "100%" : t,
        i = e.height,
        r = void 0 === i ? "1rem" : i,
        s = e.className,
        n = void 0 === s ? "" : s,
        l = e.style;
      return o.default.createElement("span", {
        className: "nosto-skeleton ".concat(n),
        style: _objectSpread({ width: a, height: r, display: "inline-block" }, l),
      });
    },
    hr = (e) => {
      var t = e.isMobile,
        a = [
          "grid__item",
          "nosto-product-grid-item-skeleton",
          t ? "small--one-half" : "large--one-quarter",
          t ? "medium--one-half" : "medium--one-quarter",
        ].join(" ");
      return o.default.createElement(
        "div",
        { className: a, "data-testid": "product-grid-item" },
        o.default.createElement(
          "div",
          { className: "nosto-skeleton-product-image-wrap nosto-skeleton-image" },
          o.default.createElement(mr, { height: "100%", width: "100%" }),
        ),
        o.default.createElement(
          "div",
          { className: "nosto-skeleton-brand-star-section", style: { marginBottom: "8px" } },
          o.default.createElement(mr, { width: "50%", height: "15px" }),
          o.default.createElement(mr, { width: "30%", height: "15px" }),
        ),
        o.default.createElement(
          "p",
          { className: "h6" },
          o.default.createElement(mr, { width: "80%", height: "15px" }),
        ),
        o.default.createElement(
          "p",
          { className: "price" },
          o.default.createElement(mr, { width: "40%", height: "15px" }),
        ),
        o.default.createElement("div", { className: "nosto-skeleton-product-switch-wrapper" }),
        o.default.createElement(
          "div",
          { className: "nosto-skeleton-quick-shop-wrapper" },
          o.default.createElement(mr, { height: "35px" }),
        ),
      );
    };
  function fr(e) {
    for (var t = void 0, a = e[0], i = 1; i < e.length; ) {
      var r = e[i],
        s = e[i + 1];
      if (((i += 2), ("optionalAccess" === r || "optionalCall" === r) && null == a)) return;
      "access" === r || "optionalAccess" === r
        ? ((t = a), (a = s(a)))
        : ("call" !== r && "optionalCall" !== r) ||
          ((a = s(function () {
            for (var e = arguments.length, i = new Array(e), r = 0; r < e; r++) i[r] = arguments[r];
            return a.call(t, ...i);
          })),
          (t = void 0));
    }
    return a;
  }
  hr.displayName = "ProductGridItemSkeleton";
  var gr = (t) => {
    var a = t.id,
      i = t.handle,
      r = t.container,
      s = t.contentBlock,
      n = _slicedToArray(e.useState(a), 2),
      l = n[0],
      c = n[1],
      d = _slicedToArray(e.useState(null), 2),
      p = d[0],
      m = d[1],
      h = Bi(768),
      f = JSON.parse(document.querySelector("#ProductRecommendationsRoot").innerHTML);
    return (
      s ||
        (r.addEventListener("searchQuickshotOpened", (e) => {
          var t = e.detail.productId;
          t && (t !== a ? void 0 === l && c(t) : void 0 !== l && c(void 0));
        }),
        e.useEffect(() => {
          if (i)
            !(function (e, t, a) {
              try {
                var i = a.querySelector("#product-details-".concat(t)),
                  r = JSON.parse(i.innerHTML),
                  s = r.product,
                  n = document.getElementById("CollectionUrlDiscount"),
                  o = n && n.innerHTML ? JSON.parse(n.innerHTML) : null,
                  l = (() => {
                    if (!o) return !1;
                    try {
                      return ur(new URLSearchParams(window.location.search).get("discount"), o.message);
                    } catch (e) {
                      return !1;
                    }
                  })();
                if (o && l) {
                  var c =
                      (!!s.compare_at_price && s.compare_at_price > s.price) ||
                      (s.variants &&
                        s.variants.some(
                          (e) => !!fr([e, "optionalAccess", (e) => e.compare_at_price]) && e.compare_at_price > e.price,
                        )),
                    d = _objectSpread({}, s),
                    p = (e) => {
                      var t = 0;
                      return (
                        o.fixed_value ? (t = 100 * o.fixed_value) : o.percentage && (t = (e * o.percentage) / 100),
                        t > 0 ? e - t : e
                      );
                    };
                  (o.message && (d.auto_discount_message = o.message),
                    c || (d.compare_at_price = s.price),
                    (d.price = p(s.price)),
                    d.variants &&
                      d.variants.length &&
                      (d.variants = d.variants.map((e) =>
                        _objectSpread(
                          _objectSpread({}, e),
                          {},
                          c
                            ? { compare_at_price: e.compare_at_price, price: p(e.price) }
                            : { compare_at_price: e.price, price: p(e.price) },
                        ),
                      )),
                    (s = d));
                }
                var u = r.variant_products,
                  h = r.linked_products,
                  f = [];
                for (var g of (u && (f = u), h && (f = h), (s.extraProducts = []), f)) {
                  s.is_merged_variant = !0;
                  var v = 0;
                  for (var _ of g.options) {
                    if (_.toLowerCase().includes("color") || _.toLowerCase().includes("colour")) break;
                    v++;
                  }
                  var y = [];
                  switch (v) {
                    case 0:
                    default:
                      y = g.variants.map((e) => e.option1.toLowerCase());
                      break;
                    case 1:
                      y = g.variants.map((e) => e.option2.toLowerCase());
                  }
                  var b = Array.from(new Set(y));
                  if (b.length > 1) {
                    var w = JSON.parse(JSON.stringify(g.variants)),
                      S = 0,
                      E = function (e) {
                        var t = JSON.parse(JSON.stringify(g));
                        ((t.variants = [...w.filter((t) => t.option1.toLowerCase() === e)]),
                          (t.newKey = "".concat(t.id, "_").concat(S)),
                          (t.isStockAvailable = t.variants.some((e) => e.available)),
                          (t.available = t.isStockAvailable),
                          s.extraProducts.push(t),
                          S++);
                      };
                    for (var C of b) E(C);
                  } else s.extraProducts.push(g);
                }
                m(s);
              } catch (e) {
                (m(null), console.error(e));
              }
            })(0, i, r);
          else {
            var e = "UK",
              t = window.location.href.toLowerCase();
            (t.includes("eu.babymori") ? (e = "EU") : t.includes("us.babymori") && (e = "US"),
              dr.getHandleById(a, e).then((e) => {
                cr.getProduct(e.handle).then((e) => {
                  e.options = e.options.map((e) => e.name);
                  var t = document.getElementById("CollectionUrlDiscount"),
                    i = t && t.innerHTML ? JSON.parse(t.innerHTML) : null,
                    r = (() => {
                      if (!i) return !1;
                      try {
                        return ur(new URLSearchParams(window.location.search).get("discount"), i.message);
                      } catch (e) {
                        return !1;
                      }
                    })();
                  if (i && r) {
                    var s =
                        (!!e.compare_at_price && e.compare_at_price > e.price) ||
                        (e.variants &&
                          e.variants.some(
                            (e) =>
                              !!fr([e, "optionalAccess", (e) => e.compare_at_price]) && e.compare_at_price > e.price,
                          )),
                      n = _objectSpread({}, e),
                      o = (e) => {
                        var t = 0;
                        return (
                          i.fixed_value ? (t = 100 * i.fixed_value) : i.percentage && (t = (e * i.percentage) / 100),
                          t > 0 ? e - t : e
                        );
                      };
                    (i.message && (n.auto_discount_message = i.message),
                      s || (n.compare_at_price = e.price),
                      (n.price = o(e.price)),
                      n.variants &&
                        n.variants.length &&
                        (n.variants = n.variants.map((e) =>
                          _objectSpread(
                            _objectSpread({}, e),
                            {},
                            s
                              ? { compare_at_price: e.compare_at_price, price: o(e.price) }
                              : { compare_at_price: e.price, price: o(e.price) },
                          ),
                        )),
                      (e = n));
                  }
                  mi("variant_products", "custom", +a, new AbortController(), !0).then((t) => {
                    mi("linked_products", "custom", +a, new AbortController(), !0).then(
                      (function () {
                        var a = _asyncToGenerator(function* (a) {
                          var i = [];
                          (t && (i = t.references.nodes), a && (i = a.references.nodes));
                          var r = [];
                          for (var s of i) r.push(yield cr.getProduct(s.handle));
                          for (var n of ((e.extraProducts = []), r)) {
                            e.is_merged_variant = !0;
                            var o = 0;
                            for (var l of ((n.options = n.options.map((e) => e.name)), n.options)) {
                              if (l.toLowerCase().includes("color") || l.toLowerCase().includes("colour")) break;
                              o++;
                            }
                            var c = [];
                            switch (o) {
                              case 0:
                              default:
                                c = n.variants.map((e) => e.option1.toLowerCase());
                                break;
                              case 1:
                                c = n.variants.map((e) => e.option2.toLowerCase());
                            }
                            var d = Array.from(new Set(c));
                            if (d.length > 1) {
                              var p = JSON.parse(JSON.stringify(n.variants)),
                                u = 0,
                                h = function (t) {
                                  var a = JSON.parse(JSON.stringify(n));
                                  ((a.variants = [...p.filter((e) => e.option1.toLowerCase() === t)]),
                                    (a.newKey = "".concat(a.id, "_").concat(u)),
                                    (a.isStockAvailable = a.variants.some((e) => e.available)),
                                    (a.available = a.isStockAvailable),
                                    e.extraProducts.push(a),
                                    u++);
                                };
                              for (var f of d) h(f);
                            } else e.extraProducts.push(n);
                          }
                          m(e);
                        });
                        return function (e) {
                          return a.apply(this, arguments);
                        };
                      })(),
                    );
                  });
                });
              }));
          }
        }, [])),
      s
        ? o.default.createElement(
            "div",
            { className: "product-card-wrapper-".concat(a) },
            o.default.createElement(lr, {
              key: a,
              product: {
                handle: "content_block",
                images: [s.src],
                hash: u.default("".concat(s.src) + s.indexToAddTo + 1),
                variants: [{}],
                index_position_: s.indexToAddTo + 1,
                tags: [],
                liveText: s.liveText,
                ctaText: s.ctaText,
                ctaUrl: s.ctaUrl,
                textColour: s.textColour,
                backgroundColour: s.backgroundColour,
                blockNumber: s.indexToAddTo + 1,
              },
              settings: f.settings,
              isScMember: !1,
              appliedFilters: "",
              sizeFilter: "",
              appliedSort: "",
              collectionUrl: "",
              idsOfProductsWhichPricesAreLoading: [],
              enableNostoAddToBag: !0,
            }),
          )
        : p
          ? p.extraProducts
            ? o.default.createElement(ir, {
                key: a,
                product: p,
                settings: f.settings,
                isScMember: !1,
                appliedFilters: "",
                sizeFilter: "",
                appliedSort: "",
                collectionUrl: "",
                idsOfProductsWhichPricesAreLoading: [],
                enableNostoAddToBag: !0,
                onQuickShopOpened: () => {
                  var e = new CustomEvent("searchQuickshotOpened", { detail: { productId: a }, bubbles: !0 });
                  r.dispatchEvent(e);
                },
                openQuickshotProductHash: l,
              })
            : o.default.createElement(
                "div",
                { className: "product-card-wrapper-".concat(a) },
                o.default.createElement(lr, {
                  key: a,
                  product: p,
                  settings: f.settings,
                  isScMember: !1,
                  appliedFilters: "",
                  sizeFilter: "",
                  appliedSort: "",
                  collectionUrl: "",
                  idsOfProductsWhichPricesAreLoading: [],
                  enableNostoAddToBag: !0,
                  onQuickShopOpened: () => {
                    var e = new CustomEvent("searchQuickshotOpened", { detail: { productId: a }, bubbles: !0 });
                    r.dispatchEvent(e);
                  },
                  openQuickshotProductHash: l,
                }),
              )
          : o.default.createElement(hr, { isMobile: h })
    );
  };
  gr.displayName = "SearchProductCard";
  var vr = (e) => {
    var t = e.handle,
      a = e.container;
    console.log("Rendering ProductCard for handle:", t);
    var i = a.querySelector("#product-details-".concat(t)),
      r = JSON.parse(i.innerHTML),
      s = JSON.parse(document.querySelector("#ProductRecommendationsRoot").innerHTML),
      n = _slicedToArray(o.default.useState(r.product.id), 2),
      l = n[0],
      c = n[1];
    return (
      a.addEventListener("pdpRecsQuickshotOpened", (e) => {
        var t = e.detail.productId;
        t && (t !== r.product.id ? void 0 === l && c(t) : void 0 !== l && c(void 0));
      }),
      o.default.createElement(
        "div",
        { className: "product-card-wrapper-".concat(t) },
        o.default.createElement(lr, {
          key: r.product.id,
          product: r.product,
          settings: s.settings,
          isScMember: !1,
          appliedFilters: "",
          sizeFilter: "",
          appliedSort: "",
          collectionUrl: "",
          idsOfProductsWhichPricesAreLoading: [],
          onQuickShopOpened: () => {
            var e = new CustomEvent("pdpRecsQuickshotOpened", { detail: { productId: r.product.id }, bubbles: !0 });
            a.dispatchEvent(e);
          },
          openQuickshotProductHash: l,
          styleOverride: "recommendations",
          noOfDesktopSwatches: 5,
        }),
      )
    );
  };
  function _r(e) {
    for (var t = void 0, a = e[0], i = 1; i < e.length; ) {
      var r = e[i],
        s = e[i + 1];
      if (((i += 2), ("optionalAccess" === r || "optionalCall" === r) && null == a)) return;
      "access" === r || "optionalAccess" === r
        ? ((t = a), (a = s(a)))
        : ("call" !== r && "optionalCall" !== r) ||
          ((a = s(function () {
            for (var e = arguments.length, i = new Array(e), r = 0; r < e; r++) i[r] = arguments[r];
            return a.call(t, ...i);
          })),
          (t = void 0));
    }
    return a;
  }
  vr.displayName = "ProductCard";
  class yr {
    static getPageSize() {
      var e = new URLSearchParams(window.location.search).get("pageSize");
      return e ? parseInt(e) : 24;
    }
    static getCurrentPage() {
      var e = new URLSearchParams(window.location.search).get("page");
      return e ? parseInt(e) : 1;
    }
    static registerRecsObserver() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ".nosto_element";
      console.log("Registering Nosto Component Service");
      var t = document.body.querySelectorAll(e);
      console.log("Found Nosto Elements:", t);
      var a = function (e) {
        e &&
          new MutationObserver(function (t) {
            t.forEach(function (t) {
              if (t.addedNodes) {
                var a = t.target.querySelector(".react-mounting-point");
                a &&
                  c.default.render(
                    o.default.createElement(vr, { handle: t.target.attributes.handle.value.toString(), container: e }),
                    a,
                    () => {
                      console.log("Nosto ProductCard rendered");
                    },
                  );
              }
            });
          }).observe(e, { childList: !0, subtree: !0 });
      };
      for (var i of t) a(i);
    }
    static registerRecsObserverSearchPage() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ".search-item",
        t = [],
        a = [],
        i = [],
        r = _r([
          document,
          "access",
          (e) => e.getElementById,
          "call",
          (e) => e("collectionRoot"),
          "optionalAccess",
          (e) => e.innerHTML,
        ]),
        s = [];
      (r && ((r = JSON.parse(r)), (s = JSON.parse(r.settings.content_block_info))),
        console.log("Registering Nosto Search Component Service"));
      var n = document.body.querySelectorAll(e);
      console.log("Found Nosto Elements:", n);
      var l = function (e) {
        e &&
          new MutationObserver(function (r) {
            r.forEach(function (r) {
              if (r.addedNodes) {
                var n = r.target.querySelectorAll("nosto-dynamic-card");
                if (n.length > 0)
                  for (var l of n) {
                    var d = l.id;
                    if (!t.includes(d)) {
                      var p = new MutationObserver(function (t) {
                        t.forEach(function (t) {
                          if (t.addedNodes) {
                            var r = t.target.querySelector(".react-mounting-point");
                            if (r && !a.includes(t.target.id.toString())) {
                              var n = yr.getPageSize(),
                                l = yr.getCurrentPage() - 1,
                                d = +r.parentNode.attributes.index.value + n * l,
                                p = _r([
                                  s,
                                  "optionalAccess",
                                  (e) => e.find,
                                  "call",
                                  (e) => e((e) => e.indexToAddTo == d),
                                ]);
                              if (
                                (c.default.render(
                                  o.default.createElement(gr, {
                                    id: t.target.id.toString(),
                                    handle:
                                      t.target.handle.toString() === t.target.id.toString()
                                        ? null
                                        : t.target.handle.toString(),
                                    container: e,
                                  }),
                                  r,
                                  () => {},
                                ),
                                p && !i.includes(d))
                              ) {
                                i.push(d);
                                var u = document.createElement("div");
                                ((u.id = "content-block-section-".concat(d)),
                                  r.parentNode.parentNode.before(u),
                                  c.default.render(
                                    o.default.createElement(gr, {
                                      id: "content-block-item-".concat(d),
                                      contentBlock: p,
                                      container: e,
                                    }),
                                    u,
                                    () => {},
                                  ));
                              }
                            }
                          }
                        });
                      });
                      p.observe(l, { childList: !0, subtree: !0 });
                    }
                  }
              }
            });
          }).observe(e, { childList: !0, subtree: !0 });
      };
      for (var d of n) l(d);
    }
  }
  var br = "size",
    wr = () =>
      (function (e) {
        for (var t = void 0, a = e[0], i = 1; i < e.length; ) {
          var r = e[i],
            s = e[i + 1];
          if (((i += 2), ("optionalAccess" === r || "optionalCall" === r) && null == a)) return;
          "access" === r || "optionalAccess" === r
            ? ((t = a), (a = s(a)))
            : ("call" !== r && "optionalCall" !== r) ||
              ((a = s(function () {
                for (var e = arguments.length, i = new Array(e), r = 0; r < e; r++) i[r] = arguments[r];
                return a.call(t, ...i);
              })),
              (t = void 0));
        }
        return a;
      })([
        [...document.querySelectorAll('variant-radios fieldset.not_color_swatch input[type="radio"]:checked')],
        "access",
        (e) => e.find,
        "call",
        (e) => e((e) => br === e.name.toLowerCase()),
        "optionalAccess",
        (e) => e.value,
      ]) || null,
    Sr = () => {
      var t = _slicedToArray(e.useState(!1), 2),
        a = t[0],
        i = t[1],
        r = e.useCallback(
          (function () {
            var e = _asyncToGenerator(function* (e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
              if (!a) {
                (i(!0), document.dispatchEvent(new CustomEvent("product:loading")));
                try {
                  var r = wr(),
                    s = "/products/".concat(e),
                    n = yield (function (e) {
                      var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                      return new Promise((a, i) => {
                        var r = sessionStorage.getItem("".concat(e));
                        r && !t
                          ? (Ti(r), window.history.replaceState({}, "", e), a({ isRendered: !0 }))
                          : fetch("".concat(e))
                              .then(function (e) {
                                return (
                                  window.location.pathname !== new URL(e.url).pathname &&
                                    window.history.replaceState({}, "", e.url),
                                  e.text()
                                );
                              })
                              .then(function (t) {
                                (Ti(t), sessionStorage.setItem(e, t), a({ isRendered: !0 }));
                              })
                              .catch(function (e) {
                                (console.error("Failed to fetch section: ", e),
                                  "QuotaExceededError" === e.name
                                    ? (a({ isRendered: !0 }), sessionStorage.clear())
                                    : i({ error: e, isRendered: !1 }));
                              });
                      });
                    })(s, !t);
                  if (n.isRendered) {
                    ((e) => {
                      if (e) {
                        var t = document.querySelector("variant-radios");
                        if (t) {
                          var a = [...t.querySelectorAll('fieldset.not_color_swatch input[type="radio"]')].find(
                            (t) => br === t.name.toLowerCase() && t.value === e,
                          );
                          a && !a.checked && ((a.checked = !0), a.dispatchEvent(new Event("change", { bubbles: !0 })));
                        }
                      }
                    })(r);
                    var o = { detail: { source: "useProductSwitch" } };
                    (document.dispatchEvent(new CustomEvent("reloadSection", o)),
                      document.dispatchEvent(new CustomEvent("product:switched", o)),
                      window.scrollTo({ top: 0, behavior: "smooth" }));
                  }
                } catch (e) {
                  console.error("Failed to switch product:", e);
                } finally {
                  (i(!1),
                    document.dispatchEvent(new CustomEvent("product:loaded")),
                    window.mori.resetKlaviyoBIS(),
                    yr.registerRecsObserver());
                }
              }
            });
            return function (t) {
              return e.apply(this, arguments);
            };
          })(),
          [a],
        );
      return { isLoading: a, switchProduct: r };
    },
    Er = e.memo((e) => {
      var t = e.product,
        a = e.isActive,
        i = e.onClick;
      return o.default.createElement(
        "li",
        { className: "linked-products-swatches__item" },
        o.default.createElement(
          "a",
          {
            href: "/products/".concat(t.handle),
            onClick: (e) => i(e, t.handle),
            className: "linked-products-swatches__swatch ".concat(a ? "is-active" : ""),
            "aria-current": a ? "page" : void 0,
            title: "View ".concat(t.title),
          },
          o.default.createElement("img", {
            src: t.featured_image.url,
            alt: t.featured_image.alt || "View product: ".concat(t.title),
            width: "50",
            height: "50",
            loading: "lazy",
          }),
        ),
      );
    });
  function Cr(e) {
    for (var t = void 0, a = e[0], i = 1; i < e.length; ) {
      var r = e[i],
        s = e[i + 1];
      if (((i += 2), ("optionalAccess" === r || "optionalCall" === r) && null == a)) return;
      "access" === r || "optionalAccess" === r
        ? ((t = a), (a = s(a)))
        : ("call" !== r && "optionalCall" !== r) ||
          ((a = s(function () {
            for (var e = arguments.length, i = new Array(e), r = 0; r < e; r++) i[r] = arguments[r];
            return a.call(t, ...i);
          })),
          (t = void 0));
    }
    return a;
  }
  Er.displayName = "ProductSwatch";
  var Pr = e.memo((t) => {
    var a = t.products,
      i = t.isColourVariant,
      r = t.currentProductHandle,
      s = t.initialProductHandle,
      n = Sr(),
      l = n.isLoading,
      c = n.switchProduct;
    if (!a || a.length <= 1) return null;
    var d = (e) => "handle-".concat(e.handle.split("?")[0]);
    if (i) {
      var p = [];
      for (var u of a) {
        if (u.options.find((e) => e.name.toLowerCase().includes("colour") || e.name.toLowerCase().includes("color"))) {
          for (var m of u.options)
            if (m.name.toLowerCase().includes("colour") || m.name.toLowerCase().includes("color")) {
              var h = function (e) {
                var t = JSON.parse(JSON.stringify(u));
                t.options = t.options.filter(
                  (t) => (
                    (t.name.toLowerCase().includes("colour") || t.name.toLowerCase().includes("color")) &&
                      (t.values = [e]),
                    !0
                  ),
                );
                var a = t.variants.find(
                  (t) =>
                    t.option1.toLocaleLowerCase() === e.toLocaleLowerCase() ||
                    !(!t.option2 || t.option2.toLocaleLowerCase() !== e.toLocaleLowerCase()) ||
                    !(!t.option3 || t.option3.toLocaleLowerCase() !== e.toLocaleLowerCase()),
                );
                ((t.title = "".concat(t.title, " - ").concat(e)),
                  a &&
                    ((t.available = a.available),
                    (t.handle = "".concat(t.handle, "?variant=").concat(Cr([a, "optionalAccess", (e) => e.id])))),
                  p.push(t));
              };
              for (var f of m.values) h(f);
            }
        } else p.push(u);
      }
      a = p;
    }
    var g = e.useMemo(() => {
        var e = [...a],
          t = e.filter((e) => {
            var t = e.variants;
            if (!t) return !1;
            var a = t.length,
              i = Math.round(a / 2);
            return t.filter((e) => !e.available).length > i;
          }),
          i = t.map((e) => e.handle.split("?")[0]),
          r = e.filter((e) => !i.includes(e.handle.split("?")[0])),
          s = t.sort((e, t) =>
            e.handle.split("?")[0].toLocaleLowerCase() > t.handle.split("?")[0].toLocaleLowerCase() ? 1 : -1,
          );
        return [
          ...r.sort((e, t) =>
            e.handle.split("?")[0].toLocaleLowerCase() > t.handle.split("?")[0].toLocaleLowerCase() ? 1 : -1,
          ),
          ...s,
        ];
      }, [a]),
      v = (e, t) => {
        (e.preventDefault(), t === r || l || c(t));
      },
      _ = !1;
    return i
      ? o.default.createElement(
          "div",
          { className: "merge_variants_product_container" },
          g.map((e) => {
            var t = yt.read("current_variant_product_chosen", ""),
              a = "" !== t ? t === e.handle : e.handle.toLocaleLowerCase().includes(s.toLocaleLowerCase());
            (g.some((e) => window.location.href.toLocaleLowerCase().includes(e.handle.toLocaleLowerCase())) &&
              !t &&
              ((a = !1), (_ = !1)),
              window.location.href.toLocaleLowerCase().includes(e.handle.toLocaleLowerCase()) &&
                !t &&
                ((_ = !1), (a = !0)),
              _ && (a = !1),
              a && (_ = !0));
            var i = ((e) => {
              var t = e.options.find((e) => "colour" === e.name.toLowerCase() || "color" === e.name.toLowerCase());
              return t && t.values.length > 0
                ? t.values[0]
                    .toLowerCase()
                    .replaceAll(/\s*&\s*/g, "-")
                    .replaceAll(/\s+/g, "-")
                    .replaceAll(/-+/g, "-")
                : e.options.length > 0 && e.options[0].values.length > 0
                  ? e.options[0].values[0]
                      .toLowerCase()
                      .replaceAll(/\s*&\s*/g, "-")
                      .replaceAll(/\s+/g, "-")
                      .replaceAll(/-+/g, "-")
                  : "";
            })(e);
            return o.default.createElement(
              "div",
              {
                key: e.handle,
                className: "gtm_pdp_colour_swatch_element "
                  .concat(d(e), " swatch-element color ")
                  .concat(i, " ")
                  .concat(e.available ? "available" : ""),
                onClick: () => {
                  t === e.handle || l || (yt.write("current_variant_product_chosen", e.handle), c(e.handle));
                },
              },
              o.default.createElement("label", {
                className: "collection_swatch "
                  .concat(a ? "selected" : "", " ")
                  .concat(i, " ")
                  .concat(e.available ? "" : "outOfStockSizes"),
                style: { cursor: "pointer" },
              }),
            );
          }),
        )
      : o.default.createElement(
          "div",
          { className: "linked-products-swatches" },
          o.default.createElement(
            "div",
            { className: "linked-products-swatches__container ".concat(l ? "is-loading" : "") },
            o.default.createElement("div", { className: "linked-products-swatches__loader" }),
            o.default.createElement(
              "ul",
              { className: "linked-products-swatches__list", "aria-busy": l },
              g.map((e) =>
                o.default.createElement(Er, { key: e.handle, product: e, isActive: e.handle === r, onClick: v }),
              ),
            ),
          ),
        );
  });
  function Ar(e, t) {
    return null != e ? e : t();
  }
  function kr(e) {
    for (var t = void 0, a = e[0], i = 1; i < e.length; ) {
      var r = e[i],
        s = e[i + 1];
      if (((i += 2), ("optionalAccess" === r || "optionalCall" === r) && null == a)) return;
      "access" === r || "optionalAccess" === r
        ? ((t = a), (a = s(a)))
        : ("call" !== r && "optionalCall" !== r) ||
          ((a = s(function () {
            for (var e = arguments.length, i = new Array(e), r = 0; r < e; r++) i[r] = arguments[r];
            return a.call(t, ...i);
          })),
          (t = void 0));
    }
    return a;
  }
  Pr.displayName = "LinkedProductSwatches";
  var Nr = (e) => {
    var t = e.initialTitle,
      a = e.isVariant,
      i = e.isMergedProduct,
      r = e.options,
      s = e.initialVariant,
      n = _slicedToArray(o.default.useState(t), 2),
      l = n[0],
      c = n[1],
      d = o.default.useCallback(
        (e) => {
          if (e) {
            var s = r.find((e) => "color" === e.name.toLowerCase() || "colour" === e.name.toLowerCase());
            if (s) {
              var n = e["option".concat(s.position)],
                o = ((e, t, a, i) => {
                  var r = kr([t, "optionalAccess", (e) => e.trim, "call", (e) => e()]);
                  if (!r) return e;
                  var s,
                    n = e;
                  for (var o of r.split(/\s+/))
                    if (o) {
                      var l = /^\w+$/.test(o) ? "\\b" : "",
                        c = new RegExp(
                          ""
                            .concat(l)
                            .concat(((s = o), s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")))
                            .concat(l),
                          "gi",
                        );
                      n = n.replace(c, "").replace(/\s{2,}/g, " ");
                    }
                  return (n = n.replace(/\s*[-–—]\s*$/, "").trim())
                    ? a || i
                      ? "".concat(n, " - ").concat(r)
                      : "".concat(n)
                    : r;
                })(
                  t,
                  n,
                  Ar(a, () => !1),
                  Ar(i, () => !1),
                );
              c(o);
            } else c(t);
          } else c(t);
        },
        [t, r],
      );
    return (
      o.default.useEffect(() => {
        d(s);
      }, [s, d]),
      o.default.useEffect(() => {
        var e = (e) => {
          var t = Ar(kr([e, "optionalAccess", (e) => e.detail, "optionalAccess", (e) => e.variant]), () => null);
          d(t);
        };
        return (
          document.addEventListener("variantChanged", e),
          () => {
            document.removeEventListener("variantChanged", e);
          }
        );
      }, [d]),
      o.default.createElement("h1", null, l)
    );
  };
  function Tr() {
    var e = document.getElementById("ProductRoot")
        ? JSON.parse(document.getElementById("ProductRoot").innerHTML)
        : null,
      t = document.getElementById("RoundelRoot") ? JSON.parse(document.getElementById("RoundelRoot").innerHTML) : null,
      a = document.querySelectorAll(".SizeGuidesRoot"),
      i = [];
    document.querySelectorAll(".SizeGuidesRoot") && a.forEach((e) => i.push(JSON.parse(e.innerHTML)));
    var r = document.querySelector(".free_uk_return");
    console.log("SizeGuidesRoot", i);
    var s = "react-product";
    if (e) {
      if (e.product.id) {
        var n = new AbortController();
        mi("auto_discount_title", "custom", e.product.id, n).then((e) => {
          n.signal.aborted ||
            ("" !== e.trim() &&
              "_" !== e.trim() &&
              document.getElementById("automaticDiscountTitle") &&
              c.default.render(
                o.default.createElement(
                  o.default.Fragment,
                  null,
                  o.default.createElement("span", { className: "automatic-discount-title" }, e, " - Auto Applied"),
                ),
                document.getElementById("automaticDiscountTitle"),
                () => {
                  f(s, "Rendered Automatic Discount Title Component");
                },
              ));
        });
      }
      if (document.getElementById("ProductTitleNode")) {
        var l = document.getElementById("product-title-data"),
          d = !!document.getElementById("linked-products-data");
        if (l && d) {
          var p = JSON.parse(l.innerHTML);
          (f(s, "Rendering <ProductTitle />"),
            c.default.render(
              o.default.createElement(
                C,
                null,
                o.default.createElement(Nr, {
                  initialTitle: p.title,
                  isVariant: null !== document.getElementById("linked-variants-data"),
                  isMergedProduct: null !== document.getElementById("linked-products-data"),
                  options: p.options,
                  initialVariant: e.initialVariant,
                }),
              ),
              document.getElementById("ProductTitleNode"),
              () => {
                f(s, "Rendered <ProductTitle />");
              },
            ));
        }
      }
      if (
        (document.getElementById("pricingRoot") &&
          (f(s, "Rendering <ProductPrice />"),
          c.default.render(
            o.default.createElement(Ni, {
              product: e.product,
              initialVariant: e.initialVariant,
              showSleepClubPricing: e.showSleepClubPricing,
              moriFriendsScDiscount: e.moriFriendsScDiscount,
            }),
            document.getElementById("pricingRoot"),
            () => {
              f(s, "Rendered <ProductPrice />");
            },
          )),
        document.getElementById("ProductImages") &&
          (f(s, "Rendering <ProductImages />"),
          c.default.render(
            o.default.createElement(
              h,
              null,
              o.default.createElement(Ei, {
                productMetafields: e.productMetafields,
                images: e.images,
                initialVariant: e.initialVariant,
                product: e.product,
                discountRuleIcon: e.discountRuleIcon,
                dealRoundel: t,
                isProductImageHorizontal: e.isProductImageHorizontal,
              }),
            ),
            document.getElementById("ProductImages"),
            () => {
              f(s, "Rendered <ProductImages />");
            },
          )),
        document.getElementById("SizeGuidesNode") &&
          (f(s, "Rendering <ProductSizeGuides />"),
          c.default.render(
            o.default.createElement(Pi, { settings: i }),
            document.getElementById("SizeGuidesNode"),
            () => {
              f(s, "Rendered <ProductSizeGuides />");
            },
          )),
        document.getElementById("DiscountPromptNode"))
      ) {
        var u = JSON.parse(document.getElementById("DiscountPromptConfig").innerHTML);
        (f(s, "Rendering <DiscountCodeWrapper />"),
          c.default.render(
            o.default.createElement(w, null, o.default.createElement(O, { config: u, product: e.product })),
            document.getElementById("DiscountPromptNode"),
            () => {
              f(s, "Rendered <DiscountCodeWrapper />");
            },
          ));
      }
      if (document.getElementById("ProductAddOns") && document.getElementById("ThreadRoot")) {
        var m = JSON.parse(document.getElementById("ThreadRoot").innerHTML),
          g = document.getElementById("PdpGiftingSettings")
            ? JSON.parse(document.getElementById("PdpGiftingSettings").innerHTML)
            : {},
          v = _objectSpread(_objectSpread({}, e.giftWrap), g);
        (f(s, "Rendering <ProductAddOns />"),
          c.default.render(
            o.default.createElement(oa, {
              productPersonalisationOptions: e.productMetafields.productPersonalisationOptions,
              settings: {
                personalisation: e.personalisation,
                giftWrap: v,
                giftWrapAll: e.giftWrapAll,
                donation: e.donation,
                sleepclubMembershipInfoPopup: e.sleepclubMembershipInfoPopup,
                scMembershipDetails: e.scMembershipDetails,
              },
              images: e.images,
              initialVariant: e.initialVariant,
              product: e.product,
              productOptions: e.productOptions,
              threads: m.threads,
              shouldMembershipBePreSelected: e.shouldMembershipBePreSelected,
              preSelectParam: e.preSelectParam,
              freeReturnsElement: r || null,
            }),
            document.getElementById("ProductAddOns"),
            () => {
              f(s, "Rendered <ProductAddOns />");
            },
          ));
      }
    }
    if (document.getElementById("FeaturedReviewsRoot") && document.getElementById("FeaturedReviewsNode")) {
      var _ = JSON.parse(document.getElementById("FeaturedReviewsRoot").innerHTML);
      (f(s, "Rendering <FeaturedReviews />"),
        c.default.render(
          o.default.createElement(
            C,
            null,
            o.default.createElement(ki, { featured_text: _.featured_text, reviewer_name: _.reviewer_name }),
          ),
          document.getElementById("FeaturedReviewsNode"),
          () => {
            f(s, "Rendered <FeaturedReviews />");
          },
        ));
    }
    if (document.getElementById("FeaturedVariantProductsNode")) {
      var y = document.getElementById("linked-variants-data");
      if (y) {
        var b = JSON.parse(y.innerHTML);
        (window.initialProductHandle || (window.initialProductHandle = b.current_product_handle),
          f(s, "Rendering <LinkedProductSwatches />"),
          c.default.render(
            o.default.createElement(
              C,
              null,
              o.default.createElement(Pr, {
                products: b.products,
                isColourVariant: !0,
                currentProductHandle: b.current_product_handle,
                initialProductHandle: window.initialProductHandle,
              }),
            ),
            document.getElementById("FeaturedVariantProductsNode"),
            () => {
              f(s, "Rendered <LinkedProductSwatches />");
            },
          ));
      }
    } else if (document.getElementById("FeaturedProductsNode")) {
      var S = document.getElementById("linked-products-data");
      if (S) {
        var E = JSON.parse(S.innerHTML);
        (window.initialProductHandle || (window.initialProductHandle = E.current_product_handle),
          f(s, "Rendering <LinkedProductSwatches />"),
          c.default.render(
            o.default.createElement(
              C,
              null,
              o.default.createElement(Pr, {
                products: E.products,
                isColourVariant: !1,
                currentProductHandle: E.current_product_handle,
                initialProductHandle: window.initialProductHandle,
              }),
            ),
            document.getElementById("FeaturedProductsNode"),
            () => {
              f(s, "Rendered <LinkedProductSwatches />");
            },
          ));
      }
    }
  }
  ((Nr.displayName = "ProductTitle"),
    yt.write("current_variant_product_chosen", ""),
    Tr(),
    setTimeout(() => {
      yr.registerRecsObserver();
    }, 500),
    setTimeout(() => {
      var e = document.body.querySelectorAll("reviewsio-product-reviews-widget");
      if (e.length > 0)
        for (var t of e) {
          var a = t.querySelectorAll(".R-ContentList");
          if (a.length > 0)
            for (var i of a)
              if (2 === i.childNodes.length) {
                t.remove();
                break;
              }
        }
    }, 2e3),
    document.addEventListener(
      "reloadSection",
      (function () {
        var e = _asyncToGenerator(function* (e) {
          Tr();
        });
        return function (t) {
          return e.apply(this, arguments);
        };
      })(),
    ));
})(React, ReactDOM, dayjs, Slider, sha1);
